import { Decimal } from 'decimal.js';
import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T;
export type InputMaybe<T> = T;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  Any: { input: any; output: any; }
  /** The `Base64` scalar type represents a base64-encoded String. */
  Base64: { input: string; output: string; }
  /** The `Decimal` scalar type represents a python Decimal. */
  CustomDecimal: { input: Decimal; output: Decimal; }
  /**
   * The `Date` scalar type represents a Date
   * value as specified by
   * [iso8601](https://en.wikipedia.org/wiki/ISO_8601).
   */
  Date: { input: string; output: string; }
  /**
   * The `DateTime` scalar type represents a DateTime
   * value as specified by
   * [iso8601](https://en.wikipedia.org/wiki/ISO_8601).
   */
  DateTime: { input: string; output: string; }
  /** The `Decimal` scalar type represents a python Decimal. */
  Decimal: { input: string; output: string; }
  /**
   * Allows use of a JSON String for input / output from the GraphQL schema.
   *
   * Use of this type is *not recommended* as you lose the benefits of having a defined, static
   * schema (one of the key benefits of GraphQL).
   */
  JSONString: { input: string; output: string; }
  /**
   * Leverages the internal Python implementation of UUID (uuid.UUID) to provide native UUID objects
   * in fields, resolvers and input.
   */
  UUID: { input: string; output: string; }
  /**
   * Create scalar that ignores normal serialization/deserialization, since
   * that will be handled by the multipart request spec
   */
  Upload: { input: File | false; output: File | false; }
};

export type AccountNode = Node & {
  __typename?: 'AccountNode';
  address?: Maybe<Scalars['String']['output']>;
  contacts: Array<ContactType>;
  created: Scalars['DateTime']['output'];
  createdBy?: Maybe<UserType>;
  externalId: Scalars['String']['output'];
  /** The ID of the object */
  id: Scalars['ID']['output'];
  isFavorite: Scalars['Boolean']['output'];
  location?: Maybe<LocationType>;
  name: Scalars['String']['output'];
  owner?: Maybe<OrganizationType>;
  seeders: Array<SeederType>;
  taxId?: Maybe<Scalars['String']['output']>;
  updated: Scalars['DateTime']['output'];
  updatedBy?: Maybe<UserType>;
  users: Array<UserType>;
  uuid: Scalars['UUID']['output'];
};

export type AccountNodeConnection = {
  __typename?: 'AccountNodeConnection';
  count: Scalars['Int']['output'];
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<AccountNodeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `AccountNode` and its cursor. */
export type AccountNodeEdge = {
  __typename?: 'AccountNodeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<AccountNode>;
};

export type AccountType = {
  __typename?: 'AccountType';
  address?: Maybe<Scalars['String']['output']>;
  contacts: Array<ContactType>;
  created: Scalars['DateTime']['output'];
  createdBy?: Maybe<UserType>;
  externalId: Scalars['String']['output'];
  id: Scalars['UUID']['output'];
  isFavorite: Scalars['Boolean']['output'];
  location?: Maybe<LocationType>;
  name: Scalars['String']['output'];
  owner?: Maybe<OrganizationType>;
  seeders: Array<SeederType>;
  taxId?: Maybe<Scalars['String']['output']>;
  updated: Scalars['DateTime']['output'];
  updatedBy?: Maybe<UserType>;
  users: Array<UserType>;
  uuid: Scalars['UUID']['output'];
};

export type AddOrderedProduct = {
  __typename?: 'AddOrderedProduct';
  errors?: Maybe<Array<Maybe<ErrorType>>>;
};

export type AmountDatum = {
  __typename?: 'AmountDatum';
  amount: Scalars['Float']['output'];
  count: Scalars['Int']['output'];
  label: Scalars['String']['output'];
  percentage?: Maybe<Scalars['Float']['output']>;
};

export type AnalyticsFilters = {
  dateFrom?: InputMaybe<Scalars['String']['input']>;
  dateTo?: InputMaybe<Scalars['String']['input']>;
  organization?: InputMaybe<Scalars['String']['input']>;
  organizations?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  products?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ApproveWarrantyClaimRequestMutationInput = {
  amount?: InputMaybe<Scalars['Decimal']['input']>;
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  warrantyClaim: Scalars['ID']['input'];
};

export type ApproveWarrantyClaimRequestMutationPayload = {
  __typename?: 'ApproveWarrantyClaimRequestMutationPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<ErrorType>;
  warrantyClaimReview?: Maybe<WarrantyClaimReviewType>;
};

export type BankInvoicePdfDisclaimerType = {
  __typename?: 'BankInvoicePDFDisclaimerType';
  address?: Maybe<Scalars['String']['output']>;
  bankAccountAddress: Scalars['String']['output'];
  bankAccountName: Scalars['String']['output'];
  bankAccountNumber: Scalars['String']['output'];
  bankSwiftCodeInternational: Scalars['String']['output'];
  disclaimer: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  legalName?: Maybe<Scalars['String']['output']>;
  routingTransitNumberChecks: Scalars['String']['output'];
  routingTransitNumberIncomingAch: Scalars['String']['output'];
  routingTransitNumberOutgoingAch: Scalars['String']['output'];
  routingTransitNumberWires: Scalars['String']['output'];
  startOfActivities?: Maybe<Scalars['String']['output']>;
  taxId?: Maybe<Scalars['String']['output']>;
  taxpayerType?: Maybe<Scalars['String']['output']>;
};

export type BundleProductType = {
  __typename?: 'BundleProductType';
  bundle: BundleType;
  created: Scalars['DateTime']['output'];
  createdBy?: Maybe<UserType>;
  id: Scalars['UUID']['output'];
  product: ProductNode;
  quantity: Scalars['Int']['output'];
  updated: Scalars['DateTime']['output'];
  updatedBy?: Maybe<UserType>;
};

export type BundleType = {
  __typename?: 'BundleType';
  created: Scalars['DateTime']['output'];
  createdBy?: Maybe<UserType>;
  id: Scalars['UUID']['output'];
  items: Array<BundleProductType>;
  multiplier: Scalars['Decimal']['output'];
  name: Scalars['String']['output'];
  order: Scalars['Int']['output'];
  published: Scalars['Boolean']['output'];
  quotedProducts: Array<QuotedProductType>;
  selectable: Scalars['Boolean']['output'];
  updated: Scalars['DateTime']['output'];
  updatedBy?: Maybe<UserType>;
};

export type ByStatusDatum = {
  __typename?: 'ByStatusDatum';
  count: Scalars['Int']['output'];
  label: Scalars['String']['output'];
};

export type CancelEcn = {
  __typename?: 'CancelEcn';
  ok?: Maybe<Scalars['Boolean']['output']>;
};

export type CancelWarrantyClaimRequestMutationInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  warrantyClaim: Scalars['ID']['input'];
};

export type CancelWarrantyClaimRequestMutationPayload = {
  __typename?: 'CancelWarrantyClaimRequestMutationPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<ErrorType>;
  warrantyClaimReview?: Maybe<WarrantyClaimReviewType>;
};

export type CategoryNode = Node & {
  __typename?: 'CategoryNode';
  created: Scalars['DateTime']['output'];
  createdBy?: Maybe<UserType>;
  enabledForAssistedQuote: Scalars['Boolean']['output'];
  enabledForSeeder: Scalars['Boolean']['output'];
  /** The ID of the object */
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  order: Scalars['Int']['output'];
  productSet: ProductNodeConnection;
  quotedproductSet: Array<QuotedProductType>;
  /** Associates the rule with a specific product category. */
  rules: Array<QuoteRuleType>;
  seederSet: Array<SeederType>;
  subcategories: Array<SubcategoryType>;
  updated: Scalars['DateTime']['output'];
  updatedBy?: Maybe<UserType>;
  uuid: Scalars['UUID']['output'];
  warrantyproductSet: Array<WarrantyProductType>;
};


export type CategoryNodeProductSetArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  externalIdIcontains?: InputMaybe<Scalars['String']['input']>;
  externalId_In?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  id_In?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  last?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  subcategory_Category_EnabledForAssistedQuote?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CategoryNodeConnection = {
  __typename?: 'CategoryNodeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<CategoryNodeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `CategoryNode` and its cursor. */
export type CategoryNodeEdge = {
  __typename?: 'CategoryNodeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<CategoryNode>;
};

export type CategoryType = {
  __typename?: 'CategoryType';
  created: Scalars['DateTime']['output'];
  createdBy?: Maybe<UserType>;
  enabledForAssistedQuote: Scalars['Boolean']['output'];
  enabledForSeeder: Scalars['Boolean']['output'];
  id: Scalars['UUID']['output'];
  name: Scalars['String']['output'];
  order: Scalars['Int']['output'];
  productSet: ProductNodeConnection;
  quotedproductSet: Array<QuotedProductType>;
  /** Associates the rule with a specific product category. */
  rules: Array<QuoteRuleType>;
  seederSet: Array<SeederType>;
  subcategories: Array<SubcategoryType>;
  updated: Scalars['DateTime']['output'];
  updatedBy?: Maybe<UserType>;
  uuid: Scalars['UUID']['output'];
  warrantyproductSet: Array<WarrantyProductType>;
};


export type CategoryTypeProductSetArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  externalIdIcontains?: InputMaybe<Scalars['String']['input']>;
  externalId_In?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  id_In?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  last?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  subcategory_Category_EnabledForAssistedQuote?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ChangeUserLanguage = {
  __typename?: 'ChangeUserLanguage';
  ok: Scalars['Boolean']['output'];
};

export type CloseQuoteMutation = {
  __typename?: 'CloseQuoteMutation';
  status: Scalars['Boolean']['output'];
};

export type CloseReasonType = {
  __typename?: 'CloseReasonType';
  created: Scalars['DateTime']['output'];
  createdBy?: Maybe<UserType>;
  description: Scalars['String']['output'];
  id: Scalars['UUID']['output'];
  updated: Scalars['DateTime']['output'];
  updatedBy?: Maybe<UserType>;
};

export type CloseWarrantyClaimWithRmaMutationInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  rmaCode: Scalars['String']['input'];
  warrantyClaim: Scalars['ID']['input'];
};

export type CloseWarrantyClaimWithRmaMutationPayload = {
  __typename?: 'CloseWarrantyClaimWithRMAMutationPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<ErrorType>;
  warrantyClaimReview?: Maybe<WarrantyClaimReviewType>;
};

export type ContactNode = Node & {
  __typename?: 'ContactNode';
  account: AccountType;
  active: Scalars['Boolean']['output'];
  created: Scalars['DateTime']['output'];
  createdBy?: Maybe<UserType>;
  displayName: Scalars['String']['output'];
  email?: Maybe<Scalars['String']['output']>;
  externalId: Scalars['String']['output'];
  firstName: Scalars['String']['output'];
  /** The ID of the object */
  id: Scalars['ID']['output'];
  lastName: Scalars['String']['output'];
  mobilePhone: Scalars['String']['output'];
  phone: Scalars['String']['output'];
  quotes: QuoteNodeConnection;
  type: ContactTypeType;
  updated: Scalars['DateTime']['output'];
  updatedBy?: Maybe<UserType>;
  uuid: Scalars['UUID']['output'];
  warrantyClaims: WarrantyClaimNodeConnection;
};


export type ContactNodeQuotesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  billingType?: InputMaybe<QuotesQuoteBillingTypeChoices>;
  billingType_Iexact?: InputMaybe<QuotesQuoteBillingTypeChoices>;
  contact_Account_Id?: InputMaybe<Scalars['UUID']['input']>;
  contact_Account_Id_In?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
  contact_Account_Owner_Id?: InputMaybe<Scalars['UUID']['input']>;
  contact_Account_Owner_Id_In?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
  contact_Id?: InputMaybe<Scalars['UUID']['input']>;
  createdBy?: InputMaybe<Scalars['UUID']['input']>;
  createdGte?: InputMaybe<Scalars['Date']['input']>;
  createdLte?: InputMaybe<Scalars['Date']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  product?: InputMaybe<Scalars['String']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<QuotesQuoteStatusChoices>;
  status_Iexact?: InputMaybe<QuotesQuoteStatusChoices>;
  user?: InputMaybe<Scalars['UUID']['input']>;
};


export type ContactNodeWarrantyClaimsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  contact_Account_Id?: InputMaybe<Scalars['UUID']['input']>;
  contact_Account_Owner_Id?: InputMaybe<Scalars['UUID']['input']>;
  contact_Id?: InputMaybe<Scalars['UUID']['input']>;
  contact_Id_In?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
  created?: InputMaybe<Scalars['Date']['input']>;
  createdBy_Id?: InputMaybe<Scalars['UUID']['input']>;
  createdGte?: InputMaybe<Scalars['Date']['input']>;
  createdLte?: InputMaybe<Scalars['Date']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  inspectionReviewStatus?: InputMaybe<Scalars['String']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  warrantyClaimType?: InputMaybe<WarrantyClaimsWarrantyClaimWarrantyClaimTypeChoices>;
  warrantyClaimType_Iexact?: InputMaybe<WarrantyClaimsWarrantyClaimWarrantyClaimTypeChoices>;
};

export type ContactNodeConnection = {
  __typename?: 'ContactNodeConnection';
  count: Scalars['Int']['output'];
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<ContactNodeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `ContactNode` and its cursor. */
export type ContactNodeEdge = {
  __typename?: 'ContactNodeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<ContactNode>;
};

export type ContactType = {
  __typename?: 'ContactType';
  account: AccountType;
  active: Scalars['Boolean']['output'];
  created: Scalars['DateTime']['output'];
  createdBy?: Maybe<UserType>;
  displayName: Scalars['String']['output'];
  email?: Maybe<Scalars['String']['output']>;
  externalId: Scalars['String']['output'];
  firstName: Scalars['String']['output'];
  id: Scalars['UUID']['output'];
  lastName: Scalars['String']['output'];
  mobilePhone: Scalars['String']['output'];
  phone: Scalars['String']['output'];
  quotes: QuoteNodeConnection;
  type: ContactTypeType;
  updated: Scalars['DateTime']['output'];
  updatedBy?: Maybe<UserType>;
  uuid: Scalars['UUID']['output'];
  warrantyClaims: WarrantyClaimNodeConnection;
};


export type ContactTypeQuotesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  billingType?: InputMaybe<QuotesQuoteBillingTypeChoices>;
  billingType_Iexact?: InputMaybe<QuotesQuoteBillingTypeChoices>;
  contact_Account_Id?: InputMaybe<Scalars['UUID']['input']>;
  contact_Account_Id_In?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
  contact_Account_Owner_Id?: InputMaybe<Scalars['UUID']['input']>;
  contact_Account_Owner_Id_In?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
  contact_Id?: InputMaybe<Scalars['UUID']['input']>;
  createdBy?: InputMaybe<Scalars['UUID']['input']>;
  createdGte?: InputMaybe<Scalars['Date']['input']>;
  createdLte?: InputMaybe<Scalars['Date']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  product?: InputMaybe<Scalars['String']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<QuotesQuoteStatusChoices>;
  status_Iexact?: InputMaybe<QuotesQuoteStatusChoices>;
  user?: InputMaybe<Scalars['UUID']['input']>;
};


export type ContactTypeWarrantyClaimsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  contact_Account_Id?: InputMaybe<Scalars['UUID']['input']>;
  contact_Account_Owner_Id?: InputMaybe<Scalars['UUID']['input']>;
  contact_Id?: InputMaybe<Scalars['UUID']['input']>;
  contact_Id_In?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
  created?: InputMaybe<Scalars['Date']['input']>;
  createdBy_Id?: InputMaybe<Scalars['UUID']['input']>;
  createdGte?: InputMaybe<Scalars['Date']['input']>;
  createdLte?: InputMaybe<Scalars['Date']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  inspectionReviewStatus?: InputMaybe<Scalars['String']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  warrantyClaimType?: InputMaybe<WarrantyClaimsWarrantyClaimWarrantyClaimTypeChoices>;
  warrantyClaimType_Iexact?: InputMaybe<WarrantyClaimsWarrantyClaimWarrantyClaimTypeChoices>;
};

export type ContactTypeType = {
  __typename?: 'ContactTypeType';
  contactSet: Array<ContactType>;
  created: Scalars['DateTime']['output'];
  createdBy?: Maybe<UserType>;
  id: Scalars['UUID']['output'];
  name: Scalars['String']['output'];
  order: Scalars['Int']['output'];
  updated: Scalars['DateTime']['output'];
  updatedBy?: Maybe<UserType>;
};

export type CreateAccountMutationInput = {
  address?: InputMaybe<Scalars['String']['input']>;
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  location?: InputMaybe<Scalars['ID']['input']>;
  name: Scalars['String']['input'];
  owner: Scalars['ID']['input'];
  taxId?: InputMaybe<Scalars['String']['input']>;
};

export type CreateAccountMutationPayload = {
  __typename?: 'CreateAccountMutationPayload';
  account?: Maybe<AccountType>;
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<ErrorType>;
};

export type CreateBankInvoicePdf = {
  __typename?: 'CreateBankInvoicePDF';
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  job?: Maybe<ExportJobType>;
};

export type CreateContactMutationInput = {
  account: Scalars['ID']['input'];
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  mobilePhone?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  type: Scalars['ID']['input'];
};

export type CreateContactMutationPayload = {
  __typename?: 'CreateContactMutationPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  contact?: Maybe<ContactType>;
  errors: Array<ErrorType>;
};

export type CreateEcnMutationInput = {
  blueprints?: InputMaybe<Array<EcnBlueprintFormInput>>;
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  draftBlueprints?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  draftEcn?: InputMaybe<Scalars['ID']['input']>;
  ecnNumber: Scalars['String']['input'];
  effectiveDate?: InputMaybe<Scalars['Date']['input']>;
  fyi?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  id?: InputMaybe<Scalars['ID']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  oems?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  parts: Array<EcnPartFormInput>;
  recipient?: InputMaybe<Scalars['String']['input']>;
  seasonPriority: Scalars['String']['input'];
  tasks?: InputMaybe<Array<EcnTaskFormInput>>;
  warrantyPriority?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CreateEcnMutationPayload = {
  __typename?: 'CreateEcnMutationPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  ecn?: Maybe<EcnType>;
  errors: Array<ErrorType>;
};

export type CreateOrderedProductMutationInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  quantity: Scalars['Int']['input'];
  quantityLeft: Scalars['Int']['input'];
  quotedProduct?: InputMaybe<Scalars['ID']['input']>;
  warrantyProduct?: InputMaybe<Scalars['ID']['input']>;
};

export type CreateOrderedProductMutationPayload = {
  __typename?: 'CreateOrderedProductMutationPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<ErrorType>;
  orderedProduct?: Maybe<OrderedProductType>;
};

export type CreatePrepaidPdf = {
  __typename?: 'CreatePrepaidPDF';
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  job?: Maybe<ExportJobType>;
};

export type CreateQuoteMutationInput = {
  additionalChargesDescription?: InputMaybe<Scalars['String']['input']>;
  additionalChargesValue?: InputMaybe<Scalars['Decimal']['input']>;
  billingType: Scalars['String']['input'];
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  contact: Scalars['ID']['input'];
  id?: InputMaybe<Scalars['ID']['input']>;
  kitMultiplier?: InputMaybe<Scalars['ID']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  paymentMethods: Array<QuotedPaymentMethodFormInput>;
  products: Array<QuotedProductFormInput>;
  rowCount?: InputMaybe<Scalars['Int']['input']>;
  seeder?: InputMaybe<Scalars['ID']['input']>;
};

export type CreateQuoteMutationPayload = {
  __typename?: 'CreateQuoteMutationPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<ErrorType>;
  quote?: Maybe<QuoteNode>;
};

export type CreateQuotePdf = {
  __typename?: 'CreateQuotePDF';
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  job?: Maybe<ExportJobType>;
};

export type CreateSaleMutationInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  paymentMethod: Scalars['ID']['input'];
  quote: Scalars['ID']['input'];
};

export type CreateSaleMutationPayload = {
  __typename?: 'CreateSaleMutationPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<ErrorType>;
  sale?: Maybe<SaleNode>;
};

export type CreateSeederMutationInput = {
  account: Scalars['ID']['input'];
  brand: Scalars['ID']['input'];
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  installedCategories?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  meterType: Scalars['String']['input'];
  model?: InputMaybe<Scalars['ID']['input']>;
  rowCount: Scalars['Int']['input'];
  year?: InputMaybe<Scalars['Int']['input']>;
};

export type CreateSeederMutationPayload = {
  __typename?: 'CreateSeederMutationPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<ErrorType>;
  seeder?: Maybe<SeederType>;
};

export type CreateShipmentMutationInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  invoice?: InputMaybe<Scalars['Upload']['input']>;
  productsShipped: Array<ShipmentProductFormInput>;
  status?: InputMaybe<Scalars['String']['input']>;
  supplyOrder: Scalars['ID']['input'];
};

export type CreateShipmentMutationPayload = {
  __typename?: 'CreateShipmentMutationPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<ErrorType>;
  shipment?: Maybe<ShipmentType>;
};

export type CreateShipmentWarrantyClaimMutationInput = {
  charter: Scalars['String']['input'];
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  shipAddress?: InputMaybe<Scalars['ID']['input']>;
};

export type CreateShipmentWarrantyClaimMutationPayload = {
  __typename?: 'CreateShipmentWarrantyClaimMutationPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<ErrorType>;
  warrantyClaim?: Maybe<WarrantyClaimNode>;
};

export type CreateSupplyOrderPdf = {
  __typename?: 'CreateSupplyOrderPDF';
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  job?: Maybe<ExportJobType>;
};

export type CreateSupplyOrderQuoteMutationInput = {
  charter: Scalars['String']['input'];
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  emailMessages?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Concrete date set when the order is approved. Empty while the order is pending review. */
  estimatedDispatchDate?: InputMaybe<Scalars['Date']['input']>;
  externalDealerId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  internalOrder?: InputMaybe<Scalars['Boolean']['input']>;
  isUrgent?: InputMaybe<Scalars['Boolean']['input']>;
  products: Array<OrderedProductFormInput>;
  quote: Scalars['ID']['input'];
  reviewStart?: InputMaybe<Scalars['DateTime']['input']>;
  shipAddress?: InputMaybe<Scalars['ID']['input']>;
  status: Scalars['String']['input'];
  warrantyClaim?: InputMaybe<Scalars['ID']['input']>;
};

export type CreateSupplyOrderQuoteMutationPayload = {
  __typename?: 'CreateSupplyOrderQuoteMutationPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<ErrorType>;
  supplyOrder?: Maybe<SupplyOrderNode>;
};

export type CreateWarrantyClaimInspectionReviewMutationInput = {
  amount?: InputMaybe<Scalars['Decimal']['input']>;
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  failureDescription?: InputMaybe<Scalars['String']['input']>;
  files?: InputMaybe<Array<WarrantyClaimInspectionFileFormInput>>;
  id?: InputMaybe<Scalars['ID']['input']>;
  inWarranty?: InputMaybe<Scalars['Boolean']['input']>;
  inspected?: InputMaybe<Scalars['Boolean']['input']>;
  inspectedDate?: InputMaybe<Scalars['DateTime']['input']>;
  received?: InputMaybe<Scalars['Boolean']['input']>;
  receivedDate?: InputMaybe<Scalars['DateTime']['input']>;
  status: Scalars['String']['input'];
  warrantyClaim: Scalars['ID']['input'];
};

export type CreateWarrantyClaimInspectionReviewMutationPayload = {
  __typename?: 'CreateWarrantyClaimInspectionReviewMutationPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<ErrorType>;
  warrantyClaimInspectionReview?: Maybe<WarrantyClaimInspectionReviewType>;
};

export type CreateWarrantyClaimMutationInput = {
  applyForCredit?: InputMaybe<Scalars['Boolean']['input']>;
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  contact: Scalars['ID']['input'];
  description: Scalars['String']['input'];
  externalId?: InputMaybe<Scalars['String']['input']>;
  failureDate?: InputMaybe<Scalars['Date']['input']>;
  finalClient?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  images?: InputMaybe<Array<WarrantyClaimImageFormInput>>;
  invoiceDate?: InputMaybe<Scalars['Date']['input']>;
  lastReview?: InputMaybe<Scalars['ID']['input']>;
  /** Order ID of the order that the claim was created from. */
  orderId?: InputMaybe<Scalars['Int']['input']>;
  phone: Scalars['String']['input'];
  product: Scalars['ID']['input'];
  quantity: Scalars['Int']['input'];
  rmaCode?: InputMaybe<Scalars['String']['input']>;
  seeder?: InputMaybe<Scalars['ID']['input']>;
  serialNumber?: InputMaybe<Scalars['String']['input']>;
  videos?: InputMaybe<Array<WarrantyClaimVideoFormInput>>;
  warrantyClaimType: Scalars['String']['input'];
};

export type CreateWarrantyClaimMutationPayload = {
  __typename?: 'CreateWarrantyClaimMutationPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<ErrorType>;
  warrantyClaim?: Maybe<WarrantyClaimNode>;
};

export type DateSeriesDatum = {
  __typename?: 'DateSeriesDatum';
  amount?: Maybe<Scalars['Float']['output']>;
  count: Scalars['Int']['output'];
  date: Scalars['Date']['output'];
};

export type DefaultTaskType = {
  __typename?: 'DefaultTaskType';
  created: Scalars['DateTime']['output'];
  createdBy?: Maybe<UserType>;
  description?: Maybe<Scalars['String']['output']>;
  displayName: Scalars['String']['output'];
  ecnTypes?: Maybe<Array<EcnsDefaultTaskEcnTypesChoices>>;
  id: Scalars['UUID']['output'];
  name: EcnsDefaultTaskNameChoices;
  roles: Array<EcnRoleType>;
  updated: Scalars['DateTime']['output'];
  updatedBy?: Maybe<UserType>;
};

export type DeleteAccountMutationInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type DeleteAccountMutationPayload = {
  __typename?: 'DeleteAccountMutationPayload';
  account?: Maybe<AccountType>;
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<ErrorType>;
};

export type DeleteContactMutationInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type DeleteContactMutationPayload = {
  __typename?: 'DeleteContactMutationPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  contact?: Maybe<ContactType>;
  errors: Array<ErrorType>;
};

export type DeleteDraftEcnMutationInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type DeleteDraftEcnMutationPayload = {
  __typename?: 'DeleteDraftEcnMutationPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  draftEcn?: Maybe<DraftEcnNode>;
  errors: Array<ErrorType>;
};

export type DeleteEcnFile = {
  __typename?: 'DeleteEcnFile';
  id: Scalars['UUID']['output'];
  ok?: Maybe<Scalars['Boolean']['output']>;
};

export type DeleteQuoteMutationInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type DeleteQuoteMutationPayload = {
  __typename?: 'DeleteQuoteMutationPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<ErrorType>;
  quote?: Maybe<QuoteNode>;
};

export type DeleteSeederMutationInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type DeleteSeederMutationPayload = {
  __typename?: 'DeleteSeederMutationPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<ErrorType>;
  seeder?: Maybe<SeederType>;
};

export type DeleteShipmentMutationInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type DeleteShipmentMutationPayload = {
  __typename?: 'DeleteShipmentMutationPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<ErrorType>;
  shipment?: Maybe<ShipmentType>;
};

export type DownloadType = {
  __typename?: 'DownloadType';
  contentType: Scalars['String']['output'];
  data: Scalars['Base64']['output'];
  filename: Scalars['String']['output'];
};

export type DraftBlueprintEcnFormInput = {
  file?: InputMaybe<Scalars['Upload']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type DraftBlueprintEcnType = {
  __typename?: 'DraftBlueprintEcnType';
  created: Scalars['DateTime']['output'];
  createdBy?: Maybe<UserType>;
  draftEcn: DraftEcnNode;
  file?: Maybe<Scalars['String']['output']>;
  id: Scalars['UUID']['output'];
  updated: Scalars['DateTime']['output'];
  updatedBy?: Maybe<UserType>;
};

export type DraftEcnMutationInput = {
  blueprints?: InputMaybe<Array<DraftBlueprintEcnFormInput>>;
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  data: Scalars['String']['input'];
  id?: InputMaybe<Scalars['ID']['input']>;
  step: Scalars['Int']['input'];
};

export type DraftEcnMutationPayload = {
  __typename?: 'DraftEcnMutationPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  draftEcn?: Maybe<DraftEcnNode>;
  errors: Array<ErrorType>;
};

export type DraftEcnNode = Node & {
  __typename?: 'DraftEcnNode';
  blueprints: Array<DraftBlueprintEcnType>;
  created: Scalars['DateTime']['output'];
  createdBy?: Maybe<UserType>;
  data?: Maybe<Scalars['JSONString']['output']>;
  ecnNumberDuplicated?: Maybe<Scalars['Boolean']['output']>;
  /** The ID of the object */
  id: Scalars['ID']['output'];
  step: Scalars['Int']['output'];
  updated: Scalars['DateTime']['output'];
  updatedBy?: Maybe<UserType>;
  uuid: Scalars['UUID']['output'];
};

export type DraftEcnNodeConnection = {
  __typename?: 'DraftEcnNodeConnection';
  count: Scalars['Int']['output'];
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<DraftEcnNodeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `DraftEcnNode` and its cursor. */
export type DraftEcnNodeEdge = {
  __typename?: 'DraftEcnNodeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<DraftEcnNode>;
};

export type EcnAnalyticsType = {
  __typename?: 'EcnAnalyticsType';
  accumulatedInProgress?: Maybe<KpiDatum>;
  accumulatedInProgressByEcn?: Maybe<Array<Maybe<ByStatusDatum>>>;
  accumulatedWithoutEffectiveDate?: Maybe<KpiDatum>;
  accumulatedWithoutEffectiveDateByEcn?: Maybe<Array<Maybe<ByStatusDatum>>>;
  byEffectiveDate?: Maybe<Array<Maybe<ByStatusDatum>>>;
  byEffectiveDateAndSeasonPriority?: Maybe<Array<Maybe<PriotityDatum>>>;
  byPartType?: Maybe<Array<Maybe<ByStatusDatum>>>;
  bySeasonPriority?: Maybe<Array<Maybe<ByStatusDatum>>>;
  byStatus?: Maybe<Array<Maybe<ByStatusDatum>>>;
  byWarrantyPriority?: Maybe<Array<Maybe<ByStatusDatum>>>;
  byWarrantyPriorityInProgress?: Maybe<Array<Maybe<ByStatusDatum>>>;
};

export type EcnBlueprintFormInput = {
  file?: InputMaybe<Scalars['Upload']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type EcnBlueprintType = {
  __typename?: 'EcnBlueprintType';
  created: Scalars['DateTime']['output'];
  createdBy?: Maybe<UserType>;
  ecn: EcnType;
  file: Scalars['String']['output'];
  id: Scalars['UUID']['output'];
  updated: Scalars['DateTime']['output'];
  updatedBy?: Maybe<UserType>;
};

export type EcnCancelledPartFormInput = {
  betaQuantity?: InputMaybe<Scalars['Decimal']['input']>;
  buyingDate?: InputMaybe<Scalars['Date']['input']>;
  buyingPrice?: InputMaybe<Scalars['Decimal']['input']>;
  currentVersion?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  estimatedDateArrival?: InputMaybe<Scalars['Date']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  origin?: InputMaybe<Scalars['ID']['input']>;
  part: Scalars['ID']['input'];
  partsArrived?: InputMaybe<Scalars['Boolean']['input']>;
  pricing?: InputMaybe<Scalars['Decimal']['input']>;
  replace: Scalars['String']['input'];
  supplier?: InputMaybe<Scalars['String']['input']>;
  supportLink?: InputMaybe<Scalars['String']['input']>;
  supportNotes?: InputMaybe<Scalars['String']['input']>;
  targetVersion?: InputMaybe<Scalars['String']['input']>;
  tariffPosition?: InputMaybe<Scalars['Boolean']['input']>;
  tariffPositionNotes?: InputMaybe<Scalars['String']['input']>;
  yearlyForecast?: InputMaybe<Scalars['Decimal']['input']>;
};

export type EcnCancelledPartType = {
  __typename?: 'EcnCancelledPartType';
  betaQuantity?: Maybe<Scalars['Decimal']['output']>;
  buyingDate?: Maybe<Scalars['Date']['output']>;
  buyingPrice?: Maybe<Scalars['Decimal']['output']>;
  created: Scalars['DateTime']['output'];
  createdBy?: Maybe<UserType>;
  currentVersion?: Maybe<Scalars['String']['output']>;
  description: Scalars['String']['output'];
  displayReplace: Scalars['String']['output'];
  ecnPart: EcnPartType;
  estimatedDateArrival?: Maybe<Scalars['Date']['output']>;
  id: Scalars['UUID']['output'];
  origin?: Maybe<ProductOriginType>;
  part: ProductNode;
  partsArrived: Scalars['Boolean']['output'];
  pricing?: Maybe<Scalars['Decimal']['output']>;
  product?: Maybe<ProductNode>;
  replace: EcnsEcnCancelledPartReplaceChoices;
  supplier?: Maybe<Scalars['String']['output']>;
  supportLink?: Maybe<Scalars['String']['output']>;
  supportNotes?: Maybe<Scalars['String']['output']>;
  targetVersion?: Maybe<Scalars['String']['output']>;
  tariffPosition?: Maybe<Scalars['Boolean']['output']>;
  tariffPositionNotes?: Maybe<Scalars['String']['output']>;
  updated: Scalars['DateTime']['output'];
  updatedBy?: Maybe<UserType>;
  yearlyForecast?: Maybe<Scalars['Decimal']['output']>;
};

export type EcnConfigType = {
  __typename?: 'EcnConfigType';
  /** Agosto por defecto */
  anualForecastEndMonth: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  /** Usuarios a los que se notificara cuando el ECN esta finalizado. */
  notificateUsersOnFinish: Array<UserType>;
  /** Roles que poseen los usuarios que pertenecen a la categorias PP-INTERNO */
  ppInternalRoles: Array<RoleType>;
};

export type EcnFileType = {
  __typename?: 'EcnFileType';
  created: Scalars['DateTime']['output'];
  createdBy?: Maybe<UserType>;
  ecn: EcnType;
  file: Scalars['String']['output'];
  id: Scalars['UUID']['output'];
  updated: Scalars['DateTime']['output'];
  updatedBy?: Maybe<UserType>;
};

export type EcnFiles = {
  __typename?: 'EcnFiles';
  ecnFiles: Array<EcnFileType>;
  errors?: Maybe<Array<Maybe<ErrorType>>>;
};

export type EcnMarkAsSeenMutationInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type EcnMarkAsSeenMutationPayload = {
  __typename?: 'EcnMarkAsSeenMutationPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  ecn?: Maybe<EcnType>;
  errors: Array<ErrorType>;
};

export type EcnNewPartFormInput = {
  betaQuantity?: InputMaybe<Scalars['Decimal']['input']>;
  buyingDate?: InputMaybe<Scalars['Date']['input']>;
  buyingPrice?: InputMaybe<Scalars['Decimal']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  estimatedDateArrival?: InputMaybe<Scalars['Date']['input']>;
  externalId: Scalars['String']['input'];
  id?: InputMaybe<Scalars['ID']['input']>;
  name: Scalars['String']['input'];
  origin?: InputMaybe<Scalars['ID']['input']>;
  partsArrived?: InputMaybe<Scalars['Boolean']['input']>;
  pricing?: InputMaybe<Scalars['Decimal']['input']>;
  subcategory: Scalars['ID']['input'];
  supplier?: InputMaybe<Scalars['String']['input']>;
  supportLink?: InputMaybe<Scalars['String']['input']>;
  supportNotes?: InputMaybe<Scalars['String']['input']>;
  tariffPosition?: InputMaybe<Scalars['Boolean']['input']>;
  tariffPositionNotes?: InputMaybe<Scalars['String']['input']>;
  type: Scalars['String']['input'];
  yearlyForecast?: InputMaybe<Scalars['Decimal']['input']>;
};

export type EcnNewPartType = {
  __typename?: 'EcnNewPartType';
  betaQuantity?: Maybe<Scalars['Decimal']['output']>;
  buyingDate?: Maybe<Scalars['Date']['output']>;
  buyingPrice?: Maybe<Scalars['Decimal']['output']>;
  created: Scalars['DateTime']['output'];
  createdBy?: Maybe<UserType>;
  description: Scalars['String']['output'];
  displayType: Scalars['String']['output'];
  ecnPart: EcnPartType;
  estimatedDateArrival?: Maybe<Scalars['Date']['output']>;
  externalId: Scalars['String']['output'];
  id: Scalars['UUID']['output'];
  name: Scalars['String']['output'];
  origin?: Maybe<ProductOriginType>;
  partsArrived: Scalars['Boolean']['output'];
  pricing?: Maybe<Scalars['Decimal']['output']>;
  product?: Maybe<ProductNode>;
  subcategory: SubcategoryType;
  supplier?: Maybe<Scalars['String']['output']>;
  supportLink?: Maybe<Scalars['String']['output']>;
  supportNotes?: Maybe<Scalars['String']['output']>;
  tariffPosition?: Maybe<Scalars['Boolean']['output']>;
  tariffPositionNotes?: Maybe<Scalars['String']['output']>;
  type: EcnsEcnNewPartTypeChoices;
  updated: Scalars['DateTime']['output'];
  updatedBy?: Maybe<UserType>;
  yearlyForecast?: Maybe<Scalars['Decimal']['output']>;
};

export type EcnNode = Node & {
  __typename?: 'EcnNode';
  blueprints: Array<EcnBlueprintType>;
  created: Scalars['DateTime']['output'];
  createdBy?: Maybe<UserType>;
  displayId: Scalars['Int']['output'];
  displayRecipient: Scalars['String']['output'];
  displaySeasonPriority: Scalars['String']['output'];
  displayStatus: Scalars['String']['output'];
  ecnNumber: Scalars['String']['output'];
  effectiveDate?: Maybe<Scalars['Date']['output']>;
  files: Array<EcnFileType>;
  fyi: Array<RoleType>;
  histories: Array<HistoricalEcnType>;
  /** The ID of the object */
  id: Scalars['ID']['output'];
  informedUsers: Array<UserType>;
  nextEcnId?: Maybe<Scalars['String']['output']>;
  notes: Scalars['String']['output'];
  oems: Array<OrganizationType>;
  parts: Array<EcnPartType>;
  previousEcnId?: Maybe<Scalars['String']['output']>;
  realesedBy?: Maybe<UserType>;
  recipient?: Maybe<EcnsEcnRecipientChoices>;
  seasonPriority: EcnsEcnSeasonPriorityChoices;
  status?: Maybe<EcnsEcnStatusChoices>;
  tasks: Array<EcnTaskType>;
  totalInformedUsers?: Maybe<Scalars['Int']['output']>;
  totalNotInformedUsers?: Maybe<Scalars['Int']['output']>;
  updated: Scalars['DateTime']['output'];
  updatedBy?: Maybe<UserType>;
  uuid: Scalars['UUID']['output'];
  viewed?: Maybe<Scalars['Boolean']['output']>;
  warrantyPriority: Scalars['Boolean']['output'];
};

export type EcnNodeConnection = {
  __typename?: 'EcnNodeConnection';
  count: Scalars['Int']['output'];
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<EcnNodeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `EcnNode` and its cursor. */
export type EcnNodeEdge = {
  __typename?: 'EcnNodeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<EcnNode>;
};

export type EcnPartFormInput = {
  cancelledParts?: InputMaybe<Array<EcnCancelledPartFormInput>>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  newParts?: InputMaybe<Array<EcnNewPartFormInput>>;
  type: Scalars['String']['input'];
};

export type EcnPartType = {
  __typename?: 'EcnPartType';
  cancelledParts: Array<EcnCancelledPartType>;
  created: Scalars['DateTime']['output'];
  createdBy?: Maybe<UserType>;
  displayType: Scalars['String']['output'];
  ecn: EcnType;
  externalId?: Maybe<Scalars['String']['output']>;
  id: Scalars['UUID']['output'];
  newParts: Array<EcnNewPartType>;
  type: EcnsEcnPartTypeChoices;
  updated: Scalars['DateTime']['output'];
  updatedBy?: Maybe<UserType>;
};

export type EcnRoleType = {
  __typename?: 'EcnRoleType';
  created: Scalars['DateTime']['output'];
  createdBy?: Maybe<UserType>;
  defaultTasks: Array<DefaultTaskType>;
  id: Scalars['UUID']['output'];
  name: Scalars['String']['output'];
  tasks: Array<EcnTaskType>;
  updated: Scalars['DateTime']['output'];
  updatedBy?: Maybe<UserType>;
  users: Array<UserType>;
};

export type EcnTaskCommentMutationInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  content: Scalars['String']['input'];
  id?: InputMaybe<Scalars['ID']['input']>;
  task: Scalars['ID']['input'];
  users?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
};

export type EcnTaskCommentMutationPayload = {
  __typename?: 'EcnTaskCommentMutationPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  ecnTaskComment?: Maybe<EcnTaskCommentNode>;
  errors: Array<ErrorType>;
};

export type EcnTaskCommentNode = Node & {
  __typename?: 'EcnTaskCommentNode';
  content: Scalars['String']['output'];
  created: Scalars['DateTime']['output'];
  createdBy?: Maybe<UserType>;
  /** The ID of the object */
  id: Scalars['ID']['output'];
  task: EcnTaskType;
  updated: Scalars['DateTime']['output'];
  updatedBy?: Maybe<UserType>;
  uuid: Scalars['UUID']['output'];
};

export type EcnTaskCommentNodeConnection = {
  __typename?: 'EcnTaskCommentNodeConnection';
  count: Scalars['Int']['output'];
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<EcnTaskCommentNodeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `EcnTaskCommentNode` and its cursor. */
export type EcnTaskCommentNodeEdge = {
  __typename?: 'EcnTaskCommentNodeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<EcnTaskCommentNode>;
};

export type EcnTaskFormInput = {
  done?: InputMaybe<Scalars['Boolean']['input']>;
  doneBy?: InputMaybe<Scalars['ID']['input']>;
  ecnTypes: Array<InputMaybe<Scalars['String']['input']>>;
  id?: InputMaybe<Scalars['ID']['input']>;
  name: Scalars['String']['input'];
  notes?: InputMaybe<Scalars['String']['input']>;
  originalTask?: InputMaybe<Scalars['ID']['input']>;
  roles: Array<InputMaybe<Scalars['ID']['input']>>;
};

export type EcnTaskType = {
  __typename?: 'EcnTaskType';
  comments: EcnTaskCommentNodeConnection;
  created: Scalars['DateTime']['output'];
  createdBy?: Maybe<UserType>;
  displayName: Scalars['String']['output'];
  done: Scalars['Boolean']['output'];
  doneBy?: Maybe<UserType>;
  ecn: EcnType;
  ecnTypes?: Maybe<Array<EcnsEcnTaskEcnTypesChoices>>;
  id: Scalars['UUID']['output'];
  name: EcnsEcnTaskNameChoices;
  notes: Scalars['String']['output'];
  originalTask?: Maybe<DefaultTaskType>;
  roles: Array<EcnRoleType>;
  updated: Scalars['DateTime']['output'];
  updatedBy?: Maybe<UserType>;
  users: Array<UserType>;
};


export type EcnTaskTypeCommentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  task_Id?: InputMaybe<Scalars['UUID']['input']>;
};

export type EcnType = {
  __typename?: 'EcnType';
  blueprints: Array<EcnBlueprintType>;
  created: Scalars['DateTime']['output'];
  createdBy?: Maybe<UserType>;
  displayId: Scalars['Int']['output'];
  displayRecipient: Scalars['String']['output'];
  displaySeasonPriority: Scalars['String']['output'];
  displayStatus: Scalars['String']['output'];
  ecnNumber: Scalars['String']['output'];
  effectiveDate?: Maybe<Scalars['Date']['output']>;
  files: Array<EcnFileType>;
  fyi: Array<RoleType>;
  histories: Array<HistoricalEcnType>;
  id: Scalars['UUID']['output'];
  informedUsers: Array<UserType>;
  nextEcnId?: Maybe<Scalars['String']['output']>;
  notes: Scalars['String']['output'];
  oems: Array<OrganizationType>;
  parts: Array<EcnPartType>;
  previousEcnId?: Maybe<Scalars['String']['output']>;
  realesedBy?: Maybe<UserType>;
  recipient?: Maybe<EcnsEcnRecipientChoices>;
  seasonPriority: EcnsEcnSeasonPriorityChoices;
  status?: Maybe<EcnsEcnStatusChoices>;
  tasks: Array<EcnTaskType>;
  totalInformedUsers?: Maybe<Scalars['Int']['output']>;
  totalNotInformedUsers?: Maybe<Scalars['Int']['output']>;
  updated: Scalars['DateTime']['output'];
  updatedBy?: Maybe<UserType>;
  viewed?: Maybe<Scalars['Boolean']['output']>;
  warrantyPriority: Scalars['Boolean']['output'];
};

/** An enumeration. */
export const EcnsDefaultTaskEcnTypesChoices = {
  /** New part */
  NewPart: 'NEW_PART',
  /** Part cancellation */
  PartCancelation: 'PART_CANCELATION',
  /** Part replacement */
  PartReplacement: 'PART_REPLACEMENT',
  /** Part revision */
  PartRevision: 'PART_REVISION'
} as const;

export type EcnsDefaultTaskEcnTypesChoices = typeof EcnsDefaultTaskEcnTypesChoices[keyof typeof EcnsDefaultTaskEcnTypesChoices];
/** An enumeration. */
export const EcnsDefaultTaskNameChoices = {
  /** Forecast */
  Forecast: 'FORECAST',
  /** New/Modify/Cancel Parts */
  NewModCancelParts: 'NEW_MOD_CANCEL_PARTS',
  /** Arrived parts */
  PartsArrival: 'PARTS_ARRIVAL',
  /** Farmer price list */
  Pricing: 'PRICING',
  /** Product support */
  ProductSupport: 'PRODUCT_SUPPORT',
  /** Purchases */
  Purchases: 'PURCHASES'
} as const;

export type EcnsDefaultTaskNameChoices = typeof EcnsDefaultTaskNameChoices[keyof typeof EcnsDefaultTaskNameChoices];
/** An enumeration. */
export const EcnsEcnCancelledPartReplaceChoices = {
  /** Immediate */
  Immediate: 'IMMEDIATE',
  /** To segregate */
  ToSegregate: 'TO_SEGREGATE',
  /** Until stock last */
  UntilStockLast: 'UNTIL_STOCK_LAST'
} as const;

export type EcnsEcnCancelledPartReplaceChoices = typeof EcnsEcnCancelledPartReplaceChoices[keyof typeof EcnsEcnCancelledPartReplaceChoices];
/** An enumeration. */
export const EcnsEcnNewPartTypeChoices = {
  /** Beta */
  Beta: 'BETA',
  /** Commercial */
  Commercial: 'COMMERCIAL',
  /** Internal beta */
  InternalBeta: 'INTERNAL_BETA'
} as const;

export type EcnsEcnNewPartTypeChoices = typeof EcnsEcnNewPartTypeChoices[keyof typeof EcnsEcnNewPartTypeChoices];
/** An enumeration. */
export const EcnsEcnPartTypeChoices = {
  /** New part */
  NewPart: 'NEW_PART',
  /** Part cancellation */
  PartCancelation: 'PART_CANCELATION',
  /** Part replacement */
  PartReplacement: 'PART_REPLACEMENT',
  /** Part revision */
  PartRevision: 'PART_REVISION'
} as const;

export type EcnsEcnPartTypeChoices = typeof EcnsEcnPartTypeChoices[keyof typeof EcnsEcnPartTypeChoices];
/** An enumeration. */
export const EcnsEcnRecipientChoices = {
  /** All */
  All: 'ALL',
  /** OEM */
  Oem: 'OEM',
  /** Only dealers */
  OnlyDealers: 'ONLY_DEALERS',
  /** PP interno */
  PpInternal: 'PP_INTERNAL'
} as const;

export type EcnsEcnRecipientChoices = typeof EcnsEcnRecipientChoices[keyof typeof EcnsEcnRecipientChoices];
/** An enumeration. */
export const EcnsEcnSeasonPriorityChoices = {
  /** High */
  High: 'HIGH',
  /** Low */
  Low: 'LOW',
  /** Medium */
  Medium: 'MEDIUM'
} as const;

export type EcnsEcnSeasonPriorityChoices = typeof EcnsEcnSeasonPriorityChoices[keyof typeof EcnsEcnSeasonPriorityChoices];
/** An enumeration. */
export const EcnsEcnStatusChoices = {
  /** Cancelado */
  Cancelled: 'CANCELLED',
  /** Efectivo */
  Effective: 'EFFECTIVE',
  /** Finished */
  Finished: 'FINISHED',
  /** In progress */
  InProgress: 'IN_PROGRESS'
} as const;

export type EcnsEcnStatusChoices = typeof EcnsEcnStatusChoices[keyof typeof EcnsEcnStatusChoices];
/** An enumeration. */
export const EcnsEcnTaskEcnTypesChoices = {
  /** New part */
  NewPart: 'NEW_PART',
  /** Part cancellation */
  PartCancelation: 'PART_CANCELATION',
  /** Part replacement */
  PartReplacement: 'PART_REPLACEMENT',
  /** Part revision */
  PartRevision: 'PART_REVISION'
} as const;

export type EcnsEcnTaskEcnTypesChoices = typeof EcnsEcnTaskEcnTypesChoices[keyof typeof EcnsEcnTaskEcnTypesChoices];
/** An enumeration. */
export const EcnsEcnTaskNameChoices = {
  /** Forecast */
  Forecast: 'FORECAST',
  /** New/Modify/Cancel Parts */
  NewModCancelParts: 'NEW_MOD_CANCEL_PARTS',
  /** Arrived parts */
  PartsArrival: 'PARTS_ARRIVAL',
  /** Farmer price list */
  Pricing: 'PRICING',
  /** Product support */
  ProductSupport: 'PRODUCT_SUPPORT',
  /** Purchases */
  Purchases: 'PURCHASES'
} as const;

export type EcnsEcnTaskNameChoices = typeof EcnsEcnTaskNameChoices[keyof typeof EcnsEcnTaskNameChoices];
export type ErrorType = {
  __typename?: 'ErrorType';
  field: Scalars['String']['output'];
  messages: Array<Scalars['String']['output']>;
};

export type ExportCloudOrder = {
  __typename?: 'ExportCloudOrder';
  job?: Maybe<ExportJobType>;
};

export type ExportExcelQuotes = {
  __typename?: 'ExportExcelQuotes';
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  job?: Maybe<ExportJobType>;
};

export type ExportExcelSales = {
  __typename?: 'ExportExcelSales';
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  job?: Maybe<ExportJobType>;
};

export type ExportExcelSupplyOrders = {
  __typename?: 'ExportExcelSupplyOrders';
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  job?: Maybe<ExportJobType>;
};

export type ExportExcelWarrantyClaims = {
  __typename?: 'ExportExcelWarrantyClaims';
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  job?: Maybe<ExportJobType>;
};

export type ExportJobType = {
  __typename?: 'ExportJobType';
  id: Scalars['UUID']['output'];
  result?: Maybe<DownloadType>;
  status: JobStatus;
};

export type FailureType = {
  __typename?: 'FailureType';
  created: Scalars['DateTime']['output'];
  createdBy?: Maybe<UserType>;
  description: Scalars['String']['output'];
  id: Scalars['UUID']['output'];
  updated: Scalars['DateTime']['output'];
  updatedBy?: Maybe<UserType>;
};

export type FeatureFlagType = {
  __typename?: 'FeatureFlagType';
  /** Description of what this feature flag controls */
  description: Scalars['String']['output'];
  id: Scalars['UUID']['output'];
  /** Whether this feature flag is currently active */
  isActive: Scalars['Boolean']['output'];
  /** Unique identifier for the feature flag */
  name: Scalars['String']['output'];
  userHasAccess?: Maybe<Scalars['Boolean']['output']>;
};

export type ForecastRunType = {
  __typename?: 'ForecastRunType';
  completedAt?: Maybe<Scalars['DateTime']['output']>;
  created: Scalars['DateTime']['output'];
  createdBy?: Maybe<UserType>;
  errorMessage: Scalars['String']['output'];
  id: Scalars['UUID']['output'];
  parametersSnapshot: Scalars['JSONString']['output'];
  status: StockForecastForecastRunStatusChoices;
  stockSnapshotAt?: Maybe<Scalars['DateTime']['output']>;
  totalOrderLines: Scalars['Int']['output'];
  totalOrderValue: Scalars['Decimal']['output'];
  totalSkus: Scalars['Int']['output'];
};

export type ForecastTaskEcnCancelledPartFormInput = {
  betaQuantity?: InputMaybe<Scalars['Decimal']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  yearlyForecast?: InputMaybe<Scalars['Decimal']['input']>;
};

export type ForecastTaskEcnNewPartFormInput = {
  betaQuantity?: InputMaybe<Scalars['Decimal']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  yearlyForecast?: InputMaybe<Scalars['Decimal']['input']>;
};

export type ForecastTaskMutationInput = {
  cancelledParts?: InputMaybe<Array<ForecastTaskEcnCancelledPartFormInput>>;
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  newParts?: InputMaybe<Array<ForecastTaskEcnNewPartFormInput>>;
};

export type ForecastTaskMutationPayload = {
  __typename?: 'ForecastTaskMutationPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  ecn?: Maybe<EcnType>;
  errors: Array<ErrorType>;
};

export type HistoricalEcnType = {
  __typename?: 'HistoricalEcnType';
  created: Scalars['DateTime']['output'];
  createdBy?: Maybe<UserType>;
  displayId: Scalars['Int']['output'];
  ecnNumber: Scalars['String']['output'];
  effectiveDate?: Maybe<Scalars['Date']['output']>;
  historyChangeReason?: Maybe<Scalars['String']['output']>;
  historyDate: Scalars['DateTime']['output'];
  historyId: Scalars['UUID']['output'];
  historyRelation: EcnType;
  historyTypeDisplay: Scalars['String']['output'];
  historyUser?: Maybe<UserType>;
  id: Scalars['UUID']['output'];
  notes: Scalars['String']['output'];
  realesedBy?: Maybe<UserType>;
  recipient: Scalars['String']['output'];
  seasonPriority: Scalars['String']['output'];
  status: Scalars['String']['output'];
  updated: Scalars['DateTime']['output'];
  updatedBy?: Maybe<UserType>;
  warrantyPriority: Scalars['Boolean']['output'];
};

export type ImportInTransitStock = {
  __typename?: 'ImportInTransitStock';
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  result?: Maybe<ImportResultType>;
};

export type ImportMonthlyDemand = {
  __typename?: 'ImportMonthlyDemand';
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  result?: Maybe<ImportResultType>;
};

export type ImportResultType = {
  __typename?: 'ImportResultType';
  duplicates: Scalars['Int']['output'];
  imported: Scalars['Int']['output'];
  skipped: Scalars['Int']['output'];
};

/** The Status of Job within its lifecycle at any given time. */
export const JobStatus = {
  Canceled: 'CANCELED',
  Deferred: 'DEFERRED',
  Failed: 'FAILED',
  Finished: 'FINISHED',
  Queued: 'QUEUED',
  Scheduled: 'SCHEDULED',
  Started: 'STARTED',
  Stopped: 'STOPPED'
} as const;

export type JobStatus = typeof JobStatus[keyof typeof JobStatus];
export type JobType = {
  __typename?: 'JobType';
  id: Scalars['UUID']['output'];
  result?: Maybe<Scalars['String']['output']>;
  status: JobStatus;
};

export type KpiDatum = {
  __typename?: 'KpiDatum';
  avg: Scalars['Int']['output'];
  max: Scalars['Int']['output'];
  min: Scalars['Int']['output'];
};

export type LocaleTranslationType = {
  __typename?: 'LocaleTranslationType';
  created: Scalars['DateTime']['output'];
  createdBy?: Maybe<UserType>;
  extract: Scalars['JSONString']['output'];
  id: Scalars['UUID']['output'];
  json: Scalars['JSONString']['output'];
  locale: Scalars['String']['output'];
  updated: Scalars['DateTime']['output'];
  updatedBy?: Maybe<UserType>;
};

export type LocationType = {
  __typename?: 'LocationType';
  accountSet: Array<AccountType>;
  children: Array<LocationType>;
  codename: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  iva: Scalars['CustomDecimal']['output'];
  level: Scalars['Int']['output'];
  lft: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  organizationSet: Array<OrganizationType>;
  parent?: Maybe<LocationType>;
  path?: Maybe<Scalars['String']['output']>;
  rght: Scalars['Int']['output'];
  treeId: Scalars['Int']['output'];
};

export type LoginInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  password: Scalars['String']['input'];
};

export type LoginPayload = {
  __typename?: 'LoginPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  email: Scalars['String']['output'];
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  password: Scalars['String']['output'];
  user?: Maybe<UserType>;
};

export type Logout = {
  __typename?: 'Logout';
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type MrpLifecycleOverrideInput = {
  categoryCap: Scalars['Int']['input'];
  forceZero: Scalars['Boolean']['input'];
  lifecycle: Scalars['String']['input'];
  multiplier: Scalars['Decimal']['input'];
};

export type MrpLifecycleOverrideType = {
  __typename?: 'MRPLifecycleOverrideType';
  categoryCap: Scalars['Int']['output'];
  forceZero: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  lifecycle: StockForecastMrpLifecycleOverrideLifecycleChoices;
  multiplier: Scalars['Decimal']['output'];
};

export type MrpParametersInput = {
  globalMaxOrderPerSku?: InputMaybe<Scalars['Int']['input']>;
  highPriorityOrderValue?: InputMaybe<Scalars['Decimal']['input']>;
  leadTimeMonths?: InputMaybe<Scalars['Int']['input']>;
  maxPercentOfPeakMonth?: InputMaybe<Scalars['Decimal']['input']>;
  mediumPriorityOrderValue?: InputMaybe<Scalars['Decimal']['input']>;
  minimumDemandMonthsToTrustAverage?: InputMaybe<Scalars['Int']['input']>;
  monthlyHistoricalCoverageTarget?: InputMaybe<Scalars['Decimal']['input']>;
  priceTiers?: InputMaybe<Scalars['JSONString']['input']>;
  quoteNoOrderThreshold?: InputMaybe<Scalars['Decimal']['input']>;
  quoteReorderTarget?: InputMaybe<Scalars['Decimal']['input']>;
  reducedOrderFractionOfCap?: InputMaybe<Scalars['Decimal']['input']>;
  stockThresholdUnits?: InputMaybe<Scalars['Int']['input']>;
  useDynamicCapByUnitPrice?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MrpParametersType = {
  __typename?: 'MRPParametersType';
  globalMaxOrderPerSku: Scalars['Int']['output'];
  highPriorityOrderValue: Scalars['Decimal']['output'];
  id: Scalars['ID']['output'];
  leadTimeMonths: Scalars['Int']['output'];
  maxPercentOfPeakMonth: Scalars['Decimal']['output'];
  mediumPriorityOrderValue: Scalars['Decimal']['output'];
  minimumDemandMonthsToTrustAverage: Scalars['Int']['output'];
  monthlyHistoricalCoverageTarget: Scalars['Decimal']['output'];
  priceTiers: Scalars['JSONString']['output'];
  quoteNoOrderThreshold: Scalars['Decimal']['output'];
  quoteReorderTarget: Scalars['Decimal']['output'];
  reducedOrderFractionOfCap: Scalars['Decimal']['output'];
  stockThresholdUnits: Scalars['Int']['output'];
  useDynamicCapByUnitPrice: Scalars['Boolean']['output'];
};

export type MakeEcnEffectiveMutationInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type MakeEcnEffectiveMutationPayload = {
  __typename?: 'MakeEcnEffectiveMutationPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  ecn?: Maybe<EcnType>;
  errors: Array<ErrorType>;
};

export type MarkAllNotificationsAsRead = {
  __typename?: 'MarkAllNotificationsAsRead';
  status?: Maybe<Scalars['Boolean']['output']>;
};

export type MarkNotificationAsReadMutationInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  isRead?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MarkNotificationAsReadMutationPayload = {
  __typename?: 'MarkNotificationAsReadMutationPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<ErrorType>;
  notification?: Maybe<NotificationNode>;
};

export type ModelChangeType = {
  __typename?: 'ModelChangeType';
  field: Scalars['String']['output'];
  new?: Maybe<Scalars['Any']['output']>;
  old?: Maybe<Scalars['Any']['output']>;
  verboseField: Scalars['String']['output'];
};

export type ModelDeltaType = {
  __typename?: 'ModelDeltaType';
  changedFields?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  changes?: Maybe<Array<Maybe<ModelChangeType>>>;
  date: Scalars['DateTime']['output'];
  updatedBy?: Maybe<UserType>;
};

export type ModelNotificationType = {
  __typename?: 'ModelNotificationType';
  id: Scalars['UUID']['output'];
  objectUuid: Scalars['UUID']['output'];
  user: UserType;
};

export type Mutation = {
  __typename?: 'Mutation';
  addOrderedProduct?: Maybe<AddOrderedProduct>;
  approveWarrantyClaim?: Maybe<ApproveWarrantyClaimRequestMutationPayload>;
  cancelEcn?: Maybe<CancelEcn>;
  cancelWarrantyClaim?: Maybe<CancelWarrantyClaimRequestMutationPayload>;
  changeLanguage?: Maybe<ChangeUserLanguage>;
  closeQuotes?: Maybe<CloseQuoteMutation>;
  closeWarrantyClaimWithRma?: Maybe<CloseWarrantyClaimWithRmaMutationPayload>;
  createAccount?: Maybe<CreateAccountMutationPayload>;
  createBankInvicePdf?: Maybe<CreateBankInvoicePdf>;
  createContact?: Maybe<CreateContactMutationPayload>;
  createEcn?: Maybe<CreateEcnMutationPayload>;
  createOrderedProduct?: Maybe<CreateOrderedProductMutationPayload>;
  createPrepaidPdf?: Maybe<CreatePrepaidPdf>;
  createQuote?: Maybe<CreateQuoteMutationPayload>;
  createQuotePdf?: Maybe<CreateQuotePdf>;
  createSale?: Maybe<CreateSaleMutationPayload>;
  createSeeder?: Maybe<CreateSeederMutationPayload>;
  createShipment?: Maybe<CreateShipmentMutationPayload>;
  createShipmentWarrantyClaim?: Maybe<CreateShipmentWarrantyClaimMutationPayload>;
  createSupplyOrderPdf?: Maybe<CreateSupplyOrderPdf>;
  createSupplyOrderQuote?: Maybe<CreateSupplyOrderQuoteMutationPayload>;
  createWarrantyClaim?: Maybe<CreateWarrantyClaimMutationPayload>;
  createWarrantyClaimInspectionReview?: Maybe<CreateWarrantyClaimInspectionReviewMutationPayload>;
  deleteAccount?: Maybe<DeleteAccountMutationPayload>;
  deleteContact?: Maybe<DeleteContactMutationPayload>;
  deleteDraftEcn?: Maybe<DeleteDraftEcnMutationPayload>;
  deleteEcnFile?: Maybe<DeleteEcnFile>;
  deleteQuote?: Maybe<DeleteQuoteMutationPayload>;
  deleteSeeder?: Maybe<DeleteSeederMutationPayload>;
  deleteShipment?: Maybe<DeleteShipmentMutationPayload>;
  draftEcn?: Maybe<DraftEcnMutationPayload>;
  ecnFiles?: Maybe<EcnFiles>;
  ecnForecastTask?: Maybe<ForecastTaskMutationPayload>;
  ecnMarkAsSeen?: Maybe<EcnMarkAsSeenMutationPayload>;
  ecnPricingTask?: Maybe<PricingTaskMutationPayload>;
  ecnTaskComment?: Maybe<EcnTaskCommentMutationPayload>;
  exportCloudOrder?: Maybe<ExportCloudOrder>;
  exportExcelQuotes?: Maybe<ExportExcelQuotes>;
  exportExcelSales?: Maybe<ExportExcelSales>;
  exportExcelSupplyOrders?: Maybe<ExportExcelSupplyOrders>;
  exportExcelWarrantyClaims?: Maybe<ExportExcelWarrantyClaims>;
  importInTransitStock?: Maybe<ImportInTransitStock>;
  importMonthlyDemand?: Maybe<ImportMonthlyDemand>;
  login?: Maybe<LoginPayload>;
  logout?: Maybe<Logout>;
  makeEcnEffective?: Maybe<MakeEcnEffectiveMutationPayload>;
  markAllNotificationsAsRead?: Maybe<MarkAllNotificationsAsRead>;
  markNotificationAsRead?: Maybe<MarkNotificationAsReadMutationPayload>;
  newModCancelPartsTask?: Maybe<NewModCancelPartsTaskMutationPayload>;
  newModCancelledPartsPurchaseTask?: Maybe<NewModCancelledPartsPurchaseTaskMutationPayload>;
  notificateTasksForUser?: Maybe<NotificateTasksForUserPayload>;
  partsArrivalTask?: Maybe<PartsArrivalTaskMutationPayload>;
  productSupportTask?: Maybe<ProductSupportTaskMutationPayload>;
  rejectWarrantyClaim?: Maybe<RejectWarrantyClaimRequestMutationPayload>;
  resetPassword?: Maybe<ResetPasswordMutationPayload>;
  reviewSupplyOrder?: Maybe<SupplyOrderReviewMutationPayload>;
  runForecast?: Maybe<RunForecast>;
  setPassword?: Maybe<SetPasswordMutationPayload>;
  startSupplyOrderReview?: Maybe<StartSupplyOrderReviewMutationPayload>;
  toggleFavoriteAccount?: Maybe<ToggleFavoriteAccount>;
  toggleNotificationConfig?: Maybe<NotificationConfigMutationPayload>;
  toggleSubscribeModelNotification?: Maybe<ToggleSubscribeModelNotificationMutationPayload>;
  updateAccount?: Maybe<UpdateAccountMutationPayload>;
  updateContact?: Maybe<UpdateContactMutationPayload>;
  updateEcn?: Maybe<UpdateEcnMutationPayload>;
  updateEffectiveDate?: Maybe<UpdateEcnEffectiveDateMutation>;
  updateMrpLifecycleOverrides?: Maybe<UpdateMrpLifecycleOverrides>;
  updateMrpParameters?: Maybe<UpdateMrpParameters>;
  updateOrderedProduct?: Maybe<UpdateOrderedProductMutationPayload>;
  updateOrganization?: Maybe<UpdateOrganizationMutationPayload>;
  updatePassword?: Maybe<UpdatePasswordMutationPayload>;
  updateQuote?: Maybe<UpdateQuoteMutationPayload>;
  updateQuotePrices?: Maybe<UpdateQuotePricesMutationPayload>;
  updateRecommendationManualInput?: Maybe<UpdateRecommendationManualInput>;
  updateSale?: Maybe<UpdateSaleMutationPayload>;
  updateSeeder?: Maybe<UpdateSeederMutationPayload>;
  updateShipment?: Maybe<UpdateShipmentMutationPayload>;
  updateSupplyOrderComment?: Maybe<UpdateSupplyOrderCommentMutationPayload>;
  updateSupplyOrderQuote?: Maybe<UpdateSupplyOrderQuoteMutationPayload>;
  updateUser?: Maybe<UpdateUserMutationPayload>;
  updateWarrantyClaim?: Maybe<UpdateWarrantyClaimMutationPayload>;
  uploadInvoice?: Maybe<UploadInvoiceMutationPayload>;
};


export type MutationAddOrderedProductArgs = {
  input: OrderedProductSupplyOrderQuoteFormInput;
  orderedProducts: Array<OrderedProductOrderedProductFormInput>;
};


export type MutationApproveWarrantyClaimArgs = {
  input: ApproveWarrantyClaimRequestMutationInput;
};


export type MutationCancelEcnArgs = {
  id: Scalars['UUID']['input'];
};


export type MutationCancelWarrantyClaimArgs = {
  input: CancelWarrantyClaimRequestMutationInput;
};


export type MutationChangeLanguageArgs = {
  language: Scalars['String']['input'];
};


export type MutationCloseQuotesArgs = {
  input: Array<InputMaybe<QuoteCloseReasonInputType>>;
};


export type MutationCloseWarrantyClaimWithRmaArgs = {
  input: CloseWarrantyClaimWithRmaMutationInput;
};


export type MutationCreateAccountArgs = {
  input: CreateAccountMutationInput;
};


export type MutationCreateBankInvicePdfArgs = {
  paymentMethodId: Scalars['UUID']['input'];
  quoteId: Scalars['UUID']['input'];
};


export type MutationCreateContactArgs = {
  input: CreateContactMutationInput;
};


export type MutationCreateEcnArgs = {
  input: CreateEcnMutationInput;
};


export type MutationCreateOrderedProductArgs = {
  input: CreateOrderedProductMutationInput;
};


export type MutationCreatePrepaidPdfArgs = {
  supplyOrderId: Scalars['UUID']['input'];
};


export type MutationCreateQuoteArgs = {
  input: CreateQuoteMutationInput;
};


export type MutationCreateQuotePdfArgs = {
  paymentMethodId?: InputMaybe<Scalars['UUID']['input']>;
  productDisplay?: InputMaybe<QuotesQuotePdfProductDisplayChoices>;
  quoteId: Scalars['UUID']['input'];
  recipient?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<QuotesQuotePdfTypeChoices>;
};


export type MutationCreateSaleArgs = {
  input: CreateSaleMutationInput;
};


export type MutationCreateSeederArgs = {
  input: CreateSeederMutationInput;
};


export type MutationCreateShipmentArgs = {
  input: CreateShipmentMutationInput;
};


export type MutationCreateShipmentWarrantyClaimArgs = {
  input: CreateShipmentWarrantyClaimMutationInput;
};


export type MutationCreateSupplyOrderPdfArgs = {
  supplyOrderId: Scalars['UUID']['input'];
};


export type MutationCreateSupplyOrderQuoteArgs = {
  input: CreateSupplyOrderQuoteMutationInput;
};


export type MutationCreateWarrantyClaimArgs = {
  input: CreateWarrantyClaimMutationInput;
};


export type MutationCreateWarrantyClaimInspectionReviewArgs = {
  input: CreateWarrantyClaimInspectionReviewMutationInput;
};


export type MutationDeleteAccountArgs = {
  input: DeleteAccountMutationInput;
};


export type MutationDeleteContactArgs = {
  input: DeleteContactMutationInput;
};


export type MutationDeleteDraftEcnArgs = {
  input: DeleteDraftEcnMutationInput;
};


export type MutationDeleteEcnFileArgs = {
  id: Scalars['UUID']['input'];
};


export type MutationDeleteQuoteArgs = {
  input: DeleteQuoteMutationInput;
};


export type MutationDeleteSeederArgs = {
  input: DeleteSeederMutationInput;
};


export type MutationDeleteShipmentArgs = {
  input: DeleteShipmentMutationInput;
};


export type MutationDraftEcnArgs = {
  input: DraftEcnMutationInput;
};


export type MutationEcnFilesArgs = {
  ecnId: Scalars['UUID']['input'];
  files: Array<Scalars['Upload']['input']>;
};


export type MutationEcnForecastTaskArgs = {
  input: ForecastTaskMutationInput;
};


export type MutationEcnMarkAsSeenArgs = {
  input: EcnMarkAsSeenMutationInput;
};


export type MutationEcnPricingTaskArgs = {
  input: PricingTaskMutationInput;
};


export type MutationEcnTaskCommentArgs = {
  input: EcnTaskCommentMutationInput;
};


export type MutationExportCloudOrderArgs = {
  forecastRunId: Scalars['UUID']['input'];
};


export type MutationExportExcelQuotesArgs = {
  billingType?: InputMaybe<QuotesQuoteBillingTypeChoices>;
  billingType_Iexact?: InputMaybe<QuotesQuoteBillingTypeChoices>;
  contact_Account_Id?: InputMaybe<Scalars['UUID']['input']>;
  contact_Account_Id_In?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
  contact_Account_Owner_Id?: InputMaybe<Scalars['UUID']['input']>;
  contact_Account_Owner_Id_In?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
  contact_Id?: InputMaybe<Scalars['UUID']['input']>;
  createdBy?: InputMaybe<Scalars['UUID']['input']>;
  createdGte?: InputMaybe<Scalars['Date']['input']>;
  createdLte?: InputMaybe<Scalars['Date']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  paymentMethodId?: InputMaybe<Scalars['UUID']['input']>;
  product?: InputMaybe<Scalars['String']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  quoteId?: InputMaybe<Scalars['UUID']['input']>;
  status?: InputMaybe<QuotesQuoteStatusChoices>;
  status_Iexact?: InputMaybe<QuotesQuoteStatusChoices>;
  user?: InputMaybe<Scalars['UUID']['input']>;
};


export type MutationExportExcelSalesArgs = {
  createdGte?: InputMaybe<Scalars['Date']['input']>;
  createdLte?: InputMaybe<Scalars['Date']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  quote_Contact_Account_Id?: InputMaybe<Scalars['UUID']['input']>;
  quote_Contact_Account_Id_In?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
  quote_Contact_Account_Owner_Id?: InputMaybe<Scalars['UUID']['input']>;
  quote_Contact_Account_Owner_Id_In?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
  quote_Contact_Id?: InputMaybe<Scalars['UUID']['input']>;
  quote_Contact_Id_In?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
  saleId?: InputMaybe<Scalars['UUID']['input']>;
  user?: InputMaybe<Scalars['UUID']['input']>;
};


export type MutationExportExcelSupplyOrdersArgs = {
  createdGte?: InputMaybe<Scalars['Date']['input']>;
  createdLte?: InputMaybe<Scalars['Date']['input']>;
  isPending?: InputMaybe<Scalars['Boolean']['input']>;
  onlyWithStock?: InputMaybe<Scalars['Boolean']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  owner?: InputMaybe<Scalars['UUID']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  quote_Contact_Account_Id?: InputMaybe<Scalars['UUID']['input']>;
  quote_Contact_Account_Id_In?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
  quote_Contact_Id?: InputMaybe<Scalars['UUID']['input']>;
  quote_Contact_Id_In?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
  rgy?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<SupplyOrdersSupplyOrderStatusChoices>;
  status_In?: InputMaybe<Array<InputMaybe<SupplyOrdersSupplyOrderStatusChoices>>>;
  supplyOrderId?: InputMaybe<Scalars['UUID']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  user?: InputMaybe<Scalars['UUID']['input']>;
};


export type MutationExportExcelWarrantyClaimsArgs = {
  contact_Account_Id?: InputMaybe<Scalars['UUID']['input']>;
  contact_Account_Owner_Id?: InputMaybe<Scalars['UUID']['input']>;
  contact_Id?: InputMaybe<Scalars['UUID']['input']>;
  contact_Id_In?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
  created?: InputMaybe<Scalars['Date']['input']>;
  createdBy_Id?: InputMaybe<Scalars['UUID']['input']>;
  createdGte?: InputMaybe<Scalars['Date']['input']>;
  createdLte?: InputMaybe<Scalars['Date']['input']>;
  inspectionReviewStatus?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  warrantyClaimId?: InputMaybe<Scalars['UUID']['input']>;
  warrantyClaimType?: InputMaybe<WarrantyClaimsWarrantyClaimWarrantyClaimTypeChoices>;
  warrantyClaimType_Iexact?: InputMaybe<WarrantyClaimsWarrantyClaimWarrantyClaimTypeChoices>;
};


export type MutationImportInTransitStockArgs = {
  file: Scalars['Upload']['input'];
};


export type MutationImportMonthlyDemandArgs = {
  file: Scalars['Upload']['input'];
};


export type MutationLoginArgs = {
  input: LoginInput;
};


export type MutationMakeEcnEffectiveArgs = {
  input: MakeEcnEffectiveMutationInput;
};


export type MutationMarkNotificationAsReadArgs = {
  input: MarkNotificationAsReadMutationInput;
};


export type MutationNewModCancelPartsTaskArgs = {
  input: NewModCancelPartsTaskMutationInput;
};


export type MutationNewModCancelledPartsPurchaseTaskArgs = {
  input: NewModCancelledPartsPurchaseTaskMutationInput;
};


export type MutationNotificateTasksForUserArgs = {
  input: NotificateTasksForUserInput;
};


export type MutationPartsArrivalTaskArgs = {
  input: PartsArrivalTaskMutationInput;
};


export type MutationProductSupportTaskArgs = {
  input: ProductSupportTaskMutationInput;
};


export type MutationRejectWarrantyClaimArgs = {
  input: RejectWarrantyClaimRequestMutationInput;
};


export type MutationResetPasswordArgs = {
  input: ResetPasswordMutationInput;
};


export type MutationReviewSupplyOrderArgs = {
  input: SupplyOrderReviewMutationInput;
};


export type MutationSetPasswordArgs = {
  input: SetPasswordMutationInput;
};


export type MutationStartSupplyOrderReviewArgs = {
  input: StartSupplyOrderReviewMutationInput;
};


export type MutationToggleFavoriteAccountArgs = {
  id: Scalars['UUID']['input'];
};


export type MutationToggleNotificationConfigArgs = {
  input: NotificationConfigMutationInput;
};


export type MutationToggleSubscribeModelNotificationArgs = {
  input: ToggleSubscribeModelNotificationMutationInput;
};


export type MutationUpdateAccountArgs = {
  input: UpdateAccountMutationInput;
};


export type MutationUpdateContactArgs = {
  input: UpdateContactMutationInput;
};


export type MutationUpdateEcnArgs = {
  input: UpdateEcnMutationInput;
};


export type MutationUpdateEffectiveDateArgs = {
  effectiveDate: Scalars['Date']['input'];
  id: Scalars['UUID']['input'];
};


export type MutationUpdateMrpLifecycleOverridesArgs = {
  overrides: Array<MrpLifecycleOverrideInput>;
};


export type MutationUpdateMrpParametersArgs = {
  input: MrpParametersInput;
};


export type MutationUpdateOrderedProductArgs = {
  input: UpdateOrderedProductMutationInput;
};


export type MutationUpdateOrganizationArgs = {
  input: UpdateOrganizationMutationInput;
};


export type MutationUpdatePasswordArgs = {
  input: UpdatePasswordMutationInput;
};


export type MutationUpdateQuoteArgs = {
  input: UpdateQuoteMutationInput;
};


export type MutationUpdateQuotePricesArgs = {
  input: UpdateQuotePricesMutationInput;
};


export type MutationUpdateRecommendationManualInputArgs = {
  manualInput?: InputMaybe<Scalars['Int']['input']>;
  recommendationId: Scalars['UUID']['input'];
};


export type MutationUpdateSaleArgs = {
  input: UpdateSaleMutationInput;
};


export type MutationUpdateSeederArgs = {
  input: UpdateSeederMutationInput;
};


export type MutationUpdateShipmentArgs = {
  input: UpdateShipmentMutationInput;
};


export type MutationUpdateSupplyOrderCommentArgs = {
  input: UpdateSupplyOrderCommentMutationInput;
};


export type MutationUpdateSupplyOrderQuoteArgs = {
  input: UpdateSupplyOrderQuoteMutationInput;
};


export type MutationUpdateUserArgs = {
  input: UpdateUserMutationInput;
};


export type MutationUpdateWarrantyClaimArgs = {
  input: UpdateWarrantyClaimMutationInput;
};


export type MutationUploadInvoiceArgs = {
  input: UploadInvoiceMutationInput;
};

export type NewModCancelPartsTaskEcnPartFormInput = {
  externalId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type NewModCancelPartsTaskMutationInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  parts: Array<NewModCancelPartsTaskEcnPartFormInput>;
};

export type NewModCancelPartsTaskMutationPayload = {
  __typename?: 'NewModCancelPartsTaskMutationPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  ecn?: Maybe<EcnType>;
  errors: Array<ErrorType>;
};

export type NewModCancelledPartsPurchaseTaskMutationInput = {
  cancelledParts?: InputMaybe<Array<PurchaseTaskEcnCancelledPartFormInput>>;
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  newParts?: InputMaybe<Array<PurchaseTaskEcnNewPartFormInput>>;
};

export type NewModCancelledPartsPurchaseTaskMutationPayload = {
  __typename?: 'NewModCancelledPartsPurchaseTaskMutationPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  ecn?: Maybe<EcnType>;
  errors: Array<ErrorType>;
};

/** An object with an ID */
export type Node = {
  /** The ID of the object */
  id: Scalars['ID']['output'];
};

export type NotificateTasksForUserInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  user: Scalars['ID']['input'];
};

export type NotificateTasksForUserPayload = {
  __typename?: 'NotificateTasksForUserPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  ecn?: Maybe<EcnType>;
  errors: Array<ErrorType>;
};

/** An enumeration. */
export const NotificationConfigChoices = {
  SupplyOrders: 'supply_orders',
  WarrantyClaims: 'warranty_claims'
} as const;

export type NotificationConfigChoices = typeof NotificationConfigChoices[keyof typeof NotificationConfigChoices];
export type NotificationConfigMutationInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  emailEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  inAppEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  user: Scalars['ID']['input'];
};

export type NotificationConfigMutationPayload = {
  __typename?: 'NotificationConfigMutationPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<ErrorType>;
  notificationConfig?: Maybe<NotificationConfigType>;
};

export type NotificationConfigNameType = {
  __typename?: 'NotificationConfigNameType';
  label: Scalars['String']['output'];
  value: NotificationConfigChoices;
};

export type NotificationConfigType = {
  __typename?: 'NotificationConfigType';
  displayName: Scalars['String']['output'];
  emailEnabled: Scalars['Boolean']['output'];
  id: Scalars['UUID']['output'];
  inAppEnabled: Scalars['Boolean']['output'];
  name: UsersNotificationConfigNameChoices;
  user: UserType;
};

export type NotificationNode = Node & {
  __typename?: 'NotificationNode';
  created: Scalars['DateTime']['output'];
  createdBy?: Maybe<UserType>;
  /** The ID of the object */
  id: Scalars['ID']['output'];
  isRead: Scalars['Boolean']['output'];
  message: Scalars['String']['output'];
  path: Scalars['String']['output'];
  updated: Scalars['DateTime']['output'];
  updatedBy?: Maybe<UserType>;
  user: UserType;
  uuid: Scalars['UUID']['output'];
};

export type NotificationNodeConnection = {
  __typename?: 'NotificationNodeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<NotificationNodeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `NotificationNode` and its cursor. */
export type NotificationNodeEdge = {
  __typename?: 'NotificationNodeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<NotificationNode>;
};

export type OrderedProductFormInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  quantity: Scalars['Int']['input'];
  quantityLeft: Scalars['Int']['input'];
  quotedProduct?: InputMaybe<Scalars['ID']['input']>;
  warrantyProduct?: InputMaybe<Scalars['ID']['input']>;
};

export type OrderedProductOrderedProductFormInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  quantity: Scalars['Int']['input'];
  quantityLeft: Scalars['Int']['input'];
  quotedProduct: OrderedProductQuotedProductFormInput;
  warrantyProduct?: InputMaybe<Scalars['ID']['input']>;
};

export type OrderedProductQuotedProductFormInput = {
  bundle?: InputMaybe<Scalars['ID']['input']>;
  bundleMultiplier?: InputMaybe<Scalars['Decimal']['input']>;
  bundleName?: InputMaybe<Scalars['String']['input']>;
  bundleQuantity?: InputMaybe<Scalars['Int']['input']>;
  categoryName?: InputMaybe<Scalars['String']['input']>;
  commissionMultiplier: Scalars['Decimal']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  enableDiscount?: InputMaybe<Scalars['Boolean']['input']>;
  externalId: Scalars['String']['input'];
  id?: InputMaybe<Scalars['ID']['input']>;
  name: Scalars['String']['input'];
  order: Scalars['Int']['input'];
  price: Scalars['Decimal']['input'];
  quantity: Scalars['Int']['input'];
  rowCount: Scalars['Int']['input'];
  ruleCategories?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  ruleGroup?: InputMaybe<Scalars['ID']['input']>;
  ruleGroups?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  subcategory: Scalars['ID']['input'];
  subcategoryName?: InputMaybe<Scalars['String']['input']>;
};

export type OrderedProductSupplyOrderQuoteFormInput = {
  charter: Scalars['String']['input'];
  emailMessages?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Concrete date set when the order is approved. Empty while the order is pending review. */
  estimatedDispatchDate?: InputMaybe<Scalars['Date']['input']>;
  externalDealerId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  internalOrder?: InputMaybe<Scalars['Boolean']['input']>;
  isUrgent?: InputMaybe<Scalars['Boolean']['input']>;
  products: Array<OrderedProductFormInput>;
  quote: Scalars['ID']['input'];
  reviewStart?: InputMaybe<Scalars['DateTime']['input']>;
  shipAddress?: InputMaybe<Scalars['ID']['input']>;
  status: Scalars['String']['input'];
  warrantyClaim?: InputMaybe<Scalars['ID']['input']>;
};

export type OrderedProductType = {
  __typename?: 'OrderedProductType';
  created: Scalars['DateTime']['output'];
  createdBy?: Maybe<UserType>;
  displayName: Scalars['String']['output'];
  id: Scalars['UUID']['output'];
  productsShipped: Array<ShipmentProductType>;
  quantity: Scalars['Int']['output'];
  quantityLeft: Scalars['Int']['output'];
  quotedProduct?: Maybe<QuotedProductType>;
  supplyOrder: SupplyOrderNode;
  updated: Scalars['DateTime']['output'];
  updatedBy?: Maybe<UserType>;
  warrantyProduct?: Maybe<WarrantyProductType>;
};

export type OrganizationAddressType = {
  __typename?: 'OrganizationAddressType';
  created: Scalars['DateTime']['output'];
  createdBy?: Maybe<UserType>;
  id: Scalars['UUID']['output'];
  location: LocationType;
  organization: OrganizationType;
  postalCode: Scalars['String']['output'];
  street: Scalars['String']['output'];
  updated: Scalars['DateTime']['output'];
  updatedBy?: Maybe<UserType>;
};

export type OrganizationGroupType = {
  __typename?: 'OrganizationGroupType';
  dealerCommission?: Maybe<Scalars['Decimal']['output']>;
  id: Scalars['UUID']['output'];
  name: Scalars['String']['output'];
  organizations: Array<OrganizationType>;
  paymentMethods: Array<PaymentMethodType>;
  priceModifiers: Array<ProductPriceModifierType>;
};

export type OrganizationType = {
  __typename?: 'OrganizationType';
  accounts: Array<AccountType>;
  created: Scalars['DateTime']['output'];
  createdBy?: Maybe<UserType>;
  directions: Array<OrganizationAddressType>;
  displayName: Scalars['String']['output'];
  ecns: Array<EcnType>;
  eoriNumber?: Maybe<Scalars['String']['output']>;
  externalId: Scalars['String']['output'];
  group: OrganizationGroupType;
  id: Scalars['UUID']['output'];
  /** Indicates if the organization belongs to the European Union */
  isEu: Scalars['Boolean']['output'];
  location?: Maybe<LocationType>;
  logo?: Maybe<Scalars['String']['output']>;
  logoThumbnail?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  taxId: Scalars['String']['output'];
  updated: Scalars['DateTime']['output'];
  updatedBy?: Maybe<UserType>;
};

/** The Relay compliant `PageInfo` type, containing data necessary to paginate this connection. */
export type PageInfo = {
  __typename?: 'PageInfo';
  /** When paginating forwards, the cursor to continue. */
  endCursor?: Maybe<Scalars['String']['output']>;
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean']['output'];
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars['Boolean']['output'];
  /** When paginating backwards, the cursor to continue. */
  startCursor?: Maybe<Scalars['String']['output']>;
};

export type PartNumberType = {
  __typename?: 'PartNumberType';
  displayName: Scalars['String']['output'];
  externalId: Scalars['String']['output'];
};

export type PartsArrivalTaskEcnCancelledPartFormInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  partsArrived?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PartsArrivalTaskEcnNewPartFormInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  partsArrived?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PartsArrivalTaskMutationInput = {
  cancelledParts?: InputMaybe<Array<PartsArrivalTaskEcnCancelledPartFormInput>>;
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  newParts?: InputMaybe<Array<PartsArrivalTaskEcnNewPartFormInput>>;
};

export type PartsArrivalTaskMutationPayload = {
  __typename?: 'PartsArrivalTaskMutationPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  ecn?: Maybe<EcnType>;
  errors: Array<ErrorType>;
};

export type PaymentMethodCategoryType = {
  __typename?: 'PaymentMethodCategoryType';
  created: Scalars['DateTime']['output'];
  createdBy?: Maybe<UserType>;
  finnancied: Scalars['Boolean']['output'];
  id: Scalars['UUID']['output'];
  name: Scalars['String']['output'];
  order: Scalars['Int']['output'];
  paymentMethods: Array<PaymentMethodType>;
  published: Scalars['Boolean']['output'];
  updated: Scalars['DateTime']['output'];
  updatedBy?: Maybe<UserType>;
};

export type PaymentMethodType = {
  __typename?: 'PaymentMethodType';
  created: Scalars['DateTime']['output'];
  createdBy?: Maybe<UserType>;
  endDate?: Maybe<Scalars['Date']['output']>;
  id: Scalars['UUID']['output'];
  multiplier: Scalars['Decimal']['output'];
  name: Scalars['String']['output'];
  order: Scalars['Int']['output'];
  organizationsGroups: Array<OrganizationGroupType>;
  originalPaymentMethod: Array<QuotedPaymentMethodType>;
  paymentmethodcategorySet: Array<PaymentMethodCategoryType>;
  published: Scalars['Boolean']['output'];
  slug: Scalars['String']['output'];
  startDate?: Maybe<Scalars['Date']['output']>;
  updated: Scalars['DateTime']['output'];
  updatedBy?: Maybe<UserType>;
};

export type PricingTaskEcnCancelledPartFormInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  pricing?: InputMaybe<Scalars['Decimal']['input']>;
};

export type PricingTaskEcnNewPartFormInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  pricing?: InputMaybe<Scalars['Decimal']['input']>;
};

export type PricingTaskMutationInput = {
  cancelledParts?: InputMaybe<Array<PricingTaskEcnCancelledPartFormInput>>;
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  newParts?: InputMaybe<Array<PricingTaskEcnNewPartFormInput>>;
};

export type PricingTaskMutationPayload = {
  __typename?: 'PricingTaskMutationPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  ecn?: Maybe<EcnType>;
  errors: Array<ErrorType>;
};

export type PriotityDatum = {
  __typename?: 'PriotityDatum';
  highCount: Scalars['Int']['output'];
  label: Scalars['String']['output'];
  lowCount: Scalars['Int']['output'];
  mediumCount: Scalars['Int']['output'];
};

export type ProductFailRate = {
  __typename?: 'ProductFailRate';
  failQuantity?: Maybe<Scalars['Int']['output']>;
  percentage?: Maybe<Scalars['Float']['output']>;
  product: WarrantyProductType;
  saleQuantity?: Maybe<Scalars['Int']['output']>;
};

export type ProductNode = Node & {
  __typename?: 'ProductNode';
  bundleItems: Array<BundleProductType>;
  created: Scalars['DateTime']['output'];
  createdBy?: Maybe<UserType>;
  currentProduct?: Maybe<ProductNode>;
  description: Scalars['String']['output'];
  displayName: Scalars['String']['output'];
  displayType: Scalars['String']['output'];
  effectiveDate?: Maybe<Scalars['Date']['output']>;
  externalId: Scalars['String']['output'];
  history: ProductNodeConnection;
  /** The ID of the object */
  id: Scalars['ID']['output'];
  image?: Maybe<Scalars['String']['output']>;
  isEffective: Scalars['Boolean']['output'];
  isRemoved: Scalars['Boolean']['output'];
  lifecycle: ProductsProductLifecycleChoices;
  name: Scalars['String']['output'];
  order: Scalars['Int']['output'];
  origin?: Maybe<ProductOriginType>;
  price: Scalars['Decimal']['output'];
  priceModifiers: Array<ProductPriceModifierType>;
  /** Determines if the product is visible while quoting */
  published: Scalars['Boolean']['output'];
  replenishmentRecommendations: Array<ReplenishmentRecommendationType>;
  rowCount: Scalars['Int']['output'];
  ruleCategories: Array<CategoryType>;
  /** Legacy field for backward compatibility. Use rule_groups for multiple groups. */
  ruleGroup?: Maybe<RuleGroupType>;
  /** Rule groups this product belongs to. A product can belong to multiple groups. */
  ruleGroups: Array<RuleGroupType>;
  /** Associates the rule with a specific product. */
  rules: Array<QuoteRuleType>;
  subcategory?: Maybe<SubcategoryType>;
  type: ProductsProductTypeChoices;
  updated: Scalars['DateTime']['output'];
  updatedBy?: Maybe<UserType>;
  uuid: Scalars['UUID']['output'];
};


export type ProductNodeHistoryArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  externalIdIcontains?: InputMaybe<Scalars['String']['input']>;
  externalId_In?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  id_In?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  last?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  subcategory_Category_EnabledForAssistedQuote?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ProductNodeConnection = {
  __typename?: 'ProductNodeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<ProductNodeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `ProductNode` and its cursor. */
export type ProductNodeEdge = {
  __typename?: 'ProductNodeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<ProductNode>;
};

export type ProductOriginType = {
  __typename?: 'ProductOriginType';
  created: Scalars['DateTime']['output'];
  createdBy?: Maybe<UserType>;
  id: Scalars['UUID']['output'];
  name: Scalars['String']['output'];
  order: Scalars['Int']['output'];
  products: ProductNodeConnection;
  updated: Scalars['DateTime']['output'];
  updatedBy?: Maybe<UserType>;
};


export type ProductOriginTypeProductsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  externalIdIcontains?: InputMaybe<Scalars['String']['input']>;
  externalId_In?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  id_In?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  last?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  subcategory_Category_EnabledForAssistedQuote?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ProductPriceModifierType = {
  __typename?: 'ProductPriceModifierType';
  billingType: ProductsProductPriceModifierBillingTypeChoices;
  commissionMultiplier: Scalars['Decimal']['output'];
  created: Scalars['DateTime']['output'];
  createdBy?: Maybe<UserType>;
  enableDiscount: Scalars['Boolean']['output'];
  id: Scalars['UUID']['output'];
  organizationGroup: OrganizationGroupType;
  productExternalIds: Array<Scalars['String']['output']>;
  products: ProductNodeConnection;
  updated: Scalars['DateTime']['output'];
  updatedBy?: Maybe<UserType>;
};


export type ProductPriceModifierTypeProductsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  externalIdIcontains?: InputMaybe<Scalars['String']['input']>;
  externalId_In?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  id_In?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  last?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  subcategory_Category_EnabledForAssistedQuote?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ProductRankingDatum = {
  __typename?: 'ProductRankingDatum';
  amount?: Maybe<Scalars['Float']['output']>;
  count: Scalars['Int']['output'];
  product: ProductNode;
  ranking: Scalars['Int']['output'];
};

export type ProductSupportTaskEcnCancelledPartFormInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  supportLink?: InputMaybe<Scalars['String']['input']>;
  supportNotes?: InputMaybe<Scalars['String']['input']>;
};

export type ProductSupportTaskEcnNewPartFormInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  supportLink?: InputMaybe<Scalars['String']['input']>;
  supportNotes?: InputMaybe<Scalars['String']['input']>;
};

export type ProductSupportTaskMutationInput = {
  cancelledParts?: InputMaybe<Array<ProductSupportTaskEcnCancelledPartFormInput>>;
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  newParts?: InputMaybe<Array<ProductSupportTaskEcnNewPartFormInput>>;
};

export type ProductSupportTaskMutationPayload = {
  __typename?: 'ProductSupportTaskMutationPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  ecn?: Maybe<EcnType>;
  errors: Array<ErrorType>;
};

export type ProductType = {
  __typename?: 'ProductType';
  bundleItems: Array<BundleProductType>;
  created: Scalars['DateTime']['output'];
  createdBy?: Maybe<UserType>;
  currentProduct?: Maybe<ProductNode>;
  description: Scalars['String']['output'];
  displayMmStatus: Scalars['String']['output'];
  displayName: Scalars['String']['output'];
  displayType: Scalars['String']['output'];
  ecnId?: Maybe<Scalars['UUID']['output']>;
  effectiveDate?: Maybe<Scalars['Date']['output']>;
  externalId: Scalars['String']['output'];
  history: ProductNodeConnection;
  id: Scalars['UUID']['output'];
  image?: Maybe<Scalars['String']['output']>;
  isRemoved: Scalars['Boolean']['output'];
  lifecycle: ProductsProductLifecycleChoices;
  name: Scalars['String']['output'];
  order: Scalars['Int']['output'];
  origin?: Maybe<ProductOriginType>;
  price: Scalars['Decimal']['output'];
  priceModifiers: Array<ProductPriceModifierType>;
  /** Determines if the product is visible while quoting */
  published: Scalars['Boolean']['output'];
  replenishmentRecommendations: Array<ReplenishmentRecommendationType>;
  rowCount: Scalars['Int']['output'];
  ruleCategories: Array<CategoryType>;
  /** Legacy field for backward compatibility. Use rule_groups for multiple groups. */
  ruleGroup?: Maybe<RuleGroupType>;
  /** Rule groups this product belongs to. A product can belong to multiple groups. */
  ruleGroups: Array<RuleGroupType>;
  /** Associates the rule with a specific product. */
  rules: Array<QuoteRuleType>;
  subcategory?: Maybe<SubcategoryType>;
  type: ProductsProductTypeChoices;
  updated: Scalars['DateTime']['output'];
  updatedBy?: Maybe<UserType>;
};


export type ProductTypeHistoryArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  externalIdIcontains?: InputMaybe<Scalars['String']['input']>;
  externalId_In?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  id_In?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  last?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  subcategory_Category_EnabledForAssistedQuote?: InputMaybe<Scalars['Boolean']['input']>;
};

/** An enumeration. */
export const ProductsProductLifecycleChoices = {
  /** Commercial */
  Commercial: 'COMMERCIAL',
  /** EOL (End of Life) */
  Eol: 'EOL',
  /** Obsolete */
  Obsolete: 'OBSOLETE',
  /** Review */
  Review: 'REVIEW',
  /** Service Only */
  ServiceOnly: 'SERVICE_ONLY',
  /** Strategic */
  Strategic: 'STRATEGIC'
} as const;

export type ProductsProductLifecycleChoices = typeof ProductsProductLifecycleChoices[keyof typeof ProductsProductLifecycleChoices];
/** An enumeration. */
export const ProductsProductPriceModifierBillingTypeChoices = {
  /** Direct - To Farmer */
  Direct: 'DIRECT',
  /** Indirect - Own purchase */
  Indirect: 'INDIRECT'
} as const;

export type ProductsProductPriceModifierBillingTypeChoices = typeof ProductsProductPriceModifierBillingTypeChoices[keyof typeof ProductsProductPriceModifierBillingTypeChoices];
/** An enumeration. */
export const ProductsProductTypeChoices = {
  /** Beta */
  Beta: 'BETA',
  /** Commercial */
  Commercial: 'COMMERCIAL',
  /** Internal beta */
  InternalBeta: 'INTERNAL_BETA'
} as const;

export type ProductsProductTypeChoices = typeof ProductsProductTypeChoices[keyof typeof ProductsProductTypeChoices];
/** An enumeration. */
export const ProductsQuoteRuleOperatorChoices = {
  /** = */
  Eq: 'EQ',
  /** > */
  Gt: 'GT',
  /** >= */
  Gte: 'GTE',
  /** < */
  Lt: 'LT',
  /** <= */
  Lte: 'LTE'
} as const;

export type ProductsQuoteRuleOperatorChoices = typeof ProductsQuoteRuleOperatorChoices[keyof typeof ProductsQuoteRuleOperatorChoices];
/** An enumeration. */
export const ProductsQuoteRuleReferenceSourceChoices = {
  /** Constant (1) */
  Constant: 'CONSTANT',
  /** Selected harness count */
  HarnessCount: 'HARNESS_COUNT',
  /** equipment row count */
  SeederRowCount: 'SEEDER_ROW_COUNT',
  /** Unused equipment row count */
  UnusedSeederRowCount: 'UNUSED_SEEDER_ROW_COUNT',
  /** Used equipment row count */
  UsedSeederRowCount: 'USED_SEEDER_ROW_COUNT'
} as const;

export type ProductsQuoteRuleReferenceSourceChoices = typeof ProductsQuoteRuleReferenceSourceChoices[keyof typeof ProductsQuoteRuleReferenceSourceChoices];
/** An enumeration. */
export const ProductsQuoteRuleValueSourceChoices = {
  /** Quantity */
  Quantity: 'QUANTITY',
  /** Row count */
  RowCount: 'ROW_COUNT'
} as const;

export type ProductsQuoteRuleValueSourceChoices = typeof ProductsQuoteRuleValueSourceChoices[keyof typeof ProductsQuoteRuleValueSourceChoices];
export type PurchaseTaskEcnCancelledPartFormInput = {
  buyingDate?: InputMaybe<Scalars['Date']['input']>;
  buyingPrice?: InputMaybe<Scalars['Decimal']['input']>;
  estimatedDateArrival?: InputMaybe<Scalars['Date']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  origin?: InputMaybe<Scalars['ID']['input']>;
  supplier?: InputMaybe<Scalars['String']['input']>;
  tariffPosition?: InputMaybe<Scalars['Boolean']['input']>;
  tariffPositionNotes?: InputMaybe<Scalars['String']['input']>;
};

export type PurchaseTaskEcnNewPartFormInput = {
  buyingDate?: InputMaybe<Scalars['Date']['input']>;
  buyingPrice?: InputMaybe<Scalars['Decimal']['input']>;
  estimatedDateArrival?: InputMaybe<Scalars['Date']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  origin?: InputMaybe<Scalars['ID']['input']>;
  supplier?: InputMaybe<Scalars['String']['input']>;
  tariffPosition?: InputMaybe<Scalars['Boolean']['input']>;
  tariffPositionNotes?: InputMaybe<Scalars['String']['input']>;
};

export type Query = {
  __typename?: 'Query';
  account?: Maybe<AccountNode>;
  accountOrganizationAddresses: Array<Maybe<OrganizationAddressType>>;
  accounts?: Maybe<AccountNodeConnection>;
  activeFeatureFlag?: Maybe<FeatureFlagType>;
  activeFeatureFlags?: Maybe<Array<Maybe<FeatureFlagType>>>;
  bankInvoicePdfDisclaimer: BankInvoicePdfDisclaimerType;
  bundles: Array<BundleType>;
  categories?: Maybe<CategoryNodeConnection>;
  category?: Maybe<CategoryNode>;
  childOrganizations: Array<OrganizationType>;
  childUsers: Array<UserType>;
  closeReasons: Array<CloseReasonType>;
  contact?: Maybe<ContactNode>;
  contactTypes: Array<ContactTypeType>;
  contacts?: Maybe<ContactNodeConnection>;
  defaultTask: DefaultTaskType;
  defaultTasks: Array<DefaultTaskType>;
  draftEcn?: Maybe<DraftEcnNode>;
  draftsEcns?: Maybe<DraftEcnNodeConnection>;
  ecn?: Maybe<EcnNode>;
  ecnAnalytics?: Maybe<EcnAnalyticsType>;
  ecnConfig: EcnConfigType;
  ecnHistoryDiff: Array<Maybe<ModelDeltaType>>;
  ecns?: Maybe<EcnNodeConnection>;
  exportFileJob?: Maybe<ExportJobType>;
  factoryControlOrganizations: Array<OrganizationType>;
  failures: Array<FailureType>;
  forecastRecommendations: Array<ReplenishmentRecommendationType>;
  forecastRun?: Maybe<ForecastRunType>;
  forecastRuns: Array<ForecastRunType>;
  job?: Maybe<JobType>;
  localeTranslations: Array<LocaleTranslationType>;
  location?: Maybe<LocationType>;
  locations?: Maybe<Array<LocationType>>;
  mrpLifecycleOverrides: Array<MrpLifecycleOverrideType>;
  mrpParameters: MrpParametersType;
  notification?: Maybe<NotificationNode>;
  notifications?: Maybe<NotificationNodeConnection>;
  notificationsConfigNames: Array<Maybe<NotificationConfigNameType>>;
  orderedProduct: OrderedProductType;
  organizations: Array<OrganizationType>;
  organizationsGroups: Array<OrganizationGroupType>;
  partsNumbers: Array<PartNumberType>;
  paymentMethod: PaymentMethodType;
  paymentMethodCategories: Array<PaymentMethodCategoryType>;
  paymentMethodCategory: PaymentMethodCategoryType;
  paymentMethods: Array<PaymentMethodType>;
  product: ProductNode;
  productOrigins: Array<ProductOriginType>;
  productPriceModifiers: Array<ProductPriceModifierType>;
  products?: Maybe<ProductNodeConnection>;
  productsImages: Array<ProductNode>;
  productsStocks?: Maybe<StockResponseType>;
  quote?: Maybe<QuoteNode>;
  quoteKitMultiplier: QuoteKitMultiplierType;
  quoteKitMultipliers: Array<QuoteKitMultiplierType>;
  quoteRules: Array<QuoteRuleType>;
  quotedPaymentMethod: QuotedPaymentMethodType;
  quotes?: Maybe<QuoteNodeConnection>;
  quotesAnalytics?: Maybe<QuotesAnalyticsType>;
  roles: Array<RoleType>;
  rulesGroups: Array<RuleGroupType>;
  runtimeSettings: RuntimeSettingsType;
  sale?: Maybe<SaleNode>;
  sales?: Maybe<SaleNodeConnection>;
  salesAnalytics?: Maybe<SalesAnalyticsType>;
  salesPotentialAnalytics?: Maybe<SalesPotentialAnalyticsType>;
  seeder?: Maybe<SeederNode>;
  seederBrands: Array<SeederBrandType>;
  seederModels: Array<Maybe<SeederModelType>>;
  seeders?: Maybe<SeederNodeConnection>;
  shipment: ShipmentType;
  shipments: Array<ShipmentType>;
  subcategories: Array<SubcategoryType>;
  supplyOrder?: Maybe<SupplyOrderNode>;
  supplyOrders?: Maybe<SupplyOrderNodeConnection>;
  taskComment?: Maybe<EcnTaskCommentNode>;
  taskComments?: Maybe<EcnTaskCommentNodeConnection>;
  unreadCount: Scalars['Int']['output'];
  user?: Maybe<UserType>;
  userFeatureAccess?: Maybe<Scalars['Boolean']['output']>;
  userNode?: Maybe<UserNode>;
  userNotificationsConfigs?: Maybe<Array<NotificationConfigType>>;
  users: Array<UserType>;
  usersNodes?: Maybe<UserNodeConnection>;
  validEcnNumber: Scalars['Boolean']['output'];
  validExternalId: Scalars['Boolean']['output'];
  warrantyClaim?: Maybe<WarrantyClaimNode>;
  warrantyClaimApprovalConfig?: Maybe<WarrantyClaimApprovalConfigType>;
  warrantyClaims?: Maybe<WarrantyClaimNodeConnection>;
  warrantyClaimsAnalytics?: Maybe<WarrantyClaimsAnalyticsType>;
};


export type QueryAccountArgs = {
  id: Scalars['ID']['input'];
  uuid?: InputMaybe<Scalars['UUID']['input']>;
};


export type QueryAccountOrganizationAddressesArgs = {
  id: Scalars['UUID']['input'];
};


export type QueryAccountsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  id_In?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
  last?: InputMaybe<Scalars['Int']['input']>;
  location_Id?: InputMaybe<Scalars['ID']['input']>;
  location_Id_In?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  owner_Id?: InputMaybe<Scalars['UUID']['input']>;
  owner_Id_In?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
  query?: InputMaybe<Scalars['String']['input']>;
  user?: InputMaybe<Scalars['UUID']['input']>;
};


export type QueryActiveFeatureFlagArgs = {
  name: Scalars['String']['input'];
};


export type QueryCategoriesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  enabledForAssistedQuote?: InputMaybe<Scalars['Boolean']['input']>;
  enabledForSeeder?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  seederId?: InputMaybe<Scalars['UUID']['input']>;
};


export type QueryCategoryArgs = {
  id: Scalars['ID']['input'];
  uuid?: InputMaybe<Scalars['UUID']['input']>;
};


export type QueryContactArgs = {
  id: Scalars['ID']['input'];
};


export type QueryContactsArgs = {
  account_Id?: InputMaybe<Scalars['UUID']['input']>;
  account_Id_In?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
  account_Owner_Id?: InputMaybe<Scalars['UUID']['input']>;
  account_Owner_Id_In?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
  active?: InputMaybe<Scalars['Boolean']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  id_In?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  type_Id?: InputMaybe<Scalars['UUID']['input']>;
  type_Id_In?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
  user?: InputMaybe<Scalars['UUID']['input']>;
};


export type QueryDefaultTaskArgs = {
  id?: InputMaybe<Scalars['UUID']['input']>;
};


export type QueryDraftEcnArgs = {
  id: Scalars['ID']['input'];
  uuid?: InputMaybe<Scalars['UUID']['input']>;
};


export type QueryDraftsEcnsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  createdGte?: InputMaybe<Scalars['Date']['input']>;
  createdLte?: InputMaybe<Scalars['Date']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_In?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
};


export type QueryEcnArgs = {
  id: Scalars['ID']['input'];
  uuid?: InputMaybe<Scalars['UUID']['input']>;
};


export type QueryEcnAnalyticsArgs = {
  filters: AnalyticsFilters;
};


export type QueryEcnHistoryDiffArgs = {
  id: Scalars['UUID']['input'];
};


export type QueryEcnsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  createdBy?: InputMaybe<Scalars['UUID']['input']>;
  createdBy_In?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
  createdGte?: InputMaybe<Scalars['Date']['input']>;
  createdLte?: InputMaybe<Scalars['Date']['input']>;
  created_Date_Gte?: InputMaybe<Scalars['DateTime']['input']>;
  created_Date_Lte?: InputMaybe<Scalars['DateTime']['input']>;
  ecnNumber?: InputMaybe<Scalars['String']['input']>;
  ecnNumber_In?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  effectiveDate_Gte?: InputMaybe<Scalars['Date']['input']>;
  effectiveDate_Lte?: InputMaybe<Scalars['Date']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  partsNumbers?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  parts_CancelledParts_Part_ExternalId?: InputMaybe<Scalars['String']['input']>;
  parts_CancelledParts_Part_ExternalId_In?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  parts_NewParts_ExternalId?: InputMaybe<Scalars['String']['input']>;
  parts_NewParts_ExternalId_In?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  parts_NewParts_Type?: InputMaybe<EcnsEcnNewPartTypeChoices>;
  parts_NewParts_Type_In?: InputMaybe<Array<InputMaybe<EcnsEcnNewPartTypeChoices>>>;
  parts_Type?: InputMaybe<EcnsEcnPartTypeChoices>;
  parts_Type_In?: InputMaybe<Array<InputMaybe<EcnsEcnPartTypeChoices>>>;
  pendingTasksName?: InputMaybe<Scalars['String']['input']>;
  pendingTasksNameIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  query?: InputMaybe<Scalars['String']['input']>;
  realesedBy?: InputMaybe<Scalars['UUID']['input']>;
  realesedBy_In?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
  recipient?: InputMaybe<EcnsEcnRecipientChoices>;
  recipient_In?: InputMaybe<Array<InputMaybe<EcnsEcnRecipientChoices>>>;
  seasonPriority?: InputMaybe<EcnsEcnSeasonPriorityChoices>;
  status?: InputMaybe<EcnsEcnStatusChoices>;
  status_In?: InputMaybe<Array<InputMaybe<EcnsEcnStatusChoices>>>;
  tasksPendingForUsers?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  tasks_Done?: InputMaybe<Scalars['Boolean']['input']>;
  tasks_DoneBy?: InputMaybe<Scalars['UUID']['input']>;
  tasks_DoneBy_In?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
  tasks_Name_Iexact?: InputMaybe<EcnsEcnTaskNameChoices>;
  tasks_Roles_Users_Id?: InputMaybe<Scalars['UUID']['input']>;
  tasks_Roles_Users_Id_In?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
  user?: InputMaybe<Scalars['UUID']['input']>;
  warrantyPriority?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryExportFileJobArgs = {
  id: Scalars['String']['input'];
};


export type QueryFactoryControlOrganizationsArgs = {
  organizationGroupId?: InputMaybe<Scalars['UUID']['input']>;
};


export type QueryForecastRecommendationsArgs = {
  forecastRunId: Scalars['UUID']['input'];
  onlyWithOrders?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryForecastRunArgs = {
  id: Scalars['UUID']['input'];
};


export type QueryJobArgs = {
  id: Scalars['String']['input'];
};


export type QueryLocationArgs = {
  id: Scalars['ID']['input'];
};


export type QueryLocationsArgs = {
  id?: InputMaybe<Scalars['Int']['input']>;
  level?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  parentDecendatsId?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
};


export type QueryNotificationArgs = {
  id: Scalars['ID']['input'];
  uuid?: InputMaybe<Scalars['UUID']['input']>;
};


export type QueryNotificationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  isRead?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryOrderedProductArgs = {
  id?: InputMaybe<Scalars['UUID']['input']>;
};


export type QueryPaymentMethodArgs = {
  id?: InputMaybe<Scalars['UUID']['input']>;
};


export type QueryPaymentMethodCategoryArgs = {
  id: Scalars['UUID']['input'];
};


export type QueryPaymentMethodsArgs = {
  categoryId?: InputMaybe<Scalars['UUID']['input']>;
  organizationId?: InputMaybe<Scalars['UUID']['input']>;
};


export type QueryProductArgs = {
  id: Scalars['ID']['input'];
  uuid?: InputMaybe<Scalars['UUID']['input']>;
};


export type QueryProductPriceModifiersArgs = {
  accountId: Scalars['UUID']['input'];
};


export type QueryProductsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  externalIdIcontains?: InputMaybe<Scalars['String']['input']>;
  externalId_In?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  id_In?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  last?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  subcategory_Category_EnabledForAssistedQuote?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryProductsImagesArgs = {
  externalIds: Array<Scalars['String']['input']>;
};


export type QueryProductsStocksArgs = {
  externalIds: Array<InputMaybe<Scalars['String']['input']>>;
};


export type QueryQuoteArgs = {
  id: Scalars['ID']['input'];
  uuid?: InputMaybe<Scalars['UUID']['input']>;
};


export type QueryQuoteKitMultiplierArgs = {
  id?: InputMaybe<Scalars['UUID']['input']>;
};


export type QueryQuotedPaymentMethodArgs = {
  id?: InputMaybe<Scalars['UUID']['input']>;
};


export type QueryQuotesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  billingType?: InputMaybe<QuotesQuoteBillingTypeChoices>;
  billingType_Iexact?: InputMaybe<QuotesQuoteBillingTypeChoices>;
  contact_Account_Id?: InputMaybe<Scalars['UUID']['input']>;
  contact_Account_Id_In?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
  contact_Account_Owner_Id?: InputMaybe<Scalars['UUID']['input']>;
  contact_Account_Owner_Id_In?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
  contact_Id?: InputMaybe<Scalars['UUID']['input']>;
  createdBy?: InputMaybe<Scalars['UUID']['input']>;
  createdGte?: InputMaybe<Scalars['Date']['input']>;
  createdLte?: InputMaybe<Scalars['Date']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  product?: InputMaybe<Scalars['String']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<QuotesQuoteStatusChoices>;
  status_Iexact?: InputMaybe<QuotesQuoteStatusChoices>;
  user?: InputMaybe<Scalars['UUID']['input']>;
};


export type QueryQuotesAnalyticsArgs = {
  filters: AnalyticsFilters;
};


export type QuerySaleArgs = {
  id: Scalars['ID']['input'];
  uuid?: InputMaybe<Scalars['UUID']['input']>;
};


export type QuerySalesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  createdGte?: InputMaybe<Scalars['Date']['input']>;
  createdLte?: InputMaybe<Scalars['Date']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  quote_Contact_Account_Id?: InputMaybe<Scalars['UUID']['input']>;
  quote_Contact_Account_Id_In?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
  quote_Contact_Account_Owner_Id?: InputMaybe<Scalars['UUID']['input']>;
  quote_Contact_Account_Owner_Id_In?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
  quote_Contact_Id?: InputMaybe<Scalars['UUID']['input']>;
  quote_Contact_Id_In?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
  user?: InputMaybe<Scalars['UUID']['input']>;
};


export type QuerySalesAnalyticsArgs = {
  filters: AnalyticsFilters;
};


export type QuerySalesPotentialAnalyticsArgs = {
  filters: AnalyticsFilters;
};


export type QuerySeederArgs = {
  id: Scalars['ID']['input'];
  uuid?: InputMaybe<Scalars['UUID']['input']>;
};


export type QuerySeederBrandsArgs = {
  organizationId?: InputMaybe<Scalars['UUID']['input']>;
};


export type QuerySeederModelsArgs = {
  seederBrandId?: InputMaybe<Scalars['UUID']['input']>;
};


export type QuerySeedersArgs = {
  account?: InputMaybe<Scalars['UUID']['input']>;
  account_Id?: InputMaybe<Scalars['UUID']['input']>;
  account_Id_In?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
  account_In?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
};


export type QueryShipmentArgs = {
  id?: InputMaybe<Scalars['UUID']['input']>;
};


export type QuerySupplyOrderArgs = {
  id: Scalars['ID']['input'];
  uuid?: InputMaybe<Scalars['UUID']['input']>;
};


export type QuerySupplyOrdersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  createdGte?: InputMaybe<Scalars['Date']['input']>;
  createdLte?: InputMaybe<Scalars['Date']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  owner?: InputMaybe<Scalars['UUID']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  quote_Contact_Account_Id?: InputMaybe<Scalars['UUID']['input']>;
  quote_Contact_Account_Id_In?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
  quote_Contact_Id?: InputMaybe<Scalars['UUID']['input']>;
  quote_Contact_Id_In?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
  rgy?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<SupplyOrdersSupplyOrderStatusChoices>;
  status_In?: InputMaybe<Array<InputMaybe<SupplyOrdersSupplyOrderStatusChoices>>>;
  type?: InputMaybe<Scalars['String']['input']>;
  user?: InputMaybe<Scalars['UUID']['input']>;
};


export type QueryTaskCommentArgs = {
  id: Scalars['ID']['input'];
  uuid?: InputMaybe<Scalars['UUID']['input']>;
};


export type QueryTaskCommentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  task_Id?: InputMaybe<Scalars['UUID']['input']>;
};


export type QueryUserFeatureAccessArgs = {
  featureName: Scalars['String']['input'];
};


export type QueryUserNodeArgs = {
  id: Scalars['ID']['input'];
  uuid?: InputMaybe<Scalars['UUID']['input']>;
};


export type QueryUsersNodesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  ecnRoles_Isnull?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasEcnRole?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryValidEcnNumberArgs = {
  ecnNumber: Scalars['String']['input'];
  id?: InputMaybe<Scalars['UUID']['input']>;
};


export type QueryValidExternalIdArgs = {
  externalId: Scalars['String']['input'];
  ignoreId?: InputMaybe<Scalars['UUID']['input']>;
};


export type QueryWarrantyClaimArgs = {
  id: Scalars['ID']['input'];
  uuid?: InputMaybe<Scalars['UUID']['input']>;
};


export type QueryWarrantyClaimsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  contact_Account_Id?: InputMaybe<Scalars['UUID']['input']>;
  contact_Account_Owner_Id?: InputMaybe<Scalars['UUID']['input']>;
  contact_Id?: InputMaybe<Scalars['UUID']['input']>;
  contact_Id_In?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
  created?: InputMaybe<Scalars['Date']['input']>;
  createdBy_Id?: InputMaybe<Scalars['UUID']['input']>;
  createdGte?: InputMaybe<Scalars['Date']['input']>;
  createdLte?: InputMaybe<Scalars['Date']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  inspectionReviewStatus?: InputMaybe<Scalars['String']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  warrantyClaimType?: InputMaybe<WarrantyClaimsWarrantyClaimWarrantyClaimTypeChoices>;
  warrantyClaimType_Iexact?: InputMaybe<WarrantyClaimsWarrantyClaimWarrantyClaimTypeChoices>;
};


export type QueryWarrantyClaimsAnalyticsArgs = {
  filters: AnalyticsFilters;
};

export type QuoteCloseReasonInputType = {
  description: Scalars['String']['input'];
  quote: Scalars['String']['input'];
};

export type QuoteCloseReasonType = {
  __typename?: 'QuoteCloseReasonType';
  created: Scalars['DateTime']['output'];
  createdBy?: Maybe<UserType>;
  description: Scalars['String']['output'];
  id: Scalars['UUID']['output'];
  quote: QuoteNode;
  updated: Scalars['DateTime']['output'];
  updatedBy?: Maybe<UserType>;
};

export type QuoteKitMultiplierType = {
  __typename?: 'QuoteKitMultiplierType';
  created: Scalars['DateTime']['output'];
  createdBy?: Maybe<UserType>;
  id: Scalars['UUID']['output'];
  /** Use only for urgent suply orders */
  isUrgentOrder: Scalars['Boolean']['output'];
  multiplier: Scalars['Decimal']['output'];
  name: Scalars['String']['output'];
  order: Scalars['Int']['output'];
  published: Scalars['Boolean']['output'];
  quoteSet: QuoteNodeConnection;
  updated: Scalars['DateTime']['output'];
  updatedBy?: Maybe<UserType>;
};


export type QuoteKitMultiplierTypeQuoteSetArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  billingType?: InputMaybe<QuotesQuoteBillingTypeChoices>;
  billingType_Iexact?: InputMaybe<QuotesQuoteBillingTypeChoices>;
  contact_Account_Id?: InputMaybe<Scalars['UUID']['input']>;
  contact_Account_Id_In?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
  contact_Account_Owner_Id?: InputMaybe<Scalars['UUID']['input']>;
  contact_Account_Owner_Id_In?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
  contact_Id?: InputMaybe<Scalars['UUID']['input']>;
  createdBy?: InputMaybe<Scalars['UUID']['input']>;
  createdGte?: InputMaybe<Scalars['Date']['input']>;
  createdLte?: InputMaybe<Scalars['Date']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  product?: InputMaybe<Scalars['String']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<QuotesQuoteStatusChoices>;
  status_Iexact?: InputMaybe<QuotesQuoteStatusChoices>;
  user?: InputMaybe<Scalars['UUID']['input']>;
};

export type QuoteNode = Node & {
  __typename?: 'QuoteNode';
  additionalChargesDescription?: Maybe<Scalars['String']['output']>;
  additionalChargesValue?: Maybe<Scalars['Decimal']['output']>;
  billingType: QuotesQuoteBillingTypeChoices;
  closeReason?: Maybe<QuoteCloseReasonType>;
  contact: ContactType;
  created: Scalars['DateTime']['output'];
  createdBy?: Maybe<UserType>;
  displayBillingType: Scalars['String']['output'];
  displayId: Scalars['Int']['output'];
  displayName: Scalars['String']['output'];
  /** The ID of the object */
  id: Scalars['ID']['output'];
  kitMultiplier?: Maybe<QuoteKitMultiplierType>;
  notes?: Maybe<Scalars['String']['output']>;
  paymentMethods: Array<QuotedPaymentMethodType>;
  pdfs: Array<QuotePdfType>;
  products: Array<QuotedProductType>;
  rowCount?: Maybe<Scalars['Int']['output']>;
  sale?: Maybe<SaleNode>;
  seeder?: Maybe<SeederType>;
  status?: Maybe<QuotesQuoteStatusChoices>;
  statusDisplay: Scalars['String']['output'];
  supplyOrder?: Maybe<SupplyOrderNode>;
  updated: Scalars['DateTime']['output'];
  updatedBy?: Maybe<UserType>;
  uuid: Scalars['UUID']['output'];
};

export type QuoteNodeConnection = {
  __typename?: 'QuoteNodeConnection';
  count: Scalars['Int']['output'];
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<QuoteNodeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `QuoteNode` and its cursor. */
export type QuoteNodeEdge = {
  __typename?: 'QuoteNodeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<QuoteNode>;
};

export type QuotePdfType = {
  __typename?: 'QuotePDFType';
  created: Scalars['DateTime']['output'];
  createdBy?: Maybe<UserType>;
  emailStatus?: Maybe<Scalars['String']['output']>;
  file?: Maybe<Scalars['String']['output']>;
  id: Scalars['UUID']['output'];
  paymentMethod?: Maybe<QuotedPaymentMethodType>;
  productDisplay: QuotesQuotePdfProductDisplayChoices;
  quote: QuoteNode;
  recipient: Scalars['String']['output'];
  type: QuotesQuotePdfTypeChoices;
  typeDisplay?: Maybe<Scalars['String']['output']>;
  updated: Scalars['DateTime']['output'];
  updatedBy?: Maybe<UserType>;
};

export type QuoteRuleType = {
  __typename?: 'QuoteRuleType';
  created: Scalars['DateTime']['output'];
  createdBy?: Maybe<UserType>;
  /** Defines a description for the rule. */
  description?: Maybe<Scalars['String']['output']>;
  /** Defines a description for the rule. */
  descriptionBgBg?: Maybe<Scalars['String']['output']>;
  /** Defines a description for the rule. */
  descriptionDeDe?: Maybe<Scalars['String']['output']>;
  /** Defines a description for the rule. */
  descriptionEnUs?: Maybe<Scalars['String']['output']>;
  /** Defines a description for the rule. */
  descriptionEsAr?: Maybe<Scalars['String']['output']>;
  /** Defines a description for the rule. */
  descriptionFrFr?: Maybe<Scalars['String']['output']>;
  /** Defines a description for the rule. */
  descriptionHuHu?: Maybe<Scalars['String']['output']>;
  /** Defines a description for the rule. */
  descriptionPlPl?: Maybe<Scalars['String']['output']>;
  /** Defines a description for the rule. */
  descriptionRoRo?: Maybe<Scalars['String']['output']>;
  /** Defines a description for the rule. */
  descriptionSlSi?: Maybe<Scalars['String']['output']>;
  /** Defines a description for the rule. */
  descriptionSrRs?: Maybe<Scalars['String']['output']>;
  /** Defines a description for the rule. */
  descriptionUkUa?: Maybe<Scalars['String']['output']>;
  /** Defines the error messages for the rule. */
  errorMessage?: Maybe<Scalars['String']['output']>;
  /** Defines the error messages for the rule. */
  errorMessageBgBg?: Maybe<Scalars['String']['output']>;
  /** Defines the error messages for the rule. */
  errorMessageDeDe?: Maybe<Scalars['String']['output']>;
  /** Defines the error messages for the rule. */
  errorMessageEnUs?: Maybe<Scalars['String']['output']>;
  /** Defines the error messages for the rule. */
  errorMessageEsAr?: Maybe<Scalars['String']['output']>;
  /** Defines the error messages for the rule. */
  errorMessageFrFr?: Maybe<Scalars['String']['output']>;
  /** Defines the error messages for the rule. */
  errorMessageHuHu?: Maybe<Scalars['String']['output']>;
  /** Defines the error messages for the rule. */
  errorMessagePlPl?: Maybe<Scalars['String']['output']>;
  /** Defines the error messages for the rule. */
  errorMessageRoRo?: Maybe<Scalars['String']['output']>;
  /** Defines the error messages for the rule. */
  errorMessageSlSi?: Maybe<Scalars['String']['output']>;
  /** Defines the error messages for the rule. */
  errorMessageSrRs?: Maybe<Scalars['String']['output']>;
  /** Defines the error messages for the rule. */
  errorMessageUkUa?: Maybe<Scalars['String']['output']>;
  /** Associates the rule with a rule group. */
  group?: Maybe<RuleGroupType>;
  id: Scalars['UUID']['output'];
  image?: Maybe<Scalars['String']['output']>;
  /** Defines the operator to use when comparing needed and requested quantity. */
  operator: ProductsQuoteRuleOperatorChoices;
  order: Scalars['Int']['output'];
  /** Prioritize rule in case it is in more than one category. */
  prioritizeRule: Scalars['Boolean']['output'];
  /** Associates the rule with a specific product. */
  product?: Maybe<ProductNode>;
  /** Associates the rule with a specific product category. */
  productCategory?: Maybe<CategoryType>;
  /** Defines the multiplier to apply to obtain the needed quantity. */
  referenceMultiplier: Scalars['Float']['output'];
  /** Defines the value that is needed to determine the needed quantity. */
  referenceSource: ProductsQuoteRuleReferenceSourceChoices;
  updated: Scalars['DateTime']['output'];
  updatedBy?: Maybe<UserType>;
  useForInitialValue: Scalars['Boolean']['output'];
  useForValidation: Scalars['Boolean']['output'];
  /** Defines which product field to sum to determine the requested quantity. */
  valueSource: ProductsQuoteRuleValueSourceChoices;
};

export type QuotedPaymentMethodFormInput = {
  dealerCommission?: InputMaybe<Scalars['Decimal']['input']>;
  extraMultiplier: Scalars['Decimal']['input'];
  finnancied?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  isCustom?: InputMaybe<Scalars['Boolean']['input']>;
  multiplier: Scalars['Decimal']['input'];
  name: Scalars['String']['input'];
  order: Scalars['Int']['input'];
  originalPaymentMethod?: InputMaybe<Scalars['ID']['input']>;
  slug: Scalars['String']['input'];
};

export type QuotedPaymentMethodType = {
  __typename?: 'QuotedPaymentMethodType';
  created: Scalars['DateTime']['output'];
  createdBy?: Maybe<UserType>;
  dealerCommission?: Maybe<Scalars['Decimal']['output']>;
  extraMultiplier: Scalars['Decimal']['output'];
  finnancied: Scalars['Boolean']['output'];
  id: Scalars['UUID']['output'];
  isCustom: Scalars['Boolean']['output'];
  multiplier: Scalars['Decimal']['output'];
  name: Scalars['String']['output'];
  order: Scalars['Int']['output'];
  originalPaymentMethod?: Maybe<PaymentMethodType>;
  quote: QuoteNode;
  quotepdfSet: Array<QuotePdfType>;
  sale?: Maybe<SaleNode>;
  slug: Scalars['String']['output'];
  updated: Scalars['DateTime']['output'];
  updatedBy?: Maybe<UserType>;
};

export type QuotedProductFormInput = {
  bundle?: InputMaybe<Scalars['ID']['input']>;
  bundleMultiplier?: InputMaybe<Scalars['Decimal']['input']>;
  bundleName?: InputMaybe<Scalars['String']['input']>;
  bundleQuantity?: InputMaybe<Scalars['Int']['input']>;
  categoryName?: InputMaybe<Scalars['String']['input']>;
  commissionMultiplier: Scalars['Decimal']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  enableDiscount?: InputMaybe<Scalars['Boolean']['input']>;
  externalId: Scalars['String']['input'];
  id?: InputMaybe<Scalars['ID']['input']>;
  name: Scalars['String']['input'];
  order: Scalars['Int']['input'];
  price: Scalars['Decimal']['input'];
  quantity: Scalars['Int']['input'];
  rowCount: Scalars['Int']['input'];
  ruleCategories?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  ruleGroup?: InputMaybe<Scalars['ID']['input']>;
  ruleGroups?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  subcategory: Scalars['ID']['input'];
  subcategoryName?: InputMaybe<Scalars['String']['input']>;
};

export type QuotedProductType = {
  __typename?: 'QuotedProductType';
  bundle?: Maybe<BundleType>;
  bundleMultiplier?: Maybe<Scalars['Decimal']['output']>;
  bundleName: Scalars['String']['output'];
  bundleQuantity?: Maybe<Scalars['Int']['output']>;
  categoryName: Scalars['String']['output'];
  commissionMultiplier: Scalars['Decimal']['output'];
  created: Scalars['DateTime']['output'];
  createdBy?: Maybe<UserType>;
  description: Scalars['String']['output'];
  enableDiscount: Scalars['Boolean']['output'];
  externalId: Scalars['String']['output'];
  id: Scalars['UUID']['output'];
  name: Scalars['String']['output'];
  order: Scalars['Int']['output'];
  orderedProducts: Array<OrderedProductType>;
  origin?: Maybe<ProductOriginType>;
  price: Scalars['Decimal']['output'];
  quantity: Scalars['Int']['output'];
  quote: QuoteNode;
  rowCount: Scalars['Int']['output'];
  ruleCategories: Array<CategoryType>;
  /** Legacy field for backward compatibility. Use rule_groups for multiple groups. */
  ruleGroup?: Maybe<RuleGroupType>;
  /** Rule groups this product belongs to. A product can belong to multiple groups. */
  ruleGroups: Array<RuleGroupType>;
  subcategory?: Maybe<SubcategoryType>;
  subcategoryName: Scalars['String']['output'];
  updated: Scalars['DateTime']['output'];
  updatedBy?: Maybe<UserType>;
};

export type QuotesAnalyticsType = {
  __typename?: 'QuotesAnalyticsType';
  amount: Scalars['Float']['output'];
  byAccount: Array<AmountDatum>;
  byBillingType: Array<AmountDatum>;
  byCloseReason: Array<AmountDatum>;
  byDate: Array<DateSeriesDatum>;
  byOrganization: Array<AmountDatum>;
  byPaymentMethod: Array<AmountDatum>;
  bySeederBrand: Array<AmountDatum>;
  bySeederModel: Array<AmountDatum>;
  byStatus: Array<AmountDatum>;
  byUser: Array<AmountDatum>;
  count: Scalars['Int']['output'];
  productRanking: Array<ProductRankingDatum>;
};

/** An enumeration. */
export const QuotesQuoteBillingTypeChoices = {
  /** Direct - To Farmer */
  Direct: 'DIRECT',
  /** Indirect - Own purchase */
  Indirect: 'INDIRECT'
} as const;

export type QuotesQuoteBillingTypeChoices = typeof QuotesQuoteBillingTypeChoices[keyof typeof QuotesQuoteBillingTypeChoices];
/** An enumeration. */
export const QuotesQuotePdfProductDisplayChoices = {
  /** By category */
  ByCategory: 'BY_CATEGORY',
  /** Default */
  Default: 'DEFAULT'
} as const;

export type QuotesQuotePdfProductDisplayChoices = typeof QuotesQuotePdfProductDisplayChoices[keyof typeof QuotesQuotePdfProductDisplayChoices];
/** An enumeration. */
export const QuotesQuotePdfTypeChoices = {
  /** Client */
  Client: 'CLIENT',
  /** Internal */
  Internal: 'INTERNAL'
} as const;

export type QuotesQuotePdfTypeChoices = typeof QuotesQuotePdfTypeChoices[keyof typeof QuotesQuotePdfTypeChoices];
/** An enumeration. */
export const QuotesQuoteStatusChoices = {
  /** Closed */
  Closed: 'CLOSED',
  /** In Progress */
  InProgress: 'IN_PROGRESS',
  /** In Sale */
  InSale: 'IN_SALE',
  /** In Supply Order */
  InSupplyOrder: 'IN_SUPPLY_ORDER'
} as const;

export type QuotesQuoteStatusChoices = typeof QuotesQuoteStatusChoices[keyof typeof QuotesQuoteStatusChoices];
/** An enumeration. */
export const Rgy = {
  Green: 'GREEN',
  Red: 'RED',
  Yellow: 'YELLOW'
} as const;

export type Rgy = typeof Rgy[keyof typeof Rgy];
export type RejectWarrantyClaimRequestMutationInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  warrantyClaim: Scalars['ID']['input'];
};

export type RejectWarrantyClaimRequestMutationPayload = {
  __typename?: 'RejectWarrantyClaimRequestMutationPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<ErrorType>;
  warrantyClaimReview?: Maybe<WarrantyClaimReviewType>;
};

export type ReplenishmentRecommendationType = {
  __typename?: 'ReplenishmentRecommendationType';
  coverageVsHistorical?: Maybe<Scalars['Decimal']['output']>;
  coverageVsQuotes?: Maybe<Scalars['Decimal']['output']>;
  finalOrder: Scalars['Int']['output'];
  historicalGap: Scalars['Int']['output'];
  id: Scalars['UUID']['output'];
  manualInput?: Maybe<Scalars['Int']['output']>;
  maxOrderCap: Scalars['Int']['output'];
  minStockGap: Scalars['Int']['output'];
  minimumStock: Scalars['Int']['output'];
  orderValue: Scalars['Decimal']['output'];
  priority: Scalars['String']['output'];
  product: ProductType;
  quoteNeed: Scalars['Int']['output'];
  reasonCode: Scalars['String']['output'];
  suggestedOrder: Scalars['Int']['output'];
};

export type ResetPasswordMutationInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
};

export type ResetPasswordMutationPayload = {
  __typename?: 'ResetPasswordMutationPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  email: Scalars['String']['output'];
  errors?: Maybe<Array<Maybe<ErrorType>>>;
};

export type RoleType = {
  __typename?: 'RoleType';
  created: Scalars['DateTime']['output'];
  createdBy?: Maybe<UserType>;
  ecns: Array<EcnType>;
  id: Scalars['UUID']['output'];
  name: Scalars['String']['output'];
  updated: Scalars['DateTime']['output'];
  updatedBy?: Maybe<UserType>;
  userSet: Array<UserType>;
};

export type RuleGroupType = {
  __typename?: 'RuleGroupType';
  created: Scalars['DateTime']['output'];
  createdBy?: Maybe<UserType>;
  id: Scalars['UUID']['output'];
  name: Scalars['String']['output'];
  /** Legacy field for backward compatibility. Use rule_groups for multiple groups. */
  productSet: ProductNodeConnection;
  /** Rule groups this product belongs to. A product can belong to multiple groups. */
  productsProductProducts: ProductNodeConnection;
  /** Legacy field for backward compatibility. Use rule_groups for multiple groups. */
  quotedproductSet: Array<QuotedProductType>;
  /** Rule groups this product belongs to. A product can belong to multiple groups. */
  quotesQuotedproductProducts: Array<QuotedProductType>;
  /** Associates the rule with a rule group. */
  rules: Array<QuoteRuleType>;
  updated: Scalars['DateTime']['output'];
  updatedBy?: Maybe<UserType>;
  /** Rule groups this product belongs to. A product can belong to multiple groups. */
  warrantyClaimsWarrantyproductProducts: Array<WarrantyProductType>;
  /** Legacy field for backward compatibility. Use rule_groups for multiple groups. */
  warrantyproductSet: Array<WarrantyProductType>;
};


export type RuleGroupTypeProductSetArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  externalIdIcontains?: InputMaybe<Scalars['String']['input']>;
  externalId_In?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  id_In?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  last?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  subcategory_Category_EnabledForAssistedQuote?: InputMaybe<Scalars['Boolean']['input']>;
};


export type RuleGroupTypeProductsProductProductsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  externalIdIcontains?: InputMaybe<Scalars['String']['input']>;
  externalId_In?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  id_In?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  last?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  subcategory_Category_EnabledForAssistedQuote?: InputMaybe<Scalars['Boolean']['input']>;
};

export type RunForecast = {
  __typename?: 'RunForecast';
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  forecastRun?: Maybe<ForecastRunType>;
};

export type RuntimeSettingsType = {
  __typename?: 'RuntimeSettingsType';
  datastudioUrl?: Maybe<Scalars['String']['output']>;
  /** Amount of days for a quote to expire */
  expireQuoteTime: Scalars['Int']['output'];
  featureTermsAndConditions: Scalars['Boolean']['output'];
  gefcoTrackingInstructions?: Maybe<Scalars['String']['output']>;
  gefcoTrackingUrl?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  /** Size in kb */
  maxVideoSize: Scalars['Int']['output'];
  quotePdfDisclaimer: Scalars['String']['output'];
  signaturesInDisclaimer: Scalars['Boolean']['output'];
  spreadsheetId?: Maybe<Scalars['String']['output']>;
  spreadsheetRange: Scalars['String']['output'];
  spreadsheetSheetName?: Maybe<Scalars['String']['output']>;
  spreedsheetAvailableQuantityColumnName?: Maybe<Scalars['String']['output']>;
  spreedsheetExternalIdColumnName?: Maybe<Scalars['String']['output']>;
  stockSpreadsheetUrl?: Maybe<Scalars['String']['output']>;
  taxIdLabel: Scalars['String']['output'];
  termsAndConditions?: Maybe<Scalars['String']['output']>;
  termsAndConditionsUpdatedAt?: Maybe<Scalars['String']['output']>;
  tinymceUrl?: Maybe<Scalars['String']['output']>;
  /** Multiplier applied to urgent supply orders (e.g. 1.05 = 5% surcharge) */
  urgentOrderSurcharge: Scalars['Decimal']['output'];
};

export type SaleNode = Node & {
  __typename?: 'SaleNode';
  created: Scalars['DateTime']['output'];
  createdBy?: Maybe<UserType>;
  displayName: Scalars['String']['output'];
  /** The ID of the object */
  id: Scalars['ID']['output'];
  paymentMethod: QuotedPaymentMethodType;
  quote: QuoteNode;
  updated: Scalars['DateTime']['output'];
  updatedBy?: Maybe<UserType>;
  uuid: Scalars['UUID']['output'];
};

export type SaleNodeConnection = {
  __typename?: 'SaleNodeConnection';
  count: Scalars['Int']['output'];
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<SaleNodeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `SaleNode` and its cursor. */
export type SaleNodeEdge = {
  __typename?: 'SaleNodeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<SaleNode>;
};

export type SalesAnalyticsType = {
  __typename?: 'SalesAnalyticsType';
  amount: Scalars['Float']['output'];
  byAccount: Array<AmountDatum>;
  byBillingType: Array<AmountDatum>;
  byDate: Array<DateSeriesDatum>;
  byOrganization: Array<AmountDatum>;
  byPaymentMethod: Array<AmountDatum>;
  bySeederBrand: Array<AmountDatum>;
  bySeederModel: Array<AmountDatum>;
  byUser: Array<AmountDatum>;
  count: Scalars['Int']['output'];
  productRanking: Array<ProductRankingDatum>;
};

export type SalesPotentialAnalyticsType = {
  __typename?: 'SalesPotentialAnalyticsType';
  byCategory: Array<AmountDatum>;
  byMeterType: Array<AmountDatum>;
  bySeederBrand: Array<AmountDatum>;
  rowsCount: Scalars['Int']['output'];
  seedersCount: Scalars['Int']['output'];
};

export type SeederBrandType = {
  __typename?: 'SeederBrandType';
  created: Scalars['DateTime']['output'];
  createdBy?: Maybe<UserType>;
  id: Scalars['UUID']['output'];
  models: Array<SeederModelType>;
  name: Scalars['String']['output'];
  order: Scalars['Int']['output'];
  seederSet: Array<SeederType>;
  updated: Scalars['DateTime']['output'];
  updatedBy?: Maybe<UserType>;
};

export type SeederModelType = {
  __typename?: 'SeederModelType';
  brand: SeederBrandType;
  created: Scalars['DateTime']['output'];
  createdBy?: Maybe<UserType>;
  id: Scalars['UUID']['output'];
  name: Scalars['String']['output'];
  order: Scalars['Int']['output'];
  seederSet: Array<SeederType>;
  updated: Scalars['DateTime']['output'];
  updatedBy?: Maybe<UserType>;
};

export type SeederNode = Node & {
  __typename?: 'SeederNode';
  account: AccountType;
  brand: SeederBrandType;
  created: Scalars['DateTime']['output'];
  createdBy?: Maybe<UserType>;
  displayName: Scalars['String']['output'];
  /** The ID of the object */
  id: Scalars['ID']['output'];
  installedCategories: Array<CategoryType>;
  meterType: SeedersSeederMeterTypeChoices;
  meterTypeDisplay: Scalars['String']['output'];
  model?: Maybe<SeederModelType>;
  quotes: QuoteNodeConnection;
  rowCount: Scalars['Int']['output'];
  updated: Scalars['DateTime']['output'];
  updatedBy?: Maybe<UserType>;
  uuid: Scalars['UUID']['output'];
  warrantyClaims: WarrantyClaimNodeConnection;
  year?: Maybe<Scalars['Int']['output']>;
};


export type SeederNodeQuotesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  billingType?: InputMaybe<QuotesQuoteBillingTypeChoices>;
  billingType_Iexact?: InputMaybe<QuotesQuoteBillingTypeChoices>;
  contact_Account_Id?: InputMaybe<Scalars['UUID']['input']>;
  contact_Account_Id_In?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
  contact_Account_Owner_Id?: InputMaybe<Scalars['UUID']['input']>;
  contact_Account_Owner_Id_In?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
  contact_Id?: InputMaybe<Scalars['UUID']['input']>;
  createdBy?: InputMaybe<Scalars['UUID']['input']>;
  createdGte?: InputMaybe<Scalars['Date']['input']>;
  createdLte?: InputMaybe<Scalars['Date']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  product?: InputMaybe<Scalars['String']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<QuotesQuoteStatusChoices>;
  status_Iexact?: InputMaybe<QuotesQuoteStatusChoices>;
  user?: InputMaybe<Scalars['UUID']['input']>;
};


export type SeederNodeWarrantyClaimsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  contact_Account_Id?: InputMaybe<Scalars['UUID']['input']>;
  contact_Account_Owner_Id?: InputMaybe<Scalars['UUID']['input']>;
  contact_Id?: InputMaybe<Scalars['UUID']['input']>;
  contact_Id_In?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
  created?: InputMaybe<Scalars['Date']['input']>;
  createdBy_Id?: InputMaybe<Scalars['UUID']['input']>;
  createdGte?: InputMaybe<Scalars['Date']['input']>;
  createdLte?: InputMaybe<Scalars['Date']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  inspectionReviewStatus?: InputMaybe<Scalars['String']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  warrantyClaimType?: InputMaybe<WarrantyClaimsWarrantyClaimWarrantyClaimTypeChoices>;
  warrantyClaimType_Iexact?: InputMaybe<WarrantyClaimsWarrantyClaimWarrantyClaimTypeChoices>;
};

export type SeederNodeConnection = {
  __typename?: 'SeederNodeConnection';
  count: Scalars['Int']['output'];
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<SeederNodeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `SeederNode` and its cursor. */
export type SeederNodeEdge = {
  __typename?: 'SeederNodeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<SeederNode>;
};

export type SeederType = {
  __typename?: 'SeederType';
  account: AccountType;
  brand: SeederBrandType;
  created: Scalars['DateTime']['output'];
  createdBy?: Maybe<UserType>;
  displayName: Scalars['String']['output'];
  id: Scalars['UUID']['output'];
  installedCategories: Array<CategoryType>;
  meterType: SeedersSeederMeterTypeChoices;
  meterTypeDisplay: Scalars['String']['output'];
  model?: Maybe<SeederModelType>;
  quotes: QuoteNodeConnection;
  rowCount: Scalars['Int']['output'];
  updated: Scalars['DateTime']['output'];
  updatedBy?: Maybe<UserType>;
  uuid: Scalars['UUID']['output'];
  warrantyClaims: WarrantyClaimNodeConnection;
  year?: Maybe<Scalars['Int']['output']>;
};


export type SeederTypeQuotesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  billingType?: InputMaybe<QuotesQuoteBillingTypeChoices>;
  billingType_Iexact?: InputMaybe<QuotesQuoteBillingTypeChoices>;
  contact_Account_Id?: InputMaybe<Scalars['UUID']['input']>;
  contact_Account_Id_In?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
  contact_Account_Owner_Id?: InputMaybe<Scalars['UUID']['input']>;
  contact_Account_Owner_Id_In?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
  contact_Id?: InputMaybe<Scalars['UUID']['input']>;
  createdBy?: InputMaybe<Scalars['UUID']['input']>;
  createdGte?: InputMaybe<Scalars['Date']['input']>;
  createdLte?: InputMaybe<Scalars['Date']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  product?: InputMaybe<Scalars['String']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<QuotesQuoteStatusChoices>;
  status_Iexact?: InputMaybe<QuotesQuoteStatusChoices>;
  user?: InputMaybe<Scalars['UUID']['input']>;
};


export type SeederTypeWarrantyClaimsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  contact_Account_Id?: InputMaybe<Scalars['UUID']['input']>;
  contact_Account_Owner_Id?: InputMaybe<Scalars['UUID']['input']>;
  contact_Id?: InputMaybe<Scalars['UUID']['input']>;
  contact_Id_In?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
  created?: InputMaybe<Scalars['Date']['input']>;
  createdBy_Id?: InputMaybe<Scalars['UUID']['input']>;
  createdGte?: InputMaybe<Scalars['Date']['input']>;
  createdLte?: InputMaybe<Scalars['Date']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  inspectionReviewStatus?: InputMaybe<Scalars['String']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  warrantyClaimType?: InputMaybe<WarrantyClaimsWarrantyClaimWarrantyClaimTypeChoices>;
  warrantyClaimType_Iexact?: InputMaybe<WarrantyClaimsWarrantyClaimWarrantyClaimTypeChoices>;
};

/** An enumeration. */
export const SeedersSeederMeterTypeChoices = {
  /** Mechanic */
  Mechanic: 'MECHANIC',
  /** Pneumatic */
  Pneumatic: 'PNEUMATIC'
} as const;

export type SeedersSeederMeterTypeChoices = typeof SeedersSeederMeterTypeChoices[keyof typeof SeedersSeederMeterTypeChoices];
export type SetPasswordMutationInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  password: Scalars['String']['input'];
  token: Scalars['String']['input'];
  user: Scalars['UUID']['input'];
};

export type SetPasswordMutationPayload = {
  __typename?: 'SetPasswordMutationPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  password: Scalars['String']['output'];
  token: Scalars['String']['output'];
  user: Scalars['UUID']['output'];
};

export type ShipmentProductFormInput = {
  batch?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  orderedProduct: Scalars['ID']['input'];
  quantity: Scalars['Int']['input'];
  supplyOrder: Scalars['ID']['input'];
};

export type ShipmentProductType = {
  __typename?: 'ShipmentProductType';
  batch?: Maybe<Scalars['String']['output']>;
  created: Scalars['DateTime']['output'];
  createdBy?: Maybe<UserType>;
  id: Scalars['UUID']['output'];
  orderedProduct: OrderedProductType;
  quantity: Scalars['Int']['output'];
  shipment: ShipmentType;
  supplyOrder: SupplyOrderNode;
  updated: Scalars['DateTime']['output'];
  updatedBy?: Maybe<UserType>;
};

export type ShipmentType = {
  __typename?: 'ShipmentType';
  created: Scalars['DateTime']['output'];
  createdBy?: Maybe<UserType>;
  externalId: Scalars['String']['output'];
  id: Scalars['UUID']['output'];
  invoice?: Maybe<Scalars['String']['output']>;
  productsShipped: Array<ShipmentProductType>;
  status?: Maybe<SupplyOrdersShipmentStatusChoices>;
  statusDisplay: Scalars['String']['output'];
  supplyOrder: SupplyOrderNode;
  updated: Scalars['DateTime']['output'];
  updatedBy?: Maybe<UserType>;
};

export type StartSupplyOrderReviewMutationInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type StartSupplyOrderReviewMutationPayload = {
  __typename?: 'StartSupplyOrderReviewMutationPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<ErrorType>;
  supplyOrder?: Maybe<SupplyOrderNode>;
};

export type StockErrorType = {
  __typename?: 'StockErrorType';
  code?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
};

/** An enumeration. */
export const StockForecastForecastRunStatusChoices = {
  /** Completed */
  Completed: 'COMPLETED',
  /** Failed */
  Failed: 'FAILED',
  /** Pending */
  Pending: 'PENDING',
  /** Running */
  Running: 'RUNNING'
} as const;

export type StockForecastForecastRunStatusChoices = typeof StockForecastForecastRunStatusChoices[keyof typeof StockForecastForecastRunStatusChoices];
/** An enumeration. */
export const StockForecastMrpLifecycleOverrideLifecycleChoices = {
  /** Commercial */
  Commercial: 'COMMERCIAL',
  /** EOL (End of Life) */
  Eol: 'EOL',
  /** Obsolete */
  Obsolete: 'OBSOLETE',
  /** Review */
  Review: 'REVIEW',
  /** Service Only */
  ServiceOnly: 'SERVICE_ONLY',
  /** Strategic */
  Strategic: 'STRATEGIC'
} as const;

export type StockForecastMrpLifecycleOverrideLifecycleChoices = typeof StockForecastMrpLifecycleOverrideLifecycleChoices[keyof typeof StockForecastMrpLifecycleOverrideLifecycleChoices];
export type StockResponseType = {
  __typename?: 'StockResponseType';
  errors: Array<StockErrorType>;
  stocks: Array<StockType>;
};

export type StockType = {
  __typename?: 'StockType';
  availableQuantity: Scalars['Int']['output'];
  externalId: Scalars['String']['output'];
  found: Scalars['Boolean']['output'];
};

export type SubcategoryType = {
  __typename?: 'SubcategoryType';
  category: CategoryType;
  created: Scalars['DateTime']['output'];
  createdBy?: Maybe<UserType>;
  ecnnewpartSet: Array<EcnNewPartType>;
  id: Scalars['UUID']['output'];
  name: Scalars['String']['output'];
  order: Scalars['Int']['output'];
  productSet: ProductNodeConnection;
  quotedproductSet: Array<QuotedProductType>;
  updated: Scalars['DateTime']['output'];
  updatedBy?: Maybe<UserType>;
  warrantyproductSet: Array<WarrantyProductType>;
};


export type SubcategoryTypeProductSetArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  externalIdIcontains?: InputMaybe<Scalars['String']['input']>;
  externalId_In?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  id_In?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  last?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  subcategory_Category_EnabledForAssistedQuote?: InputMaybe<Scalars['Boolean']['input']>;
};

export type SupplyOrderNode = Node & {
  __typename?: 'SupplyOrderNode';
  charter: SupplyOrdersSupplyOrderCharterChoices;
  charterDisplay: Scalars['String']['output'];
  comment: Scalars['String']['output'];
  created: Scalars['DateTime']['output'];
  createdBy?: Maybe<UserType>;
  displayId: Scalars['Int']['output'];
  displayIdWithPrefix: Scalars['String']['output'];
  displayName: Scalars['String']['output'];
  /** Concrete date set when the order is approved. Empty while the order is pending review. */
  estimatedDispatchDate?: Maybe<Scalars['Date']['output']>;
  externalDealerId?: Maybe<Scalars['String']['output']>;
  /** The ID of the object */
  id: Scalars['ID']['output'];
  internalOrder: Scalars['Boolean']['output'];
  isUrgent: Scalars['Boolean']['output'];
  orderedProducts: Array<OrderedProductType>;
  productsWithoutShipment: Array<OrderedProductType>;
  quantityShipped: Rgy;
  quote?: Maybe<QuoteNode>;
  reviewStart?: Maybe<Scalars['DateTime']['output']>;
  reviews: Array<SupplyOrderReviewType>;
  salesCanReview: Scalars['Boolean']['output'];
  shipAddress?: Maybe<OrganizationAddressType>;
  shipLocation: Scalars['String']['output'];
  shipPostalCode: Scalars['String']['output'];
  shipStreet: Scalars['String']['output'];
  shipmentProducts: Array<ShipmentProductType>;
  shipments: Array<ShipmentType>;
  status: SupplyOrdersSupplyOrderStatusChoices;
  statusDisplay: Scalars['String']['output'];
  updated: Scalars['DateTime']['output'];
  updatedBy?: Maybe<UserType>;
  userNotification: Scalars['Boolean']['output'];
  uuid: Scalars['UUID']['output'];
  warrantyClaim?: Maybe<WarrantyClaimNode>;
};

export type SupplyOrderNodeConnection = {
  __typename?: 'SupplyOrderNodeConnection';
  count: Scalars['Int']['output'];
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<SupplyOrderNodeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `SupplyOrderNode` and its cursor. */
export type SupplyOrderNodeEdge = {
  __typename?: 'SupplyOrderNodeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<SupplyOrderNode>;
};

export type SupplyOrderReviewMutationInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  status: Scalars['String']['input'];
  supplyOrder: Scalars['ID']['input'];
  type: Scalars['String']['input'];
};

export type SupplyOrderReviewMutationPayload = {
  __typename?: 'SupplyOrderReviewMutationPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<ErrorType>;
  supplyOrderReview?: Maybe<SupplyOrderReviewType>;
};

export type SupplyOrderReviewType = {
  __typename?: 'SupplyOrderReviewType';
  created: Scalars['DateTime']['output'];
  createdBy?: Maybe<UserType>;
  externalId?: Maybe<Scalars['String']['output']>;
  id: Scalars['UUID']['output'];
  notes: Scalars['String']['output'];
  status: SupplyOrdersSupplyOrderReviewStatusChoices;
  statusDisplay: Scalars['String']['output'];
  supplyOrder: SupplyOrderNode;
  type: SupplyOrdersSupplyOrderReviewTypeChoices;
  typeDisplay: Scalars['String']['output'];
  updated: Scalars['DateTime']['output'];
  updatedBy?: Maybe<UserType>;
};

/** An enumeration. */
export const SupplyOrdersShipmentStatusChoices = {
  /** Cancelled */
  Cancelled: 'CANCELLED',
  /** Confirmed */
  Confirmed: 'CONFIRMED'
} as const;

export type SupplyOrdersShipmentStatusChoices = typeof SupplyOrdersShipmentStatusChoices[keyof typeof SupplyOrdersShipmentStatusChoices];
/** An enumeration. */
export const SupplyOrdersSupplyOrderCharterChoices = {
  /** Customer arranged */
  Customer: 'CUSTOMER',
  /** PP arranged */
  Pp: 'PP'
} as const;

export type SupplyOrdersSupplyOrderCharterChoices = typeof SupplyOrdersSupplyOrderCharterChoices[keyof typeof SupplyOrdersSupplyOrderCharterChoices];
/** An enumeration. */
export const SupplyOrdersSupplyOrderReviewStatusChoices = {
  /** Approved */
  Approved: 'APPROVED',
  /** Rejected */
  Rejected: 'REJECTED'
} as const;

export type SupplyOrdersSupplyOrderReviewStatusChoices = typeof SupplyOrdersSupplyOrderReviewStatusChoices[keyof typeof SupplyOrdersSupplyOrderReviewStatusChoices];
/** An enumeration. */
export const SupplyOrdersSupplyOrderReviewTypeChoices = {
  /** Sales */
  Sales: 'SALES'
} as const;

export type SupplyOrdersSupplyOrderReviewTypeChoices = typeof SupplyOrdersSupplyOrderReviewTypeChoices[keyof typeof SupplyOrdersSupplyOrderReviewTypeChoices];
/** An enumeration. */
export const SupplyOrdersSupplyOrderStatusChoices = {
  /** Approved */
  Approved: 'APPROVED',
  /** Cancelled */
  Cancelled: 'CANCELLED',
  /** Draft */
  Draft: 'DRAFT',
  /** Shipment finished */
  Finished: 'FINISHED',
  /** In progress */
  InProgress: 'IN_PROGRESS',
  /** Sales review */
  SalesReview: 'SALES_REVIEW'
} as const;

export type SupplyOrdersSupplyOrderStatusChoices = typeof SupplyOrdersSupplyOrderStatusChoices[keyof typeof SupplyOrdersSupplyOrderStatusChoices];
export type ToggleFavoriteAccount = {
  __typename?: 'ToggleFavoriteAccount';
  ok: Scalars['Boolean']['output'];
};

export type ToggleSubscribeModelNotificationMutationInput = {
  appLabel: Scalars['String']['input'];
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  model: Scalars['String']['input'];
  objectUuid: Scalars['UUID']['input'];
};

export type ToggleSubscribeModelNotificationMutationPayload = {
  __typename?: 'ToggleSubscribeModelNotificationMutationPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<ErrorType>;
  modelNotification?: Maybe<ModelNotificationType>;
};

export type UpdateAccountMutationInput = {
  address?: InputMaybe<Scalars['String']['input']>;
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  location?: InputMaybe<Scalars['ID']['input']>;
  name: Scalars['String']['input'];
  owner: Scalars['ID']['input'];
  taxId?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateAccountMutationPayload = {
  __typename?: 'UpdateAccountMutationPayload';
  account?: Maybe<AccountType>;
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<ErrorType>;
};

export type UpdateContactMutationInput = {
  account: Scalars['ID']['input'];
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  mobilePhone?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  type: Scalars['ID']['input'];
};

export type UpdateContactMutationPayload = {
  __typename?: 'UpdateContactMutationPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  contact?: Maybe<ContactType>;
  errors: Array<ErrorType>;
};

export type UpdateEcnEffectiveDateMutation = {
  __typename?: 'UpdateEcnEffectiveDateMutation';
  ecn?: Maybe<EcnType>;
};

export type UpdateEcnMutationInput = {
  blueprints?: InputMaybe<Array<EcnBlueprintFormInput>>;
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  draftBlueprints?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  draftEcn?: InputMaybe<Scalars['ID']['input']>;
  ecnNumber: Scalars['String']['input'];
  effectiveDate?: InputMaybe<Scalars['Date']['input']>;
  fyi?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  id?: InputMaybe<Scalars['ID']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  oems?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  parts: Array<EcnPartFormInput>;
  recipient?: InputMaybe<Scalars['String']['input']>;
  resendFyi?: InputMaybe<Scalars['Boolean']['input']>;
  resendTasks?: InputMaybe<Scalars['Boolean']['input']>;
  seasonPriority: Scalars['String']['input'];
  tasks?: InputMaybe<Array<EcnTaskFormInput>>;
  warrantyPriority?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateEcnMutationPayload = {
  __typename?: 'UpdateEcnMutationPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  ecn?: Maybe<EcnType>;
  errors: Array<ErrorType>;
};

export type UpdateMrpLifecycleOverrides = {
  __typename?: 'UpdateMRPLifecycleOverrides';
  overrides: Array<MrpLifecycleOverrideType>;
};

export type UpdateMrpParameters = {
  __typename?: 'UpdateMRPParameters';
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  parameters?: Maybe<MrpParametersType>;
};

export type UpdateOrderedProductMutationInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  quantity: Scalars['Int']['input'];
  quantityLeft: Scalars['Int']['input'];
  quotedProduct?: InputMaybe<Scalars['ID']['input']>;
  warrantyProduct?: InputMaybe<Scalars['ID']['input']>;
};

export type UpdateOrderedProductMutationPayload = {
  __typename?: 'UpdateOrderedProductMutationPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<ErrorType>;
  orderedProduct?: Maybe<OrderedProductType>;
};

export type UpdateOrganizationMutationInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  logo?: InputMaybe<Scalars['Upload']['input']>;
  name: Scalars['String']['input'];
};

export type UpdateOrganizationMutationPayload = {
  __typename?: 'UpdateOrganizationMutationPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<ErrorType>;
  organization?: Maybe<OrganizationType>;
};

export type UpdatePasswordMutationInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  currentPassword: Scalars['String']['input'];
  newPassword: Scalars['String']['input'];
};

export type UpdatePasswordMutationPayload = {
  __typename?: 'UpdatePasswordMutationPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  currentPassword: Scalars['String']['output'];
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  newPassword: Scalars['String']['output'];
};

export type UpdateQuoteMutationInput = {
  additionalChargesDescription?: InputMaybe<Scalars['String']['input']>;
  additionalChargesValue?: InputMaybe<Scalars['Decimal']['input']>;
  billingType: Scalars['String']['input'];
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  contact: Scalars['ID']['input'];
  id?: InputMaybe<Scalars['ID']['input']>;
  kitMultiplier?: InputMaybe<Scalars['ID']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  paymentMethods: Array<QuotedPaymentMethodFormInput>;
  products: Array<QuotedProductFormInput>;
  rowCount?: InputMaybe<Scalars['Int']['input']>;
  seeder?: InputMaybe<Scalars['ID']['input']>;
};

export type UpdateQuoteMutationPayload = {
  __typename?: 'UpdateQuoteMutationPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<ErrorType>;
  quote?: Maybe<QuoteNode>;
};

export type UpdateQuotePricesMutationInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type UpdateQuotePricesMutationPayload = {
  __typename?: 'UpdateQuotePricesMutationPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<ErrorType>;
  quote?: Maybe<QuoteNode>;
};

export type UpdateRecommendationManualInput = {
  __typename?: 'UpdateRecommendationManualInput';
  recommendation?: Maybe<ReplenishmentRecommendationType>;
};

export type UpdateSaleMutationInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  paymentMethod: Scalars['ID']['input'];
  quote: Scalars['ID']['input'];
};

export type UpdateSaleMutationPayload = {
  __typename?: 'UpdateSaleMutationPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<ErrorType>;
  sale?: Maybe<SaleNode>;
};

export type UpdateSeederMutationInput = {
  account: Scalars['ID']['input'];
  brand: Scalars['ID']['input'];
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  installedCategories?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  meterType: Scalars['String']['input'];
  model?: InputMaybe<Scalars['ID']['input']>;
  rowCount: Scalars['Int']['input'];
  year?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdateSeederMutationPayload = {
  __typename?: 'UpdateSeederMutationPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<ErrorType>;
  seeder?: Maybe<SeederType>;
};

export type UpdateShipmentMutationInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  invoice?: InputMaybe<Scalars['Upload']['input']>;
  productsShipped: Array<UpdateShipmentProductFormInput>;
  status?: InputMaybe<Scalars['String']['input']>;
  supplyOrder: Scalars['ID']['input'];
};

export type UpdateShipmentMutationPayload = {
  __typename?: 'UpdateShipmentMutationPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<ErrorType>;
  shipment?: Maybe<ShipmentType>;
};

export type UpdateShipmentProductFormInput = {
  batch?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  orderedProduct: Scalars['ID']['input'];
  quantity: Scalars['Int']['input'];
  supplyOrder: Scalars['ID']['input'];
};

export type UpdateSupplyOrderCommentMutationInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  comment?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type UpdateSupplyOrderCommentMutationPayload = {
  __typename?: 'UpdateSupplyOrderCommentMutationPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<ErrorType>;
  supplyOrder?: Maybe<SupplyOrderNode>;
};

export type UpdateSupplyOrderQuoteMutationInput = {
  charter: Scalars['String']['input'];
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  emailMessages?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Concrete date set when the order is approved. Empty while the order is pending review. */
  estimatedDispatchDate?: InputMaybe<Scalars['Date']['input']>;
  externalDealerId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  internalOrder?: InputMaybe<Scalars['Boolean']['input']>;
  isUrgent?: InputMaybe<Scalars['Boolean']['input']>;
  products: Array<OrderedProductFormInput>;
  quote: Scalars['ID']['input'];
  reviewStart?: InputMaybe<Scalars['DateTime']['input']>;
  shipAddress?: InputMaybe<Scalars['ID']['input']>;
  status: Scalars['String']['input'];
  warrantyClaim?: InputMaybe<Scalars['ID']['input']>;
};

export type UpdateSupplyOrderQuoteMutationPayload = {
  __typename?: 'UpdateSupplyOrderQuoteMutationPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<ErrorType>;
  supplyOrder?: Maybe<SupplyOrderNode>;
};

export type UpdateUserMutationInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  emailNotifications?: InputMaybe<Scalars['Boolean']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  inAppNotifications?: InputMaybe<Scalars['Boolean']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  termsAndConditionsAcceptedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type UpdateUserMutationPayload = {
  __typename?: 'UpdateUserMutationPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<ErrorType>;
  user?: Maybe<UserType>;
};

export type UpdateWarrantyClaimMutationInput = {
  applyForCredit?: InputMaybe<Scalars['Boolean']['input']>;
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  description: Scalars['String']['input'];
  id?: InputMaybe<Scalars['ID']['input']>;
  product: Scalars['ID']['input'];
  serialNumber?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateWarrantyClaimMutationPayload = {
  __typename?: 'UpdateWarrantyClaimMutationPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<ErrorType>;
  warrantyClaim?: Maybe<WarrantyClaimNode>;
};

export type UploadInvoiceMutationInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  invoice?: InputMaybe<Scalars['Upload']['input']>;
};

export type UploadInvoiceMutationPayload = {
  __typename?: 'UploadInvoiceMutationPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<ErrorType>;
  shipment?: Maybe<ShipmentType>;
};

export type UserNode = Node & {
  __typename?: 'UserNode';
  dateJoined: Scalars['DateTime']['output'];
  displayName: Scalars['String']['output'];
  ecnRoles: Array<EcnRoleType>;
  email: Scalars['String']['output'];
  emailNotifications: Scalars['Boolean']['output'];
  favoriteAccounts: Array<AccountType>;
  /** Users who have access to this feature */
  featureflagSet: Array<FeatureFlagType>;
  firstName: Scalars['String']['output'];
  /** The ID of the object */
  id: Scalars['ID']['output'];
  inAppNotifications: Scalars['Boolean']['output'];
  /** Designates whether this user should be treated as active. Unselect this instead of deleting accounts. */
  isActive: Scalars['Boolean']['output'];
  /** Designates whether the user can log into this admin site. */
  isStaff: Scalars['Boolean']['output'];
  /** Designates that this user has all permissions without explicitly assigning them. */
  isSuperuser: Scalars['Boolean']['output'];
  language: Scalars['String']['output'];
  lastLogin?: Maybe<Scalars['DateTime']['output']>;
  lastName: Scalars['String']['output'];
  modelNotifications: Array<ModelNotificationType>;
  notificationConfigs: Array<NotificationConfigType>;
  notifications: NotificationNodeConnection;
  organization?: Maybe<OrganizationType>;
  password: Scalars['String']['output'];
  permissions: UserPermissions;
  role?: Maybe<RoleType>;
  termsAndConditionsAcceptedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Required. 150 characters or fewer. Letters, digits and @/./+/-/_ only. */
  username: Scalars['String']['output'];
  uuid: Scalars['UUID']['output'];
  viewedEcns: Array<EcnType>;
};


export type UserNodeNotificationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  isRead?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type UserNodeConnection = {
  __typename?: 'UserNodeConnection';
  count: Scalars['Int']['output'];
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<UserNodeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `UserNode` and its cursor. */
export type UserNodeEdge = {
  __typename?: 'UserNodeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<UserNode>;
};

export type UserPermissions = {
  __typename?: 'UserPermissions';
  assignAccountOwner: Scalars['Boolean']['output'];
  configureMrpParameters: Scalars['Boolean']['output'];
  editApprovedSupplyOrders: Scalars['Boolean']['output'];
  manageAccounts: Scalars['Boolean']['output'];
  manageEcns: Scalars['Boolean']['output'];
  manageQuotes: Scalars['Boolean']['output'];
  manageSales: Scalars['Boolean']['output'];
  manageShipments: Scalars['Boolean']['output'];
  manageStockForecast: Scalars['Boolean']['output'];
  manageSupplyOrders: Scalars['Boolean']['output'];
  manageWarrantyClaims: Scalars['Boolean']['output'];
  performTechnicalReview: Scalars['Boolean']['output'];
  receiveSupplyOrderApprovedNotification: Scalars['Boolean']['output'];
  requestSupplyOrderReview: Scalars['Boolean']['output'];
  submitCreditsSupplyOrderReview: Scalars['Boolean']['output'];
  submitSalesSupplyOrderReview: Scalars['Boolean']['output'];
  ticketSystemAccess: Scalars['Boolean']['output'];
  viewAccounts: Scalars['Boolean']['output'];
  viewAnalytics: Scalars['Boolean']['output'];
  viewContacts: Scalars['Boolean']['output'];
  viewDatastudio: Scalars['Boolean']['output'];
  viewEcns: Scalars['Boolean']['output'];
  viewInternalSupplyOrders: Scalars['Boolean']['output'];
  viewOpportunities: Scalars['Boolean']['output'];
  viewQuotes: Scalars['Boolean']['output'];
  viewSales: Scalars['Boolean']['output'];
  viewSeeders: Scalars['Boolean']['output'];
  viewStockForecast: Scalars['Boolean']['output'];
  viewSupplyOrders: Scalars['Boolean']['output'];
  viewWarrantyClaims: Scalars['Boolean']['output'];
  viewWarrantyClaimsAnalytics: Scalars['Boolean']['output'];
  warrantyClaimsManageApprove: Scalars['Boolean']['output'];
  warrantyClaimsWarrantyAdminApprove: Scalars['Boolean']['output'];
};

export type UserType = {
  __typename?: 'UserType';
  dateJoined: Scalars['DateTime']['output'];
  displayName: Scalars['String']['output'];
  ecnRoles: Array<EcnRoleType>;
  email: Scalars['String']['output'];
  emailNotifications: Scalars['Boolean']['output'];
  favoriteAccounts: Array<AccountType>;
  /** Users who have access to this feature */
  featureflagSet: Array<FeatureFlagType>;
  firstName: Scalars['String']['output'];
  id: Scalars['UUID']['output'];
  inAppNotifications: Scalars['Boolean']['output'];
  /** Designates whether this user should be treated as active. Unselect this instead of deleting accounts. */
  isActive: Scalars['Boolean']['output'];
  /** Designates whether the user can log into this admin site. */
  isStaff: Scalars['Boolean']['output'];
  /** Designates that this user has all permissions without explicitly assigning them. */
  isSuperuser: Scalars['Boolean']['output'];
  language: Scalars['String']['output'];
  lastLogin?: Maybe<Scalars['DateTime']['output']>;
  lastName: Scalars['String']['output'];
  modelNotifications: Array<ModelNotificationType>;
  notificationConfigs: Array<NotificationConfigType>;
  notifications: NotificationNodeConnection;
  organization?: Maybe<OrganizationType>;
  password: Scalars['String']['output'];
  permissions: UserPermissions;
  role?: Maybe<RoleType>;
  termsAndConditionsAcceptedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Required. 150 characters or fewer. Letters, digits and @/./+/-/_ only. */
  username: Scalars['String']['output'];
  uuid: Scalars['UUID']['output'];
  viewedEcns: Array<EcnType>;
};


export type UserTypeNotificationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  isRead?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

/** An enumeration. */
export const UsersNotificationConfigNameChoices = {
  /** Supply orders */
  SupplyOrders: 'SUPPLY_ORDERS',
  /** Warranty claims */
  WarrantyClaims: 'WARRANTY_CLAIMS'
} as const;

export type UsersNotificationConfigNameChoices = typeof UsersNotificationConfigNameChoices[keyof typeof UsersNotificationConfigNameChoices];
export type WarrantyClaimApprovalConfigType = {
  __typename?: 'WarrantyClaimApprovalConfigType';
  id: Scalars['ID']['output'];
  /** Amount above which manager approval is required for defective parts claims */
  mainApprovalThreshold: Scalars['Decimal']['output'];
  /** Amount above which warranty admin approval is required for defective parts claims */
  secondaryApprovalThreshold: Scalars['Decimal']['output'];
};

export type WarrantyClaimImageFormInput = {
  file: Scalars['Upload']['input'];
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type WarrantyClaimImageType = {
  __typename?: 'WarrantyClaimImageType';
  file: Scalars['String']['output'];
  id: Scalars['UUID']['output'];
  warrantyClaim: WarrantyClaimNode;
};

export type WarrantyClaimInspectionFileFormInput = {
  file: Scalars['Upload']['input'];
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type WarrantyClaimInspectionFileType = {
  __typename?: 'WarrantyClaimInspectionFileType';
  created: Scalars['DateTime']['output'];
  createdBy?: Maybe<UserType>;
  file?: Maybe<Scalars['String']['output']>;
  id: Scalars['UUID']['output'];
  inspection: WarrantyClaimInspectionReviewType;
  updated: Scalars['DateTime']['output'];
  updatedBy?: Maybe<UserType>;
};

export type WarrantyClaimInspectionReviewType = {
  __typename?: 'WarrantyClaimInspectionReviewType';
  created: Scalars['DateTime']['output'];
  createdBy?: Maybe<UserType>;
  failureDescription: Scalars['String']['output'];
  files: Array<WarrantyClaimInspectionFileType>;
  id: Scalars['UUID']['output'];
  inWarranty: Scalars['Boolean']['output'];
  inspected: Scalars['Boolean']['output'];
  inspectedDate?: Maybe<Scalars['DateTime']['output']>;
  received: Scalars['Boolean']['output'];
  receivedDate?: Maybe<Scalars['DateTime']['output']>;
  status: WarrantyClaimsWarrantyClaimInspectionReviewStatusChoices;
  statusDisplay: Scalars['String']['output'];
  updated: Scalars['DateTime']['output'];
  updatedBy?: Maybe<UserType>;
  warrantyClaim: WarrantyClaimNode;
};

export type WarrantyClaimNode = Node & {
  __typename?: 'WarrantyClaimNode';
  amount?: Maybe<Scalars['Decimal']['output']>;
  applyForCredit: Scalars['Boolean']['output'];
  canCurrentUserApprove: Scalars['Boolean']['output'];
  contact: ContactType;
  created: Scalars['DateTime']['output'];
  createdBy?: Maybe<UserType>;
  description: Scalars['String']['output'];
  displayId: Scalars['Int']['output'];
  displayWarrantyClaimType: Scalars['String']['output'];
  externalId?: Maybe<Scalars['String']['output']>;
  failureDate?: Maybe<Scalars['Date']['output']>;
  finalClient: Scalars['String']['output'];
  hasCompletedInspectionReview: Scalars['Boolean']['output'];
  /** The ID of the object */
  id: Scalars['ID']['output'];
  images: Array<WarrantyClaimImageType>;
  inspectionReview?: Maybe<WarrantyClaimInspectionReviewType>;
  invoiceDate?: Maybe<Scalars['Date']['output']>;
  isFullyApproved: Scalars['Boolean']['output'];
  isInFinalState: Scalars['Boolean']['output'];
  lastReview?: Maybe<WarrantyClaimReviewType>;
  missingApprovals: Array<Maybe<WarrantyClaimsWarrantyClaimReviewApprovalTypeChoices>>;
  /** Order ID of the order that the claim was created from. */
  orderId?: Maybe<Scalars['Int']['output']>;
  phone: Scalars['String']['output'];
  product?: Maybe<WarrantyProductType>;
  quantity: Scalars['Int']['output'];
  requiredApprovalType?: Maybe<Scalars['String']['output']>;
  requiredApprovalsList: Array<Maybe<WarrantyClaimsWarrantyClaimReviewApprovalTypeChoices>>;
  requiresInspectionReview: Scalars['Boolean']['output'];
  requiresSpecialApproval: Scalars['Boolean']['output'];
  reviews: Array<WarrantyClaimReviewType>;
  rmaCode?: Maybe<Scalars['String']['output']>;
  seeder?: Maybe<SeederType>;
  serialNumber?: Maybe<Scalars['String']['output']>;
  /** Current state of the warranty claim */
  state: WarrantyClaimsWarrantyClaimStateChoices;
  stateDisplay: Scalars['String']['output'];
  supplyOrder?: Maybe<SupplyOrderNode>;
  updated: Scalars['DateTime']['output'];
  updatedBy?: Maybe<UserType>;
  uuid: Scalars['UUID']['output'];
  videos: Array<WarrantyClaimVideoType>;
  warrantyClaimType: WarrantyClaimsWarrantyClaimWarrantyClaimTypeChoices;
};

export type WarrantyClaimNodeConnection = {
  __typename?: 'WarrantyClaimNodeConnection';
  count: Scalars['Int']['output'];
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<WarrantyClaimNodeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `WarrantyClaimNode` and its cursor. */
export type WarrantyClaimNodeEdge = {
  __typename?: 'WarrantyClaimNodeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<WarrantyClaimNode>;
};

export type WarrantyClaimReviewType = {
  __typename?: 'WarrantyClaimReviewType';
  approvalType?: Maybe<WarrantyClaimsWarrantyClaimReviewApprovalTypeChoices>;
  approvalTypeDisplay: Scalars['String']['output'];
  created: Scalars['DateTime']['output'];
  createdBy?: Maybe<UserType>;
  id: Scalars['UUID']['output'];
  notes: Scalars['String']['output'];
  status: WarrantyClaimsWarrantyClaimReviewStatusChoices;
  statusDisplay: Scalars['String']['output'];
  updated: Scalars['DateTime']['output'];
  updatedBy?: Maybe<UserType>;
  warrantyClaim: WarrantyClaimNode;
  warrantyclaimSet: WarrantyClaimNodeConnection;
};


export type WarrantyClaimReviewTypeWarrantyclaimSetArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  contact_Account_Id?: InputMaybe<Scalars['UUID']['input']>;
  contact_Account_Owner_Id?: InputMaybe<Scalars['UUID']['input']>;
  contact_Id?: InputMaybe<Scalars['UUID']['input']>;
  contact_Id_In?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
  created?: InputMaybe<Scalars['Date']['input']>;
  createdBy_Id?: InputMaybe<Scalars['UUID']['input']>;
  createdGte?: InputMaybe<Scalars['Date']['input']>;
  createdLte?: InputMaybe<Scalars['Date']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  inspectionReviewStatus?: InputMaybe<Scalars['String']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  warrantyClaimType?: InputMaybe<WarrantyClaimsWarrantyClaimWarrantyClaimTypeChoices>;
  warrantyClaimType_Iexact?: InputMaybe<WarrantyClaimsWarrantyClaimWarrantyClaimTypeChoices>;
};

export type WarrantyClaimVideoFormInput = {
  file: Scalars['Upload']['input'];
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type WarrantyClaimVideoType = {
  __typename?: 'WarrantyClaimVideoType';
  file: Scalars['String']['output'];
  id: Scalars['UUID']['output'];
  warrantyClaim: WarrantyClaimNode;
};

export type WarrantyClaimsAnalyticsType = {
  __typename?: 'WarrantyClaimsAnalyticsType';
  approvedCount: Scalars['Int']['output'];
  byDate: Array<DateSeriesDatum>;
  cancelledCount: Scalars['Int']['output'];
  count: Scalars['Int']['output'];
  failRate: Array<ProductFailRate>;
  pendingCount: Scalars['Int']['output'];
  productRanking: Array<WarrantyProductRankingDatum>;
  rejectedCount: Scalars['Int']['output'];
};

/** An enumeration. */
export const WarrantyClaimsWarrantyClaimInspectionReviewStatusChoices = {
  /** Finished */
  Finished: 'FINISHED',
  /** Received */
  Received: 'RECEIVED'
} as const;

export type WarrantyClaimsWarrantyClaimInspectionReviewStatusChoices = typeof WarrantyClaimsWarrantyClaimInspectionReviewStatusChoices[keyof typeof WarrantyClaimsWarrantyClaimInspectionReviewStatusChoices];
/** An enumeration. */
export const WarrantyClaimsWarrantyClaimReviewApprovalTypeChoices = {
  /** Main Approval */
  Main: 'MAIN',
  /** Secondary Approval */
  Secondary: 'SECONDARY',
  /** Standard */
  Standard: 'STANDARD'
} as const;

export type WarrantyClaimsWarrantyClaimReviewApprovalTypeChoices = typeof WarrantyClaimsWarrantyClaimReviewApprovalTypeChoices[keyof typeof WarrantyClaimsWarrantyClaimReviewApprovalTypeChoices];
/** An enumeration. */
export const WarrantyClaimsWarrantyClaimReviewStatusChoices = {
  /** Approved */
  Approved: 'APPROVED',
  /** Cancelled */
  Cancelled: 'CANCELLED',
  /** Finished */
  Done: 'DONE',
  /** Partially Approved */
  PartiallyApproved: 'PARTIALLY_APPROVED',
  /** Pending */
  Pending: 'PENDING',
  /** Rejected */
  Rejected: 'REJECTED'
} as const;

export type WarrantyClaimsWarrantyClaimReviewStatusChoices = typeof WarrantyClaimsWarrantyClaimReviewStatusChoices[keyof typeof WarrantyClaimsWarrantyClaimReviewStatusChoices];
/** An enumeration. */
export const WarrantyClaimsWarrantyClaimStateChoices = {
  /** Approved */
  Approved: 'APPROVED',
  /** Cancelled */
  Cancelled: 'CANCELLED',
  /** Done */
  Done: 'DONE',
  /** Partially Approved */
  PartiallyApproved: 'PARTIALLY_APPROVED',
  /** Pending */
  Pending: 'PENDING',
  /** Rejected */
  Rejected: 'REJECTED'
} as const;

export type WarrantyClaimsWarrantyClaimStateChoices = typeof WarrantyClaimsWarrantyClaimStateChoices[keyof typeof WarrantyClaimsWarrantyClaimStateChoices];
/** An enumeration. */
export const WarrantyClaimsWarrantyClaimWarrantyClaimTypeChoices = {
  /** Defective Part */
  DefectivePart: 'DEFECTIVE_PART',
  /** Missing Part */
  MissingPart: 'MISSING_PART'
} as const;

export type WarrantyClaimsWarrantyClaimWarrantyClaimTypeChoices = typeof WarrantyClaimsWarrantyClaimWarrantyClaimTypeChoices[keyof typeof WarrantyClaimsWarrantyClaimWarrantyClaimTypeChoices];
export type WarrantyProductRankingDatum = {
  __typename?: 'WarrantyProductRankingDatum';
  amount?: Maybe<Scalars['Float']['output']>;
  count: Scalars['Int']['output'];
  product: WarrantyProductType;
  ranking: Scalars['Int']['output'];
};

export type WarrantyProductType = {
  __typename?: 'WarrantyProductType';
  created: Scalars['DateTime']['output'];
  createdBy?: Maybe<UserType>;
  description: Scalars['String']['output'];
  displayName: Scalars['String']['output'];
  externalId: Scalars['String']['output'];
  id: Scalars['UUID']['output'];
  name: Scalars['String']['output'];
  order: Scalars['Int']['output'];
  orderedProducts: Array<OrderedProductType>;
  originalProduct?: Maybe<ProductNode>;
  price: Scalars['Decimal']['output'];
  quantity: Scalars['Int']['output'];
  rowCount: Scalars['Int']['output'];
  ruleCategories: Array<CategoryType>;
  /** Legacy field for backward compatibility. Use rule_groups for multiple groups. */
  ruleGroup?: Maybe<RuleGroupType>;
  /** Rule groups this product belongs to. A product can belong to multiple groups. */
  ruleGroups: Array<RuleGroupType>;
  subcategory?: Maybe<SubcategoryType>;
  updated: Scalars['DateTime']['output'];
  updatedBy?: Maybe<UserType>;
  warrantyClaim: WarrantyClaimNode;
};

export type SalesPotentialAnalyticsFragment = { __typename?: 'SalesPotentialAnalyticsType', rowsCount: number, seedersCount: number, bySeederBrand: Array<{ __typename?: 'AmountDatum', label: string, count: number, percentage?: number }>, byMeterType: Array<{ __typename?: 'AmountDatum', label: string, count: number, percentage?: number }>, byCategory: Array<{ __typename?: 'AmountDatum', label: string, count: number, percentage?: number }> };

export type GetSalesPotentialAnalyticsQueryVariables = Exact<{
  filters: AnalyticsFilters;
}>;


export type GetSalesPotentialAnalyticsQuery = { __typename?: 'Query', salesPotentialAnalytics?: { __typename?: 'SalesPotentialAnalyticsType', rowsCount: number, seedersCount: number, bySeederBrand: Array<{ __typename?: 'AmountDatum', label: string, count: number, percentage?: number }>, byMeterType: Array<{ __typename?: 'AmountDatum', label: string, count: number, percentage?: number }>, byCategory: Array<{ __typename?: 'AmountDatum', label: string, count: number, percentage?: number }> } };

export type CreateAccountMutationVariables = Exact<{
  input: CreateAccountMutationInput;
}>;


export type CreateAccountMutation = { __typename?: 'Mutation', createAccount?: { __typename?: 'CreateAccountMutationPayload', account?: { __typename?: 'AccountType', id: string, uuid: string }, errors: Array<{ __typename?: 'ErrorType', field: string, messages: Array<string> }> } };

export type AccountFragment = { __typename?: 'AccountNode', id: string, uuid: string, name: string, taxId?: string, externalId: string, isFavorite: boolean, address?: string, location?: { __typename?: 'LocationType', id: string, path?: string, iva: Decimal }, owner?: { __typename?: 'OrganizationType', id: string, name: string, externalId: string, isEu: boolean, displayName: string, logo?: string, logoThumbnail?: string, location?: { __typename?: 'LocationType', id: string, name: string, path?: string, iva: Decimal }, group: { __typename?: 'OrganizationGroupType', id: string, dealerCommission?: string } } };

export type AccountTypeFragment = { __typename?: 'AccountType', id: string, uuid: string, name: string, taxId?: string, externalId: string, isFavorite: boolean, address?: string, location?: { __typename?: 'LocationType', id: string, path?: string, iva: Decimal }, owner?: { __typename?: 'OrganizationType', id: string, name: string, externalId: string, isEu: boolean, displayName: string, logo?: string, logoThumbnail?: string, location?: { __typename?: 'LocationType', id: string, name: string, path?: string, iva: Decimal }, group: { __typename?: 'OrganizationGroupType', id: string, dealerCommission?: string } } };

export type AccountOptionFragment = { __typename?: 'AccountNode', id: string, uuid: string, name: string, externalId: string, location?: { __typename?: 'LocationType', id: string, path?: string, iva: Decimal }, owner?: { __typename?: 'OrganizationType', isEu: boolean, id: string } };

export type GetAccountUuidQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetAccountUuidQuery = { __typename?: 'Query', account?: { __typename?: 'AccountNode', id: string, uuid: string, name: string } };

export type GetAccountQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  uuid?: InputMaybe<Scalars['UUID']['input']>;
}>;


export type GetAccountQuery = { __typename?: 'Query', account?: { __typename?: 'AccountNode', id: string, uuid: string, name: string, taxId?: string, externalId: string, isFavorite: boolean, address?: string, location?: { __typename?: 'LocationType', id: string, path?: string, iva: Decimal }, owner?: { __typename?: 'OrganizationType', id: string, name: string, externalId: string, isEu: boolean, displayName: string, logo?: string, logoThumbnail?: string, location?: { __typename?: 'LocationType', id: string, name: string, path?: string, iva: Decimal }, group: { __typename?: 'OrganizationGroupType', id: string, dealerCommission?: string } } } };

export type AccountListFragment = { __typename?: 'AccountNode', taxId?: string, id: string, uuid: string, name: string, externalId: string, isFavorite: boolean, location?: { __typename?: 'LocationType', id: string, path?: string }, owner?: { __typename?: 'OrganizationType', id: string, name: string } };

export type GetAccountsQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  owner?: InputMaybe<Scalars['UUID']['input']>;
}>;


export type GetAccountsQuery = { __typename?: 'Query', accounts?: { __typename?: 'AccountNodeConnection', count: number, edges: Array<{ __typename?: 'AccountNodeEdge', cursor: string, node?: { __typename?: 'AccountNode', taxId?: string, id: string, uuid: string, name: string, externalId: string, isFavorite: boolean, location?: { __typename?: 'LocationType', id: string, path?: string }, owner?: { __typename?: 'OrganizationType', id: string, name: string } } }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string, endCursor?: string } } };

export type UpdateAccountMutationVariables = Exact<{
  input: UpdateAccountMutationInput;
}>;


export type UpdateAccountMutation = { __typename?: 'Mutation', updateAccount?: { __typename?: 'UpdateAccountMutationPayload', account?: { __typename?: 'AccountType', id: string }, errors: Array<{ __typename?: 'ErrorType', field: string, messages: Array<string> }> } };

export type GetAccountOptionsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAccountOptionsQuery = { __typename?: 'Query', accounts?: { __typename?: 'AccountNodeConnection', edges: Array<{ __typename?: 'AccountNodeEdge', cursor: string, node?: { __typename?: 'AccountNode', id: string, uuid: string, name: string, externalId: string, location?: { __typename?: 'LocationType', id: string, path?: string, iva: Decimal }, owner?: { __typename?: 'OrganizationType', isEu: boolean, id: string } } }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string, endCursor?: string } } };

export type GetAccountOptionQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  uuid?: InputMaybe<Scalars['UUID']['input']>;
}>;


export type GetAccountOptionQuery = { __typename?: 'Query', account?: { __typename?: 'AccountNode', id: string, uuid: string, name: string, externalId: string, location?: { __typename?: 'LocationType', id: string, path?: string, iva: Decimal }, owner?: { __typename?: 'OrganizationType', isEu: boolean, id: string } } };

export type GetAccountEditQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetAccountEditQuery = { __typename?: 'Query', account?: { __typename?: 'AccountNode', id: string, uuid: string, name: string, externalId: string, taxId?: string, owner?: { __typename?: 'OrganizationType', id: string }, location?: { __typename?: 'LocationType', id: string } } };

export type DeleteAccountMutationVariables = Exact<{
  input: DeleteAccountMutationInput;
}>;


export type DeleteAccountMutation = { __typename?: 'Mutation', deleteAccount?: { __typename?: 'DeleteAccountMutationPayload', errors: Array<{ __typename?: 'ErrorType', field: string, messages: Array<string> }> } };

export type ToggleFavoriteAcccountMutationVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type ToggleFavoriteAcccountMutation = { __typename?: 'Mutation', toggleFavoriteAccount?: { __typename?: 'ToggleFavoriteAccount', ok: boolean } };

export type GetAccountTaxQueryVariables = Exact<{
  uuid?: InputMaybe<Scalars['UUID']['input']>;
}>;


export type GetAccountTaxQuery = { __typename?: 'Query', account?: { __typename?: 'AccountNode', uuid: string, location?: { __typename?: 'LocationType', id: string, iva: Decimal }, owner?: { __typename?: 'OrganizationType', location?: { __typename?: 'LocationType', id: string, iva: Decimal } } } };

export type GetSalesAnalyticsQueryVariables = Exact<{
  filters: AnalyticsFilters;
}>;


export type GetSalesAnalyticsQuery = { __typename?: 'Query', salesAnalytics?: { __typename?: 'SalesAnalyticsType', count: number, amount: number, byDate: Array<{ __typename?: 'DateSeriesDatum', date: string, count: number, amount?: number }>, productRanking: Array<{ __typename?: 'ProductRankingDatum', count: number, amount?: number, ranking: number, product: { __typename?: 'ProductNode', displayName: string, subcategory?: { __typename?: 'SubcategoryType', name: string, category: { __typename?: 'CategoryType', name: string } } } }>, byBillingType: Array<{ __typename?: 'AmountDatum', label: string, count: number, amount: number, percentage?: number }>, byPaymentMethod: Array<{ __typename?: 'AmountDatum', label: string, count: number, amount: number, percentage?: number }>, bySeederBrand: Array<{ __typename?: 'AmountDatum', label: string, count: number, amount: number, percentage?: number }>, bySeederModel: Array<{ __typename?: 'AmountDatum', label: string, count: number, amount: number, percentage?: number }>, byOrganization: Array<{ __typename?: 'AmountDatum', label: string, count: number, amount: number, percentage?: number }>, byAccount: Array<{ __typename?: 'AmountDatum', label: string, count: number, amount: number, percentage?: number }>, byUser: Array<{ __typename?: 'AmountDatum', label: string, count: number, amount: number, percentage?: number }> } };

export type GetQuotesAnalyticsQueryVariables = Exact<{
  filters: AnalyticsFilters;
}>;


export type GetQuotesAnalyticsQuery = { __typename?: 'Query', quotesAnalytics?: { __typename?: 'QuotesAnalyticsType', count: number, amount: number, byDate: Array<{ __typename?: 'DateSeriesDatum', date: string, count: number, amount?: number }>, productRanking: Array<{ __typename?: 'ProductRankingDatum', count: number, amount?: number, ranking: number, product: { __typename?: 'ProductNode', displayName: string, subcategory?: { __typename?: 'SubcategoryType', name: string, category: { __typename?: 'CategoryType', name: string } } } }>, byBillingType: Array<{ __typename?: 'AmountDatum', label: string, count: number, amount: number, percentage?: number }>, byPaymentMethod: Array<{ __typename?: 'AmountDatum', label: string, count: number, amount: number, percentage?: number }>, bySeederBrand: Array<{ __typename?: 'AmountDatum', label: string, count: number, amount: number, percentage?: number }>, bySeederModel: Array<{ __typename?: 'AmountDatum', label: string, count: number, amount: number, percentage?: number }>, byStatus: Array<{ __typename?: 'AmountDatum', label: string, count: number, amount: number, percentage?: number }>, byOrganization: Array<{ __typename?: 'AmountDatum', label: string, count: number, amount: number, percentage?: number }>, byAccount: Array<{ __typename?: 'AmountDatum', label: string, count: number, amount: number, percentage?: number }>, byUser: Array<{ __typename?: 'AmountDatum', label: string, count: number, amount: number, percentage?: number }>, byCloseReason: Array<{ __typename?: 'AmountDatum', label: string, count: number, amount: number, percentage?: number }> } };

export type GetWarrantyClaimsAnalyticsQueryVariables = Exact<{
  filters: AnalyticsFilters;
}>;


export type GetWarrantyClaimsAnalyticsQuery = { __typename?: 'Query', warrantyClaimsAnalytics?: { __typename?: 'WarrantyClaimsAnalyticsType', count: number, pendingCount: number, cancelledCount: number, approvedCount: number, rejectedCount: number, byDate: Array<{ __typename?: 'DateSeriesDatum', date: string, count: number, amount?: number }>, productRanking: Array<{ __typename?: 'WarrantyProductRankingDatum', count: number, amount?: number, ranking: number, product: { __typename?: 'WarrantyProductType', displayName: string, subcategory?: { __typename?: 'SubcategoryType', name: string, category: { __typename?: 'CategoryType', name: string } } } }>, failRate: Array<{ __typename?: 'ProductFailRate', percentage?: number, failQuantity?: number, saleQuantity?: number, product: { __typename?: 'WarrantyProductType', displayName: string, subcategory?: { __typename?: 'SubcategoryType', name: string, category: { __typename?: 'CategoryType', name: string } } } }> } };

export type DateSeriesFragment = { __typename?: 'DateSeriesDatum', date: string, count: number, amount?: number };

export type AmountDatumFragment = { __typename?: 'AmountDatum', label: string, count: number, amount: number, percentage?: number };

export type ProductRankingDatumFragment = { __typename?: 'ProductRankingDatum', count: number, amount?: number, ranking: number, product: { __typename?: 'ProductNode', displayName: string, subcategory?: { __typename?: 'SubcategoryType', name: string, category: { __typename?: 'CategoryType', name: string } } } };

export type WarrantyProductRankingDatumFragment = { __typename?: 'WarrantyProductRankingDatum', count: number, amount?: number, ranking: number, product: { __typename?: 'WarrantyProductType', displayName: string, subcategory?: { __typename?: 'SubcategoryType', name: string, category: { __typename?: 'CategoryType', name: string } } } };

export type ContactTypeOptionFragment = { __typename?: 'ContactTypeType', id: string, name: string };

export type ContactFragment = { __typename?: 'ContactNode', id: string, uuid: string, externalId: string, email?: string, firstName: string, lastName: string, displayName: string, phone: string, mobilePhone: string, active: boolean, type: { __typename?: 'ContactTypeType', id: string, name: string }, account: { __typename?: 'AccountType', id: string, uuid: string, name: string, taxId?: string, externalId: string, isFavorite: boolean, address?: string, location?: { __typename?: 'LocationType', id: string, path?: string, iva: Decimal }, owner?: { __typename?: 'OrganizationType', id: string, name: string, externalId: string, isEu: boolean, displayName: string, logo?: string, logoThumbnail?: string, location?: { __typename?: 'LocationType', id: string, name: string, path?: string, iva: Decimal }, group: { __typename?: 'OrganizationGroupType', id: string, dealerCommission?: string } } } };

export type ContactTypeFragment = { __typename?: 'ContactType', id: string, uuid: string, externalId: string, email?: string, firstName: string, lastName: string, displayName: string, phone: string, mobilePhone: string, active: boolean, type: { __typename?: 'ContactTypeType', id: string, name: string }, account: { __typename?: 'AccountType', id: string, uuid: string, name: string, taxId?: string, externalId: string, isFavorite: boolean, address?: string, location?: { __typename?: 'LocationType', id: string, path?: string, iva: Decimal }, owner?: { __typename?: 'OrganizationType', id: string, name: string, externalId: string, isEu: boolean, displayName: string, logo?: string, logoThumbnail?: string, location?: { __typename?: 'LocationType', id: string, name: string, path?: string, iva: Decimal }, group: { __typename?: 'OrganizationGroupType', id: string, dealerCommission?: string } } } };

export type ContactListFragment = { __typename?: 'ContactNode', uuid: string, id: string, email?: string, lastName: string, firstName: string, mobilePhone: string, phone: string, account: { __typename?: 'AccountType', id: string, uuid: string, name: string, owner?: { __typename?: 'OrganizationType', id: string, name: string } }, type: { __typename?: 'ContactTypeType', id: string, name: string } };

export type GetContactsQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  accountGlobalId?: InputMaybe<Scalars['UUID']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  owner?: InputMaybe<Scalars['UUID']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetContactsQuery = { __typename?: 'Query', contacts?: { __typename?: 'ContactNodeConnection', count: number, edges: Array<{ __typename?: 'ContactNodeEdge', cursor: string, node?: { __typename?: 'ContactNode', uuid: string, id: string, email?: string, lastName: string, firstName: string, mobilePhone: string, phone: string, account: { __typename?: 'AccountType', id: string, uuid: string, name: string, owner?: { __typename?: 'OrganizationType', id: string, name: string } }, type: { __typename?: 'ContactTypeType', id: string, name: string } } }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string, endCursor?: string } } };

export type GetContactQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetContactQuery = { __typename?: 'Query', contact?: { __typename?: 'ContactNode', id: string, uuid: string, externalId: string, email?: string, firstName: string, lastName: string, displayName: string, phone: string, mobilePhone: string, active: boolean, type: { __typename?: 'ContactTypeType', id: string, name: string }, account: { __typename?: 'AccountType', id: string, uuid: string, name: string, taxId?: string, externalId: string, isFavorite: boolean, address?: string, location?: { __typename?: 'LocationType', id: string, path?: string, iva: Decimal }, owner?: { __typename?: 'OrganizationType', id: string, name: string, externalId: string, isEu: boolean, displayName: string, logo?: string, logoThumbnail?: string, location?: { __typename?: 'LocationType', id: string, name: string, path?: string, iva: Decimal }, group: { __typename?: 'OrganizationGroupType', id: string, dealerCommission?: string } } } } };

export type GetContactsOptionsQueryVariables = Exact<{
  account?: InputMaybe<Scalars['UUID']['input']>;
}>;


export type GetContactsOptionsQuery = { __typename?: 'Query', contacts?: { __typename?: 'ContactNodeConnection', edges: Array<{ __typename?: 'ContactNodeEdge', cursor: string, node?: { __typename?: 'ContactNode', id: string, uuid: string, displayName: string } }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string, endCursor?: string } } };

export type GetContactTypesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetContactTypesQuery = { __typename?: 'Query', contactTypes: Array<{ __typename?: 'ContactTypeType', id: string, name: string }> };

export type CreateContactMutationVariables = Exact<{
  input: CreateContactMutationInput;
}>;


export type CreateContactMutation = { __typename?: 'Mutation', createContact?: { __typename?: 'CreateContactMutationPayload', contact?: { __typename?: 'ContactType', id: string, uuid: string }, errors: Array<{ __typename?: 'ErrorType', field: string, messages: Array<string> }> } };

export type UpdateContactMutationVariables = Exact<{
  input: UpdateContactMutationInput;
}>;


export type UpdateContactMutation = { __typename?: 'Mutation', updateContact?: { __typename?: 'UpdateContactMutationPayload', contact?: { __typename?: 'ContactType', id: string, uuid: string }, errors: Array<{ __typename?: 'ErrorType', field: string, messages: Array<string> }> } };

export type DeleteContactMutationVariables = Exact<{
  input: DeleteContactMutationInput;
}>;


export type DeleteContactMutation = { __typename?: 'Mutation', deleteContact?: { __typename?: 'DeleteContactMutationPayload', errors: Array<{ __typename?: 'ErrorType', field: string, messages: Array<string> }> } };

export type FeatureFlagFragment = { __typename?: 'FeatureFlagType', id: string, name: string, description: string, isActive: boolean, userHasAccess?: boolean };

export type GetFeatureFlagsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetFeatureFlagsQuery = { __typename?: 'Query', activeFeatureFlags?: Array<{ __typename?: 'FeatureFlagType', id: string, name: string, description: string, isActive: boolean, userHasAccess?: boolean }> };

export type GetFeatureFlagQueryVariables = Exact<{
  name: Scalars['String']['input'];
}>;


export type GetFeatureFlagQuery = { __typename?: 'Query', activeFeatureFlag?: { __typename?: 'FeatureFlagType', id: string, name: string, description: string, isActive: boolean, userHasAccess?: boolean } };

export type GetUserFeatureAccessQueryVariables = Exact<{
  featureName: Scalars['String']['input'];
}>;


export type GetUserFeatureAccessQuery = { __typename?: 'Query', userFeatureAccess?: boolean };

export type LocationOptionFragment = { __typename?: 'LocationType', id: string, path?: string, iva: Decimal };

export type GetLocationsQueryVariables = Exact<{
  id?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  parentDescendatsId?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetLocationsQuery = { __typename?: 'Query', locations?: Array<{ __typename?: 'LocationType', id: string, path?: string, iva: Decimal }> };

export type GetLocationQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetLocationQuery = { __typename?: 'Query', location?: { __typename?: 'LocationType', id: string, path?: string, iva: Decimal } };

export type NotificationFragment = { __typename?: 'NotificationNode', id: string, uuid: string, message: string, path: string, isRead: boolean, created: string, updated: string, user: { __typename?: 'UserType', id: string } };

export type GetNotificationsQueryVariables = Exact<{
  offset?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetNotificationsQuery = { __typename?: 'Query', unreadCount: number, notifications?: { __typename?: 'NotificationNodeConnection', edges: Array<{ __typename?: 'NotificationNodeEdge', cursor: string, node?: { __typename?: 'NotificationNode', id: string, uuid: string, message: string, path: string, isRead: boolean, created: string, updated: string, user: { __typename?: 'UserType', id: string } } }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string, endCursor?: string } } };

export type GetNotificationsUnreadCountQueryVariables = Exact<{ [key: string]: never; }>;


export type GetNotificationsUnreadCountQuery = { __typename?: 'Query', unreadCount: number };

export type MarkNotificationAsReadMutationVariables = Exact<{
  input: MarkNotificationAsReadMutationInput;
}>;


export type MarkNotificationAsReadMutation = { __typename?: 'Mutation', markNotificationAsRead?: { __typename?: 'MarkNotificationAsReadMutationPayload', notification?: { __typename?: 'NotificationNode', id: string, uuid: string, message: string, path: string, isRead: boolean, created: string, updated: string, user: { __typename?: 'UserType', id: string } }, errors: Array<{ __typename?: 'ErrorType', field: string, messages: Array<string> }> } };

export type MarkAllNotificationsAsReadMutationVariables = Exact<{ [key: string]: never; }>;


export type MarkAllNotificationsAsReadMutation = { __typename?: 'Mutation', markAllNotificationsAsRead?: { __typename?: 'MarkAllNotificationsAsRead', status?: boolean } };

export type ErrorFragment = { __typename?: 'ErrorType', field: string, messages: Array<string> };

export type DraftBlueprintEcnFragment = { __typename?: 'DraftBlueprintEcnType', id: string, file?: string };

export type DraftEcnFragment = { __typename?: 'DraftEcnNode', id: string, uuid: string, step: number, data?: string, created: string, updated: string, createdBy?: { __typename?: 'UserType', id: string, uuid: string, email: string, firstName: string, lastName: string, displayName: string, isActive: boolean, isStaff: boolean, dateJoined: string, lastLogin?: string, language: string, emailNotifications: boolean, inAppNotifications: boolean, termsAndConditionsAcceptedAt?: string }, updatedBy?: { __typename?: 'UserType', id: string, uuid: string, email: string, firstName: string, lastName: string, displayName: string, isActive: boolean, isStaff: boolean, dateJoined: string, lastLogin?: string, language: string, emailNotifications: boolean, inAppNotifications: boolean, termsAndConditionsAcceptedAt?: string }, blueprints: Array<{ __typename?: 'DraftBlueprintEcnType', id: string, file?: string }> };

export type DraftEcnListFragment = { __typename?: 'DraftEcnNode', ecnNumberDuplicated?: boolean, id: string, uuid: string, step: number, data?: string, created: string, updated: string, createdBy?: { __typename?: 'UserType', id: string, uuid: string, email: string, firstName: string, lastName: string, displayName: string, isActive: boolean, isStaff: boolean, dateJoined: string, lastLogin?: string, language: string, emailNotifications: boolean, inAppNotifications: boolean, termsAndConditionsAcceptedAt?: string }, updatedBy?: { __typename?: 'UserType', id: string, uuid: string, email: string, firstName: string, lastName: string, displayName: string, isActive: boolean, isStaff: boolean, dateJoined: string, lastLogin?: string, language: string, emailNotifications: boolean, inAppNotifications: boolean, termsAndConditionsAcceptedAt?: string }, blueprints: Array<{ __typename?: 'DraftBlueprintEcnType', id: string, file?: string }> };

export type DefaultEcnTaskFragment = { __typename?: 'DefaultTaskType', id: string, name: EcnsDefaultTaskNameChoices, displayName: string, description?: string, ecnTypes?: Array<EcnsDefaultTaskEcnTypesChoices>, roles: Array<{ __typename?: 'EcnRoleType', id: string, name: string }> };

export type EcnTaskFragment = { __typename?: 'EcnTaskType', id: string, notes: string, name: EcnsEcnTaskNameChoices, displayName: string, done: boolean, ecnTypes?: Array<EcnsEcnTaskEcnTypesChoices>, originalTask?: { __typename?: 'DefaultTaskType', id: string }, roles: Array<{ __typename?: 'EcnRoleType', id: string, name: string }>, doneBy?: { __typename?: 'UserType', id: string, uuid: string, email: string, firstName: string, lastName: string, displayName: string, isActive: boolean, isStaff: boolean, dateJoined: string, lastLogin?: string, language: string, emailNotifications: boolean, inAppNotifications: boolean, termsAndConditionsAcceptedAt?: string } };

export type EcnNewPartFragment = { __typename?: 'EcnNewPartType', id: string, name: string, externalId: string, type: EcnsEcnNewPartTypeChoices, displayType: string, pricing?: string, yearlyForecast?: string, betaQuantity?: string, buyingDate?: string, estimatedDateArrival?: string, buyingPrice?: string, supplier?: string, description: string, supportNotes?: string, supportLink?: string, tariffPosition?: boolean, tariffPositionNotes?: string, partsArrived: boolean, subcategory: { __typename?: 'SubcategoryType', id: string, name: string }, origin?: { __typename?: 'ProductOriginType', id: string, name: string } };

export type EcnCancelledPartFragment = { __typename?: 'EcnCancelledPartType', id: string, replace: EcnsEcnCancelledPartReplaceChoices, displayReplace: string, currentVersion?: string, targetVersion?: string, description: string, pricing?: string, yearlyForecast?: string, betaQuantity?: string, buyingDate?: string, estimatedDateArrival?: string, buyingPrice?: string, supplier?: string, supportNotes?: string, supportLink?: string, tariffPosition?: boolean, tariffPositionNotes?: string, partsArrived: boolean, part: { __typename?: 'ProductNode', type: ProductsProductTypeChoices, displayType: string, id: string, name: string, displayName: string, externalId: string, subcategory?: { __typename?: 'SubcategoryType', id: string, name: string, category: { __typename?: 'CategoryType', name: string, id: string } } }, origin?: { __typename?: 'ProductOriginType', id: string, name: string } };

export type EcnPartFragment = { __typename?: 'EcnPartType', id: string, externalId?: string, type: EcnsEcnPartTypeChoices, displayType: string, newParts: Array<{ __typename?: 'EcnNewPartType', id: string, name: string, externalId: string, type: EcnsEcnNewPartTypeChoices, displayType: string, pricing?: string, yearlyForecast?: string, betaQuantity?: string, buyingDate?: string, estimatedDateArrival?: string, buyingPrice?: string, supplier?: string, description: string, supportNotes?: string, supportLink?: string, tariffPosition?: boolean, tariffPositionNotes?: string, partsArrived: boolean, subcategory: { __typename?: 'SubcategoryType', id: string, name: string }, origin?: { __typename?: 'ProductOriginType', id: string, name: string } }>, cancelledParts: Array<{ __typename?: 'EcnCancelledPartType', id: string, replace: EcnsEcnCancelledPartReplaceChoices, displayReplace: string, currentVersion?: string, targetVersion?: string, description: string, pricing?: string, yearlyForecast?: string, betaQuantity?: string, buyingDate?: string, estimatedDateArrival?: string, buyingPrice?: string, supplier?: string, supportNotes?: string, supportLink?: string, tariffPosition?: boolean, tariffPositionNotes?: string, partsArrived: boolean, part: { __typename?: 'ProductNode', type: ProductsProductTypeChoices, displayType: string, id: string, name: string, displayName: string, externalId: string, subcategory?: { __typename?: 'SubcategoryType', id: string, name: string, category: { __typename?: 'CategoryType', name: string, id: string } } }, origin?: { __typename?: 'ProductOriginType', id: string, name: string } }> };

export type EcnFragment = { __typename?: 'EcnNode', id: string, uuid: string, created: string, effectiveDate?: string, previousEcnId?: string, nextEcnId?: string, updated: string, status?: EcnsEcnStatusChoices, displayStatus: string, displayId: number, ecnNumber: string, notes: string, recipient?: EcnsEcnRecipientChoices, displayRecipient: string, viewed?: boolean, warrantyPriority: boolean, seasonPriority: EcnsEcnSeasonPriorityChoices, displaySeasonPriority: string, createdBy?: { __typename?: 'UserType', id: string, uuid: string, email: string, firstName: string, lastName: string, displayName: string, isActive: boolean, isStaff: boolean, dateJoined: string, lastLogin?: string, language: string, emailNotifications: boolean, inAppNotifications: boolean, termsAndConditionsAcceptedAt?: string }, realesedBy?: { __typename?: 'UserType', id: string, uuid: string, email: string, firstName: string, lastName: string, displayName: string, isActive: boolean, isStaff: boolean, dateJoined: string, lastLogin?: string, language: string, emailNotifications: boolean, inAppNotifications: boolean, termsAndConditionsAcceptedAt?: string }, updatedBy?: { __typename?: 'UserType', id: string, uuid: string, email: string, firstName: string, lastName: string, displayName: string, isActive: boolean, isStaff: boolean, dateJoined: string, lastLogin?: string, language: string, emailNotifications: boolean, inAppNotifications: boolean, termsAndConditionsAcceptedAt?: string }, oems: Array<{ __typename?: 'OrganizationType', id: string, name: string }>, fyi: Array<{ __typename?: 'RoleType', id: string, name: string }>, informedUsers: Array<{ __typename?: 'UserType', id: string, email: string }>, blueprints: Array<{ __typename?: 'EcnBlueprintType', id: string, file: string }>, tasks: Array<{ __typename?: 'EcnTaskType', id: string, notes: string, name: EcnsEcnTaskNameChoices, displayName: string, done: boolean, ecnTypes?: Array<EcnsEcnTaskEcnTypesChoices>, originalTask?: { __typename?: 'DefaultTaskType', id: string }, roles: Array<{ __typename?: 'EcnRoleType', id: string, name: string }>, doneBy?: { __typename?: 'UserType', id: string, uuid: string, email: string, firstName: string, lastName: string, displayName: string, isActive: boolean, isStaff: boolean, dateJoined: string, lastLogin?: string, language: string, emailNotifications: boolean, inAppNotifications: boolean, termsAndConditionsAcceptedAt?: string } }>, parts: Array<{ __typename?: 'EcnPartType', id: string, externalId?: string, type: EcnsEcnPartTypeChoices, displayType: string, newParts: Array<{ __typename?: 'EcnNewPartType', id: string, name: string, externalId: string, type: EcnsEcnNewPartTypeChoices, displayType: string, pricing?: string, yearlyForecast?: string, betaQuantity?: string, buyingDate?: string, estimatedDateArrival?: string, buyingPrice?: string, supplier?: string, description: string, supportNotes?: string, supportLink?: string, tariffPosition?: boolean, tariffPositionNotes?: string, partsArrived: boolean, subcategory: { __typename?: 'SubcategoryType', id: string, name: string }, origin?: { __typename?: 'ProductOriginType', id: string, name: string } }>, cancelledParts: Array<{ __typename?: 'EcnCancelledPartType', id: string, replace: EcnsEcnCancelledPartReplaceChoices, displayReplace: string, currentVersion?: string, targetVersion?: string, description: string, pricing?: string, yearlyForecast?: string, betaQuantity?: string, buyingDate?: string, estimatedDateArrival?: string, buyingPrice?: string, supplier?: string, supportNotes?: string, supportLink?: string, tariffPosition?: boolean, tariffPositionNotes?: string, partsArrived: boolean, part: { __typename?: 'ProductNode', type: ProductsProductTypeChoices, displayType: string, id: string, name: string, displayName: string, externalId: string, subcategory?: { __typename?: 'SubcategoryType', id: string, name: string, category: { __typename?: 'CategoryType', name: string, id: string } } }, origin?: { __typename?: 'ProductOriginType', id: string, name: string } }> }>, files: Array<{ __typename?: 'EcnFileType', id: string, created: string, file: string }> };

export type EcnListFragment = { __typename?: 'EcnNode', uuid: string, id: string, displayId: number, created: string, effectiveDate?: string, status?: EcnsEcnStatusChoices, displayStatus: string, totalInformedUsers?: number, totalNotInformedUsers?: number, ecnNumber: string, viewed?: boolean, warrantyPriority: boolean, seasonPriority: EcnsEcnSeasonPriorityChoices, displaySeasonPriority: string, createdBy?: { __typename?: 'UserType', id: string, uuid: string, email: string, firstName: string, lastName: string, displayName: string, isActive: boolean, isStaff: boolean, dateJoined: string, lastLogin?: string, language: string, emailNotifications: boolean, inAppNotifications: boolean, termsAndConditionsAcceptedAt?: string }, realesedBy?: { __typename?: 'UserType', id: string, uuid: string, email: string, firstName: string, lastName: string, displayName: string, isActive: boolean, isStaff: boolean, dateJoined: string, lastLogin?: string, language: string, emailNotifications: boolean, inAppNotifications: boolean, termsAndConditionsAcceptedAt?: string }, parts: Array<{ __typename?: 'EcnPartType', id: string, type: EcnsEcnPartTypeChoices, displayType: string, newParts: Array<{ __typename?: 'EcnNewPartType', id: string, name: string, externalId: string, type: EcnsEcnNewPartTypeChoices, displayType: string, pricing?: string, yearlyForecast?: string, betaQuantity?: string, buyingDate?: string, estimatedDateArrival?: string, buyingPrice?: string, supplier?: string, description: string, supportNotes?: string, supportLink?: string, tariffPosition?: boolean, tariffPositionNotes?: string, partsArrived: boolean, subcategory: { __typename?: 'SubcategoryType', id: string, name: string }, origin?: { __typename?: 'ProductOriginType', id: string, name: string } }>, cancelledParts: Array<{ __typename?: 'EcnCancelledPartType', id: string, replace: EcnsEcnCancelledPartReplaceChoices, displayReplace: string, currentVersion?: string, targetVersion?: string, description: string, pricing?: string, yearlyForecast?: string, betaQuantity?: string, buyingDate?: string, estimatedDateArrival?: string, buyingPrice?: string, supplier?: string, supportNotes?: string, supportLink?: string, tariffPosition?: boolean, tariffPositionNotes?: string, partsArrived: boolean, part: { __typename?: 'ProductNode', type: ProductsProductTypeChoices, displayType: string, id: string, name: string, displayName: string, externalId: string, subcategory?: { __typename?: 'SubcategoryType', id: string, name: string, category: { __typename?: 'CategoryType', name: string, id: string } } }, origin?: { __typename?: 'ProductOriginType', id: string, name: string } }> }>, fyi: Array<{ __typename?: 'RoleType', id: string, name: string }>, tasks: Array<{ __typename?: 'EcnTaskType', id: string, done: boolean, name: EcnsEcnTaskNameChoices, displayName: string, users: Array<{ __typename?: 'UserType', id: string, email: string, firstName: string, lastName: string, displayName: string, isActive: boolean, isStaff: boolean, dateJoined: string, lastLogin?: string, language: string, emailNotifications: boolean, inAppNotifications: boolean, termsAndConditionsAcceptedAt?: string }> }> };

export type GetEcnsNumbersQueryVariables = Exact<{ [key: string]: never; }>;


export type GetEcnsNumbersQuery = { __typename?: 'Query', ecns?: { __typename?: 'EcnNodeConnection', edges: Array<{ __typename?: 'EcnNodeEdge', node?: { __typename?: 'EcnNode', ecnNumber: string } }> } };

export type GetEcnQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  uuid?: InputMaybe<Scalars['UUID']['input']>;
}>;


export type GetEcnQuery = { __typename?: 'Query', ecn?: { __typename?: 'EcnNode', id: string, uuid: string, created: string, effectiveDate?: string, previousEcnId?: string, nextEcnId?: string, updated: string, status?: EcnsEcnStatusChoices, displayStatus: string, displayId: number, ecnNumber: string, notes: string, recipient?: EcnsEcnRecipientChoices, displayRecipient: string, viewed?: boolean, warrantyPriority: boolean, seasonPriority: EcnsEcnSeasonPriorityChoices, displaySeasonPriority: string, createdBy?: { __typename?: 'UserType', id: string, uuid: string, email: string, firstName: string, lastName: string, displayName: string, isActive: boolean, isStaff: boolean, dateJoined: string, lastLogin?: string, language: string, emailNotifications: boolean, inAppNotifications: boolean, termsAndConditionsAcceptedAt?: string }, realesedBy?: { __typename?: 'UserType', id: string, uuid: string, email: string, firstName: string, lastName: string, displayName: string, isActive: boolean, isStaff: boolean, dateJoined: string, lastLogin?: string, language: string, emailNotifications: boolean, inAppNotifications: boolean, termsAndConditionsAcceptedAt?: string }, updatedBy?: { __typename?: 'UserType', id: string, uuid: string, email: string, firstName: string, lastName: string, displayName: string, isActive: boolean, isStaff: boolean, dateJoined: string, lastLogin?: string, language: string, emailNotifications: boolean, inAppNotifications: boolean, termsAndConditionsAcceptedAt?: string }, oems: Array<{ __typename?: 'OrganizationType', id: string, name: string }>, fyi: Array<{ __typename?: 'RoleType', id: string, name: string }>, informedUsers: Array<{ __typename?: 'UserType', id: string, email: string }>, blueprints: Array<{ __typename?: 'EcnBlueprintType', id: string, file: string }>, tasks: Array<{ __typename?: 'EcnTaskType', id: string, notes: string, name: EcnsEcnTaskNameChoices, displayName: string, done: boolean, ecnTypes?: Array<EcnsEcnTaskEcnTypesChoices>, originalTask?: { __typename?: 'DefaultTaskType', id: string }, roles: Array<{ __typename?: 'EcnRoleType', id: string, name: string }>, doneBy?: { __typename?: 'UserType', id: string, uuid: string, email: string, firstName: string, lastName: string, displayName: string, isActive: boolean, isStaff: boolean, dateJoined: string, lastLogin?: string, language: string, emailNotifications: boolean, inAppNotifications: boolean, termsAndConditionsAcceptedAt?: string } }>, parts: Array<{ __typename?: 'EcnPartType', id: string, externalId?: string, type: EcnsEcnPartTypeChoices, displayType: string, newParts: Array<{ __typename?: 'EcnNewPartType', id: string, name: string, externalId: string, type: EcnsEcnNewPartTypeChoices, displayType: string, pricing?: string, yearlyForecast?: string, betaQuantity?: string, buyingDate?: string, estimatedDateArrival?: string, buyingPrice?: string, supplier?: string, description: string, supportNotes?: string, supportLink?: string, tariffPosition?: boolean, tariffPositionNotes?: string, partsArrived: boolean, subcategory: { __typename?: 'SubcategoryType', id: string, name: string }, origin?: { __typename?: 'ProductOriginType', id: string, name: string } }>, cancelledParts: Array<{ __typename?: 'EcnCancelledPartType', id: string, replace: EcnsEcnCancelledPartReplaceChoices, displayReplace: string, currentVersion?: string, targetVersion?: string, description: string, pricing?: string, yearlyForecast?: string, betaQuantity?: string, buyingDate?: string, estimatedDateArrival?: string, buyingPrice?: string, supplier?: string, supportNotes?: string, supportLink?: string, tariffPosition?: boolean, tariffPositionNotes?: string, partsArrived: boolean, part: { __typename?: 'ProductNode', type: ProductsProductTypeChoices, displayType: string, id: string, name: string, displayName: string, externalId: string, subcategory?: { __typename?: 'SubcategoryType', id: string, name: string, category: { __typename?: 'CategoryType', name: string, id: string } } }, origin?: { __typename?: 'ProductOriginType', id: string, name: string } }> }>, files: Array<{ __typename?: 'EcnFileType', id: string, created: string, file: string }> } };

export type GetDefaultTaskQueryVariables = Exact<{
  id?: InputMaybe<Scalars['UUID']['input']>;
}>;


export type GetDefaultTaskQuery = { __typename?: 'Query', defaultTask: { __typename?: 'DefaultTaskType', id: string, name: EcnsDefaultTaskNameChoices, displayName: string, description?: string, ecnTypes?: Array<EcnsDefaultTaskEcnTypesChoices>, roles: Array<{ __typename?: 'EcnRoleType', id: string, name: string }> } };

export type GetDefaultTasksQueryVariables = Exact<{ [key: string]: never; }>;


export type GetDefaultTasksQuery = { __typename?: 'Query', defaultTasks: Array<{ __typename?: 'DefaultTaskType', id: string, name: EcnsDefaultTaskNameChoices, displayName: string, description?: string, ecnTypes?: Array<EcnsDefaultTaskEcnTypesChoices>, roles: Array<{ __typename?: 'EcnRoleType', id: string, name: string }> }> };

export type GetRolesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetRolesQuery = { __typename?: 'Query', roles: Array<{ __typename?: 'RoleType', id: string, name: string, userSet: Array<{ __typename?: 'UserType', id: string, displayName: string }> }> };

export type GetValidEncNumberQueryVariables = Exact<{
  ecnNumber: Scalars['String']['input'];
  id?: InputMaybe<Scalars['UUID']['input']>;
}>;


export type GetValidEncNumberQuery = { __typename?: 'Query', validEcnNumber: boolean };

export type GetDraftEcnQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  uuid?: InputMaybe<Scalars['UUID']['input']>;
}>;


export type GetDraftEcnQuery = { __typename?: 'Query', draftEcn?: { __typename?: 'DraftEcnNode', id: string, uuid: string, step: number, data?: string, created: string, updated: string, createdBy?: { __typename?: 'UserType', id: string, uuid: string, email: string, firstName: string, lastName: string, displayName: string, isActive: boolean, isStaff: boolean, dateJoined: string, lastLogin?: string, language: string, emailNotifications: boolean, inAppNotifications: boolean, termsAndConditionsAcceptedAt?: string }, updatedBy?: { __typename?: 'UserType', id: string, uuid: string, email: string, firstName: string, lastName: string, displayName: string, isActive: boolean, isStaff: boolean, dateJoined: string, lastLogin?: string, language: string, emailNotifications: boolean, inAppNotifications: boolean, termsAndConditionsAcceptedAt?: string }, blueprints: Array<{ __typename?: 'DraftBlueprintEcnType', id: string, file?: string }> } };

export type GetProductOriginsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetProductOriginsQuery = { __typename?: 'Query', productOrigins: Array<{ __typename?: 'ProductOriginType', id: string, name: string }> };

export type GetDraftsEcnsQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  createdGte?: InputMaybe<Scalars['Date']['input']>;
  createdLte?: InputMaybe<Scalars['Date']['input']>;
}>;


export type GetDraftsEcnsQuery = { __typename?: 'Query', draftsEcns?: { __typename?: 'DraftEcnNodeConnection', count: number, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string, endCursor?: string }, edges: Array<{ __typename?: 'DraftEcnNodeEdge', cursor: string, node?: { __typename?: 'DraftEcnNode', ecnNumberDuplicated?: boolean, id: string, uuid: string, step: number, data?: string, created: string, updated: string, createdBy?: { __typename?: 'UserType', id: string, uuid: string, email: string, firstName: string, lastName: string, displayName: string, isActive: boolean, isStaff: boolean, dateJoined: string, lastLogin?: string, language: string, emailNotifications: boolean, inAppNotifications: boolean, termsAndConditionsAcceptedAt?: string }, updatedBy?: { __typename?: 'UserType', id: string, uuid: string, email: string, firstName: string, lastName: string, displayName: string, isActive: boolean, isStaff: boolean, dateJoined: string, lastLogin?: string, language: string, emailNotifications: boolean, inAppNotifications: boolean, termsAndConditionsAcceptedAt?: string }, blueprints: Array<{ __typename?: 'DraftBlueprintEcnType', id: string, file?: string }> } }> } };

export type GetEcnsQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  createdGte?: InputMaybe<Scalars['Date']['input']>;
  createdLte?: InputMaybe<Scalars['Date']['input']>;
  createdByIn?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
  releasedByIn?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
  statusIn?: InputMaybe<Array<InputMaybe<EcnsEcnStatusChoices>>>;
  tasksDone?: InputMaybe<Scalars['Boolean']['input']>;
  recipientIn?: InputMaybe<Array<InputMaybe<EcnsEcnRecipientChoices>>>;
  pendingTaskName?: InputMaybe<Scalars['String']['input']>;
  pendingTaskNameIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  partsNumbers?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  seasonPriority?: InputMaybe<EcnsEcnSeasonPriorityChoices>;
  parts_Type_In?: InputMaybe<Array<InputMaybe<EcnsEcnPartTypeChoices>>>;
  parts_NewParts_Type_In?: InputMaybe<Array<InputMaybe<EcnsEcnNewPartTypeChoices>>>;
  tasksPendingForUsers?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  ecnNumber_In?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  effectiveDate_Gte?: InputMaybe<Scalars['Date']['input']>;
  effectiveDate_Lte?: InputMaybe<Scalars['Date']['input']>;
  warrantyPriority?: InputMaybe<Scalars['Boolean']['input']>;
  tasksRolesUsersIn?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
}>;


export type GetEcnsQuery = { __typename?: 'Query', ecns?: { __typename?: 'EcnNodeConnection', count: number, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string, endCursor?: string }, edges: Array<{ __typename?: 'EcnNodeEdge', cursor: string, node?: { __typename?: 'EcnNode', uuid: string, id: string, displayId: number, created: string, effectiveDate?: string, status?: EcnsEcnStatusChoices, displayStatus: string, totalInformedUsers?: number, totalNotInformedUsers?: number, ecnNumber: string, viewed?: boolean, warrantyPriority: boolean, seasonPriority: EcnsEcnSeasonPriorityChoices, displaySeasonPriority: string, createdBy?: { __typename?: 'UserType', id: string, uuid: string, email: string, firstName: string, lastName: string, displayName: string, isActive: boolean, isStaff: boolean, dateJoined: string, lastLogin?: string, language: string, emailNotifications: boolean, inAppNotifications: boolean, termsAndConditionsAcceptedAt?: string }, realesedBy?: { __typename?: 'UserType', id: string, uuid: string, email: string, firstName: string, lastName: string, displayName: string, isActive: boolean, isStaff: boolean, dateJoined: string, lastLogin?: string, language: string, emailNotifications: boolean, inAppNotifications: boolean, termsAndConditionsAcceptedAt?: string }, parts: Array<{ __typename?: 'EcnPartType', id: string, type: EcnsEcnPartTypeChoices, displayType: string, newParts: Array<{ __typename?: 'EcnNewPartType', id: string, name: string, externalId: string, type: EcnsEcnNewPartTypeChoices, displayType: string, pricing?: string, yearlyForecast?: string, betaQuantity?: string, buyingDate?: string, estimatedDateArrival?: string, buyingPrice?: string, supplier?: string, description: string, supportNotes?: string, supportLink?: string, tariffPosition?: boolean, tariffPositionNotes?: string, partsArrived: boolean, subcategory: { __typename?: 'SubcategoryType', id: string, name: string }, origin?: { __typename?: 'ProductOriginType', id: string, name: string } }>, cancelledParts: Array<{ __typename?: 'EcnCancelledPartType', id: string, replace: EcnsEcnCancelledPartReplaceChoices, displayReplace: string, currentVersion?: string, targetVersion?: string, description: string, pricing?: string, yearlyForecast?: string, betaQuantity?: string, buyingDate?: string, estimatedDateArrival?: string, buyingPrice?: string, supplier?: string, supportNotes?: string, supportLink?: string, tariffPosition?: boolean, tariffPositionNotes?: string, partsArrived: boolean, part: { __typename?: 'ProductNode', type: ProductsProductTypeChoices, displayType: string, id: string, name: string, displayName: string, externalId: string, subcategory?: { __typename?: 'SubcategoryType', id: string, name: string, category: { __typename?: 'CategoryType', name: string, id: string } } }, origin?: { __typename?: 'ProductOriginType', id: string, name: string } }> }>, fyi: Array<{ __typename?: 'RoleType', id: string, name: string }>, tasks: Array<{ __typename?: 'EcnTaskType', id: string, done: boolean, name: EcnsEcnTaskNameChoices, displayName: string, users: Array<{ __typename?: 'UserType', id: string, email: string, firstName: string, lastName: string, displayName: string, isActive: boolean, isStaff: boolean, dateJoined: string, lastLogin?: string, language: string, emailNotifications: boolean, inAppNotifications: boolean, termsAndConditionsAcceptedAt?: string }> }> } }> } };

export type GetPartsNumbersQueryVariables = Exact<{ [key: string]: never; }>;


export type GetPartsNumbersQuery = { __typename?: 'Query', partsNumbers: Array<{ __typename?: 'PartNumberType', displayName: string, externalId: string }> };

export type CreateEcnMutationVariables = Exact<{
  input: CreateEcnMutationInput;
}>;


export type CreateEcnMutation = { __typename?: 'Mutation', createEcn?: { __typename?: 'CreateEcnMutationPayload', ecn?: { __typename?: 'EcnType', id: string }, errors: Array<{ __typename?: 'ErrorType', field: string, messages: Array<string> }> } };

export type UpdateEcnMutationVariables = Exact<{
  input: UpdateEcnMutationInput;
}>;


export type UpdateEcnMutation = { __typename?: 'Mutation', updateEcn?: { __typename?: 'UpdateEcnMutationPayload', ecn?: { __typename?: 'EcnType', id: string }, errors: Array<{ __typename?: 'ErrorType', field: string, messages: Array<string> }> } };

export type EcnPricingTaskMutationVariables = Exact<{
  input: PricingTaskMutationInput;
}>;


export type EcnPricingTaskMutation = { __typename?: 'Mutation', ecnPricingTask?: { __typename?: 'PricingTaskMutationPayload', ecn?: { __typename?: 'EcnType', id: string }, errors: Array<{ __typename?: 'ErrorType', field: string, messages: Array<string> }> } };

export type EcnForecastTaskMutationVariables = Exact<{
  input: ForecastTaskMutationInput;
}>;


export type EcnForecastTaskMutation = { __typename?: 'Mutation', ecnForecastTask?: { __typename?: 'ForecastTaskMutationPayload', ecn?: { __typename?: 'EcnType', id: string }, errors: Array<{ __typename?: 'ErrorType', field: string, messages: Array<string> }> } };

export type NewModCancelledPartsPurchaseTaskMutationVariables = Exact<{
  input: NewModCancelledPartsPurchaseTaskMutationInput;
}>;


export type NewModCancelledPartsPurchaseTaskMutation = { __typename?: 'Mutation', newModCancelledPartsPurchaseTask?: { __typename?: 'NewModCancelledPartsPurchaseTaskMutationPayload', ecn?: { __typename?: 'EcnType', id: string }, errors: Array<{ __typename?: 'ErrorType', field: string, messages: Array<string> }> } };

export type NewModCancelPartsTaskMutationVariables = Exact<{
  input: NewModCancelPartsTaskMutationInput;
}>;


export type NewModCancelPartsTaskMutation = { __typename?: 'Mutation', newModCancelPartsTask?: { __typename?: 'NewModCancelPartsTaskMutationPayload', ecn?: { __typename?: 'EcnType', id: string }, errors: Array<{ __typename?: 'ErrorType', field: string, messages: Array<string> }> } };

export type ProductSupportTaskMutationVariables = Exact<{
  input: ProductSupportTaskMutationInput;
}>;


export type ProductSupportTaskMutation = { __typename?: 'Mutation', productSupportTask?: { __typename?: 'ProductSupportTaskMutationPayload', ecn?: { __typename?: 'EcnType', id: string }, errors: Array<{ __typename?: 'ErrorType', field: string, messages: Array<string> }> } };

export type EcnMarkAsSeenMutationVariables = Exact<{
  input: EcnMarkAsSeenMutationInput;
}>;


export type EcnMarkAsSeenMutation = { __typename?: 'Mutation', ecnMarkAsSeen?: { __typename?: 'EcnMarkAsSeenMutationPayload', ecn?: { __typename?: 'EcnType', id: string }, errors: Array<{ __typename?: 'ErrorType', field: string, messages: Array<string> }> } };

export type DraftEcnMutationVariables = Exact<{
  input: DraftEcnMutationInput;
}>;


export type DraftEcnMutation = { __typename?: 'Mutation', draftEcn?: { __typename?: 'DraftEcnMutationPayload', draftEcn?: { __typename?: 'DraftEcnNode', id: string, data?: string, blueprints: Array<{ __typename?: 'DraftBlueprintEcnType', id: string, file?: string }> }, errors: Array<{ __typename?: 'ErrorType', field: string, messages: Array<string> }> } };

export type DeleteDraftEcnMutationVariables = Exact<{
  input: DeleteDraftEcnMutationInput;
}>;


export type DeleteDraftEcnMutation = { __typename?: 'Mutation', deleteDraftEcn?: { __typename?: 'DeleteDraftEcnMutationPayload', errors: Array<{ __typename?: 'ErrorType', field: string, messages: Array<string> }> } };

export type NotificateTasksForUserMutationVariables = Exact<{
  input: NotificateTasksForUserInput;
}>;


export type NotificateTasksForUserMutation = { __typename?: 'Mutation', notificateTasksForUser?: { __typename?: 'NotificateTasksForUserPayload', errors: Array<{ __typename?: 'ErrorType', field: string, messages: Array<string> }> } };

export type UpdateEffectiveDateMutationVariables = Exact<{
  id: Scalars['UUID']['input'];
  effectiveDate: Scalars['Date']['input'];
}>;


export type UpdateEffectiveDateMutation = { __typename?: 'Mutation', updateEffectiveDate?: { __typename?: 'UpdateEcnEffectiveDateMutation', ecn?: { __typename?: 'EcnType', id: string } } };

export type HistoricalEcnFragment = { __typename?: 'HistoricalEcnType', created: string, updated: string, id: string, status: string, displayId: number, ecnNumber: string, notes: string, recipient: string, warrantyPriority: boolean, seasonPriority: string, effectiveDate?: string, historyId: string, historyDate: string, historyChangeReason?: string, historyTypeDisplay: string };

export type EcnTaskCommentFragment = { __typename?: 'EcnTaskCommentNode', id: string, uuid: string, created: string, content: string, createdBy?: { __typename?: 'UserType', id: string, uuid: string, email: string, firstName: string, lastName: string, displayName: string, isActive: boolean, isStaff: boolean, dateJoined: string, lastLogin?: string, language: string, emailNotifications: boolean, inAppNotifications: boolean, termsAndConditionsAcceptedAt?: string }, task: { __typename?: 'EcnTaskType', id: string } };

export type GetEcnTaskCommentsQueryVariables = Exact<{
  taskId?: InputMaybe<Scalars['UUID']['input']>;
}>;


export type GetEcnTaskCommentsQuery = { __typename?: 'Query', taskComments?: { __typename?: 'EcnTaskCommentNodeConnection', count: number, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string, endCursor?: string }, edges: Array<{ __typename?: 'EcnTaskCommentNodeEdge', node?: { __typename?: 'EcnTaskCommentNode', id: string, uuid: string, created: string, content: string, createdBy?: { __typename?: 'UserType', id: string, uuid: string, email: string, firstName: string, lastName: string, displayName: string, isActive: boolean, isStaff: boolean, dateJoined: string, lastLogin?: string, language: string, emailNotifications: boolean, inAppNotifications: boolean, termsAndConditionsAcceptedAt?: string }, task: { __typename?: 'EcnTaskType', id: string } } }> } };

export type EcnTaskCommentMutationVariables = Exact<{
  input: EcnTaskCommentMutationInput;
}>;


export type EcnTaskCommentMutation = { __typename?: 'Mutation', ecnTaskComment?: { __typename?: 'EcnTaskCommentMutationPayload', ecnTaskComment?: { __typename?: 'EcnTaskCommentNode', id: string, uuid: string, created: string, content: string, createdBy?: { __typename?: 'UserType', id: string, uuid: string, email: string, firstName: string, lastName: string, displayName: string, isActive: boolean, isStaff: boolean, dateJoined: string, lastLogin?: string, language: string, emailNotifications: boolean, inAppNotifications: boolean, termsAndConditionsAcceptedAt?: string }, task: { __typename?: 'EcnTaskType', id: string } }, errors: Array<{ __typename?: 'ErrorType', field: string, messages: Array<string> }> } };

export type PartsArrivalTaskMutationVariables = Exact<{
  input: PartsArrivalTaskMutationInput;
}>;


export type PartsArrivalTaskMutation = { __typename?: 'Mutation', partsArrivalTask?: { __typename?: 'PartsArrivalTaskMutationPayload', ecn?: { __typename?: 'EcnType', id: string }, errors: Array<{ __typename?: 'ErrorType', field: string, messages: Array<string> }> } };

export type EcnFilesMutationVariables = Exact<{
  ecnId: Scalars['UUID']['input'];
  files: Array<Scalars['Upload']['input']>;
}>;


export type EcnFilesMutation = { __typename?: 'Mutation', ecnFiles?: { __typename?: 'EcnFiles', ecnFiles: Array<{ __typename?: 'EcnFileType', id: string, file: string }>, errors?: Array<{ __typename?: 'ErrorType', field: string, messages: Array<string> }> } };

export type DeleteEcnFileMutationVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type DeleteEcnFileMutation = { __typename?: 'Mutation', deleteEcnFile?: { __typename?: 'DeleteEcnFile', ok?: boolean, id: string } };

export type EcnAnalyticsQueryVariables = Exact<{
  filters: AnalyticsFilters;
}>;


export type EcnAnalyticsQuery = { __typename?: 'Query', ecnAnalytics?: { __typename?: 'EcnAnalyticsType', byStatus?: Array<{ __typename?: 'ByStatusDatum', label: string, count: number }>, accumulatedInProgressByEcn?: Array<{ __typename?: 'ByStatusDatum', label: string, count: number }>, accumulatedWithoutEffectiveDateByEcn?: Array<{ __typename?: 'ByStatusDatum', label: string, count: number }>, byEffectiveDate?: Array<{ __typename?: 'ByStatusDatum', label: string, count: number }>, byWarrantyPriorityInProgress?: Array<{ __typename?: 'ByStatusDatum', label: string, count: number }>, byWarrantyPriority?: Array<{ __typename?: 'ByStatusDatum', label: string, count: number }>, byEffectiveDateAndSeasonPriority?: Array<{ __typename?: 'PriotityDatum', label: string, lowCount: number, mediumCount: number, highCount: number }>, byPartType?: Array<{ __typename?: 'ByStatusDatum', label: string, count: number }>, accumulatedInProgress?: { __typename?: 'KpiDatum', min: number, max: number, avg: number }, accumulatedWithoutEffectiveDate?: { __typename?: 'KpiDatum', min: number, max: number, avg: number }, bySeasonPriority?: Array<{ __typename?: 'ByStatusDatum', label: string, count: number }> } };

export type CancelEcnMutationVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type CancelEcnMutation = { __typename?: 'Mutation', cancelEcn?: { __typename?: 'CancelEcn', ok?: boolean } };

export type MakeEcnEffectiveMutationVariables = Exact<{
  input: MakeEcnEffectiveMutationInput;
}>;


export type MakeEcnEffectiveMutation = { __typename?: 'Mutation', makeEcnEffective?: { __typename?: 'MakeEcnEffectiveMutationPayload', ecn?: { __typename?: 'EcnType', id: string }, errors: Array<{ __typename?: 'ErrorType', field: string, messages: Array<string> }> } };

export type ValidExternalIdQueryVariables = Exact<{
  externalId: Scalars['String']['input'];
  ignoreId?: InputMaybe<Scalars['UUID']['input']>;
}>;


export type ValidExternalIdQuery = { __typename?: 'Query', validExternalId: boolean };

export type EcnHistoryDiffQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type EcnHistoryDiffQuery = { __typename?: 'Query', ecnHistoryDiff: Array<{ __typename?: 'ModelDeltaType', changedFields?: Array<string>, date: string, changes?: Array<{ __typename?: 'ModelChangeType', field: string, old?: any, new?: any, verboseField: string }>, updatedBy?: { __typename?: 'UserType', id: string, email: string, firstName: string, lastName: string, displayName: string, isActive: boolean, isStaff: boolean, dateJoined: string, lastLogin?: string, language: string, emailNotifications: boolean, inAppNotifications: boolean, termsAndConditionsAcceptedAt?: string } }> };

export type PaymentMethodFragment = { __typename?: 'PaymentMethodType', id: string, name: string, order: number, multiplier: string, slug: string, paymentmethodcategorySet: Array<{ __typename?: 'PaymentMethodCategoryType', finnancied: boolean }> };

export type PaymentMethodOptionFragment = { __typename?: 'PaymentMethodType', id: string, name: string };

export type PaymentMethodCategoryFragment = { __typename?: 'PaymentMethodCategoryType', id: string, name: string, finnancied: boolean, paymentMethods: Array<{ __typename?: 'PaymentMethodType', id: string, name: string }> };

export type GetPaymentMethodCategoriesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetPaymentMethodCategoriesQuery = { __typename?: 'Query', paymentMethodCategories: Array<{ __typename?: 'PaymentMethodCategoryType', id: string, name: string, finnancied: boolean }> };

export type GetPaymentMethodsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetPaymentMethodsQuery = { __typename?: 'Query', paymentMethods: Array<{ __typename?: 'PaymentMethodType', id: string, name: string, order: number, multiplier: string, slug: string, paymentmethodcategorySet: Array<{ __typename?: 'PaymentMethodCategoryType', finnancied: boolean }> }> };

export type GetPaymentMethodQueryVariables = Exact<{
  id?: InputMaybe<Scalars['UUID']['input']>;
}>;


export type GetPaymentMethodQuery = { __typename?: 'Query', paymentMethod: { __typename?: 'PaymentMethodType', id: string, name: string, order: number, multiplier: string, slug: string, paymentmethodcategorySet: Array<{ __typename?: 'PaymentMethodCategoryType', finnancied: boolean }> } };

export type GetPaymentMethodOptionsQueryVariables = Exact<{
  categoryId?: InputMaybe<Scalars['UUID']['input']>;
  organizationId?: InputMaybe<Scalars['UUID']['input']>;
}>;


export type GetPaymentMethodOptionsQuery = { __typename?: 'Query', paymentMethods: Array<{ __typename?: 'PaymentMethodType', id: string, name: string }> };

export type CategoryOptionFragment = { __typename?: 'CategoryNode', id: string, uuid: string, name: string };

export type CategoryOptionTypeFragment = { __typename?: 'CategoryType', id: string, uuid: string, name: string };

export type CategoryFragment = { __typename?: 'CategoryNode', enabledForAssistedQuote: boolean, id: string, uuid: string, name: string };

export type CategoryTypeFragment = { __typename?: 'CategoryType', enabledForAssistedQuote: boolean, id: string, uuid: string, name: string };

export type ProductSubcategoryOptionFragment = { __typename?: 'SubcategoryType', id: string, name: string };

export type ProductOriginOptionFragment = { __typename?: 'ProductOriginType', id: string, name: string };

export type ProductOptionFragment = { __typename?: 'ProductNode', id: string, name: string, displayName: string, displayType: string, externalId: string, subcategory?: { __typename?: 'SubcategoryType', id: string, name: string, category: { __typename?: 'CategoryType', name: string, id: string } } };

export type GetCategoriesQueryVariables = Exact<{
  enabledForSeeder?: InputMaybe<Scalars['Boolean']['input']>;
  seederId?: InputMaybe<Scalars['UUID']['input']>;
}>;


export type GetCategoriesQuery = { __typename?: 'Query', categories?: { __typename?: 'CategoryNodeConnection', edges: Array<{ __typename?: 'CategoryNodeEdge', node?: { __typename?: 'CategoryNode', id: string, uuid: string, name: string } }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string, endCursor?: string } } };

export type GetCategoriesForAssistedQuoteQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCategoriesForAssistedQuoteQuery = { __typename?: 'Query', categories?: { __typename?: 'CategoryNodeConnection', edges: Array<{ __typename?: 'CategoryNodeEdge', cursor: string, node?: { __typename?: 'CategoryNode', id: string, uuid: string, name: string } }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string, endCursor?: string } } };

export type GetProductOptionsQueryVariables = Exact<{
  query?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  externalIdIcontains?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetProductOptionsQuery = { __typename?: 'Query', products?: { __typename?: 'ProductNodeConnection', pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string, endCursor?: string }, edges: Array<{ __typename?: 'ProductNodeEdge', cursor: string, node?: { __typename?: 'ProductNode', id: string, uuid: string, name: string, displayName: string, externalId: string, published: boolean, subcategory?: { __typename?: 'SubcategoryType', id: string, category: { __typename?: 'CategoryType', id: string, uuid: string } } } }> } };

export type ProductFragment = { __typename?: 'ProductNode', id: string, uuid: string, displayType: string, externalId: string, name: string, type: ProductsProductTypeChoices, displayName: string, price: string, rowCount: number, order: number, description: string, published: boolean, subcategory?: { __typename?: 'SubcategoryType', id: string, name: string, category: { __typename?: 'CategoryType', id: string, uuid: string, name: string } }, ruleGroup?: { __typename?: 'RuleGroupType', id: string, name: string }, ruleGroups: Array<{ __typename?: 'RuleGroupType', id: string, name: string }>, ruleCategories: Array<{ __typename?: 'CategoryType', enabledForAssistedQuote: boolean, id: string, uuid: string, name: string }> };

export type GetProductQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  uuid?: InputMaybe<Scalars['UUID']['input']>;
}>;


export type GetProductQuery = { __typename?: 'Query', product: { __typename?: 'ProductNode', id: string, uuid: string, displayType: string, externalId: string, name: string, type: ProductsProductTypeChoices, displayName: string, price: string, rowCount: number, order: number, description: string, published: boolean, subcategory?: { __typename?: 'SubcategoryType', id: string, name: string, category: { __typename?: 'CategoryType', id: string, uuid: string, name: string } }, ruleGroup?: { __typename?: 'RuleGroupType', id: string, name: string }, ruleGroups: Array<{ __typename?: 'RuleGroupType', id: string, name: string }>, ruleCategories: Array<{ __typename?: 'CategoryType', enabledForAssistedQuote: boolean, id: string, uuid: string, name: string }> } };

export type GetProductsQueryVariables = Exact<{
  idIn?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  externalIdIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
}>;


export type GetProductsQuery = { __typename?: 'Query', products?: { __typename?: 'ProductNodeConnection', edges: Array<{ __typename?: 'ProductNodeEdge', cursor: string, node?: { __typename?: 'ProductNode', id: string, uuid: string, displayType: string, externalId: string, name: string, type: ProductsProductTypeChoices, displayName: string, price: string, rowCount: number, order: number, description: string, published: boolean, subcategory?: { __typename?: 'SubcategoryType', id: string, name: string, category: { __typename?: 'CategoryType', id: string, uuid: string, name: string } }, ruleGroup?: { __typename?: 'RuleGroupType', id: string, name: string }, ruleGroups: Array<{ __typename?: 'RuleGroupType', id: string, name: string }>, ruleCategories: Array<{ __typename?: 'CategoryType', enabledForAssistedQuote: boolean, id: string, uuid: string, name: string }> } }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string, endCursor?: string } } };

export type GetProductsEffectiveDatesQueryVariables = Exact<{
  idIn?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  externalIdIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
}>;


export type GetProductsEffectiveDatesQuery = { __typename?: 'Query', products?: { __typename?: 'ProductNodeConnection', edges: Array<{ __typename?: 'ProductNodeEdge', node?: { __typename?: 'ProductNode', id: string, uuid: string, externalId: string, isEffective: boolean } }> } };

export type ProductPriceModifiersFragment = { __typename?: 'ProductPriceModifierType', id: string, billingType: ProductsProductPriceModifierBillingTypeChoices, enableDiscount: boolean, commissionMultiplier: string, productExternalIds: Array<string> };

export type GetProductPriceModifiersQueryVariables = Exact<{
  accountId: Scalars['UUID']['input'];
}>;


export type GetProductPriceModifiersQuery = { __typename?: 'Query', productPriceModifiers: Array<{ __typename?: 'ProductPriceModifierType', id: string, billingType: ProductsProductPriceModifierBillingTypeChoices, enableDiscount: boolean, commissionMultiplier: string, productExternalIds: Array<string> }> };

export type SubcategoryFragment = { __typename?: 'SubcategoryType', id: string, name: string, category: { __typename?: 'CategoryType', id: string, uuid: string, name: string } };

export type GetSubcategoriesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetSubcategoriesQuery = { __typename?: 'Query', subcategories: Array<{ __typename?: 'SubcategoryType', id: string, name: string, category: { __typename?: 'CategoryType', id: string, uuid: string, name: string } }> };

export type RuleGroupFragment = { __typename?: 'RuleGroupType', id: string, name: string };

export type QuoteRuleFragment = { __typename?: 'QuoteRuleType', id: string, valueSource: ProductsQuoteRuleValueSourceChoices, image?: string, referenceSource: ProductsQuoteRuleReferenceSourceChoices, referenceMultiplier: number, operator: ProductsQuoteRuleOperatorChoices, description?: string, errorMessage?: string, useForValidation: boolean, useForInitialValue: boolean, prioritizeRule: boolean, product?: { __typename?: 'ProductNode', id: string, uuid: string, externalId: string }, productCategory?: { __typename?: 'CategoryType', id: string, uuid: string, name: string }, group?: { __typename?: 'RuleGroupType', id: string, name: string } };

export type GetQuoteRulesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetQuoteRulesQuery = { __typename?: 'Query', quoteRules: Array<{ __typename?: 'QuoteRuleType', id: string, valueSource: ProductsQuoteRuleValueSourceChoices, image?: string, referenceSource: ProductsQuoteRuleReferenceSourceChoices, referenceMultiplier: number, operator: ProductsQuoteRuleOperatorChoices, description?: string, errorMessage?: string, useForValidation: boolean, useForInitialValue: boolean, prioritizeRule: boolean, product?: { __typename?: 'ProductNode', id: string, uuid: string, externalId: string }, productCategory?: { __typename?: 'CategoryType', id: string, uuid: string, name: string }, group?: { __typename?: 'RuleGroupType', id: string, name: string } }> };

export type GetProductsImagesQueryVariables = Exact<{
  externalIds: Array<Scalars['String']['input']>;
}>;


export type GetProductsImagesQuery = { __typename?: 'Query', productsImages: Array<{ __typename?: 'ProductNode', image?: string, externalId: string, uuid: string, id: string }> };

export type GetMinimalProductsForAssistedQuoteQueryVariables = Exact<{ [key: string]: never; }>;


export type GetMinimalProductsForAssistedQuoteQuery = { __typename?: 'Query', products?: { __typename?: 'ProductNodeConnection', pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string, endCursor?: string }, edges: Array<{ __typename?: 'ProductNodeEdge', cursor: string, node?: { __typename?: 'ProductNode', id: string, uuid: string, ruleCategories: Array<{ __typename?: 'CategoryType', id: string, uuid: string }> } }> } };

export type QuotedProductPayloadFragment = { __typename?: 'ProductNode', id: string, uuid: string, externalId: string, name: string, price: string, rowCount: number, order: number, description: string, subcategory?: { __typename?: 'SubcategoryType', id: string }, ruleGroup?: { __typename?: 'RuleGroupType', id: string }, ruleGroups: Array<{ __typename?: 'RuleGroupType', id: string }>, ruleCategories: Array<{ __typename?: 'CategoryType', uuid: string, id: string }> };

export type GetBundlesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetBundlesQuery = { __typename?: 'Query', bundles: Array<{ __typename?: 'BundleType', id: string, name: string, multiplier: string, selectable: boolean, items: Array<{ __typename?: 'BundleProductType', quantity: number, product: { __typename?: 'ProductNode', published: boolean, id: string, uuid: string, externalId: string, name: string, price: string, rowCount: number, order: number, description: string, subcategory?: { __typename?: 'SubcategoryType', id: string }, ruleGroup?: { __typename?: 'RuleGroupType', id: string }, ruleGroups: Array<{ __typename?: 'RuleGroupType', id: string }>, ruleCategories: Array<{ __typename?: 'CategoryType', uuid: string, id: string }> } }> }> };

export type GetProductsForAssistedQuoteQueryVariables = Exact<{
  idIn?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
}>;


export type GetProductsForAssistedQuoteQuery = { __typename?: 'Query', products?: { __typename?: 'ProductNodeConnection', edges: Array<{ __typename?: 'ProductNodeEdge', cursor: string, node?: { __typename?: 'ProductNode', id: string, uuid: string, externalId: string, name: string, price: string, rowCount: number, order: number, description: string, subcategory?: { __typename?: 'SubcategoryType', id: string }, ruleGroup?: { __typename?: 'RuleGroupType', id: string }, ruleGroups: Array<{ __typename?: 'RuleGroupType', id: string }>, ruleCategories: Array<{ __typename?: 'CategoryType', uuid: string, id: string }> } }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string, endCursor?: string } } };

export type ProductEffectiveDateFragment = { __typename?: 'ProductNode', id: string, uuid: string, externalId: string, isEffective: boolean };

export type GetProductsPriceQueryVariables = Exact<{
  idIn?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  externalIdIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
}>;


export type GetProductsPriceQuery = { __typename?: 'Query', products?: { __typename?: 'ProductNodeConnection', edges: Array<{ __typename?: 'ProductNodeEdge', node?: { __typename?: 'ProductNode', id: string, uuid: string, externalId: string, price: string } }> } };

export type PageInfoFragment = { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string, endCursor?: string };

export type MinimalQuotedProductFragment = { __typename?: 'QuotedProductType', price: string, quantity: number, enableDiscount: boolean, commissionMultiplier: string, externalId: string, bundleName: string, bundleMultiplier?: string, bundleQuantity?: number };

export type QuotedProductFragment = { __typename?: 'QuotedProductType', id: string, name: string, order: number, rowCount: number, externalId: string, description: string, subcategoryName: string, categoryName: string, price: string, quantity: number, enableDiscount: boolean, commissionMultiplier: string, bundleName: string, bundleMultiplier?: string, bundleQuantity?: number, bundle?: { __typename?: 'BundleType', id: string }, origin?: { __typename?: 'ProductOriginType', id: string, name: string }, subcategory?: { __typename?: 'SubcategoryType', id: string, name: string, category: { __typename?: 'CategoryType', id: string, uuid: string, name: string } }, ruleGroup?: { __typename?: 'RuleGroupType', id: string, name: string }, ruleCategories: Array<{ __typename?: 'CategoryType', enabledForAssistedQuote: boolean, id: string, uuid: string, name: string }> };

export type MinimalQuoteFragment = { __typename?: 'QuoteNode', id: string, uuid: string, displayName: string, displayId: number, status?: QuotesQuoteStatusChoices, statusDisplay: string };

export type QuoteFragment = { __typename?: 'QuoteNode', additionalChargesValue?: string, additionalChargesDescription?: string, billingType: QuotesQuoteBillingTypeChoices, displayBillingType: string, rowCount?: number, notes?: string, created: string, id: string, uuid: string, displayName: string, displayId: number, status?: QuotesQuoteStatusChoices, statusDisplay: string, kitMultiplier?: { __typename?: 'QuoteKitMultiplierType', id: string, name: string, multiplier: string }, seeder?: { __typename?: 'SeederType', id: string, uuid: string, displayName: string, year?: number, rowCount: number, meterType: SeedersSeederMeterTypeChoices, account: { __typename?: 'AccountType', id: string, uuid: string, name: string }, brand: { __typename?: 'SeederBrandType', id: string }, model?: { __typename?: 'SeederModelType', id: string }, installedCategories: Array<{ __typename?: 'CategoryType', id: string, uuid: string }> }, products: Array<{ __typename?: 'QuotedProductType', id: string, name: string, order: number, rowCount: number, externalId: string, description: string, subcategoryName: string, categoryName: string, price: string, quantity: number, enableDiscount: boolean, commissionMultiplier: string, bundleName: string, bundleMultiplier?: string, bundleQuantity?: number, bundle?: { __typename?: 'BundleType', id: string }, origin?: { __typename?: 'ProductOriginType', id: string, name: string }, subcategory?: { __typename?: 'SubcategoryType', id: string, name: string, category: { __typename?: 'CategoryType', id: string, uuid: string, name: string } }, ruleGroup?: { __typename?: 'RuleGroupType', id: string, name: string }, ruleCategories: Array<{ __typename?: 'CategoryType', enabledForAssistedQuote: boolean, id: string, uuid: string, name: string }> }>, paymentMethods: Array<{ __typename?: 'QuotedPaymentMethodType', id: string, order: number, isCustom: boolean, dealerCommission?: string, name: string, multiplier: string, extraMultiplier: string, slug: string, finnancied: boolean, originalPaymentMethod?: { __typename?: 'PaymentMethodType', id: string } }>, contact: { __typename?: 'ContactType', id: string, uuid: string, externalId: string, email?: string, firstName: string, lastName: string, displayName: string, phone: string, mobilePhone: string, active: boolean, type: { __typename?: 'ContactTypeType', id: string, name: string }, account: { __typename?: 'AccountType', id: string, uuid: string, name: string, taxId?: string, externalId: string, isFavorite: boolean, address?: string, location?: { __typename?: 'LocationType', id: string, path?: string, iva: Decimal }, owner?: { __typename?: 'OrganizationType', id: string, name: string, externalId: string, isEu: boolean, displayName: string, logo?: string, logoThumbnail?: string, location?: { __typename?: 'LocationType', id: string, name: string, path?: string, iva: Decimal }, group: { __typename?: 'OrganizationGroupType', id: string, dealerCommission?: string } } } }, sale?: { __typename?: 'SaleNode', id: string, uuid: string, paymentMethod: { __typename?: 'QuotedPaymentMethodType', id: string, order: number, isCustom: boolean, dealerCommission?: string, name: string, multiplier: string, extraMultiplier: string, slug: string, finnancied: boolean, originalPaymentMethod?: { __typename?: 'PaymentMethodType', id: string } } }, createdBy?: { __typename?: 'UserType', id: string, uuid: string, email: string, firstName: string, lastName: string, displayName: string, isActive: boolean, isStaff: boolean, dateJoined: string, lastLogin?: string, language: string, emailNotifications: boolean, inAppNotifications: boolean, termsAndConditionsAcceptedAt?: string }, closeReason?: { __typename?: 'QuoteCloseReasonType', id: string, description: string, quote: { __typename?: 'QuoteNode', id: string } }, supplyOrder?: { __typename?: 'SupplyOrderNode', id: string, uuid: string, displayId: number, created: string, statusDisplay: string, status: SupplyOrdersSupplyOrderStatusChoices, charter: SupplyOrdersSupplyOrderCharterChoices, orderedProducts: Array<{ __typename?: 'OrderedProductType', id: string, quantity: number, quantityLeft: number, quotedProduct?: { __typename?: 'QuotedProductType', id: string, name: string, order: number, rowCount: number, externalId: string, description: string, subcategoryName: string, categoryName: string, price: string, quantity: number, enableDiscount: boolean, commissionMultiplier: string, bundleName: string, bundleMultiplier?: string, bundleQuantity?: number, bundle?: { __typename?: 'BundleType', id: string }, origin?: { __typename?: 'ProductOriginType', id: string, name: string }, subcategory?: { __typename?: 'SubcategoryType', id: string, name: string, category: { __typename?: 'CategoryType', id: string, uuid: string, name: string } }, ruleGroup?: { __typename?: 'RuleGroupType', id: string, name: string }, ruleCategories: Array<{ __typename?: 'CategoryType', enabledForAssistedQuote: boolean, id: string, uuid: string, name: string }> }, warrantyProduct?: { __typename?: 'WarrantyProductType', id: string, quantity: number, externalId: string, name: string, displayName: string, price: string, order: number, description: string, rowCount: number, originalProduct?: { __typename?: 'ProductNode', id: string, uuid: string, image?: string }, subcategory?: { __typename?: 'SubcategoryType', id: string, name: string, category: { __typename?: 'CategoryType', id: string, uuid: string, name: string } } } }> }, pdfs: Array<{ __typename?: 'QuotePDFType', id: string, file?: string, type: QuotesQuotePdfTypeChoices, recipient: string, typeDisplay?: string, emailStatus?: string, created: string, paymentMethod?: { __typename?: 'QuotedPaymentMethodType', id: string, order: number, isCustom: boolean, dealerCommission?: string, name: string, multiplier: string, extraMultiplier: string, slug: string, finnancied: boolean, originalPaymentMethod?: { __typename?: 'PaymentMethodType', id: string } }, createdBy?: { __typename?: 'UserType', id: string, uuid: string, email: string, firstName: string, lastName: string, displayName: string, isActive: boolean, isStaff: boolean, dateJoined: string, lastLogin?: string, language: string, emailNotifications: boolean, inAppNotifications: boolean, termsAndConditionsAcceptedAt?: string } }> };

export type SupplyOrderQuoteDetailFragment = { __typename?: 'SupplyOrderNode', id: string, uuid: string, displayId: number, created: string, statusDisplay: string, status: SupplyOrdersSupplyOrderStatusChoices, orderedProducts: Array<{ __typename?: 'OrderedProductType', id: string, quantity: number, quantityLeft: number, quotedProduct?: { __typename?: 'QuotedProductType', id: string, name: string, order: number, rowCount: number, externalId: string, description: string, subcategoryName: string, categoryName: string, price: string, quantity: number, enableDiscount: boolean, commissionMultiplier: string, bundleName: string, bundleMultiplier?: string, bundleQuantity?: number, bundle?: { __typename?: 'BundleType', id: string }, origin?: { __typename?: 'ProductOriginType', id: string, name: string }, subcategory?: { __typename?: 'SubcategoryType', id: string, name: string, category: { __typename?: 'CategoryType', id: string, uuid: string, name: string } }, ruleGroup?: { __typename?: 'RuleGroupType', id: string, name: string }, ruleCategories: Array<{ __typename?: 'CategoryType', enabledForAssistedQuote: boolean, id: string, uuid: string, name: string }> }, warrantyProduct?: { __typename?: 'WarrantyProductType', id: string, quantity: number, externalId: string, name: string, displayName: string, price: string, order: number, description: string, rowCount: number, originalProduct?: { __typename?: 'ProductNode', id: string, uuid: string, image?: string }, subcategory?: { __typename?: 'SubcategoryType', id: string, name: string, category: { __typename?: 'CategoryType', id: string, uuid: string, name: string } } } }> };

export type QuoteSaleFragment = { __typename?: 'QuoteNode', id: string, uuid: string, displayId: number, sale?: { __typename?: 'SaleNode', id: string }, closeReason?: { __typename?: 'QuoteCloseReasonType', id: string }, paymentMethods: Array<{ __typename?: 'QuotedPaymentMethodType', id: string, order: number, isCustom: boolean, dealerCommission?: string, name: string, multiplier: string, extraMultiplier: string, slug: string, finnancied: boolean, originalPaymentMethod?: { __typename?: 'PaymentMethodType', id: string } }>, products: Array<{ __typename?: 'QuotedProductType', id: string, name: string, order: number, rowCount: number, externalId: string, description: string, subcategoryName: string, categoryName: string, price: string, quantity: number, enableDiscount: boolean, commissionMultiplier: string, bundleName: string, bundleMultiplier?: string, bundleQuantity?: number, bundle?: { __typename?: 'BundleType', id: string }, origin?: { __typename?: 'ProductOriginType', id: string, name: string }, subcategory?: { __typename?: 'SubcategoryType', id: string, name: string, category: { __typename?: 'CategoryType', id: string, uuid: string, name: string } }, ruleGroup?: { __typename?: 'RuleGroupType', id: string, name: string }, ruleCategories: Array<{ __typename?: 'CategoryType', enabledForAssistedQuote: boolean, id: string, uuid: string, name: string }> }> };

export type MinimalQuotedPaymentMethodFragment = { __typename?: 'QuotedPaymentMethodType', name: string, multiplier: string, extraMultiplier: string, slug: string, finnancied: boolean };

export type QuotedPaymentMethodFragment = { __typename?: 'QuotedPaymentMethodType', id: string, order: number, isCustom: boolean, dealerCommission?: string, name: string, multiplier: string, extraMultiplier: string, slug: string, finnancied: boolean, originalPaymentMethod?: { __typename?: 'PaymentMethodType', id: string } };

export type QuoteEditFragment = { __typename?: 'QuoteNode', id: string, uuid: string, billingType: QuotesQuoteBillingTypeChoices, displayId: number, additionalChargesValue?: string, additionalChargesDescription?: string, rowCount?: number, notes?: string, created: string, updated: string, kitMultiplier?: { __typename?: 'QuoteKitMultiplierType', id: string }, seeder?: { __typename?: 'SeederType', id: string, uuid: string }, contact: { __typename?: 'ContactType', id: string, uuid: string, account: { __typename?: 'AccountType', id: string, uuid: string } }, products: Array<{ __typename?: 'QuotedProductType', id: string, name: string, order: number, rowCount: number, externalId: string, description: string, subcategoryName: string, categoryName: string, price: string, quantity: number, enableDiscount: boolean, commissionMultiplier: string, bundleName: string, bundleMultiplier?: string, bundleQuantity?: number, bundle?: { __typename?: 'BundleType', id: string }, origin?: { __typename?: 'ProductOriginType', id: string, name: string }, subcategory?: { __typename?: 'SubcategoryType', id: string, name: string, category: { __typename?: 'CategoryType', id: string, uuid: string, name: string } }, ruleGroup?: { __typename?: 'RuleGroupType', id: string, name: string }, ruleCategories: Array<{ __typename?: 'CategoryType', enabledForAssistedQuote: boolean, id: string, uuid: string, name: string }> }>, paymentMethods: Array<{ __typename?: 'QuotedPaymentMethodType', id: string, order: number, isCustom: boolean, dealerCommission?: string, name: string, multiplier: string, extraMultiplier: string, slug: string, finnancied: boolean, originalPaymentMethod?: { __typename?: 'PaymentMethodType', id: string } }>, createdBy?: { __typename?: 'UserType', id: string, uuid: string, email: string, firstName: string, lastName: string, displayName: string, isActive: boolean, isStaff: boolean, dateJoined: string, lastLogin?: string, language: string, emailNotifications: boolean, inAppNotifications: boolean, termsAndConditionsAcceptedAt?: string }, updatedBy?: { __typename?: 'UserType', id: string, uuid: string, email: string, firstName: string, lastName: string, displayName: string, isActive: boolean, isStaff: boolean, dateJoined: string, lastLogin?: string, language: string, emailNotifications: boolean, inAppNotifications: boolean, termsAndConditionsAcceptedAt?: string } };

export type CreateQuoteMutationVariables = Exact<{
  input: CreateQuoteMutationInput;
}>;


export type CreateQuoteMutation = { __typename?: 'Mutation', createQuote?: { __typename?: 'CreateQuoteMutationPayload', errors: Array<{ __typename?: 'ErrorType', field: string, messages: Array<string> }>, quote?: { __typename?: 'QuoteNode', id: string, uuid: string } } };

export type UpdateQuoteMutationVariables = Exact<{
  input: UpdateQuoteMutationInput;
}>;


export type UpdateQuoteMutation = { __typename?: 'Mutation', updateQuote?: { __typename?: 'UpdateQuoteMutationPayload', errors: Array<{ __typename?: 'ErrorType', field: string, messages: Array<string> }>, quote?: { __typename?: 'QuoteNode', id: string, uuid: string } } };

export type GetQuoteEditQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  uuid?: InputMaybe<Scalars['UUID']['input']>;
}>;


export type GetQuoteEditQuery = { __typename?: 'Query', quote?: { __typename?: 'QuoteNode', id: string, uuid: string, billingType: QuotesQuoteBillingTypeChoices, displayId: number, additionalChargesValue?: string, additionalChargesDescription?: string, rowCount?: number, notes?: string, created: string, updated: string, kitMultiplier?: { __typename?: 'QuoteKitMultiplierType', id: string }, seeder?: { __typename?: 'SeederType', id: string, uuid: string }, contact: { __typename?: 'ContactType', id: string, uuid: string, account: { __typename?: 'AccountType', id: string, uuid: string } }, products: Array<{ __typename?: 'QuotedProductType', id: string, name: string, order: number, rowCount: number, externalId: string, description: string, subcategoryName: string, categoryName: string, price: string, quantity: number, enableDiscount: boolean, commissionMultiplier: string, bundleName: string, bundleMultiplier?: string, bundleQuantity?: number, bundle?: { __typename?: 'BundleType', id: string }, origin?: { __typename?: 'ProductOriginType', id: string, name: string }, subcategory?: { __typename?: 'SubcategoryType', id: string, name: string, category: { __typename?: 'CategoryType', id: string, uuid: string, name: string } }, ruleGroup?: { __typename?: 'RuleGroupType', id: string, name: string }, ruleCategories: Array<{ __typename?: 'CategoryType', enabledForAssistedQuote: boolean, id: string, uuid: string, name: string }> }>, paymentMethods: Array<{ __typename?: 'QuotedPaymentMethodType', id: string, order: number, isCustom: boolean, dealerCommission?: string, name: string, multiplier: string, extraMultiplier: string, slug: string, finnancied: boolean, originalPaymentMethod?: { __typename?: 'PaymentMethodType', id: string } }>, createdBy?: { __typename?: 'UserType', id: string, uuid: string, email: string, firstName: string, lastName: string, displayName: string, isActive: boolean, isStaff: boolean, dateJoined: string, lastLogin?: string, language: string, emailNotifications: boolean, inAppNotifications: boolean, termsAndConditionsAcceptedAt?: string }, updatedBy?: { __typename?: 'UserType', id: string, uuid: string, email: string, firstName: string, lastName: string, displayName: string, isActive: boolean, isStaff: boolean, dateJoined: string, lastLogin?: string, language: string, emailNotifications: boolean, inAppNotifications: boolean, termsAndConditionsAcceptedAt?: string } } };

export type QuoteKitMultiplierFragment = { __typename?: 'QuoteKitMultiplierType', id: string, name: string, multiplier: string };

export type GetQuoteKitMultipliersQueryVariables = Exact<{ [key: string]: never; }>;


export type GetQuoteKitMultipliersQuery = { __typename?: 'Query', quoteKitMultipliers: Array<{ __typename?: 'QuoteKitMultiplierType', id: string, name: string, multiplier: string }> };

export type GetQuoteKitMultiplierQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type GetQuoteKitMultiplierQuery = { __typename?: 'Query', quoteKitMultiplier: { __typename?: 'QuoteKitMultiplierType', id: string, name: string, multiplier: string } };

export type QuoteListFragment = { __typename?: 'QuoteNode', uuid: string, id: string, created: string, status?: QuotesQuoteStatusChoices, displayId: number, statusDisplay: string, rowCount?: number, contact: { __typename?: 'ContactType', id: string, uuid: string, email?: string, displayName: string, account: { __typename?: 'AccountType', id: string, uuid: string, name: string, owner?: { __typename?: 'OrganizationType', id: string, name: string } } }, seeder?: { __typename?: 'SeederType', displayName: string, brand: { __typename?: 'SeederBrandType', name: string } }, createdBy?: { __typename?: 'UserType', displayName: string, email: string }, closeReason?: { __typename?: 'QuoteCloseReasonType', id: string }, paymentMethods: Array<{ __typename?: 'QuotedPaymentMethodType', id: string, order: number, isCustom: boolean, dealerCommission?: string, name: string, multiplier: string, extraMultiplier: string, slug: string, finnancied: boolean, originalPaymentMethod?: { __typename?: 'PaymentMethodType', id: string } }>, kitMultiplier?: { __typename?: 'QuoteKitMultiplierType', multiplier: string }, products: Array<{ __typename?: 'QuotedProductType', id: string, name: string, order: number, rowCount: number, externalId: string, description: string, subcategoryName: string, categoryName: string, price: string, quantity: number, enableDiscount: boolean, commissionMultiplier: string, bundleName: string, bundleMultiplier?: string, bundleQuantity?: number, bundle?: { __typename?: 'BundleType', id: string }, origin?: { __typename?: 'ProductOriginType', id: string, name: string }, subcategory?: { __typename?: 'SubcategoryType', id: string, name: string, category: { __typename?: 'CategoryType', id: string, uuid: string, name: string } }, ruleGroup?: { __typename?: 'RuleGroupType', id: string, name: string }, ruleCategories: Array<{ __typename?: 'CategoryType', enabledForAssistedQuote: boolean, id: string, uuid: string, name: string }> }> };

export type GetQuotesQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  createdGte?: InputMaybe<Scalars['Date']['input']>;
  createdLte?: InputMaybe<Scalars['Date']['input']>;
  owner?: InputMaybe<Scalars['UUID']['input']>;
  accountGlobalId?: InputMaybe<Scalars['UUID']['input']>;
  contactGlobalId?: InputMaybe<Scalars['UUID']['input']>;
  user?: InputMaybe<Scalars['UUID']['input']>;
  status?: InputMaybe<QuotesQuoteStatusChoices>;
  product?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetQuotesQuery = { __typename?: 'Query', quotes?: { __typename?: 'QuoteNodeConnection', count: number, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string, endCursor?: string }, edges: Array<{ __typename?: 'QuoteNodeEdge', cursor: string, node?: { __typename?: 'QuoteNode', uuid: string, id: string, created: string, status?: QuotesQuoteStatusChoices, displayId: number, statusDisplay: string, rowCount?: number, contact: { __typename?: 'ContactType', id: string, uuid: string, email?: string, displayName: string, account: { __typename?: 'AccountType', id: string, uuid: string, name: string, owner?: { __typename?: 'OrganizationType', id: string, name: string } } }, seeder?: { __typename?: 'SeederType', displayName: string, brand: { __typename?: 'SeederBrandType', name: string } }, createdBy?: { __typename?: 'UserType', displayName: string, email: string }, closeReason?: { __typename?: 'QuoteCloseReasonType', id: string }, paymentMethods: Array<{ __typename?: 'QuotedPaymentMethodType', id: string, order: number, isCustom: boolean, dealerCommission?: string, name: string, multiplier: string, extraMultiplier: string, slug: string, finnancied: boolean, originalPaymentMethod?: { __typename?: 'PaymentMethodType', id: string } }>, kitMultiplier?: { __typename?: 'QuoteKitMultiplierType', multiplier: string }, products: Array<{ __typename?: 'QuotedProductType', id: string, name: string, order: number, rowCount: number, externalId: string, description: string, subcategoryName: string, categoryName: string, price: string, quantity: number, enableDiscount: boolean, commissionMultiplier: string, bundleName: string, bundleMultiplier?: string, bundleQuantity?: number, bundle?: { __typename?: 'BundleType', id: string }, origin?: { __typename?: 'ProductOriginType', id: string, name: string }, subcategory?: { __typename?: 'SubcategoryType', id: string, name: string, category: { __typename?: 'CategoryType', id: string, uuid: string, name: string } }, ruleGroup?: { __typename?: 'RuleGroupType', id: string, name: string }, ruleCategories: Array<{ __typename?: 'CategoryType', enabledForAssistedQuote: boolean, id: string, uuid: string, name: string }> }> } }> } };

export type GetQuoteQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  uuid?: InputMaybe<Scalars['UUID']['input']>;
}>;


export type GetQuoteQuery = { __typename?: 'Query', quote?: { __typename?: 'QuoteNode', additionalChargesValue?: string, additionalChargesDescription?: string, billingType: QuotesQuoteBillingTypeChoices, displayBillingType: string, rowCount?: number, notes?: string, created: string, id: string, uuid: string, displayName: string, displayId: number, status?: QuotesQuoteStatusChoices, statusDisplay: string, kitMultiplier?: { __typename?: 'QuoteKitMultiplierType', id: string, name: string, multiplier: string }, seeder?: { __typename?: 'SeederType', id: string, uuid: string, displayName: string, year?: number, rowCount: number, meterType: SeedersSeederMeterTypeChoices, account: { __typename?: 'AccountType', id: string, uuid: string, name: string }, brand: { __typename?: 'SeederBrandType', id: string }, model?: { __typename?: 'SeederModelType', id: string }, installedCategories: Array<{ __typename?: 'CategoryType', id: string, uuid: string }> }, products: Array<{ __typename?: 'QuotedProductType', id: string, name: string, order: number, rowCount: number, externalId: string, description: string, subcategoryName: string, categoryName: string, price: string, quantity: number, enableDiscount: boolean, commissionMultiplier: string, bundleName: string, bundleMultiplier?: string, bundleQuantity?: number, bundle?: { __typename?: 'BundleType', id: string }, origin?: { __typename?: 'ProductOriginType', id: string, name: string }, subcategory?: { __typename?: 'SubcategoryType', id: string, name: string, category: { __typename?: 'CategoryType', id: string, uuid: string, name: string } }, ruleGroup?: { __typename?: 'RuleGroupType', id: string, name: string }, ruleCategories: Array<{ __typename?: 'CategoryType', enabledForAssistedQuote: boolean, id: string, uuid: string, name: string }> }>, paymentMethods: Array<{ __typename?: 'QuotedPaymentMethodType', id: string, order: number, isCustom: boolean, dealerCommission?: string, name: string, multiplier: string, extraMultiplier: string, slug: string, finnancied: boolean, originalPaymentMethod?: { __typename?: 'PaymentMethodType', id: string } }>, contact: { __typename?: 'ContactType', id: string, uuid: string, externalId: string, email?: string, firstName: string, lastName: string, displayName: string, phone: string, mobilePhone: string, active: boolean, type: { __typename?: 'ContactTypeType', id: string, name: string }, account: { __typename?: 'AccountType', id: string, uuid: string, name: string, taxId?: string, externalId: string, isFavorite: boolean, address?: string, location?: { __typename?: 'LocationType', id: string, path?: string, iva: Decimal }, owner?: { __typename?: 'OrganizationType', id: string, name: string, externalId: string, isEu: boolean, displayName: string, logo?: string, logoThumbnail?: string, location?: { __typename?: 'LocationType', id: string, name: string, path?: string, iva: Decimal }, group: { __typename?: 'OrganizationGroupType', id: string, dealerCommission?: string } } } }, sale?: { __typename?: 'SaleNode', id: string, uuid: string, paymentMethod: { __typename?: 'QuotedPaymentMethodType', id: string, order: number, isCustom: boolean, dealerCommission?: string, name: string, multiplier: string, extraMultiplier: string, slug: string, finnancied: boolean, originalPaymentMethod?: { __typename?: 'PaymentMethodType', id: string } } }, createdBy?: { __typename?: 'UserType', id: string, uuid: string, email: string, firstName: string, lastName: string, displayName: string, isActive: boolean, isStaff: boolean, dateJoined: string, lastLogin?: string, language: string, emailNotifications: boolean, inAppNotifications: boolean, termsAndConditionsAcceptedAt?: string }, closeReason?: { __typename?: 'QuoteCloseReasonType', id: string, description: string, quote: { __typename?: 'QuoteNode', id: string } }, supplyOrder?: { __typename?: 'SupplyOrderNode', id: string, uuid: string, displayId: number, created: string, statusDisplay: string, status: SupplyOrdersSupplyOrderStatusChoices, charter: SupplyOrdersSupplyOrderCharterChoices, orderedProducts: Array<{ __typename?: 'OrderedProductType', id: string, quantity: number, quantityLeft: number, quotedProduct?: { __typename?: 'QuotedProductType', id: string, name: string, order: number, rowCount: number, externalId: string, description: string, subcategoryName: string, categoryName: string, price: string, quantity: number, enableDiscount: boolean, commissionMultiplier: string, bundleName: string, bundleMultiplier?: string, bundleQuantity?: number, bundle?: { __typename?: 'BundleType', id: string }, origin?: { __typename?: 'ProductOriginType', id: string, name: string }, subcategory?: { __typename?: 'SubcategoryType', id: string, name: string, category: { __typename?: 'CategoryType', id: string, uuid: string, name: string } }, ruleGroup?: { __typename?: 'RuleGroupType', id: string, name: string }, ruleCategories: Array<{ __typename?: 'CategoryType', enabledForAssistedQuote: boolean, id: string, uuid: string, name: string }> }, warrantyProduct?: { __typename?: 'WarrantyProductType', id: string, quantity: number, externalId: string, name: string, displayName: string, price: string, order: number, description: string, rowCount: number, originalProduct?: { __typename?: 'ProductNode', id: string, uuid: string, image?: string }, subcategory?: { __typename?: 'SubcategoryType', id: string, name: string, category: { __typename?: 'CategoryType', id: string, uuid: string, name: string } } } }> }, pdfs: Array<{ __typename?: 'QuotePDFType', id: string, file?: string, type: QuotesQuotePdfTypeChoices, recipient: string, typeDisplay?: string, emailStatus?: string, created: string, paymentMethod?: { __typename?: 'QuotedPaymentMethodType', id: string, order: number, isCustom: boolean, dealerCommission?: string, name: string, multiplier: string, extraMultiplier: string, slug: string, finnancied: boolean, originalPaymentMethod?: { __typename?: 'PaymentMethodType', id: string } }, createdBy?: { __typename?: 'UserType', id: string, uuid: string, email: string, firstName: string, lastName: string, displayName: string, isActive: boolean, isStaff: boolean, dateJoined: string, lastLogin?: string, language: string, emailNotifications: boolean, inAppNotifications: boolean, termsAndConditionsAcceptedAt?: string } }> } };

export type QuoteCloseReasonFragment = { __typename?: 'QuoteCloseReasonType', id: string, description: string, quote: { __typename?: 'QuoteNode', id: string } };

export type ExportExcelQuotesMutationVariables = Exact<{
  query?: InputMaybe<Scalars['String']['input']>;
  createdGte?: InputMaybe<Scalars['Date']['input']>;
  createdLte?: InputMaybe<Scalars['Date']['input']>;
  owner?: InputMaybe<Scalars['UUID']['input']>;
  accountGlobalId?: InputMaybe<Scalars['UUID']['input']>;
  contactGlobalId?: InputMaybe<Scalars['UUID']['input']>;
  user?: InputMaybe<Scalars['UUID']['input']>;
  status?: InputMaybe<QuotesQuoteStatusChoices>;
  product?: InputMaybe<Scalars['String']['input']>;
  quoteId?: InputMaybe<Scalars['UUID']['input']>;
  paymentMethodId?: InputMaybe<Scalars['UUID']['input']>;
}>;


export type ExportExcelQuotesMutation = { __typename?: 'Mutation', exportExcelQuotes?: { __typename?: 'ExportExcelQuotes', job?: { __typename?: 'ExportJobType', id: string, status: JobStatus } } };

export type UpdateQuotePricesMutationVariables = Exact<{
  input: UpdateQuotePricesMutationInput;
}>;


export type UpdateQuotePricesMutation = { __typename?: 'Mutation', updateQuotePrices?: { __typename?: 'UpdateQuotePricesMutationPayload', quote?: { __typename?: 'QuoteNode', id: string }, errors: Array<{ __typename?: 'ErrorType', field: string, messages: Array<string> }> } };

export type DeleteQuoteMutationVariables = Exact<{
  input: DeleteQuoteMutationInput;
}>;


export type DeleteQuoteMutation = { __typename?: 'Mutation', deleteQuote?: { __typename?: 'DeleteQuoteMutationPayload', errors: Array<{ __typename?: 'ErrorType', field: string, messages: Array<string> }> } };

export type CreateBankInvoicePdfMutationVariables = Exact<{
  paymentMethodUuid: Scalars['UUID']['input'];
  quoteUuid: Scalars['UUID']['input'];
}>;


export type CreateBankInvoicePdfMutation = { __typename?: 'Mutation', createBankInvicePdf?: { __typename?: 'CreateBankInvoicePDF', job?: { __typename?: 'ExportJobType', id: string }, errors?: Array<{ __typename?: 'ErrorType', field: string, messages: Array<string> }> } };

export type QuotePdfFragment = { __typename?: 'QuotePDFType', id: string, file?: string, type: QuotesQuotePdfTypeChoices, recipient: string, typeDisplay?: string, emailStatus?: string, created: string, paymentMethod?: { __typename?: 'QuotedPaymentMethodType', id: string, order: number, isCustom: boolean, dealerCommission?: string, name: string, multiplier: string, extraMultiplier: string, slug: string, finnancied: boolean, originalPaymentMethod?: { __typename?: 'PaymentMethodType', id: string } }, createdBy?: { __typename?: 'UserType', id: string, uuid: string, email: string, firstName: string, lastName: string, displayName: string, isActive: boolean, isStaff: boolean, dateJoined: string, lastLogin?: string, language: string, emailNotifications: boolean, inAppNotifications: boolean, termsAndConditionsAcceptedAt?: string } };

export type CreateQuotePdfMutationVariables = Exact<{
  paymentMethodId?: InputMaybe<Scalars['UUID']['input']>;
  productDisplay?: InputMaybe<QuotesQuotePdfProductDisplayChoices>;
  quoteUuid: Scalars['UUID']['input'];
  recipient?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<QuotesQuotePdfTypeChoices>;
}>;


export type CreateQuotePdfMutation = { __typename?: 'Mutation', createQuotePdf?: { __typename?: 'CreateQuotePDF', job?: { __typename?: 'ExportJobType', id: string }, errors?: Array<{ __typename?: 'ErrorType', field: string, messages: Array<string> }> } };

export type BankInvoicePdfDisclaimerFragment = { __typename?: 'BankInvoicePDFDisclaimerType', id: string, legalName?: string, address?: string, taxId?: string, taxpayerType?: string, startOfActivities?: string, disclaimer: string, bankAccountName: string, bankAccountNumber: string, routingTransitNumberChecks: string, routingTransitNumberIncomingAch: string, routingTransitNumberOutgoingAch: string, routingTransitNumberWires: string, bankSwiftCodeInternational: string, bankAccountAddress: string };

export type GetBankInvoicePdfDisclaimerQueryVariables = Exact<{ [key: string]: never; }>;


export type GetBankInvoicePdfDisclaimerQuery = { __typename?: 'Query', bankInvoicePdfDisclaimer: { __typename?: 'BankInvoicePDFDisclaimerType', id: string, legalName?: string, address?: string, taxId?: string, taxpayerType?: string, startOfActivities?: string, disclaimer: string, bankAccountName: string, bankAccountNumber: string, routingTransitNumberChecks: string, routingTransitNumberIncomingAch: string, routingTransitNumberOutgoingAch: string, routingTransitNumberWires: string, bankSwiftCodeInternational: string, bankAccountAddress: string } };

export type CloseReasonFragment = { __typename?: 'CloseReasonType', id: string, description: string };

export type GetCloseReasonsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCloseReasonsQuery = { __typename?: 'Query', closeReasons: Array<{ __typename?: 'CloseReasonType', id: string, description: string }> };

export type CloseQuotesMutationVariables = Exact<{
  input: Array<InputMaybe<QuoteCloseReasonInputType>>;
}>;


export type CloseQuotesMutation = { __typename?: 'Mutation', closeQuotes?: { __typename?: 'CloseQuoteMutation', status: boolean } };

export type MinimalSaleFragment = { __typename?: 'SaleNode', id: string, uuid: string, paymentMethod: { __typename?: 'QuotedPaymentMethodType', id: string, order: number, isCustom: boolean, dealerCommission?: string, name: string, multiplier: string, extraMultiplier: string, slug: string, finnancied: boolean, originalPaymentMethod?: { __typename?: 'PaymentMethodType', id: string } } };

export type SaleFragment = { __typename?: 'SaleNode', id: string, uuid: string, created: string, createdBy?: { __typename?: 'UserType', id: string, uuid: string, email: string, firstName: string, lastName: string, displayName: string, isActive: boolean, isStaff: boolean, dateJoined: string, lastLogin?: string, language: string, emailNotifications: boolean, inAppNotifications: boolean, termsAndConditionsAcceptedAt?: string }, quote: { __typename?: 'QuoteNode', additionalChargesValue?: string, additionalChargesDescription?: string, billingType: QuotesQuoteBillingTypeChoices, displayBillingType: string, rowCount?: number, notes?: string, created: string, id: string, uuid: string, displayName: string, displayId: number, status?: QuotesQuoteStatusChoices, statusDisplay: string, kitMultiplier?: { __typename?: 'QuoteKitMultiplierType', id: string, name: string, multiplier: string }, seeder?: { __typename?: 'SeederType', id: string, uuid: string, displayName: string, year?: number, rowCount: number, meterType: SeedersSeederMeterTypeChoices, account: { __typename?: 'AccountType', id: string, uuid: string, name: string }, brand: { __typename?: 'SeederBrandType', id: string }, model?: { __typename?: 'SeederModelType', id: string }, installedCategories: Array<{ __typename?: 'CategoryType', id: string, uuid: string }> }, products: Array<{ __typename?: 'QuotedProductType', id: string, name: string, order: number, rowCount: number, externalId: string, description: string, subcategoryName: string, categoryName: string, price: string, quantity: number, enableDiscount: boolean, commissionMultiplier: string, bundleName: string, bundleMultiplier?: string, bundleQuantity?: number, bundle?: { __typename?: 'BundleType', id: string }, origin?: { __typename?: 'ProductOriginType', id: string, name: string }, subcategory?: { __typename?: 'SubcategoryType', id: string, name: string, category: { __typename?: 'CategoryType', id: string, uuid: string, name: string } }, ruleGroup?: { __typename?: 'RuleGroupType', id: string, name: string }, ruleCategories: Array<{ __typename?: 'CategoryType', enabledForAssistedQuote: boolean, id: string, uuid: string, name: string }> }>, paymentMethods: Array<{ __typename?: 'QuotedPaymentMethodType', id: string, order: number, isCustom: boolean, dealerCommission?: string, name: string, multiplier: string, extraMultiplier: string, slug: string, finnancied: boolean, originalPaymentMethod?: { __typename?: 'PaymentMethodType', id: string } }>, contact: { __typename?: 'ContactType', id: string, uuid: string, externalId: string, email?: string, firstName: string, lastName: string, displayName: string, phone: string, mobilePhone: string, active: boolean, type: { __typename?: 'ContactTypeType', id: string, name: string }, account: { __typename?: 'AccountType', id: string, uuid: string, name: string, taxId?: string, externalId: string, isFavorite: boolean, address?: string, location?: { __typename?: 'LocationType', id: string, path?: string, iva: Decimal }, owner?: { __typename?: 'OrganizationType', id: string, name: string, externalId: string, isEu: boolean, displayName: string, logo?: string, logoThumbnail?: string, location?: { __typename?: 'LocationType', id: string, name: string, path?: string, iva: Decimal }, group: { __typename?: 'OrganizationGroupType', id: string, dealerCommission?: string } } } }, sale?: { __typename?: 'SaleNode', id: string, uuid: string, paymentMethod: { __typename?: 'QuotedPaymentMethodType', id: string, order: number, isCustom: boolean, dealerCommission?: string, name: string, multiplier: string, extraMultiplier: string, slug: string, finnancied: boolean, originalPaymentMethod?: { __typename?: 'PaymentMethodType', id: string } } }, createdBy?: { __typename?: 'UserType', id: string, uuid: string, email: string, firstName: string, lastName: string, displayName: string, isActive: boolean, isStaff: boolean, dateJoined: string, lastLogin?: string, language: string, emailNotifications: boolean, inAppNotifications: boolean, termsAndConditionsAcceptedAt?: string }, closeReason?: { __typename?: 'QuoteCloseReasonType', id: string, description: string, quote: { __typename?: 'QuoteNode', id: string } }, supplyOrder?: { __typename?: 'SupplyOrderNode', id: string, uuid: string, displayId: number, created: string, statusDisplay: string, status: SupplyOrdersSupplyOrderStatusChoices, charter: SupplyOrdersSupplyOrderCharterChoices, orderedProducts: Array<{ __typename?: 'OrderedProductType', id: string, quantity: number, quantityLeft: number, quotedProduct?: { __typename?: 'QuotedProductType', id: string, name: string, order: number, rowCount: number, externalId: string, description: string, subcategoryName: string, categoryName: string, price: string, quantity: number, enableDiscount: boolean, commissionMultiplier: string, bundleName: string, bundleMultiplier?: string, bundleQuantity?: number, bundle?: { __typename?: 'BundleType', id: string }, origin?: { __typename?: 'ProductOriginType', id: string, name: string }, subcategory?: { __typename?: 'SubcategoryType', id: string, name: string, category: { __typename?: 'CategoryType', id: string, uuid: string, name: string } }, ruleGroup?: { __typename?: 'RuleGroupType', id: string, name: string }, ruleCategories: Array<{ __typename?: 'CategoryType', enabledForAssistedQuote: boolean, id: string, uuid: string, name: string }> }, warrantyProduct?: { __typename?: 'WarrantyProductType', id: string, quantity: number, externalId: string, name: string, displayName: string, price: string, order: number, description: string, rowCount: number, originalProduct?: { __typename?: 'ProductNode', id: string, uuid: string, image?: string }, subcategory?: { __typename?: 'SubcategoryType', id: string, name: string, category: { __typename?: 'CategoryType', id: string, uuid: string, name: string } } } }> }, pdfs: Array<{ __typename?: 'QuotePDFType', id: string, file?: string, type: QuotesQuotePdfTypeChoices, recipient: string, typeDisplay?: string, emailStatus?: string, created: string, paymentMethod?: { __typename?: 'QuotedPaymentMethodType', id: string, order: number, isCustom: boolean, dealerCommission?: string, name: string, multiplier: string, extraMultiplier: string, slug: string, finnancied: boolean, originalPaymentMethod?: { __typename?: 'PaymentMethodType', id: string } }, createdBy?: { __typename?: 'UserType', id: string, uuid: string, email: string, firstName: string, lastName: string, displayName: string, isActive: boolean, isStaff: boolean, dateJoined: string, lastLogin?: string, language: string, emailNotifications: boolean, inAppNotifications: boolean, termsAndConditionsAcceptedAt?: string } }> }, paymentMethod: { __typename?: 'QuotedPaymentMethodType', id: string, order: number, isCustom: boolean, dealerCommission?: string, name: string, multiplier: string, extraMultiplier: string, slug: string, finnancied: boolean, originalPaymentMethod?: { __typename?: 'PaymentMethodType', id: string } } };

export type SaleListFragment = { __typename?: 'SaleNode', id: string, uuid: string, created: string, createdBy?: { __typename?: 'UserType', displayName: string }, quote: { __typename?: 'QuoteNode', uuid: string, id: string, created: string, status?: QuotesQuoteStatusChoices, displayId: number, statusDisplay: string, rowCount?: number, contact: { __typename?: 'ContactType', id: string, uuid: string, email?: string, displayName: string, account: { __typename?: 'AccountType', id: string, uuid: string, name: string, owner?: { __typename?: 'OrganizationType', id: string, name: string } } }, seeder?: { __typename?: 'SeederType', displayName: string, brand: { __typename?: 'SeederBrandType', name: string } }, createdBy?: { __typename?: 'UserType', displayName: string, email: string }, closeReason?: { __typename?: 'QuoteCloseReasonType', id: string }, paymentMethods: Array<{ __typename?: 'QuotedPaymentMethodType', id: string, order: number, isCustom: boolean, dealerCommission?: string, name: string, multiplier: string, extraMultiplier: string, slug: string, finnancied: boolean, originalPaymentMethod?: { __typename?: 'PaymentMethodType', id: string } }>, kitMultiplier?: { __typename?: 'QuoteKitMultiplierType', multiplier: string }, products: Array<{ __typename?: 'QuotedProductType', id: string, name: string, order: number, rowCount: number, externalId: string, description: string, subcategoryName: string, categoryName: string, price: string, quantity: number, enableDiscount: boolean, commissionMultiplier: string, bundleName: string, bundleMultiplier?: string, bundleQuantity?: number, bundle?: { __typename?: 'BundleType', id: string }, origin?: { __typename?: 'ProductOriginType', id: string, name: string }, subcategory?: { __typename?: 'SubcategoryType', id: string, name: string, category: { __typename?: 'CategoryType', id: string, uuid: string, name: string } }, ruleGroup?: { __typename?: 'RuleGroupType', id: string, name: string }, ruleCategories: Array<{ __typename?: 'CategoryType', enabledForAssistedQuote: boolean, id: string, uuid: string, name: string }> }> }, paymentMethod: { __typename?: 'QuotedPaymentMethodType', id: string, order: number, isCustom: boolean, dealerCommission?: string, name: string, multiplier: string, extraMultiplier: string, slug: string, finnancied: boolean, originalPaymentMethod?: { __typename?: 'PaymentMethodType', id: string } } };

export type CreateSaleMutationVariables = Exact<{
  input: CreateSaleMutationInput;
}>;


export type CreateSaleMutation = { __typename?: 'Mutation', createSale?: { __typename?: 'CreateSaleMutationPayload', sale?: { __typename?: 'SaleNode', id: string, uuid: string }, errors: Array<{ __typename?: 'ErrorType', field: string, messages: Array<string> }> } };

export type UpdateSaleMutationVariables = Exact<{
  input: UpdateSaleMutationInput;
}>;


export type UpdateSaleMutation = { __typename?: 'Mutation', updateSale?: { __typename?: 'UpdateSaleMutationPayload', errors: Array<{ __typename?: 'ErrorType', field: string, messages: Array<string> }>, sale?: { __typename?: 'SaleNode', id: string, uuid: string } } };

export type GetSaleQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  uuid?: InputMaybe<Scalars['UUID']['input']>;
}>;


export type GetSaleQuery = { __typename?: 'Query', sale?: { __typename?: 'SaleNode', id: string, uuid: string, created: string, createdBy?: { __typename?: 'UserType', id: string, uuid: string, email: string, firstName: string, lastName: string, displayName: string, isActive: boolean, isStaff: boolean, dateJoined: string, lastLogin?: string, language: string, emailNotifications: boolean, inAppNotifications: boolean, termsAndConditionsAcceptedAt?: string }, quote: { __typename?: 'QuoteNode', additionalChargesValue?: string, additionalChargesDescription?: string, billingType: QuotesQuoteBillingTypeChoices, displayBillingType: string, rowCount?: number, notes?: string, created: string, id: string, uuid: string, displayName: string, displayId: number, status?: QuotesQuoteStatusChoices, statusDisplay: string, kitMultiplier?: { __typename?: 'QuoteKitMultiplierType', id: string, name: string, multiplier: string }, seeder?: { __typename?: 'SeederType', id: string, uuid: string, displayName: string, year?: number, rowCount: number, meterType: SeedersSeederMeterTypeChoices, account: { __typename?: 'AccountType', id: string, uuid: string, name: string }, brand: { __typename?: 'SeederBrandType', id: string }, model?: { __typename?: 'SeederModelType', id: string }, installedCategories: Array<{ __typename?: 'CategoryType', id: string, uuid: string }> }, products: Array<{ __typename?: 'QuotedProductType', id: string, name: string, order: number, rowCount: number, externalId: string, description: string, subcategoryName: string, categoryName: string, price: string, quantity: number, enableDiscount: boolean, commissionMultiplier: string, bundleName: string, bundleMultiplier?: string, bundleQuantity?: number, bundle?: { __typename?: 'BundleType', id: string }, origin?: { __typename?: 'ProductOriginType', id: string, name: string }, subcategory?: { __typename?: 'SubcategoryType', id: string, name: string, category: { __typename?: 'CategoryType', id: string, uuid: string, name: string } }, ruleGroup?: { __typename?: 'RuleGroupType', id: string, name: string }, ruleCategories: Array<{ __typename?: 'CategoryType', enabledForAssistedQuote: boolean, id: string, uuid: string, name: string }> }>, paymentMethods: Array<{ __typename?: 'QuotedPaymentMethodType', id: string, order: number, isCustom: boolean, dealerCommission?: string, name: string, multiplier: string, extraMultiplier: string, slug: string, finnancied: boolean, originalPaymentMethod?: { __typename?: 'PaymentMethodType', id: string } }>, contact: { __typename?: 'ContactType', id: string, uuid: string, externalId: string, email?: string, firstName: string, lastName: string, displayName: string, phone: string, mobilePhone: string, active: boolean, type: { __typename?: 'ContactTypeType', id: string, name: string }, account: { __typename?: 'AccountType', id: string, uuid: string, name: string, taxId?: string, externalId: string, isFavorite: boolean, address?: string, location?: { __typename?: 'LocationType', id: string, path?: string, iva: Decimal }, owner?: { __typename?: 'OrganizationType', id: string, name: string, externalId: string, isEu: boolean, displayName: string, logo?: string, logoThumbnail?: string, location?: { __typename?: 'LocationType', id: string, name: string, path?: string, iva: Decimal }, group: { __typename?: 'OrganizationGroupType', id: string, dealerCommission?: string } } } }, sale?: { __typename?: 'SaleNode', id: string, uuid: string, paymentMethod: { __typename?: 'QuotedPaymentMethodType', id: string, order: number, isCustom: boolean, dealerCommission?: string, name: string, multiplier: string, extraMultiplier: string, slug: string, finnancied: boolean, originalPaymentMethod?: { __typename?: 'PaymentMethodType', id: string } } }, createdBy?: { __typename?: 'UserType', id: string, uuid: string, email: string, firstName: string, lastName: string, displayName: string, isActive: boolean, isStaff: boolean, dateJoined: string, lastLogin?: string, language: string, emailNotifications: boolean, inAppNotifications: boolean, termsAndConditionsAcceptedAt?: string }, closeReason?: { __typename?: 'QuoteCloseReasonType', id: string, description: string, quote: { __typename?: 'QuoteNode', id: string } }, supplyOrder?: { __typename?: 'SupplyOrderNode', id: string, uuid: string, displayId: number, created: string, statusDisplay: string, status: SupplyOrdersSupplyOrderStatusChoices, charter: SupplyOrdersSupplyOrderCharterChoices, orderedProducts: Array<{ __typename?: 'OrderedProductType', id: string, quantity: number, quantityLeft: number, quotedProduct?: { __typename?: 'QuotedProductType', id: string, name: string, order: number, rowCount: number, externalId: string, description: string, subcategoryName: string, categoryName: string, price: string, quantity: number, enableDiscount: boolean, commissionMultiplier: string, bundleName: string, bundleMultiplier?: string, bundleQuantity?: number, bundle?: { __typename?: 'BundleType', id: string }, origin?: { __typename?: 'ProductOriginType', id: string, name: string }, subcategory?: { __typename?: 'SubcategoryType', id: string, name: string, category: { __typename?: 'CategoryType', id: string, uuid: string, name: string } }, ruleGroup?: { __typename?: 'RuleGroupType', id: string, name: string }, ruleCategories: Array<{ __typename?: 'CategoryType', enabledForAssistedQuote: boolean, id: string, uuid: string, name: string }> }, warrantyProduct?: { __typename?: 'WarrantyProductType', id: string, quantity: number, externalId: string, name: string, displayName: string, price: string, order: number, description: string, rowCount: number, originalProduct?: { __typename?: 'ProductNode', id: string, uuid: string, image?: string }, subcategory?: { __typename?: 'SubcategoryType', id: string, name: string, category: { __typename?: 'CategoryType', id: string, uuid: string, name: string } } } }> }, pdfs: Array<{ __typename?: 'QuotePDFType', id: string, file?: string, type: QuotesQuotePdfTypeChoices, recipient: string, typeDisplay?: string, emailStatus?: string, created: string, paymentMethod?: { __typename?: 'QuotedPaymentMethodType', id: string, order: number, isCustom: boolean, dealerCommission?: string, name: string, multiplier: string, extraMultiplier: string, slug: string, finnancied: boolean, originalPaymentMethod?: { __typename?: 'PaymentMethodType', id: string } }, createdBy?: { __typename?: 'UserType', id: string, uuid: string, email: string, firstName: string, lastName: string, displayName: string, isActive: boolean, isStaff: boolean, dateJoined: string, lastLogin?: string, language: string, emailNotifications: boolean, inAppNotifications: boolean, termsAndConditionsAcceptedAt?: string } }> }, paymentMethod: { __typename?: 'QuotedPaymentMethodType', id: string, order: number, isCustom: boolean, dealerCommission?: string, name: string, multiplier: string, extraMultiplier: string, slug: string, finnancied: boolean, originalPaymentMethod?: { __typename?: 'PaymentMethodType', id: string } } } };

export type GetSalesQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  createdGte?: InputMaybe<Scalars['Date']['input']>;
  createdLte?: InputMaybe<Scalars['Date']['input']>;
  owner?: InputMaybe<Scalars['UUID']['input']>;
  accountGlobalId?: InputMaybe<Scalars['UUID']['input']>;
  contactGlobalId?: InputMaybe<Scalars['UUID']['input']>;
  user?: InputMaybe<Scalars['UUID']['input']>;
}>;


export type GetSalesQuery = { __typename?: 'Query', sales?: { __typename?: 'SaleNodeConnection', count: number, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string, endCursor?: string }, edges: Array<{ __typename?: 'SaleNodeEdge', cursor: string, node?: { __typename?: 'SaleNode', id: string, uuid: string, created: string, createdBy?: { __typename?: 'UserType', displayName: string }, quote: { __typename?: 'QuoteNode', uuid: string, id: string, created: string, status?: QuotesQuoteStatusChoices, displayId: number, statusDisplay: string, rowCount?: number, contact: { __typename?: 'ContactType', id: string, uuid: string, email?: string, displayName: string, account: { __typename?: 'AccountType', id: string, uuid: string, name: string, owner?: { __typename?: 'OrganizationType', id: string, name: string } } }, seeder?: { __typename?: 'SeederType', displayName: string, brand: { __typename?: 'SeederBrandType', name: string } }, createdBy?: { __typename?: 'UserType', displayName: string, email: string }, closeReason?: { __typename?: 'QuoteCloseReasonType', id: string }, paymentMethods: Array<{ __typename?: 'QuotedPaymentMethodType', id: string, order: number, isCustom: boolean, dealerCommission?: string, name: string, multiplier: string, extraMultiplier: string, slug: string, finnancied: boolean, originalPaymentMethod?: { __typename?: 'PaymentMethodType', id: string } }>, kitMultiplier?: { __typename?: 'QuoteKitMultiplierType', multiplier: string }, products: Array<{ __typename?: 'QuotedProductType', id: string, name: string, order: number, rowCount: number, externalId: string, description: string, subcategoryName: string, categoryName: string, price: string, quantity: number, enableDiscount: boolean, commissionMultiplier: string, bundleName: string, bundleMultiplier?: string, bundleQuantity?: number, bundle?: { __typename?: 'BundleType', id: string }, origin?: { __typename?: 'ProductOriginType', id: string, name: string }, subcategory?: { __typename?: 'SubcategoryType', id: string, name: string, category: { __typename?: 'CategoryType', id: string, uuid: string, name: string } }, ruleGroup?: { __typename?: 'RuleGroupType', id: string, name: string }, ruleCategories: Array<{ __typename?: 'CategoryType', enabledForAssistedQuote: boolean, id: string, uuid: string, name: string }> }> }, paymentMethod: { __typename?: 'QuotedPaymentMethodType', id: string, order: number, isCustom: boolean, dealerCommission?: string, name: string, multiplier: string, extraMultiplier: string, slug: string, finnancied: boolean, originalPaymentMethod?: { __typename?: 'PaymentMethodType', id: string } } } }> } };

export type ExportExcelSalesMutationVariables = Exact<{
  query?: InputMaybe<Scalars['String']['input']>;
  createdGte?: InputMaybe<Scalars['Date']['input']>;
  createdLte?: InputMaybe<Scalars['Date']['input']>;
  owner?: InputMaybe<Scalars['UUID']['input']>;
  accountGlobalId?: InputMaybe<Scalars['UUID']['input']>;
  contactGlobalId?: InputMaybe<Scalars['UUID']['input']>;
  user?: InputMaybe<Scalars['UUID']['input']>;
  saleId?: InputMaybe<Scalars['UUID']['input']>;
}>;


export type ExportExcelSalesMutation = { __typename?: 'Mutation', exportExcelSales?: { __typename?: 'ExportExcelSales', job?: { __typename?: 'ExportJobType', id: string, status: JobStatus } } };

export type SeederFragment = { __typename?: 'SeederNode', id: string, uuid: string, displayName: string, year?: number, rowCount: number, meterType: SeedersSeederMeterTypeChoices, account: { __typename?: 'AccountType', id: string, uuid: string, name: string }, brand: { __typename?: 'SeederBrandType', id: string }, model?: { __typename?: 'SeederModelType', id: string }, installedCategories: Array<{ __typename?: 'CategoryType', id: string, uuid: string }> };

export type SeederTypeFragment = { __typename?: 'SeederType', id: string, uuid: string, displayName: string, year?: number, rowCount: number, meterType: SeedersSeederMeterTypeChoices, account: { __typename?: 'AccountType', id: string, uuid: string, name: string }, brand: { __typename?: 'SeederBrandType', id: string }, model?: { __typename?: 'SeederModelType', id: string }, installedCategories: Array<{ __typename?: 'CategoryType', id: string, uuid: string }> };

export type SeederOptionFragment = { __typename?: 'SeederNode', id: string, uuid: string, displayName: string, rowCount: number };

export type SeederOptionTypeFragment = { __typename?: 'SeederType', uuid: string, displayName: string, rowCount: number, id: string };

export type GetSeederModelsQueryVariables = Exact<{
  seederBrandId?: InputMaybe<Scalars['UUID']['input']>;
}>;


export type GetSeederModelsQuery = { __typename?: 'Query', seederModels: Array<{ __typename?: 'SeederModelType', id: string, name: string }> };

export type GetSeederBrandsQueryVariables = Exact<{
  organizationId?: InputMaybe<Scalars['UUID']['input']>;
}>;


export type GetSeederBrandsQuery = { __typename?: 'Query', seederBrands: Array<{ __typename?: 'SeederBrandType', id: string, name: string }> };

export type GetSeederOptionsQueryVariables = Exact<{
  accountId?: InputMaybe<Scalars['UUID']['input']>;
}>;


export type GetSeederOptionsQuery = { __typename?: 'Query', seeders?: { __typename?: 'SeederNodeConnection', count: number, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string, endCursor?: string }, edges: Array<{ __typename?: 'SeederNodeEdge', cursor: string, node?: { __typename?: 'SeederNode', id: string, uuid: string, displayName: string, rowCount: number } }> } };

export type GetSeederQueryVariables = Exact<{
  uuid?: InputMaybe<Scalars['UUID']['input']>;
  id: Scalars['ID']['input'];
}>;


export type GetSeederQuery = { __typename?: 'Query', seeder?: { __typename?: 'SeederNode', id: string, uuid: string, year?: number, rowCount: number, meterType: SeedersSeederMeterTypeChoices, account: { __typename?: 'AccountType', id: string, uuid: string, name: string }, brand: { __typename?: 'SeederBrandType', id: string }, model?: { __typename?: 'SeederModelType', id: string }, installedCategories: Array<{ __typename?: 'CategoryType', id: string, uuid: string }> } };

export type CreateSeederMutationVariables = Exact<{
  input: CreateSeederMutationInput;
}>;


export type CreateSeederMutation = { __typename?: 'Mutation', createSeeder?: { __typename?: 'CreateSeederMutationPayload', seeder?: { __typename?: 'SeederType', id: string, uuid: string, account: { __typename?: 'AccountType', id: string, uuid: string } }, errors: Array<{ __typename?: 'ErrorType', field: string, messages: Array<string> }> } };

export type UpdateSeederMutationVariables = Exact<{
  input: UpdateSeederMutationInput;
}>;


export type UpdateSeederMutation = { __typename?: 'Mutation', updateSeeder?: { __typename?: 'UpdateSeederMutationPayload', seeder?: { __typename?: 'SeederType', id: string, account: { __typename?: 'AccountType', id: string } }, errors: Array<{ __typename?: 'ErrorType', field: string, messages: Array<string> }> } };

export type SeederListFragment = { __typename?: 'SeederNode', id: string, uuid: string, displayName: string, year?: number, rowCount: number, meterType: SeedersSeederMeterTypeChoices, meterTypeDisplay: string, account: { __typename?: 'AccountType', id: string, uuid: string, name: string }, brand: { __typename?: 'SeederBrandType', id: string, name: string }, model?: { __typename?: 'SeederModelType', id: string, name: string }, installedCategories: Array<{ __typename?: 'CategoryType', id: string, uuid: string, name: string }> };

export type GetSeedersQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  accountGlobalId?: InputMaybe<Scalars['UUID']['input']>;
}>;


export type GetSeedersQuery = { __typename?: 'Query', seeders?: { __typename?: 'SeederNodeConnection', count: number, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string, endCursor?: string }, edges: Array<{ __typename?: 'SeederNodeEdge', cursor: string, node?: { __typename?: 'SeederNode', id: string, uuid: string, displayName: string, year?: number, rowCount: number, meterType: SeedersSeederMeterTypeChoices, meterTypeDisplay: string, account: { __typename?: 'AccountType', id: string, uuid: string, name: string }, brand: { __typename?: 'SeederBrandType', id: string, name: string }, model?: { __typename?: 'SeederModelType', id: string, name: string }, installedCategories: Array<{ __typename?: 'CategoryType', id: string, uuid: string, name: string }> } }> } };

export type DeleteSeederMutationVariables = Exact<{
  input: DeleteSeederMutationInput;
}>;


export type DeleteSeederMutation = { __typename?: 'Mutation', deleteSeeder?: { __typename?: 'DeleteSeederMutationPayload', errors: Array<{ __typename?: 'ErrorType', field: string, messages: Array<string> }> } };

export type GetForecastRunsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetForecastRunsQuery = { __typename?: 'Query', forecastRuns: Array<{ __typename?: 'ForecastRunType', id: string, status: StockForecastForecastRunStatusChoices, created: string, completedAt?: string, totalSkus: number, totalOrderLines: number, totalOrderValue: string, createdBy?: { __typename?: 'UserType', displayName: string } }> };

export type GetForecastRunQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type GetForecastRunQuery = { __typename?: 'Query', forecastRun?: { __typename?: 'ForecastRunType', id: string, status: StockForecastForecastRunStatusChoices, created: string, completedAt?: string, errorMessage: string, totalSkus: number, totalOrderLines: number, totalOrderValue: string, stockSnapshotAt?: string } };

export type GetForecastRecommendationsQueryVariables = Exact<{
  forecastRunId: Scalars['UUID']['input'];
  onlyWithOrders?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetForecastRecommendationsQuery = { __typename?: 'Query', forecastRecommendations: Array<{ __typename?: 'ReplenishmentRecommendationType', id: string, finalOrder: number, quoteNeed: number, historicalGap: number, suggestedOrder: number, maxOrderCap: number, minimumStock: number, minStockGap: number, reasonCode: string, priority: string, orderValue: string, manualInput?: number, product: { __typename?: 'ProductType', id: string, externalId: string, name: string } }> };

export type GetMrpParametersQueryVariables = Exact<{ [key: string]: never; }>;


export type GetMrpParametersQuery = { __typename?: 'Query', mrpParameters: { __typename?: 'MRPParametersType', id: string, quoteNoOrderThreshold: string, quoteReorderTarget: string, monthlyHistoricalCoverageTarget: string, stockThresholdUnits: number, reducedOrderFractionOfCap: string, globalMaxOrderPerSku: number, useDynamicCapByUnitPrice: boolean, leadTimeMonths: number, minimumDemandMonthsToTrustAverage: number, maxPercentOfPeakMonth: string, highPriorityOrderValue: string, mediumPriorityOrderValue: string, priceTiers: string }, mrpLifecycleOverrides: Array<{ __typename?: 'MRPLifecycleOverrideType', id: string, lifecycle: StockForecastMrpLifecycleOverrideLifecycleChoices, categoryCap: number, multiplier: string, forceZero: boolean }> };

export type RunForecastMutationVariables = Exact<{ [key: string]: never; }>;


export type RunForecastMutation = { __typename?: 'Mutation', runForecast?: { __typename?: 'RunForecast', forecastRun?: { __typename?: 'ForecastRunType', id: string, status: StockForecastForecastRunStatusChoices }, errors?: Array<{ __typename?: 'ErrorType', field: string, messages: Array<string> }> } };

export type ExportCloudOrderMutationVariables = Exact<{
  forecastRunId: Scalars['UUID']['input'];
}>;


export type ExportCloudOrderMutation = { __typename?: 'Mutation', exportCloudOrder?: { __typename?: 'ExportCloudOrder', job?: { __typename?: 'ExportJobType', id: string, status: JobStatus } } };

export type ImportInTransitStockMutationVariables = Exact<{
  file: Scalars['Upload']['input'];
}>;


export type ImportInTransitStockMutation = { __typename?: 'Mutation', importInTransitStock?: { __typename?: 'ImportInTransitStock', result?: { __typename?: 'ImportResultType', imported: number, skipped: number, duplicates: number }, errors?: Array<{ __typename?: 'ErrorType', field: string, messages: Array<string> }> } };

export type ImportMonthlyDemandMutationVariables = Exact<{
  file: Scalars['Upload']['input'];
}>;


export type ImportMonthlyDemandMutation = { __typename?: 'Mutation', importMonthlyDemand?: { __typename?: 'ImportMonthlyDemand', result?: { __typename?: 'ImportResultType', imported: number, skipped: number, duplicates: number }, errors?: Array<{ __typename?: 'ErrorType', field: string, messages: Array<string> }> } };

export type UpdateMrpLifecycleOverridesMutationVariables = Exact<{
  overrides: Array<MrpLifecycleOverrideInput>;
}>;


export type UpdateMrpLifecycleOverridesMutation = { __typename?: 'Mutation', updateMrpLifecycleOverrides?: { __typename?: 'UpdateMRPLifecycleOverrides', overrides: Array<{ __typename?: 'MRPLifecycleOverrideType', id: string, lifecycle: StockForecastMrpLifecycleOverrideLifecycleChoices, categoryCap: number, multiplier: string, forceZero: boolean }> } };

export type UpdateRecommendationManualInputMutationVariables = Exact<{
  recommendationId: Scalars['UUID']['input'];
  manualInput?: InputMaybe<Scalars['Int']['input']>;
}>;


export type UpdateRecommendationManualInputMutation = { __typename?: 'Mutation', updateRecommendationManualInput?: { __typename?: 'UpdateRecommendationManualInput', recommendation?: { __typename?: 'ReplenishmentRecommendationType', id: string, manualInput?: number, suggestedOrder: number, finalOrder: number, reasonCode: string, priority: string, orderValue: string } } };

export type UpdateMrpParametersMutationVariables = Exact<{
  input: MrpParametersInput;
}>;


export type UpdateMrpParametersMutation = { __typename?: 'Mutation', updateMrpParameters?: { __typename?: 'UpdateMRPParameters', parameters?: { __typename?: 'MRPParametersType', id: string, quoteNoOrderThreshold: string, quoteReorderTarget: string, monthlyHistoricalCoverageTarget: string, stockThresholdUnits: number, reducedOrderFractionOfCap: string, globalMaxOrderPerSku: number, useDynamicCapByUnitPrice: boolean, leadTimeMonths: number, minimumDemandMonthsToTrustAverage: number, maxPercentOfPeakMonth: string, highPriorityOrderValue: string, mediumPriorityOrderValue: string, priceTiers: string }, errors?: Array<{ __typename?: 'ErrorType', field: string, messages: Array<string> }> } };

export type GetProductsStocksQueryVariables = Exact<{
  externalIds: Array<InputMaybe<Scalars['String']['input']>>;
}>;


export type GetProductsStocksQuery = { __typename?: 'Query', productsStocks?: { __typename?: 'StockResponseType', stocks: Array<{ __typename?: 'StockType', externalId: string, availableQuantity: number, found: boolean }>, errors: Array<{ __typename?: 'StockErrorType', code?: string, message?: string }> } };

export type CreateSupplyOrderQuoteMutationVariables = Exact<{
  input: CreateSupplyOrderQuoteMutationInput;
}>;


export type CreateSupplyOrderQuoteMutation = { __typename?: 'Mutation', createSupplyOrderQuote?: { __typename?: 'CreateSupplyOrderQuoteMutationPayload', supplyOrder?: { __typename?: 'SupplyOrderNode', id: string, uuid: string }, errors: Array<{ __typename?: 'ErrorType', field: string, messages: Array<string> }> } };

export type UpdateSupplyOrderQuoteMutationVariables = Exact<{
  input: UpdateSupplyOrderQuoteMutationInput;
}>;


export type UpdateSupplyOrderQuoteMutation = { __typename?: 'Mutation', updateSupplyOrderQuote?: { __typename?: 'UpdateSupplyOrderQuoteMutationPayload', errors: Array<{ __typename?: 'ErrorType', field: string, messages: Array<string> }>, supplyOrder?: { __typename?: 'SupplyOrderNode', id: string, uuid: string } } };

export type OrderedProductFragment = { __typename?: 'OrderedProductType', id: string, quantity: number, quantityLeft: number, quotedProduct?: { __typename?: 'QuotedProductType', id: string, name: string, order: number, rowCount: number, externalId: string, description: string, subcategoryName: string, categoryName: string, price: string, quantity: number, enableDiscount: boolean, commissionMultiplier: string, bundleName: string, bundleMultiplier?: string, bundleQuantity?: number, bundle?: { __typename?: 'BundleType', id: string }, origin?: { __typename?: 'ProductOriginType', id: string, name: string }, subcategory?: { __typename?: 'SubcategoryType', id: string, name: string, category: { __typename?: 'CategoryType', id: string, uuid: string, name: string } }, ruleGroup?: { __typename?: 'RuleGroupType', id: string, name: string }, ruleCategories: Array<{ __typename?: 'CategoryType', enabledForAssistedQuote: boolean, id: string, uuid: string, name: string }> }, warrantyProduct?: { __typename?: 'WarrantyProductType', id: string, quantity: number, externalId: string, name: string, displayName: string, price: string, order: number, description: string, rowCount: number, originalProduct?: { __typename?: 'ProductNode', id: string, uuid: string, image?: string }, subcategory?: { __typename?: 'SubcategoryType', id: string, name: string, category: { __typename?: 'CategoryType', id: string, uuid: string, name: string } } } };

export type ShipmentProductFragment = { __typename?: 'ShipmentProductType', id: string, quantity: number, batch?: string, supplyOrder: { __typename?: 'SupplyOrderNode', id: string }, shipment: { __typename?: 'ShipmentType', id: string }, orderedProduct: { __typename?: 'OrderedProductType', id: string, quantity: number, quantityLeft: number, quotedProduct?: { __typename?: 'QuotedProductType', id: string, name: string, order: number, rowCount: number, externalId: string, description: string, subcategoryName: string, categoryName: string, price: string, quantity: number, enableDiscount: boolean, commissionMultiplier: string, bundleName: string, bundleMultiplier?: string, bundleQuantity?: number, bundle?: { __typename?: 'BundleType', id: string }, origin?: { __typename?: 'ProductOriginType', id: string, name: string }, subcategory?: { __typename?: 'SubcategoryType', id: string, name: string, category: { __typename?: 'CategoryType', id: string, uuid: string, name: string } }, ruleGroup?: { __typename?: 'RuleGroupType', id: string, name: string }, ruleCategories: Array<{ __typename?: 'CategoryType', enabledForAssistedQuote: boolean, id: string, uuid: string, name: string }> }, warrantyProduct?: { __typename?: 'WarrantyProductType', id: string, quantity: number, externalId: string, name: string, displayName: string, price: string, order: number, description: string, rowCount: number, originalProduct?: { __typename?: 'ProductNode', id: string, uuid: string, image?: string }, subcategory?: { __typename?: 'SubcategoryType', id: string, name: string, category: { __typename?: 'CategoryType', id: string, uuid: string, name: string } } } } };

export type MinimalSupplyOrderFragment = { __typename?: 'SupplyOrderNode', id: string, uuid: string, displayName: string, externalDealerId?: string, isUrgent: boolean };

export type ShipmentFragment = { __typename?: 'ShipmentType', id: string, externalId: string, invoice?: string, created: string, status?: SupplyOrdersShipmentStatusChoices, statusDisplay: string, supplyOrder: { __typename?: 'SupplyOrderNode', id: string, uuid: string, displayName: string, externalDealerId?: string, isUrgent: boolean }, productsShipped: Array<{ __typename?: 'ShipmentProductType', id: string, quantity: number, batch?: string, supplyOrder: { __typename?: 'SupplyOrderNode', id: string }, shipment: { __typename?: 'ShipmentType', id: string }, orderedProduct: { __typename?: 'OrderedProductType', id: string, quantity: number, quantityLeft: number, quotedProduct?: { __typename?: 'QuotedProductType', id: string, name: string, order: number, rowCount: number, externalId: string, description: string, subcategoryName: string, categoryName: string, price: string, quantity: number, enableDiscount: boolean, commissionMultiplier: string, bundleName: string, bundleMultiplier?: string, bundleQuantity?: number, bundle?: { __typename?: 'BundleType', id: string }, origin?: { __typename?: 'ProductOriginType', id: string, name: string }, subcategory?: { __typename?: 'SubcategoryType', id: string, name: string, category: { __typename?: 'CategoryType', id: string, uuid: string, name: string } }, ruleGroup?: { __typename?: 'RuleGroupType', id: string, name: string }, ruleCategories: Array<{ __typename?: 'CategoryType', enabledForAssistedQuote: boolean, id: string, uuid: string, name: string }> }, warrantyProduct?: { __typename?: 'WarrantyProductType', id: string, quantity: number, externalId: string, name: string, displayName: string, price: string, order: number, description: string, rowCount: number, originalProduct?: { __typename?: 'ProductNode', id: string, uuid: string, image?: string }, subcategory?: { __typename?: 'SubcategoryType', id: string, name: string, category: { __typename?: 'CategoryType', id: string, uuid: string, name: string } } } } }>, createdBy?: { __typename?: 'UserType', id: string, uuid: string, email: string, firstName: string, lastName: string, displayName: string, isActive: boolean, isStaff: boolean, dateJoined: string, lastLogin?: string, language: string, emailNotifications: boolean, inAppNotifications: boolean, termsAndConditionsAcceptedAt?: string } };

export type SupplyOrderFragment = { __typename?: 'SupplyOrderNode', id: string, uuid: string, displayId: number, displayIdWithPrefix: string, charter: SupplyOrdersSupplyOrderCharterChoices, charterDisplay: string, externalDealerId?: string, isUrgent: boolean, internalOrder: boolean, estimatedDispatchDate?: string, comment: string, salesCanReview: boolean, status: SupplyOrdersSupplyOrderStatusChoices, statusDisplay: string, created: string, userNotification: boolean, warrantyClaim?: { __typename?: 'WarrantyClaimNode', id: string, uuid: string, invoiceDate?: string, failureDate?: string, serialNumber?: string, created: string, quantity: number, description: string, finalClient: string, phone: string, externalId?: string, displayId: number, orderId?: number, warrantyClaimType: WarrantyClaimsWarrantyClaimWarrantyClaimTypeChoices, displayWarrantyClaimType: string, applyForCredit: boolean, rmaCode?: string, amount?: string, state: WarrantyClaimsWarrantyClaimStateChoices, stateDisplay: string, requiredApprovalType?: string, requiresSpecialApproval: boolean, requiresInspectionReview: boolean, hasCompletedInspectionReview: boolean, canCurrentUserApprove: boolean, requiredApprovalsList: Array<WarrantyClaimsWarrantyClaimReviewApprovalTypeChoices>, missingApprovals: Array<WarrantyClaimsWarrantyClaimReviewApprovalTypeChoices>, isFullyApproved: boolean, isInFinalState: boolean, product?: { __typename?: 'WarrantyProductType', id: string, quantity: number, externalId: string, name: string, displayName: string, price: string, order: number, description: string, rowCount: number, originalProduct?: { __typename?: 'ProductNode', id: string, uuid: string, image?: string }, subcategory?: { __typename?: 'SubcategoryType', id: string, name: string, category: { __typename?: 'CategoryType', id: string, uuid: string, name: string } } }, contact: { __typename?: 'ContactType', id: string, uuid: string, externalId: string, email?: string, firstName: string, lastName: string, displayName: string, phone: string, mobilePhone: string, active: boolean, type: { __typename?: 'ContactTypeType', id: string, name: string }, account: { __typename?: 'AccountType', id: string, uuid: string, name: string, taxId?: string, externalId: string, isFavorite: boolean, address?: string, location?: { __typename?: 'LocationType', id: string, path?: string, iva: Decimal }, owner?: { __typename?: 'OrganizationType', id: string, name: string, externalId: string, isEu: boolean, displayName: string, logo?: string, logoThumbnail?: string, location?: { __typename?: 'LocationType', id: string, name: string, path?: string, iva: Decimal }, group: { __typename?: 'OrganizationGroupType', id: string, dealerCommission?: string } } } }, createdBy?: { __typename?: 'UserType', id: string, uuid: string, email: string, firstName: string, lastName: string, displayName: string, isActive: boolean, isStaff: boolean, dateJoined: string, lastLogin?: string, language: string, emailNotifications: boolean, inAppNotifications: boolean, termsAndConditionsAcceptedAt?: string }, seeder?: { __typename?: 'SeederType', uuid: string, displayName: string, rowCount: number, id: string }, lastReview?: { __typename?: 'WarrantyClaimReviewType', id: string, created: string, notes: string, statusDisplay: string, status: WarrantyClaimsWarrantyClaimReviewStatusChoices, approvalType?: WarrantyClaimsWarrantyClaimReviewApprovalTypeChoices, approvalTypeDisplay: string, createdBy?: { __typename?: 'UserType', id: string, uuid: string, email: string, firstName: string, lastName: string, displayName: string, isActive: boolean, isStaff: boolean, dateJoined: string, lastLogin?: string, language: string, emailNotifications: boolean, inAppNotifications: boolean, termsAndConditionsAcceptedAt?: string } }, inspectionReview?: { __typename?: 'WarrantyClaimInspectionReviewType', statusDisplay: string, status: WarrantyClaimsWarrantyClaimInspectionReviewStatusChoices, inWarranty: boolean }, supplyOrder?: { __typename?: 'SupplyOrderNode', id: string, uuid: string, displayId: number, displayIdWithPrefix: string } }, quote?: { __typename?: 'QuoteNode', additionalChargesValue?: string, additionalChargesDescription?: string, billingType: QuotesQuoteBillingTypeChoices, displayBillingType: string, rowCount?: number, notes?: string, created: string, id: string, uuid: string, displayName: string, displayId: number, status?: QuotesQuoteStatusChoices, statusDisplay: string, kitMultiplier?: { __typename?: 'QuoteKitMultiplierType', id: string, name: string, multiplier: string }, seeder?: { __typename?: 'SeederType', id: string, uuid: string, displayName: string, year?: number, rowCount: number, meterType: SeedersSeederMeterTypeChoices, account: { __typename?: 'AccountType', id: string, uuid: string, name: string }, brand: { __typename?: 'SeederBrandType', id: string }, model?: { __typename?: 'SeederModelType', id: string }, installedCategories: Array<{ __typename?: 'CategoryType', id: string, uuid: string }> }, products: Array<{ __typename?: 'QuotedProductType', id: string, name: string, order: number, rowCount: number, externalId: string, description: string, subcategoryName: string, categoryName: string, price: string, quantity: number, enableDiscount: boolean, commissionMultiplier: string, bundleName: string, bundleMultiplier?: string, bundleQuantity?: number, bundle?: { __typename?: 'BundleType', id: string }, origin?: { __typename?: 'ProductOriginType', id: string, name: string }, subcategory?: { __typename?: 'SubcategoryType', id: string, name: string, category: { __typename?: 'CategoryType', id: string, uuid: string, name: string } }, ruleGroup?: { __typename?: 'RuleGroupType', id: string, name: string }, ruleCategories: Array<{ __typename?: 'CategoryType', enabledForAssistedQuote: boolean, id: string, uuid: string, name: string }> }>, paymentMethods: Array<{ __typename?: 'QuotedPaymentMethodType', id: string, order: number, isCustom: boolean, dealerCommission?: string, name: string, multiplier: string, extraMultiplier: string, slug: string, finnancied: boolean, originalPaymentMethod?: { __typename?: 'PaymentMethodType', id: string } }>, contact: { __typename?: 'ContactType', id: string, uuid: string, externalId: string, email?: string, firstName: string, lastName: string, displayName: string, phone: string, mobilePhone: string, active: boolean, type: { __typename?: 'ContactTypeType', id: string, name: string }, account: { __typename?: 'AccountType', id: string, uuid: string, name: string, taxId?: string, externalId: string, isFavorite: boolean, address?: string, location?: { __typename?: 'LocationType', id: string, path?: string, iva: Decimal }, owner?: { __typename?: 'OrganizationType', id: string, name: string, externalId: string, isEu: boolean, displayName: string, logo?: string, logoThumbnail?: string, location?: { __typename?: 'LocationType', id: string, name: string, path?: string, iva: Decimal }, group: { __typename?: 'OrganizationGroupType', id: string, dealerCommission?: string } } } }, sale?: { __typename?: 'SaleNode', id: string, uuid: string, paymentMethod: { __typename?: 'QuotedPaymentMethodType', id: string, order: number, isCustom: boolean, dealerCommission?: string, name: string, multiplier: string, extraMultiplier: string, slug: string, finnancied: boolean, originalPaymentMethod?: { __typename?: 'PaymentMethodType', id: string } } }, createdBy?: { __typename?: 'UserType', id: string, uuid: string, email: string, firstName: string, lastName: string, displayName: string, isActive: boolean, isStaff: boolean, dateJoined: string, lastLogin?: string, language: string, emailNotifications: boolean, inAppNotifications: boolean, termsAndConditionsAcceptedAt?: string }, closeReason?: { __typename?: 'QuoteCloseReasonType', id: string, description: string, quote: { __typename?: 'QuoteNode', id: string } }, supplyOrder?: { __typename?: 'SupplyOrderNode', id: string, uuid: string, displayId: number, created: string, statusDisplay: string, status: SupplyOrdersSupplyOrderStatusChoices, charter: SupplyOrdersSupplyOrderCharterChoices, orderedProducts: Array<{ __typename?: 'OrderedProductType', id: string, quantity: number, quantityLeft: number, quotedProduct?: { __typename?: 'QuotedProductType', id: string, name: string, order: number, rowCount: number, externalId: string, description: string, subcategoryName: string, categoryName: string, price: string, quantity: number, enableDiscount: boolean, commissionMultiplier: string, bundleName: string, bundleMultiplier?: string, bundleQuantity?: number, bundle?: { __typename?: 'BundleType', id: string }, origin?: { __typename?: 'ProductOriginType', id: string, name: string }, subcategory?: { __typename?: 'SubcategoryType', id: string, name: string, category: { __typename?: 'CategoryType', id: string, uuid: string, name: string } }, ruleGroup?: { __typename?: 'RuleGroupType', id: string, name: string }, ruleCategories: Array<{ __typename?: 'CategoryType', enabledForAssistedQuote: boolean, id: string, uuid: string, name: string }> }, warrantyProduct?: { __typename?: 'WarrantyProductType', id: string, quantity: number, externalId: string, name: string, displayName: string, price: string, order: number, description: string, rowCount: number, originalProduct?: { __typename?: 'ProductNode', id: string, uuid: string, image?: string }, subcategory?: { __typename?: 'SubcategoryType', id: string, name: string, category: { __typename?: 'CategoryType', id: string, uuid: string, name: string } } } }> }, pdfs: Array<{ __typename?: 'QuotePDFType', id: string, file?: string, type: QuotesQuotePdfTypeChoices, recipient: string, typeDisplay?: string, emailStatus?: string, created: string, paymentMethod?: { __typename?: 'QuotedPaymentMethodType', id: string, order: number, isCustom: boolean, dealerCommission?: string, name: string, multiplier: string, extraMultiplier: string, slug: string, finnancied: boolean, originalPaymentMethod?: { __typename?: 'PaymentMethodType', id: string } }, createdBy?: { __typename?: 'UserType', id: string, uuid: string, email: string, firstName: string, lastName: string, displayName: string, isActive: boolean, isStaff: boolean, dateJoined: string, lastLogin?: string, language: string, emailNotifications: boolean, inAppNotifications: boolean, termsAndConditionsAcceptedAt?: string } }> }, orderedProducts: Array<{ __typename?: 'OrderedProductType', id: string, quantity: number, quantityLeft: number, quotedProduct?: { __typename?: 'QuotedProductType', id: string, name: string, order: number, rowCount: number, externalId: string, description: string, subcategoryName: string, categoryName: string, price: string, quantity: number, enableDiscount: boolean, commissionMultiplier: string, bundleName: string, bundleMultiplier?: string, bundleQuantity?: number, bundle?: { __typename?: 'BundleType', id: string }, origin?: { __typename?: 'ProductOriginType', id: string, name: string }, subcategory?: { __typename?: 'SubcategoryType', id: string, name: string, category: { __typename?: 'CategoryType', id: string, uuid: string, name: string } }, ruleGroup?: { __typename?: 'RuleGroupType', id: string, name: string }, ruleCategories: Array<{ __typename?: 'CategoryType', enabledForAssistedQuote: boolean, id: string, uuid: string, name: string }> }, warrantyProduct?: { __typename?: 'WarrantyProductType', id: string, quantity: number, externalId: string, name: string, displayName: string, price: string, order: number, description: string, rowCount: number, originalProduct?: { __typename?: 'ProductNode', id: string, uuid: string, image?: string }, subcategory?: { __typename?: 'SubcategoryType', id: string, name: string, category: { __typename?: 'CategoryType', id: string, uuid: string, name: string } } } }>, productsWithoutShipment: Array<{ __typename?: 'OrderedProductType', id: string, quantity: number, quantityLeft: number, quotedProduct?: { __typename?: 'QuotedProductType', id: string, name: string, order: number, rowCount: number, externalId: string, description: string, subcategoryName: string, categoryName: string, price: string, quantity: number, enableDiscount: boolean, commissionMultiplier: string, bundleName: string, bundleMultiplier?: string, bundleQuantity?: number, bundle?: { __typename?: 'BundleType', id: string }, origin?: { __typename?: 'ProductOriginType', id: string, name: string }, subcategory?: { __typename?: 'SubcategoryType', id: string, name: string, category: { __typename?: 'CategoryType', id: string, uuid: string, name: string } }, ruleGroup?: { __typename?: 'RuleGroupType', id: string, name: string }, ruleCategories: Array<{ __typename?: 'CategoryType', enabledForAssistedQuote: boolean, id: string, uuid: string, name: string }> }, warrantyProduct?: { __typename?: 'WarrantyProductType', id: string, quantity: number, externalId: string, name: string, displayName: string, price: string, order: number, description: string, rowCount: number, originalProduct?: { __typename?: 'ProductNode', id: string, uuid: string, image?: string }, subcategory?: { __typename?: 'SubcategoryType', id: string, name: string, category: { __typename?: 'CategoryType', id: string, uuid: string, name: string } } } }>, shipments: Array<{ __typename?: 'ShipmentType', id: string, externalId: string, invoice?: string, created: string, status?: SupplyOrdersShipmentStatusChoices, statusDisplay: string, supplyOrder: { __typename?: 'SupplyOrderNode', id: string, uuid: string, displayName: string, externalDealerId?: string, isUrgent: boolean }, productsShipped: Array<{ __typename?: 'ShipmentProductType', id: string, quantity: number, batch?: string, supplyOrder: { __typename?: 'SupplyOrderNode', id: string }, shipment: { __typename?: 'ShipmentType', id: string }, orderedProduct: { __typename?: 'OrderedProductType', id: string, quantity: number, quantityLeft: number, quotedProduct?: { __typename?: 'QuotedProductType', id: string, name: string, order: number, rowCount: number, externalId: string, description: string, subcategoryName: string, categoryName: string, price: string, quantity: number, enableDiscount: boolean, commissionMultiplier: string, bundleName: string, bundleMultiplier?: string, bundleQuantity?: number, bundle?: { __typename?: 'BundleType', id: string }, origin?: { __typename?: 'ProductOriginType', id: string, name: string }, subcategory?: { __typename?: 'SubcategoryType', id: string, name: string, category: { __typename?: 'CategoryType', id: string, uuid: string, name: string } }, ruleGroup?: { __typename?: 'RuleGroupType', id: string, name: string }, ruleCategories: Array<{ __typename?: 'CategoryType', enabledForAssistedQuote: boolean, id: string, uuid: string, name: string }> }, warrantyProduct?: { __typename?: 'WarrantyProductType', id: string, quantity: number, externalId: string, name: string, displayName: string, price: string, order: number, description: string, rowCount: number, originalProduct?: { __typename?: 'ProductNode', id: string, uuid: string, image?: string }, subcategory?: { __typename?: 'SubcategoryType', id: string, name: string, category: { __typename?: 'CategoryType', id: string, uuid: string, name: string } } } } }>, createdBy?: { __typename?: 'UserType', id: string, uuid: string, email: string, firstName: string, lastName: string, displayName: string, isActive: boolean, isStaff: boolean, dateJoined: string, lastLogin?: string, language: string, emailNotifications: boolean, inAppNotifications: boolean, termsAndConditionsAcceptedAt?: string } }>, createdBy?: { __typename?: 'UserType', id: string, uuid: string, email: string, firstName: string, lastName: string, displayName: string, isActive: boolean, isStaff: boolean, dateJoined: string, lastLogin?: string, language: string, emailNotifications: boolean, inAppNotifications: boolean, termsAndConditionsAcceptedAt?: string } };

export type SupplyOrderDetailFragment = { __typename?: 'SupplyOrderNode', reviewStart?: string, shipStreet: string, shipLocation: string, shipPostalCode: string, updated: string, isUrgent: boolean, id: string, uuid: string, displayId: number, displayIdWithPrefix: string, charter: SupplyOrdersSupplyOrderCharterChoices, charterDisplay: string, externalDealerId?: string, internalOrder: boolean, estimatedDispatchDate?: string, comment: string, salesCanReview: boolean, status: SupplyOrdersSupplyOrderStatusChoices, statusDisplay: string, created: string, userNotification: boolean, reviews: Array<{ __typename?: 'SupplyOrderReviewType', id: string, statusDisplay: string, typeDisplay: string, notes: string, created: string, createdBy?: { __typename?: 'UserType', id: string, uuid: string, email: string, firstName: string, lastName: string, displayName: string, isActive: boolean, isStaff: boolean, dateJoined: string, lastLogin?: string, language: string, emailNotifications: boolean, inAppNotifications: boolean, termsAndConditionsAcceptedAt?: string } }>, shipAddress?: { __typename?: 'OrganizationAddressType', id: string }, updatedBy?: { __typename?: 'UserType', id: string, uuid: string, email: string, firstName: string, lastName: string, displayName: string, isActive: boolean, isStaff: boolean, dateJoined: string, lastLogin?: string, language: string, emailNotifications: boolean, inAppNotifications: boolean, termsAndConditionsAcceptedAt?: string }, warrantyClaim?: { __typename?: 'WarrantyClaimNode', id: string, uuid: string, invoiceDate?: string, failureDate?: string, serialNumber?: string, created: string, quantity: number, description: string, finalClient: string, phone: string, externalId?: string, displayId: number, orderId?: number, warrantyClaimType: WarrantyClaimsWarrantyClaimWarrantyClaimTypeChoices, displayWarrantyClaimType: string, applyForCredit: boolean, rmaCode?: string, amount?: string, state: WarrantyClaimsWarrantyClaimStateChoices, stateDisplay: string, requiredApprovalType?: string, requiresSpecialApproval: boolean, requiresInspectionReview: boolean, hasCompletedInspectionReview: boolean, canCurrentUserApprove: boolean, requiredApprovalsList: Array<WarrantyClaimsWarrantyClaimReviewApprovalTypeChoices>, missingApprovals: Array<WarrantyClaimsWarrantyClaimReviewApprovalTypeChoices>, isFullyApproved: boolean, isInFinalState: boolean, product?: { __typename?: 'WarrantyProductType', id: string, quantity: number, externalId: string, name: string, displayName: string, price: string, order: number, description: string, rowCount: number, originalProduct?: { __typename?: 'ProductNode', id: string, uuid: string, image?: string }, subcategory?: { __typename?: 'SubcategoryType', id: string, name: string, category: { __typename?: 'CategoryType', id: string, uuid: string, name: string } } }, contact: { __typename?: 'ContactType', id: string, uuid: string, externalId: string, email?: string, firstName: string, lastName: string, displayName: string, phone: string, mobilePhone: string, active: boolean, type: { __typename?: 'ContactTypeType', id: string, name: string }, account: { __typename?: 'AccountType', id: string, uuid: string, name: string, taxId?: string, externalId: string, isFavorite: boolean, address?: string, location?: { __typename?: 'LocationType', id: string, path?: string, iva: Decimal }, owner?: { __typename?: 'OrganizationType', id: string, name: string, externalId: string, isEu: boolean, displayName: string, logo?: string, logoThumbnail?: string, location?: { __typename?: 'LocationType', id: string, name: string, path?: string, iva: Decimal }, group: { __typename?: 'OrganizationGroupType', id: string, dealerCommission?: string } } } }, createdBy?: { __typename?: 'UserType', id: string, uuid: string, email: string, firstName: string, lastName: string, displayName: string, isActive: boolean, isStaff: boolean, dateJoined: string, lastLogin?: string, language: string, emailNotifications: boolean, inAppNotifications: boolean, termsAndConditionsAcceptedAt?: string }, seeder?: { __typename?: 'SeederType', uuid: string, displayName: string, rowCount: number, id: string }, lastReview?: { __typename?: 'WarrantyClaimReviewType', id: string, created: string, notes: string, statusDisplay: string, status: WarrantyClaimsWarrantyClaimReviewStatusChoices, approvalType?: WarrantyClaimsWarrantyClaimReviewApprovalTypeChoices, approvalTypeDisplay: string, createdBy?: { __typename?: 'UserType', id: string, uuid: string, email: string, firstName: string, lastName: string, displayName: string, isActive: boolean, isStaff: boolean, dateJoined: string, lastLogin?: string, language: string, emailNotifications: boolean, inAppNotifications: boolean, termsAndConditionsAcceptedAt?: string } }, inspectionReview?: { __typename?: 'WarrantyClaimInspectionReviewType', statusDisplay: string, status: WarrantyClaimsWarrantyClaimInspectionReviewStatusChoices, inWarranty: boolean }, supplyOrder?: { __typename?: 'SupplyOrderNode', id: string, uuid: string, displayId: number, displayIdWithPrefix: string } }, quote?: { __typename?: 'QuoteNode', additionalChargesValue?: string, additionalChargesDescription?: string, billingType: QuotesQuoteBillingTypeChoices, displayBillingType: string, rowCount?: number, notes?: string, created: string, id: string, uuid: string, displayName: string, displayId: number, status?: QuotesQuoteStatusChoices, statusDisplay: string, kitMultiplier?: { __typename?: 'QuoteKitMultiplierType', id: string, name: string, multiplier: string }, seeder?: { __typename?: 'SeederType', id: string, uuid: string, displayName: string, year?: number, rowCount: number, meterType: SeedersSeederMeterTypeChoices, account: { __typename?: 'AccountType', id: string, uuid: string, name: string }, brand: { __typename?: 'SeederBrandType', id: string }, model?: { __typename?: 'SeederModelType', id: string }, installedCategories: Array<{ __typename?: 'CategoryType', id: string, uuid: string }> }, products: Array<{ __typename?: 'QuotedProductType', id: string, name: string, order: number, rowCount: number, externalId: string, description: string, subcategoryName: string, categoryName: string, price: string, quantity: number, enableDiscount: boolean, commissionMultiplier: string, bundleName: string, bundleMultiplier?: string, bundleQuantity?: number, bundle?: { __typename?: 'BundleType', id: string }, origin?: { __typename?: 'ProductOriginType', id: string, name: string }, subcategory?: { __typename?: 'SubcategoryType', id: string, name: string, category: { __typename?: 'CategoryType', id: string, uuid: string, name: string } }, ruleGroup?: { __typename?: 'RuleGroupType', id: string, name: string }, ruleCategories: Array<{ __typename?: 'CategoryType', enabledForAssistedQuote: boolean, id: string, uuid: string, name: string }> }>, paymentMethods: Array<{ __typename?: 'QuotedPaymentMethodType', id: string, order: number, isCustom: boolean, dealerCommission?: string, name: string, multiplier: string, extraMultiplier: string, slug: string, finnancied: boolean, originalPaymentMethod?: { __typename?: 'PaymentMethodType', id: string } }>, contact: { __typename?: 'ContactType', id: string, uuid: string, externalId: string, email?: string, firstName: string, lastName: string, displayName: string, phone: string, mobilePhone: string, active: boolean, type: { __typename?: 'ContactTypeType', id: string, name: string }, account: { __typename?: 'AccountType', id: string, uuid: string, name: string, taxId?: string, externalId: string, isFavorite: boolean, address?: string, location?: { __typename?: 'LocationType', id: string, path?: string, iva: Decimal }, owner?: { __typename?: 'OrganizationType', id: string, name: string, externalId: string, isEu: boolean, displayName: string, logo?: string, logoThumbnail?: string, location?: { __typename?: 'LocationType', id: string, name: string, path?: string, iva: Decimal }, group: { __typename?: 'OrganizationGroupType', id: string, dealerCommission?: string } } } }, sale?: { __typename?: 'SaleNode', id: string, uuid: string, paymentMethod: { __typename?: 'QuotedPaymentMethodType', id: string, order: number, isCustom: boolean, dealerCommission?: string, name: string, multiplier: string, extraMultiplier: string, slug: string, finnancied: boolean, originalPaymentMethod?: { __typename?: 'PaymentMethodType', id: string } } }, createdBy?: { __typename?: 'UserType', id: string, uuid: string, email: string, firstName: string, lastName: string, displayName: string, isActive: boolean, isStaff: boolean, dateJoined: string, lastLogin?: string, language: string, emailNotifications: boolean, inAppNotifications: boolean, termsAndConditionsAcceptedAt?: string }, closeReason?: { __typename?: 'QuoteCloseReasonType', id: string, description: string, quote: { __typename?: 'QuoteNode', id: string } }, supplyOrder?: { __typename?: 'SupplyOrderNode', id: string, uuid: string, displayId: number, created: string, statusDisplay: string, status: SupplyOrdersSupplyOrderStatusChoices, charter: SupplyOrdersSupplyOrderCharterChoices, orderedProducts: Array<{ __typename?: 'OrderedProductType', id: string, quantity: number, quantityLeft: number, quotedProduct?: { __typename?: 'QuotedProductType', id: string, name: string, order: number, rowCount: number, externalId: string, description: string, subcategoryName: string, categoryName: string, price: string, quantity: number, enableDiscount: boolean, commissionMultiplier: string, bundleName: string, bundleMultiplier?: string, bundleQuantity?: number, bundle?: { __typename?: 'BundleType', id: string }, origin?: { __typename?: 'ProductOriginType', id: string, name: string }, subcategory?: { __typename?: 'SubcategoryType', id: string, name: string, category: { __typename?: 'CategoryType', id: string, uuid: string, name: string } }, ruleGroup?: { __typename?: 'RuleGroupType', id: string, name: string }, ruleCategories: Array<{ __typename?: 'CategoryType', enabledForAssistedQuote: boolean, id: string, uuid: string, name: string }> }, warrantyProduct?: { __typename?: 'WarrantyProductType', id: string, quantity: number, externalId: string, name: string, displayName: string, price: string, order: number, description: string, rowCount: number, originalProduct?: { __typename?: 'ProductNode', id: string, uuid: string, image?: string }, subcategory?: { __typename?: 'SubcategoryType', id: string, name: string, category: { __typename?: 'CategoryType', id: string, uuid: string, name: string } } } }> }, pdfs: Array<{ __typename?: 'QuotePDFType', id: string, file?: string, type: QuotesQuotePdfTypeChoices, recipient: string, typeDisplay?: string, emailStatus?: string, created: string, paymentMethod?: { __typename?: 'QuotedPaymentMethodType', id: string, order: number, isCustom: boolean, dealerCommission?: string, name: string, multiplier: string, extraMultiplier: string, slug: string, finnancied: boolean, originalPaymentMethod?: { __typename?: 'PaymentMethodType', id: string } }, createdBy?: { __typename?: 'UserType', id: string, uuid: string, email: string, firstName: string, lastName: string, displayName: string, isActive: boolean, isStaff: boolean, dateJoined: string, lastLogin?: string, language: string, emailNotifications: boolean, inAppNotifications: boolean, termsAndConditionsAcceptedAt?: string } }> }, orderedProducts: Array<{ __typename?: 'OrderedProductType', id: string, quantity: number, quantityLeft: number, quotedProduct?: { __typename?: 'QuotedProductType', id: string, name: string, order: number, rowCount: number, externalId: string, description: string, subcategoryName: string, categoryName: string, price: string, quantity: number, enableDiscount: boolean, commissionMultiplier: string, bundleName: string, bundleMultiplier?: string, bundleQuantity?: number, bundle?: { __typename?: 'BundleType', id: string }, origin?: { __typename?: 'ProductOriginType', id: string, name: string }, subcategory?: { __typename?: 'SubcategoryType', id: string, name: string, category: { __typename?: 'CategoryType', id: string, uuid: string, name: string } }, ruleGroup?: { __typename?: 'RuleGroupType', id: string, name: string }, ruleCategories: Array<{ __typename?: 'CategoryType', enabledForAssistedQuote: boolean, id: string, uuid: string, name: string }> }, warrantyProduct?: { __typename?: 'WarrantyProductType', id: string, quantity: number, externalId: string, name: string, displayName: string, price: string, order: number, description: string, rowCount: number, originalProduct?: { __typename?: 'ProductNode', id: string, uuid: string, image?: string }, subcategory?: { __typename?: 'SubcategoryType', id: string, name: string, category: { __typename?: 'CategoryType', id: string, uuid: string, name: string } } } }>, productsWithoutShipment: Array<{ __typename?: 'OrderedProductType', id: string, quantity: number, quantityLeft: number, quotedProduct?: { __typename?: 'QuotedProductType', id: string, name: string, order: number, rowCount: number, externalId: string, description: string, subcategoryName: string, categoryName: string, price: string, quantity: number, enableDiscount: boolean, commissionMultiplier: string, bundleName: string, bundleMultiplier?: string, bundleQuantity?: number, bundle?: { __typename?: 'BundleType', id: string }, origin?: { __typename?: 'ProductOriginType', id: string, name: string }, subcategory?: { __typename?: 'SubcategoryType', id: string, name: string, category: { __typename?: 'CategoryType', id: string, uuid: string, name: string } }, ruleGroup?: { __typename?: 'RuleGroupType', id: string, name: string }, ruleCategories: Array<{ __typename?: 'CategoryType', enabledForAssistedQuote: boolean, id: string, uuid: string, name: string }> }, warrantyProduct?: { __typename?: 'WarrantyProductType', id: string, quantity: number, externalId: string, name: string, displayName: string, price: string, order: number, description: string, rowCount: number, originalProduct?: { __typename?: 'ProductNode', id: string, uuid: string, image?: string }, subcategory?: { __typename?: 'SubcategoryType', id: string, name: string, category: { __typename?: 'CategoryType', id: string, uuid: string, name: string } } } }>, shipments: Array<{ __typename?: 'ShipmentType', id: string, externalId: string, invoice?: string, created: string, status?: SupplyOrdersShipmentStatusChoices, statusDisplay: string, supplyOrder: { __typename?: 'SupplyOrderNode', id: string, uuid: string, displayName: string, externalDealerId?: string, isUrgent: boolean }, productsShipped: Array<{ __typename?: 'ShipmentProductType', id: string, quantity: number, batch?: string, supplyOrder: { __typename?: 'SupplyOrderNode', id: string }, shipment: { __typename?: 'ShipmentType', id: string }, orderedProduct: { __typename?: 'OrderedProductType', id: string, quantity: number, quantityLeft: number, quotedProduct?: { __typename?: 'QuotedProductType', id: string, name: string, order: number, rowCount: number, externalId: string, description: string, subcategoryName: string, categoryName: string, price: string, quantity: number, enableDiscount: boolean, commissionMultiplier: string, bundleName: string, bundleMultiplier?: string, bundleQuantity?: number, bundle?: { __typename?: 'BundleType', id: string }, origin?: { __typename?: 'ProductOriginType', id: string, name: string }, subcategory?: { __typename?: 'SubcategoryType', id: string, name: string, category: { __typename?: 'CategoryType', id: string, uuid: string, name: string } }, ruleGroup?: { __typename?: 'RuleGroupType', id: string, name: string }, ruleCategories: Array<{ __typename?: 'CategoryType', enabledForAssistedQuote: boolean, id: string, uuid: string, name: string }> }, warrantyProduct?: { __typename?: 'WarrantyProductType', id: string, quantity: number, externalId: string, name: string, displayName: string, price: string, order: number, description: string, rowCount: number, originalProduct?: { __typename?: 'ProductNode', id: string, uuid: string, image?: string }, subcategory?: { __typename?: 'SubcategoryType', id: string, name: string, category: { __typename?: 'CategoryType', id: string, uuid: string, name: string } } } } }>, createdBy?: { __typename?: 'UserType', id: string, uuid: string, email: string, firstName: string, lastName: string, displayName: string, isActive: boolean, isStaff: boolean, dateJoined: string, lastLogin?: string, language: string, emailNotifications: boolean, inAppNotifications: boolean, termsAndConditionsAcceptedAt?: string } }>, createdBy?: { __typename?: 'UserType', id: string, uuid: string, email: string, firstName: string, lastName: string, displayName: string, isActive: boolean, isStaff: boolean, dateJoined: string, lastLogin?: string, language: string, emailNotifications: boolean, inAppNotifications: boolean, termsAndConditionsAcceptedAt?: string } };

export type GetSupplyOrderQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  uuid?: InputMaybe<Scalars['UUID']['input']>;
}>;


export type GetSupplyOrderQuery = { __typename?: 'Query', supplyOrder?: { __typename?: 'SupplyOrderNode', reviewStart?: string, shipStreet: string, shipLocation: string, shipPostalCode: string, updated: string, isUrgent: boolean, id: string, uuid: string, displayId: number, displayIdWithPrefix: string, charter: SupplyOrdersSupplyOrderCharterChoices, charterDisplay: string, externalDealerId?: string, internalOrder: boolean, estimatedDispatchDate?: string, comment: string, salesCanReview: boolean, status: SupplyOrdersSupplyOrderStatusChoices, statusDisplay: string, created: string, userNotification: boolean, reviews: Array<{ __typename?: 'SupplyOrderReviewType', id: string, statusDisplay: string, typeDisplay: string, notes: string, created: string, createdBy?: { __typename?: 'UserType', id: string, uuid: string, email: string, firstName: string, lastName: string, displayName: string, isActive: boolean, isStaff: boolean, dateJoined: string, lastLogin?: string, language: string, emailNotifications: boolean, inAppNotifications: boolean, termsAndConditionsAcceptedAt?: string } }>, shipAddress?: { __typename?: 'OrganizationAddressType', id: string }, updatedBy?: { __typename?: 'UserType', id: string, uuid: string, email: string, firstName: string, lastName: string, displayName: string, isActive: boolean, isStaff: boolean, dateJoined: string, lastLogin?: string, language: string, emailNotifications: boolean, inAppNotifications: boolean, termsAndConditionsAcceptedAt?: string }, warrantyClaim?: { __typename?: 'WarrantyClaimNode', id: string, uuid: string, invoiceDate?: string, failureDate?: string, serialNumber?: string, created: string, quantity: number, description: string, finalClient: string, phone: string, externalId?: string, displayId: number, orderId?: number, warrantyClaimType: WarrantyClaimsWarrantyClaimWarrantyClaimTypeChoices, displayWarrantyClaimType: string, applyForCredit: boolean, rmaCode?: string, amount?: string, state: WarrantyClaimsWarrantyClaimStateChoices, stateDisplay: string, requiredApprovalType?: string, requiresSpecialApproval: boolean, requiresInspectionReview: boolean, hasCompletedInspectionReview: boolean, canCurrentUserApprove: boolean, requiredApprovalsList: Array<WarrantyClaimsWarrantyClaimReviewApprovalTypeChoices>, missingApprovals: Array<WarrantyClaimsWarrantyClaimReviewApprovalTypeChoices>, isFullyApproved: boolean, isInFinalState: boolean, product?: { __typename?: 'WarrantyProductType', id: string, quantity: number, externalId: string, name: string, displayName: string, price: string, order: number, description: string, rowCount: number, originalProduct?: { __typename?: 'ProductNode', id: string, uuid: string, image?: string }, subcategory?: { __typename?: 'SubcategoryType', id: string, name: string, category: { __typename?: 'CategoryType', id: string, uuid: string, name: string } } }, contact: { __typename?: 'ContactType', id: string, uuid: string, externalId: string, email?: string, firstName: string, lastName: string, displayName: string, phone: string, mobilePhone: string, active: boolean, type: { __typename?: 'ContactTypeType', id: string, name: string }, account: { __typename?: 'AccountType', id: string, uuid: string, name: string, taxId?: string, externalId: string, isFavorite: boolean, address?: string, location?: { __typename?: 'LocationType', id: string, path?: string, iva: Decimal }, owner?: { __typename?: 'OrganizationType', id: string, name: string, externalId: string, isEu: boolean, displayName: string, logo?: string, logoThumbnail?: string, location?: { __typename?: 'LocationType', id: string, name: string, path?: string, iva: Decimal }, group: { __typename?: 'OrganizationGroupType', id: string, dealerCommission?: string } } } }, createdBy?: { __typename?: 'UserType', id: string, uuid: string, email: string, firstName: string, lastName: string, displayName: string, isActive: boolean, isStaff: boolean, dateJoined: string, lastLogin?: string, language: string, emailNotifications: boolean, inAppNotifications: boolean, termsAndConditionsAcceptedAt?: string }, seeder?: { __typename?: 'SeederType', uuid: string, displayName: string, rowCount: number, id: string }, lastReview?: { __typename?: 'WarrantyClaimReviewType', id: string, created: string, notes: string, statusDisplay: string, status: WarrantyClaimsWarrantyClaimReviewStatusChoices, approvalType?: WarrantyClaimsWarrantyClaimReviewApprovalTypeChoices, approvalTypeDisplay: string, createdBy?: { __typename?: 'UserType', id: string, uuid: string, email: string, firstName: string, lastName: string, displayName: string, isActive: boolean, isStaff: boolean, dateJoined: string, lastLogin?: string, language: string, emailNotifications: boolean, inAppNotifications: boolean, termsAndConditionsAcceptedAt?: string } }, inspectionReview?: { __typename?: 'WarrantyClaimInspectionReviewType', statusDisplay: string, status: WarrantyClaimsWarrantyClaimInspectionReviewStatusChoices, inWarranty: boolean }, supplyOrder?: { __typename?: 'SupplyOrderNode', id: string, uuid: string, displayId: number, displayIdWithPrefix: string } }, quote?: { __typename?: 'QuoteNode', additionalChargesValue?: string, additionalChargesDescription?: string, billingType: QuotesQuoteBillingTypeChoices, displayBillingType: string, rowCount?: number, notes?: string, created: string, id: string, uuid: string, displayName: string, displayId: number, status?: QuotesQuoteStatusChoices, statusDisplay: string, kitMultiplier?: { __typename?: 'QuoteKitMultiplierType', id: string, name: string, multiplier: string }, seeder?: { __typename?: 'SeederType', id: string, uuid: string, displayName: string, year?: number, rowCount: number, meterType: SeedersSeederMeterTypeChoices, account: { __typename?: 'AccountType', id: string, uuid: string, name: string }, brand: { __typename?: 'SeederBrandType', id: string }, model?: { __typename?: 'SeederModelType', id: string }, installedCategories: Array<{ __typename?: 'CategoryType', id: string, uuid: string }> }, products: Array<{ __typename?: 'QuotedProductType', id: string, name: string, order: number, rowCount: number, externalId: string, description: string, subcategoryName: string, categoryName: string, price: string, quantity: number, enableDiscount: boolean, commissionMultiplier: string, bundleName: string, bundleMultiplier?: string, bundleQuantity?: number, bundle?: { __typename?: 'BundleType', id: string }, origin?: { __typename?: 'ProductOriginType', id: string, name: string }, subcategory?: { __typename?: 'SubcategoryType', id: string, name: string, category: { __typename?: 'CategoryType', id: string, uuid: string, name: string } }, ruleGroup?: { __typename?: 'RuleGroupType', id: string, name: string }, ruleCategories: Array<{ __typename?: 'CategoryType', enabledForAssistedQuote: boolean, id: string, uuid: string, name: string }> }>, paymentMethods: Array<{ __typename?: 'QuotedPaymentMethodType', id: string, order: number, isCustom: boolean, dealerCommission?: string, name: string, multiplier: string, extraMultiplier: string, slug: string, finnancied: boolean, originalPaymentMethod?: { __typename?: 'PaymentMethodType', id: string } }>, contact: { __typename?: 'ContactType', id: string, uuid: string, externalId: string, email?: string, firstName: string, lastName: string, displayName: string, phone: string, mobilePhone: string, active: boolean, type: { __typename?: 'ContactTypeType', id: string, name: string }, account: { __typename?: 'AccountType', id: string, uuid: string, name: string, taxId?: string, externalId: string, isFavorite: boolean, address?: string, location?: { __typename?: 'LocationType', id: string, path?: string, iva: Decimal }, owner?: { __typename?: 'OrganizationType', id: string, name: string, externalId: string, isEu: boolean, displayName: string, logo?: string, logoThumbnail?: string, location?: { __typename?: 'LocationType', id: string, name: string, path?: string, iva: Decimal }, group: { __typename?: 'OrganizationGroupType', id: string, dealerCommission?: string } } } }, sale?: { __typename?: 'SaleNode', id: string, uuid: string, paymentMethod: { __typename?: 'QuotedPaymentMethodType', id: string, order: number, isCustom: boolean, dealerCommission?: string, name: string, multiplier: string, extraMultiplier: string, slug: string, finnancied: boolean, originalPaymentMethod?: { __typename?: 'PaymentMethodType', id: string } } }, createdBy?: { __typename?: 'UserType', id: string, uuid: string, email: string, firstName: string, lastName: string, displayName: string, isActive: boolean, isStaff: boolean, dateJoined: string, lastLogin?: string, language: string, emailNotifications: boolean, inAppNotifications: boolean, termsAndConditionsAcceptedAt?: string }, closeReason?: { __typename?: 'QuoteCloseReasonType', id: string, description: string, quote: { __typename?: 'QuoteNode', id: string } }, supplyOrder?: { __typename?: 'SupplyOrderNode', id: string, uuid: string, displayId: number, created: string, statusDisplay: string, status: SupplyOrdersSupplyOrderStatusChoices, charter: SupplyOrdersSupplyOrderCharterChoices, orderedProducts: Array<{ __typename?: 'OrderedProductType', id: string, quantity: number, quantityLeft: number, quotedProduct?: { __typename?: 'QuotedProductType', id: string, name: string, order: number, rowCount: number, externalId: string, description: string, subcategoryName: string, categoryName: string, price: string, quantity: number, enableDiscount: boolean, commissionMultiplier: string, bundleName: string, bundleMultiplier?: string, bundleQuantity?: number, bundle?: { __typename?: 'BundleType', id: string }, origin?: { __typename?: 'ProductOriginType', id: string, name: string }, subcategory?: { __typename?: 'SubcategoryType', id: string, name: string, category: { __typename?: 'CategoryType', id: string, uuid: string, name: string } }, ruleGroup?: { __typename?: 'RuleGroupType', id: string, name: string }, ruleCategories: Array<{ __typename?: 'CategoryType', enabledForAssistedQuote: boolean, id: string, uuid: string, name: string }> }, warrantyProduct?: { __typename?: 'WarrantyProductType', id: string, quantity: number, externalId: string, name: string, displayName: string, price: string, order: number, description: string, rowCount: number, originalProduct?: { __typename?: 'ProductNode', id: string, uuid: string, image?: string }, subcategory?: { __typename?: 'SubcategoryType', id: string, name: string, category: { __typename?: 'CategoryType', id: string, uuid: string, name: string } } } }> }, pdfs: Array<{ __typename?: 'QuotePDFType', id: string, file?: string, type: QuotesQuotePdfTypeChoices, recipient: string, typeDisplay?: string, emailStatus?: string, created: string, paymentMethod?: { __typename?: 'QuotedPaymentMethodType', id: string, order: number, isCustom: boolean, dealerCommission?: string, name: string, multiplier: string, extraMultiplier: string, slug: string, finnancied: boolean, originalPaymentMethod?: { __typename?: 'PaymentMethodType', id: string } }, createdBy?: { __typename?: 'UserType', id: string, uuid: string, email: string, firstName: string, lastName: string, displayName: string, isActive: boolean, isStaff: boolean, dateJoined: string, lastLogin?: string, language: string, emailNotifications: boolean, inAppNotifications: boolean, termsAndConditionsAcceptedAt?: string } }> }, orderedProducts: Array<{ __typename?: 'OrderedProductType', id: string, quantity: number, quantityLeft: number, quotedProduct?: { __typename?: 'QuotedProductType', id: string, name: string, order: number, rowCount: number, externalId: string, description: string, subcategoryName: string, categoryName: string, price: string, quantity: number, enableDiscount: boolean, commissionMultiplier: string, bundleName: string, bundleMultiplier?: string, bundleQuantity?: number, bundle?: { __typename?: 'BundleType', id: string }, origin?: { __typename?: 'ProductOriginType', id: string, name: string }, subcategory?: { __typename?: 'SubcategoryType', id: string, name: string, category: { __typename?: 'CategoryType', id: string, uuid: string, name: string } }, ruleGroup?: { __typename?: 'RuleGroupType', id: string, name: string }, ruleCategories: Array<{ __typename?: 'CategoryType', enabledForAssistedQuote: boolean, id: string, uuid: string, name: string }> }, warrantyProduct?: { __typename?: 'WarrantyProductType', id: string, quantity: number, externalId: string, name: string, displayName: string, price: string, order: number, description: string, rowCount: number, originalProduct?: { __typename?: 'ProductNode', id: string, uuid: string, image?: string }, subcategory?: { __typename?: 'SubcategoryType', id: string, name: string, category: { __typename?: 'CategoryType', id: string, uuid: string, name: string } } } }>, productsWithoutShipment: Array<{ __typename?: 'OrderedProductType', id: string, quantity: number, quantityLeft: number, quotedProduct?: { __typename?: 'QuotedProductType', id: string, name: string, order: number, rowCount: number, externalId: string, description: string, subcategoryName: string, categoryName: string, price: string, quantity: number, enableDiscount: boolean, commissionMultiplier: string, bundleName: string, bundleMultiplier?: string, bundleQuantity?: number, bundle?: { __typename?: 'BundleType', id: string }, origin?: { __typename?: 'ProductOriginType', id: string, name: string }, subcategory?: { __typename?: 'SubcategoryType', id: string, name: string, category: { __typename?: 'CategoryType', id: string, uuid: string, name: string } }, ruleGroup?: { __typename?: 'RuleGroupType', id: string, name: string }, ruleCategories: Array<{ __typename?: 'CategoryType', enabledForAssistedQuote: boolean, id: string, uuid: string, name: string }> }, warrantyProduct?: { __typename?: 'WarrantyProductType', id: string, quantity: number, externalId: string, name: string, displayName: string, price: string, order: number, description: string, rowCount: number, originalProduct?: { __typename?: 'ProductNode', id: string, uuid: string, image?: string }, subcategory?: { __typename?: 'SubcategoryType', id: string, name: string, category: { __typename?: 'CategoryType', id: string, uuid: string, name: string } } } }>, shipments: Array<{ __typename?: 'ShipmentType', id: string, externalId: string, invoice?: string, created: string, status?: SupplyOrdersShipmentStatusChoices, statusDisplay: string, supplyOrder: { __typename?: 'SupplyOrderNode', id: string, uuid: string, displayName: string, externalDealerId?: string, isUrgent: boolean }, productsShipped: Array<{ __typename?: 'ShipmentProductType', id: string, quantity: number, batch?: string, supplyOrder: { __typename?: 'SupplyOrderNode', id: string }, shipment: { __typename?: 'ShipmentType', id: string }, orderedProduct: { __typename?: 'OrderedProductType', id: string, quantity: number, quantityLeft: number, quotedProduct?: { __typename?: 'QuotedProductType', id: string, name: string, order: number, rowCount: number, externalId: string, description: string, subcategoryName: string, categoryName: string, price: string, quantity: number, enableDiscount: boolean, commissionMultiplier: string, bundleName: string, bundleMultiplier?: string, bundleQuantity?: number, bundle?: { __typename?: 'BundleType', id: string }, origin?: { __typename?: 'ProductOriginType', id: string, name: string }, subcategory?: { __typename?: 'SubcategoryType', id: string, name: string, category: { __typename?: 'CategoryType', id: string, uuid: string, name: string } }, ruleGroup?: { __typename?: 'RuleGroupType', id: string, name: string }, ruleCategories: Array<{ __typename?: 'CategoryType', enabledForAssistedQuote: boolean, id: string, uuid: string, name: string }> }, warrantyProduct?: { __typename?: 'WarrantyProductType', id: string, quantity: number, externalId: string, name: string, displayName: string, price: string, order: number, description: string, rowCount: number, originalProduct?: { __typename?: 'ProductNode', id: string, uuid: string, image?: string }, subcategory?: { __typename?: 'SubcategoryType', id: string, name: string, category: { __typename?: 'CategoryType', id: string, uuid: string, name: string } } } } }>, createdBy?: { __typename?: 'UserType', id: string, uuid: string, email: string, firstName: string, lastName: string, displayName: string, isActive: boolean, isStaff: boolean, dateJoined: string, lastLogin?: string, language: string, emailNotifications: boolean, inAppNotifications: boolean, termsAndConditionsAcceptedAt?: string } }>, createdBy?: { __typename?: 'UserType', id: string, uuid: string, email: string, firstName: string, lastName: string, displayName: string, isActive: boolean, isStaff: boolean, dateJoined: string, lastLogin?: string, language: string, emailNotifications: boolean, inAppNotifications: boolean, termsAndConditionsAcceptedAt?: string } } };

export type SupplyOrderReviewFragment = { __typename?: 'SupplyOrderReviewType', id: string, statusDisplay: string, typeDisplay: string, notes: string, created: string, createdBy?: { __typename?: 'UserType', id: string, uuid: string, email: string, firstName: string, lastName: string, displayName: string, isActive: boolean, isStaff: boolean, dateJoined: string, lastLogin?: string, language: string, emailNotifications: boolean, inAppNotifications: boolean, termsAndConditionsAcceptedAt?: string } };

export type SupplyOrderListFragment = { __typename?: 'SupplyOrderNode', id: string, uuid: string, charter: SupplyOrdersSupplyOrderCharterChoices, charterDisplay: string, displayIdWithPrefix: string, externalDealerId?: string, quantityShipped: Rgy, statusDisplay: string, status: SupplyOrdersSupplyOrderStatusChoices, created: string, userNotification: boolean, isUrgent: boolean, estimatedDispatchDate?: string, quote?: { __typename?: 'QuoteNode', id: string, uuid: string, rowCount?: number, contact: { __typename?: 'ContactType', email?: string, account: { __typename?: 'AccountType', name: string, owner?: { __typename?: 'OrganizationType', name: string } } }, seeder?: { __typename?: 'SeederType', displayName: string }, sale?: { __typename?: 'SaleNode', paymentMethod: { __typename?: 'QuotedPaymentMethodType', multiplier: string, extraMultiplier: string, finnancied: boolean } }, kitMultiplier?: { __typename?: 'QuoteKitMultiplierType', multiplier: string } }, warrantyClaim?: { __typename?: 'WarrantyClaimNode', contact: { __typename?: 'ContactType', account: { __typename?: 'AccountType', name: string, owner?: { __typename?: 'OrganizationType', name: string } } } }, orderedProducts: Array<{ __typename?: 'OrderedProductType', quantity: number, quotedProduct?: { __typename?: 'QuotedProductType', price: string, quantity: number, commissionMultiplier: string, enableDiscount: boolean, bundleName: string, bundleMultiplier?: string, bundleQuantity?: number } }> };

export type GetSupplyOrdersQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  createdGte?: InputMaybe<Scalars['Date']['input']>;
  createdLte?: InputMaybe<Scalars['Date']['input']>;
  owner?: InputMaybe<Scalars['UUID']['input']>;
  accountGlobalId?: InputMaybe<Scalars['UUID']['input']>;
  contactGlobalId?: InputMaybe<Scalars['UUID']['input']>;
  user?: InputMaybe<Scalars['UUID']['input']>;
  statusEnumIn?: InputMaybe<Array<InputMaybe<SupplyOrdersSupplyOrderStatusChoices>>>;
  rgy?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetSupplyOrdersQuery = { __typename?: 'Query', supplyOrders?: { __typename?: 'SupplyOrderNodeConnection', count: number, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string, endCursor?: string }, edges: Array<{ __typename?: 'SupplyOrderNodeEdge', cursor: string, node?: { __typename?: 'SupplyOrderNode', id: string, uuid: string, charter: SupplyOrdersSupplyOrderCharterChoices, charterDisplay: string, displayIdWithPrefix: string, externalDealerId?: string, quantityShipped: Rgy, statusDisplay: string, status: SupplyOrdersSupplyOrderStatusChoices, created: string, userNotification: boolean, isUrgent: boolean, estimatedDispatchDate?: string, quote?: { __typename?: 'QuoteNode', id: string, uuid: string, rowCount?: number, contact: { __typename?: 'ContactType', email?: string, account: { __typename?: 'AccountType', name: string, owner?: { __typename?: 'OrganizationType', name: string } } }, seeder?: { __typename?: 'SeederType', displayName: string }, sale?: { __typename?: 'SaleNode', paymentMethod: { __typename?: 'QuotedPaymentMethodType', multiplier: string, extraMultiplier: string, finnancied: boolean } }, kitMultiplier?: { __typename?: 'QuoteKitMultiplierType', multiplier: string } }, warrantyClaim?: { __typename?: 'WarrantyClaimNode', contact: { __typename?: 'ContactType', account: { __typename?: 'AccountType', name: string, owner?: { __typename?: 'OrganizationType', name: string } } } }, orderedProducts: Array<{ __typename?: 'OrderedProductType', quantity: number, quotedProduct?: { __typename?: 'QuotedProductType', price: string, quantity: number, commissionMultiplier: string, enableDiscount: boolean, bundleName: string, bundleMultiplier?: string, bundleQuantity?: number } }> } }> } };

export type ExportExcelSupplyOrdersMutationVariables = Exact<{
  query?: InputMaybe<Scalars['String']['input']>;
  createdGte?: InputMaybe<Scalars['Date']['input']>;
  createdLte?: InputMaybe<Scalars['Date']['input']>;
  owner?: InputMaybe<Scalars['UUID']['input']>;
  accountGlobalId?: InputMaybe<Scalars['UUID']['input']>;
  contactGlobalId?: InputMaybe<Scalars['UUID']['input']>;
  user?: InputMaybe<Scalars['UUID']['input']>;
  statusEnumIn?: InputMaybe<Array<InputMaybe<SupplyOrdersSupplyOrderStatusChoices>>>;
  supplyOrderId?: InputMaybe<Scalars['UUID']['input']>;
  rgy?: InputMaybe<Scalars['String']['input']>;
  isPending?: InputMaybe<Scalars['Boolean']['input']>;
  onlyWithStock?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type ExportExcelSupplyOrdersMutation = { __typename?: 'Mutation', exportExcelSupplyOrders?: { __typename?: 'ExportExcelSupplyOrders', job?: { __typename?: 'ExportJobType', id: string } } };

export type StartSupplyOrderReviewMutationVariables = Exact<{
  input: StartSupplyOrderReviewMutationInput;
}>;


export type StartSupplyOrderReviewMutation = { __typename?: 'Mutation', startSupplyOrderReview?: { __typename?: 'StartSupplyOrderReviewMutationPayload', supplyOrder?: { __typename?: 'SupplyOrderNode', id: string, uuid: string }, errors: Array<{ __typename?: 'ErrorType', field: string, messages: Array<string> }> } };

export type ReviewSupplyOrderMutationVariables = Exact<{
  input: SupplyOrderReviewMutationInput;
}>;


export type ReviewSupplyOrderMutation = { __typename?: 'Mutation', reviewSupplyOrder?: { __typename?: 'SupplyOrderReviewMutationPayload', supplyOrderReview?: { __typename?: 'SupplyOrderReviewType', supplyOrder: { __typename?: 'SupplyOrderNode', id: string, uuid: string } }, errors: Array<{ __typename?: 'ErrorType', field: string, messages: Array<string> }> } };

export type CreateShipmentMutationVariables = Exact<{
  input: CreateShipmentMutationInput;
}>;


export type CreateShipmentMutation = { __typename?: 'Mutation', createShipment?: { __typename?: 'CreateShipmentMutationPayload', shipment?: { __typename?: 'ShipmentType', id: string }, errors: Array<{ __typename?: 'ErrorType', field: string, messages: Array<string> }> } };

export type DeleteShipmentMutationVariables = Exact<{
  input: DeleteShipmentMutationInput;
}>;


export type DeleteShipmentMutation = { __typename?: 'Mutation', deleteShipment?: { __typename?: 'DeleteShipmentMutationPayload', errors: Array<{ __typename?: 'ErrorType', field: string, messages: Array<string> }> } };

export type UpdateShipmentMutationVariables = Exact<{
  input: UpdateShipmentMutationInput;
}>;


export type UpdateShipmentMutation = { __typename?: 'Mutation', updateShipment?: { __typename?: 'UpdateShipmentMutationPayload', shipment?: { __typename?: 'ShipmentType', id: string }, errors: Array<{ __typename?: 'ErrorType', field: string, messages: Array<string> }> } };

export type UploadInvoiceMutationVariables = Exact<{
  input: UploadInvoiceMutationInput;
}>;


export type UploadInvoiceMutation = { __typename?: 'Mutation', uploadInvoice?: { __typename?: 'UploadInvoiceMutationPayload', shipment?: { __typename?: 'ShipmentType', id: string }, errors: Array<{ __typename?: 'ErrorType', field: string, messages: Array<string> }> } };

export type CreateSupplyOrderPdfMutationVariables = Exact<{
  supplyOrderId: Scalars['UUID']['input'];
}>;


export type CreateSupplyOrderPdfMutation = { __typename?: 'Mutation', createSupplyOrderPdf?: { __typename?: 'CreateSupplyOrderPDF', job?: { __typename?: 'ExportJobType', id: string }, errors?: Array<{ __typename?: 'ErrorType', field: string, messages: Array<string> }> } };

export type CreatePrepaidPdfMutationVariables = Exact<{
  supplyOrderId: Scalars['UUID']['input'];
}>;


export type CreatePrepaidPdfMutation = { __typename?: 'Mutation', createPrepaidPdf?: { __typename?: 'CreatePrepaidPDF', job?: { __typename?: 'ExportJobType', id: string }, errors?: Array<{ __typename?: 'ErrorType', field: string, messages: Array<string> }> } };

export type ToggleSubscribeModelNotificationMutationVariables = Exact<{
  input: ToggleSubscribeModelNotificationMutationInput;
}>;


export type ToggleSubscribeModelNotificationMutation = { __typename?: 'Mutation', toggleSubscribeModelNotification?: { __typename?: 'ToggleSubscribeModelNotificationMutationPayload', errors: Array<{ __typename?: 'ErrorType', field: string, messages: Array<string> }> } };

export type UpdateSupplyOrderCommentMutationVariables = Exact<{
  input: UpdateSupplyOrderCommentMutationInput;
}>;


export type UpdateSupplyOrderCommentMutation = { __typename?: 'Mutation', updateSupplyOrderComment?: { __typename?: 'UpdateSupplyOrderCommentMutationPayload', errors: Array<{ __typename?: 'ErrorType', field: string, messages: Array<string> }>, supplyOrder?: { __typename?: 'SupplyOrderNode', id: string, comment: string } } };

export type AddOrderedProductMutationVariables = Exact<{
  input: OrderedProductSupplyOrderQuoteFormInput;
  orderedProducts: Array<OrderedProductOrderedProductFormInput>;
}>;


export type AddOrderedProductMutation = { __typename?: 'Mutation', addOrderedProduct?: { __typename?: 'AddOrderedProduct', errors?: Array<{ __typename?: 'ErrorType', field: string, messages: Array<string> }> } };

export type DownloadFragment = { __typename?: 'DownloadType', contentType: string, data: string, filename: string };

export type JobFragment = { __typename?: 'JobType', id: string, status: JobStatus, result?: string };

export type GetJobQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type GetJobQuery = { __typename?: 'Query', job?: { __typename?: 'JobType', id: string, status: JobStatus, result?: string } };

export type GetExportFileJobQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type GetExportFileJobQuery = { __typename?: 'Query', exportFileJob?: { __typename?: 'ExportJobType', id: string, status: JobStatus, result?: { __typename?: 'DownloadType', contentType: string, data: string, filename: string } } };

export type RuntimeSettingsFragment = { __typename?: 'RuntimeSettingsType', id: string, quotePdfDisclaimer: string, taxIdLabel: string, signaturesInDisclaimer: boolean, maxVideoSize: number, datastudioUrl?: string, tinymceUrl?: string, featureTermsAndConditions: boolean, termsAndConditions?: string, termsAndConditionsUpdatedAt?: string, gefcoTrackingUrl?: string, gefcoTrackingInstructions?: string, urgentOrderSurcharge: string };

export type GetRuntimeSettingsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetRuntimeSettingsQuery = { __typename?: 'Query', runtimeSettings: { __typename?: 'RuntimeSettingsType', id: string, quotePdfDisclaimer: string, taxIdLabel: string, signaturesInDisclaimer: boolean, maxVideoSize: number, datastudioUrl?: string, tinymceUrl?: string, featureTermsAndConditions: boolean, termsAndConditions?: string, termsAndConditionsUpdatedAt?: string, gefcoTrackingUrl?: string, gefcoTrackingInstructions?: string, urgentOrderSurcharge: string } };

export type LocaleTranslationsFragment = { __typename?: 'LocaleTranslationType', id: string, locale: string, extract: string, json: string };

export type GetLocaleTranslationQueryVariables = Exact<{ [key: string]: never; }>;


export type GetLocaleTranslationQuery = { __typename?: 'Query', localeTranslations: Array<{ __typename?: 'LocaleTranslationType', id: string, locale: string, extract: string, json: string }> };

export type PermissionsFragment = { __typename?: 'UserPermissions', viewQuotes: boolean, viewSales: boolean, viewSupplyOrders: boolean, viewAccounts: boolean, viewContacts: boolean, viewOpportunities: boolean, viewAnalytics: boolean, viewWarrantyClaims: boolean, viewSeeders: boolean, assignAccountOwner: boolean, requestSupplyOrderReview: boolean, submitSalesSupplyOrderReview: boolean, submitCreditsSupplyOrderReview: boolean, receiveSupplyOrderApprovedNotification: boolean, viewWarrantyClaimsAnalytics: boolean, manageQuotes: boolean, manageSales: boolean, manageSupplyOrders: boolean, editApprovedSupplyOrders: boolean, manageShipments: boolean, manageWarrantyClaims: boolean, performTechnicalReview: boolean, manageAccounts: boolean, viewDatastudio: boolean, manageEcns: boolean, viewEcns: boolean, warrantyClaimsWarrantyAdminApprove: boolean, warrantyClaimsManageApprove: boolean, ticketSystemAccess: boolean, viewStockForecast: boolean, manageStockForecast: boolean, configureMrpParameters: boolean };

export type MinimalUserFragment = { __typename?: 'UserType', id: string, email: string, firstName: string, lastName: string, displayName: string, isActive: boolean, isStaff: boolean, dateJoined: string, lastLogin?: string, language: string, emailNotifications: boolean, inAppNotifications: boolean, termsAndConditionsAcceptedAt?: string };

export type MinimalUserNodeFragment = { __typename?: 'UserNode', id: string, uuid: string, email: string, firstName: string, lastName: string, displayName: string, isActive: boolean, isStaff: boolean, dateJoined: string, lastLogin?: string, language: string, emailNotifications: boolean, inAppNotifications: boolean, termsAndConditionsAcceptedAt?: string };

export type MinimalUserTypeFragment = { __typename?: 'UserType', id: string, uuid: string, email: string, firstName: string, lastName: string, displayName: string, isActive: boolean, isStaff: boolean, dateJoined: string, lastLogin?: string, language: string, emailNotifications: boolean, inAppNotifications: boolean, termsAndConditionsAcceptedAt?: string };

export type OrganizationGroupFragment = { __typename?: 'OrganizationGroupType', id: string, dealerCommission?: string };

export type OrganizationOptionFragment = { __typename?: 'OrganizationType', id: string, name: string };

export type OrganizationFragment = { __typename?: 'OrganizationType', id: string, name: string, externalId: string, isEu: boolean, displayName: string, logo?: string, logoThumbnail?: string, location?: { __typename?: 'LocationType', id: string, name: string, path?: string, iva: Decimal }, group: { __typename?: 'OrganizationGroupType', id: string, dealerCommission?: string } };

export type UserNodeFragment = { __typename?: 'UserNode', uuid: string, id: string, email: string, firstName: string, lastName: string, displayName: string, isActive: boolean, isStaff: boolean, dateJoined: string, lastLogin?: string, language: string, emailNotifications: boolean, inAppNotifications: boolean, termsAndConditionsAcceptedAt?: string, organization?: { __typename?: 'OrganizationType', id: string, name: string, externalId: string, isEu: boolean, displayName: string, logo?: string, logoThumbnail?: string, location?: { __typename?: 'LocationType', id: string, name: string, path?: string, iva: Decimal }, group: { __typename?: 'OrganizationGroupType', id: string, dealerCommission?: string } }, role?: { __typename?: 'RoleType', id: string, name: string }, ecnRoles: Array<{ __typename?: 'EcnRoleType', id: string }>, permissions: { __typename?: 'UserPermissions', viewQuotes: boolean, viewSales: boolean, viewSupplyOrders: boolean, viewAccounts: boolean, viewContacts: boolean, viewOpportunities: boolean, viewAnalytics: boolean, viewWarrantyClaims: boolean, viewSeeders: boolean, assignAccountOwner: boolean, requestSupplyOrderReview: boolean, submitSalesSupplyOrderReview: boolean, submitCreditsSupplyOrderReview: boolean, receiveSupplyOrderApprovedNotification: boolean, viewWarrantyClaimsAnalytics: boolean, manageQuotes: boolean, manageSales: boolean, manageSupplyOrders: boolean, editApprovedSupplyOrders: boolean, manageShipments: boolean, manageWarrantyClaims: boolean, performTechnicalReview: boolean, manageAccounts: boolean, viewDatastudio: boolean, manageEcns: boolean, viewEcns: boolean, warrantyClaimsWarrantyAdminApprove: boolean, warrantyClaimsManageApprove: boolean, ticketSystemAccess: boolean, viewStockForecast: boolean, manageStockForecast: boolean, configureMrpParameters: boolean } };

export type UserFragment = { __typename?: 'UserType', id: string, email: string, firstName: string, lastName: string, displayName: string, isActive: boolean, isStaff: boolean, dateJoined: string, lastLogin?: string, language: string, emailNotifications: boolean, inAppNotifications: boolean, termsAndConditionsAcceptedAt?: string, organization?: { __typename?: 'OrganizationType', id: string, name: string, externalId: string, isEu: boolean, displayName: string, logo?: string, logoThumbnail?: string, location?: { __typename?: 'LocationType', id: string, name: string, path?: string, iva: Decimal }, group: { __typename?: 'OrganizationGroupType', id: string, dealerCommission?: string } }, role?: { __typename?: 'RoleType', id: string, name: string }, ecnRoles: Array<{ __typename?: 'EcnRoleType', id: string }>, permissions: { __typename?: 'UserPermissions', viewQuotes: boolean, viewSales: boolean, viewSupplyOrders: boolean, viewAccounts: boolean, viewContacts: boolean, viewOpportunities: boolean, viewAnalytics: boolean, viewWarrantyClaims: boolean, viewSeeders: boolean, assignAccountOwner: boolean, requestSupplyOrderReview: boolean, submitSalesSupplyOrderReview: boolean, submitCreditsSupplyOrderReview: boolean, receiveSupplyOrderApprovedNotification: boolean, viewWarrantyClaimsAnalytics: boolean, manageQuotes: boolean, manageSales: boolean, manageSupplyOrders: boolean, editApprovedSupplyOrders: boolean, manageShipments: boolean, manageWarrantyClaims: boolean, performTechnicalReview: boolean, manageAccounts: boolean, viewDatastudio: boolean, manageEcns: boolean, viewEcns: boolean, warrantyClaimsWarrantyAdminApprove: boolean, warrantyClaimsManageApprove: boolean, ticketSystemAccess: boolean, viewStockForecast: boolean, manageStockForecast: boolean, configureMrpParameters: boolean } };

export type RoleFragment = { __typename?: 'RoleType', id: string, name: string };

export type LoginMutationVariables = Exact<{
  input: LoginInput;
}>;


export type LoginMutation = { __typename?: 'Mutation', login?: { __typename?: 'LoginPayload', email: string, errors?: Array<{ __typename?: 'ErrorType', field: string, messages: Array<string> }>, user?: { __typename?: 'UserType', id: string } } };

export type LogoutMutationVariables = Exact<{ [key: string]: never; }>;


export type LogoutMutation = { __typename?: 'Mutation', logout?: { __typename?: 'Logout', success?: boolean } };

export type ResetPasswordMutationVariables = Exact<{
  input: ResetPasswordMutationInput;
}>;


export type ResetPasswordMutation = { __typename?: 'Mutation', resetPassword?: { __typename?: 'ResetPasswordMutationPayload', email: string, errors?: Array<{ __typename?: 'ErrorType', field: string, messages: Array<string> }> } };

export type UpdatePasswordMutationVariables = Exact<{
  input: UpdatePasswordMutationInput;
}>;


export type UpdatePasswordMutation = { __typename?: 'Mutation', updatePassword?: { __typename?: 'UpdatePasswordMutationPayload', errors?: Array<{ __typename?: 'ErrorType', field: string, messages: Array<string> }> } };

export type SetPasswordMutationVariables = Exact<{
  input: SetPasswordMutationInput;
}>;


export type SetPasswordMutation = { __typename?: 'Mutation', setPassword?: { __typename?: 'SetPasswordMutationPayload', errors?: Array<{ __typename?: 'ErrorType', field: string, messages: Array<string> }> } };

export type UpdateUserMutationVariables = Exact<{
  input: UpdateUserMutationInput;
}>;


export type UpdateUserMutation = { __typename?: 'Mutation', updateUser?: { __typename?: 'UpdateUserMutationPayload', errors: Array<{ __typename?: 'ErrorType', field: string, messages: Array<string> }> } };

export type ToggleNotificationConfigMutationVariables = Exact<{
  input: NotificationConfigMutationInput;
}>;


export type ToggleNotificationConfigMutation = { __typename?: 'Mutation', toggleNotificationConfig?: { __typename?: 'NotificationConfigMutationPayload', errors: Array<{ __typename?: 'ErrorType', field: string, messages: Array<string> }> } };

export type UserQueryVariables = Exact<{ [key: string]: never; }>;


export type UserQuery = { __typename?: 'Query', user?: { __typename?: 'UserType', id: string, email: string, firstName: string, lastName: string, displayName: string, isActive: boolean, isStaff: boolean, dateJoined: string, lastLogin?: string, language: string, emailNotifications: boolean, inAppNotifications: boolean, termsAndConditionsAcceptedAt?: string, organization?: { __typename?: 'OrganizationType', id: string, name: string, externalId: string, isEu: boolean, displayName: string, logo?: string, logoThumbnail?: string, location?: { __typename?: 'LocationType', id: string, iva: Decimal, name: string, path?: string }, group: { __typename?: 'OrganizationGroupType', id: string, dealerCommission?: string } }, role?: { __typename?: 'RoleType', id: string, name: string }, ecnRoles: Array<{ __typename?: 'EcnRoleType', id: string }>, permissions: { __typename?: 'UserPermissions', viewQuotes: boolean, viewSales: boolean, viewSupplyOrders: boolean, viewAccounts: boolean, viewContacts: boolean, viewOpportunities: boolean, viewAnalytics: boolean, viewWarrantyClaims: boolean, viewSeeders: boolean, assignAccountOwner: boolean, requestSupplyOrderReview: boolean, submitSalesSupplyOrderReview: boolean, submitCreditsSupplyOrderReview: boolean, receiveSupplyOrderApprovedNotification: boolean, viewWarrantyClaimsAnalytics: boolean, manageQuotes: boolean, manageSales: boolean, manageSupplyOrders: boolean, editApprovedSupplyOrders: boolean, manageShipments: boolean, manageWarrantyClaims: boolean, performTechnicalReview: boolean, manageAccounts: boolean, viewDatastudio: boolean, manageEcns: boolean, viewEcns: boolean, warrantyClaimsWarrantyAdminApprove: boolean, warrantyClaimsManageApprove: boolean, ticketSystemAccess: boolean, viewStockForecast: boolean, manageStockForecast: boolean, configureMrpParameters: boolean } } };

export type GetUsersQueryVariables = Exact<{ [key: string]: never; }>;


export type GetUsersQuery = { __typename?: 'Query', users: Array<{ __typename?: 'UserType', id: string, email: string, firstName: string, lastName: string, displayName: string, isActive: boolean, isStaff: boolean, dateJoined: string, lastLogin?: string, language: string, emailNotifications: boolean, inAppNotifications: boolean, termsAndConditionsAcceptedAt?: string, organization?: { __typename?: 'OrganizationType', id: string, name: string, externalId: string, isEu: boolean, displayName: string, logo?: string, logoThumbnail?: string, location?: { __typename?: 'LocationType', id: string, name: string, path?: string, iva: Decimal }, group: { __typename?: 'OrganizationGroupType', id: string, dealerCommission?: string } }, role?: { __typename?: 'RoleType', id: string, name: string }, ecnRoles: Array<{ __typename?: 'EcnRoleType', id: string }>, permissions: { __typename?: 'UserPermissions', viewQuotes: boolean, viewSales: boolean, viewSupplyOrders: boolean, viewAccounts: boolean, viewContacts: boolean, viewOpportunities: boolean, viewAnalytics: boolean, viewWarrantyClaims: boolean, viewSeeders: boolean, assignAccountOwner: boolean, requestSupplyOrderReview: boolean, submitSalesSupplyOrderReview: boolean, submitCreditsSupplyOrderReview: boolean, receiveSupplyOrderApprovedNotification: boolean, viewWarrantyClaimsAnalytics: boolean, manageQuotes: boolean, manageSales: boolean, manageSupplyOrders: boolean, editApprovedSupplyOrders: boolean, manageShipments: boolean, manageWarrantyClaims: boolean, performTechnicalReview: boolean, manageAccounts: boolean, viewDatastudio: boolean, manageEcns: boolean, viewEcns: boolean, warrantyClaimsWarrantyAdminApprove: boolean, warrantyClaimsManageApprove: boolean, ticketSystemAccess: boolean, viewStockForecast: boolean, manageStockForecast: boolean, configureMrpParameters: boolean } }> };

export type NotificationConfigFragment = { __typename?: 'NotificationConfigType', id: string, name: UsersNotificationConfigNameChoices, inAppEnabled: boolean, emailEnabled: boolean, displayName: string, user: { __typename?: 'UserType', id: string } };

export type NotificationConfigNameFragment = { __typename?: 'NotificationConfigNameType', value: NotificationConfigChoices, label: string };

export type GetUserNotificationConfigQueryVariables = Exact<{ [key: string]: never; }>;


export type GetUserNotificationConfigQuery = { __typename?: 'Query', notificationsConfigNames: Array<{ __typename?: 'NotificationConfigNameType', value: NotificationConfigChoices, label: string }>, userNotificationsConfigs?: Array<{ __typename?: 'NotificationConfigType', id: string, name: UsersNotificationConfigNameChoices, inAppEnabled: boolean, emailEnabled: boolean, displayName: string, user: { __typename?: 'UserType', id: string } }> };

export type GetChildOrganizationsOptionsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetChildOrganizationsOptionsQuery = { __typename?: 'Query', childOrganizations: Array<{ __typename?: 'OrganizationType', id: string, name: string }> };

export type GetChildUsersQueryVariables = Exact<{ [key: string]: never; }>;


export type GetChildUsersQuery = { __typename?: 'Query', childUsers: Array<{ __typename?: 'UserType', id: string, email: string, firstName: string, lastName: string, displayName: string, isActive: boolean, isStaff: boolean, dateJoined: string, lastLogin?: string, language: string, emailNotifications: boolean, inAppNotifications: boolean, termsAndConditionsAcceptedAt?: string, organization?: { __typename?: 'OrganizationType', id: string, name: string, externalId: string, isEu: boolean, displayName: string, logo?: string, logoThumbnail?: string, location?: { __typename?: 'LocationType', id: string, name: string, path?: string, iva: Decimal }, group: { __typename?: 'OrganizationGroupType', id: string, dealerCommission?: string } }, role?: { __typename?: 'RoleType', id: string, name: string }, ecnRoles: Array<{ __typename?: 'EcnRoleType', id: string }>, permissions: { __typename?: 'UserPermissions', viewQuotes: boolean, viewSales: boolean, viewSupplyOrders: boolean, viewAccounts: boolean, viewContacts: boolean, viewOpportunities: boolean, viewAnalytics: boolean, viewWarrantyClaims: boolean, viewSeeders: boolean, assignAccountOwner: boolean, requestSupplyOrderReview: boolean, submitSalesSupplyOrderReview: boolean, submitCreditsSupplyOrderReview: boolean, receiveSupplyOrderApprovedNotification: boolean, viewWarrantyClaimsAnalytics: boolean, manageQuotes: boolean, manageSales: boolean, manageSupplyOrders: boolean, editApprovedSupplyOrders: boolean, manageShipments: boolean, manageWarrantyClaims: boolean, performTechnicalReview: boolean, manageAccounts: boolean, viewDatastudio: boolean, manageEcns: boolean, viewEcns: boolean, warrantyClaimsWarrantyAdminApprove: boolean, warrantyClaimsManageApprove: boolean, ticketSystemAccess: boolean, viewStockForecast: boolean, manageStockForecast: boolean, configureMrpParameters: boolean } }> };

export type GetUsersListQueryVariables = Exact<{
  ecnRolesIsNull?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetUsersListQuery = { __typename?: 'Query', usersNodes?: { __typename?: 'UserNodeConnection', count: number, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string, endCursor?: string }, edges: Array<{ __typename?: 'UserNodeEdge', node?: { __typename?: 'UserNode', uuid: string, id: string, email: string, firstName: string, lastName: string, displayName: string, isActive: boolean, isStaff: boolean, dateJoined: string, lastLogin?: string, language: string, emailNotifications: boolean, inAppNotifications: boolean, termsAndConditionsAcceptedAt?: string, organization?: { __typename?: 'OrganizationType', id: string, name: string, externalId: string, isEu: boolean, displayName: string, logo?: string, logoThumbnail?: string, location?: { __typename?: 'LocationType', id: string, name: string, path?: string, iva: Decimal }, group: { __typename?: 'OrganizationGroupType', id: string, dealerCommission?: string } }, role?: { __typename?: 'RoleType', id: string, name: string }, ecnRoles: Array<{ __typename?: 'EcnRoleType', id: string }>, permissions: { __typename?: 'UserPermissions', viewQuotes: boolean, viewSales: boolean, viewSupplyOrders: boolean, viewAccounts: boolean, viewContacts: boolean, viewOpportunities: boolean, viewAnalytics: boolean, viewWarrantyClaims: boolean, viewSeeders: boolean, assignAccountOwner: boolean, requestSupplyOrderReview: boolean, submitSalesSupplyOrderReview: boolean, submitCreditsSupplyOrderReview: boolean, receiveSupplyOrderApprovedNotification: boolean, viewWarrantyClaimsAnalytics: boolean, manageQuotes: boolean, manageSales: boolean, manageSupplyOrders: boolean, editApprovedSupplyOrders: boolean, manageShipments: boolean, manageWarrantyClaims: boolean, performTechnicalReview: boolean, manageAccounts: boolean, viewDatastudio: boolean, manageEcns: boolean, viewEcns: boolean, warrantyClaimsWarrantyAdminApprove: boolean, warrantyClaimsManageApprove: boolean, ticketSystemAccess: boolean, viewStockForecast: boolean, manageStockForecast: boolean, configureMrpParameters: boolean } } }> } };

export type GetOrganizationsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetOrganizationsQuery = { __typename?: 'Query', organizations: Array<{ __typename?: 'OrganizationType', id: string, name: string, externalId: string, isEu: boolean, displayName: string, logo?: string, logoThumbnail?: string, location?: { __typename?: 'LocationType', id: string, name: string, path?: string, iva: Decimal }, group: { __typename?: 'OrganizationGroupType', id: string, dealerCommission?: string } }> };

export type ChangeLanguageMutationVariables = Exact<{
  language: Scalars['String']['input'];
}>;


export type ChangeLanguageMutation = { __typename?: 'Mutation', changeLanguage?: { __typename?: 'ChangeUserLanguage', ok: boolean } };

export type UpdateOrganizationMutationVariables = Exact<{
  input: UpdateOrganizationMutationInput;
}>;


export type UpdateOrganizationMutation = { __typename?: 'Mutation', updateOrganization?: { __typename?: 'UpdateOrganizationMutationPayload', organization?: { __typename?: 'OrganizationType', id: string }, errors: Array<{ __typename?: 'ErrorType', field: string, messages: Array<string> }> } };

export type OrganizationAddressFragment = { __typename?: 'OrganizationAddressType', id: string, street: string, postalCode: string, location: { __typename?: 'LocationType', name: string } };

export type GetAccountOrganizationAddressesQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type GetAccountOrganizationAddressesQuery = { __typename?: 'Query', accountOrganizationAddresses: Array<{ __typename?: 'OrganizationAddressType', id: string, street: string, postalCode: string, location: { __typename?: 'LocationType', name: string } }> };

export type WarrantyClaimInspectionReviewFragment = { __typename?: 'WarrantyClaimInspectionReviewType', id: string, created: string, updated: string, received: boolean, receivedDate?: string, inspected: boolean, inspectedDate?: string, failureDescription: string, status: WarrantyClaimsWarrantyClaimInspectionReviewStatusChoices, statusDisplay: string, inWarranty: boolean, createdBy?: { __typename?: 'UserType', id: string, uuid: string, email: string, firstName: string, lastName: string, displayName: string, isActive: boolean, isStaff: boolean, dateJoined: string, lastLogin?: string, language: string, emailNotifications: boolean, inAppNotifications: boolean, termsAndConditionsAcceptedAt?: string }, updatedBy?: { __typename?: 'UserType', id: string, uuid: string, email: string, firstName: string, lastName: string, displayName: string, isActive: boolean, isStaff: boolean, dateJoined: string, lastLogin?: string, language: string, emailNotifications: boolean, inAppNotifications: boolean, termsAndConditionsAcceptedAt?: string }, warrantyClaim: { __typename?: 'WarrantyClaimNode', id: string }, files: Array<{ __typename?: 'WarrantyClaimInspectionFileType', id: string, file?: string }> };

export type WarrantyClaimImageFragment = { __typename?: 'WarrantyClaimImageType', id: string, file: string, warrantyClaim: { __typename?: 'WarrantyClaimNode', id: string } };

export type WarrantyClaimVideoFragment = { __typename?: 'WarrantyClaimVideoType', id: string, file: string, warrantyClaim: { __typename?: 'WarrantyClaimNode', id: string } };

export type WarrantyProductFragment = { __typename?: 'WarrantyProductType', id: string, quantity: number, externalId: string, name: string, displayName: string, price: string, order: number, description: string, rowCount: number, originalProduct?: { __typename?: 'ProductNode', id: string, uuid: string, image?: string }, subcategory?: { __typename?: 'SubcategoryType', id: string, name: string, category: { __typename?: 'CategoryType', id: string, uuid: string, name: string } } };

export type WarrantyClaimListFragment = { __typename?: 'WarrantyClaimNode', id: string, uuid: string, invoiceDate?: string, failureDate?: string, serialNumber?: string, created: string, quantity: number, description: string, finalClient: string, phone: string, externalId?: string, displayId: number, orderId?: number, warrantyClaimType: WarrantyClaimsWarrantyClaimWarrantyClaimTypeChoices, displayWarrantyClaimType: string, applyForCredit: boolean, rmaCode?: string, amount?: string, state: WarrantyClaimsWarrantyClaimStateChoices, stateDisplay: string, requiredApprovalType?: string, requiresSpecialApproval: boolean, requiresInspectionReview: boolean, hasCompletedInspectionReview: boolean, canCurrentUserApprove: boolean, requiredApprovalsList: Array<WarrantyClaimsWarrantyClaimReviewApprovalTypeChoices>, missingApprovals: Array<WarrantyClaimsWarrantyClaimReviewApprovalTypeChoices>, isFullyApproved: boolean, isInFinalState: boolean, product?: { __typename?: 'WarrantyProductType', id: string, quantity: number, externalId: string, name: string, displayName: string, price: string, order: number, description: string, rowCount: number, originalProduct?: { __typename?: 'ProductNode', id: string, uuid: string, image?: string }, subcategory?: { __typename?: 'SubcategoryType', id: string, name: string, category: { __typename?: 'CategoryType', id: string, uuid: string, name: string } } }, contact: { __typename?: 'ContactType', id: string, uuid: string, externalId: string, email?: string, firstName: string, lastName: string, displayName: string, phone: string, mobilePhone: string, active: boolean, type: { __typename?: 'ContactTypeType', id: string, name: string }, account: { __typename?: 'AccountType', id: string, uuid: string, name: string, taxId?: string, externalId: string, isFavorite: boolean, address?: string, location?: { __typename?: 'LocationType', id: string, path?: string, iva: Decimal }, owner?: { __typename?: 'OrganizationType', id: string, name: string, externalId: string, isEu: boolean, displayName: string, logo?: string, logoThumbnail?: string, location?: { __typename?: 'LocationType', id: string, name: string, path?: string, iva: Decimal }, group: { __typename?: 'OrganizationGroupType', id: string, dealerCommission?: string } } } }, createdBy?: { __typename?: 'UserType', id: string, uuid: string, email: string, firstName: string, lastName: string, displayName: string, isActive: boolean, isStaff: boolean, dateJoined: string, lastLogin?: string, language: string, emailNotifications: boolean, inAppNotifications: boolean, termsAndConditionsAcceptedAt?: string }, seeder?: { __typename?: 'SeederType', uuid: string, displayName: string, rowCount: number, id: string }, lastReview?: { __typename?: 'WarrantyClaimReviewType', id: string, created: string, notes: string, statusDisplay: string, status: WarrantyClaimsWarrantyClaimReviewStatusChoices, approvalType?: WarrantyClaimsWarrantyClaimReviewApprovalTypeChoices, approvalTypeDisplay: string, createdBy?: { __typename?: 'UserType', id: string, uuid: string, email: string, firstName: string, lastName: string, displayName: string, isActive: boolean, isStaff: boolean, dateJoined: string, lastLogin?: string, language: string, emailNotifications: boolean, inAppNotifications: boolean, termsAndConditionsAcceptedAt?: string } }, inspectionReview?: { __typename?: 'WarrantyClaimInspectionReviewType', statusDisplay: string, status: WarrantyClaimsWarrantyClaimInspectionReviewStatusChoices, inWarranty: boolean }, supplyOrder?: { __typename?: 'SupplyOrderNode', id: string, uuid: string, displayId: number, displayIdWithPrefix: string } };

export type WarrantyClaimFragment = { __typename?: 'WarrantyClaimNode', id: string, uuid: string, invoiceDate?: string, failureDate?: string, serialNumber?: string, created: string, quantity: number, description: string, finalClient: string, phone: string, externalId?: string, displayId: number, orderId?: number, warrantyClaimType: WarrantyClaimsWarrantyClaimWarrantyClaimTypeChoices, displayWarrantyClaimType: string, applyForCredit: boolean, rmaCode?: string, amount?: string, state: WarrantyClaimsWarrantyClaimStateChoices, stateDisplay: string, requiredApprovalType?: string, requiresSpecialApproval: boolean, requiresInspectionReview: boolean, hasCompletedInspectionReview: boolean, canCurrentUserApprove: boolean, requiredApprovalsList: Array<WarrantyClaimsWarrantyClaimReviewApprovalTypeChoices>, missingApprovals: Array<WarrantyClaimsWarrantyClaimReviewApprovalTypeChoices>, isFullyApproved: boolean, isInFinalState: boolean, inspectionReview?: { __typename?: 'WarrantyClaimInspectionReviewType', statusDisplay: string, status: WarrantyClaimsWarrantyClaimInspectionReviewStatusChoices, inWarranty: boolean, id: string, created: string, updated: string, received: boolean, receivedDate?: string, inspected: boolean, inspectedDate?: string, failureDescription: string, createdBy?: { __typename?: 'UserType', id: string, uuid: string, email: string, firstName: string, lastName: string, displayName: string, isActive: boolean, isStaff: boolean, dateJoined: string, lastLogin?: string, language: string, emailNotifications: boolean, inAppNotifications: boolean, termsAndConditionsAcceptedAt?: string }, updatedBy?: { __typename?: 'UserType', id: string, uuid: string, email: string, firstName: string, lastName: string, displayName: string, isActive: boolean, isStaff: boolean, dateJoined: string, lastLogin?: string, language: string, emailNotifications: boolean, inAppNotifications: boolean, termsAndConditionsAcceptedAt?: string }, warrantyClaim: { __typename?: 'WarrantyClaimNode', id: string }, files: Array<{ __typename?: 'WarrantyClaimInspectionFileType', id: string, file?: string }> }, seeder?: { __typename?: 'SeederType', id: string, uuid: string, displayName: string, year?: number, rowCount: number, meterType: SeedersSeederMeterTypeChoices, account: { __typename?: 'AccountType', id: string, uuid: string, name: string }, brand: { __typename?: 'SeederBrandType', id: string }, model?: { __typename?: 'SeederModelType', id: string }, installedCategories: Array<{ __typename?: 'CategoryType', id: string, uuid: string }> }, images: Array<{ __typename?: 'WarrantyClaimImageType', id: string, file: string, warrantyClaim: { __typename?: 'WarrantyClaimNode', id: string } }>, videos: Array<{ __typename?: 'WarrantyClaimVideoType', id: string, file: string, warrantyClaim: { __typename?: 'WarrantyClaimNode', id: string } }>, reviews: Array<{ __typename?: 'WarrantyClaimReviewType', id: string, created: string, notes: string, statusDisplay: string, status: WarrantyClaimsWarrantyClaimReviewStatusChoices, approvalType?: WarrantyClaimsWarrantyClaimReviewApprovalTypeChoices, approvalTypeDisplay: string, createdBy?: { __typename?: 'UserType', id: string, uuid: string, email: string, firstName: string, lastName: string, displayName: string, isActive: boolean, isStaff: boolean, dateJoined: string, lastLogin?: string, language: string, emailNotifications: boolean, inAppNotifications: boolean, termsAndConditionsAcceptedAt?: string } }>, product?: { __typename?: 'WarrantyProductType', id: string, quantity: number, externalId: string, name: string, displayName: string, price: string, order: number, description: string, rowCount: number, originalProduct?: { __typename?: 'ProductNode', id: string, uuid: string, image?: string }, subcategory?: { __typename?: 'SubcategoryType', id: string, name: string, category: { __typename?: 'CategoryType', id: string, uuid: string, name: string } } }, contact: { __typename?: 'ContactType', id: string, uuid: string, externalId: string, email?: string, firstName: string, lastName: string, displayName: string, phone: string, mobilePhone: string, active: boolean, type: { __typename?: 'ContactTypeType', id: string, name: string }, account: { __typename?: 'AccountType', id: string, uuid: string, name: string, taxId?: string, externalId: string, isFavorite: boolean, address?: string, location?: { __typename?: 'LocationType', id: string, path?: string, iva: Decimal }, owner?: { __typename?: 'OrganizationType', id: string, name: string, externalId: string, isEu: boolean, displayName: string, logo?: string, logoThumbnail?: string, location?: { __typename?: 'LocationType', id: string, name: string, path?: string, iva: Decimal }, group: { __typename?: 'OrganizationGroupType', id: string, dealerCommission?: string } } } }, createdBy?: { __typename?: 'UserType', id: string, uuid: string, email: string, firstName: string, lastName: string, displayName: string, isActive: boolean, isStaff: boolean, dateJoined: string, lastLogin?: string, language: string, emailNotifications: boolean, inAppNotifications: boolean, termsAndConditionsAcceptedAt?: string }, lastReview?: { __typename?: 'WarrantyClaimReviewType', id: string, created: string, notes: string, statusDisplay: string, status: WarrantyClaimsWarrantyClaimReviewStatusChoices, approvalType?: WarrantyClaimsWarrantyClaimReviewApprovalTypeChoices, approvalTypeDisplay: string, createdBy?: { __typename?: 'UserType', id: string, uuid: string, email: string, firstName: string, lastName: string, displayName: string, isActive: boolean, isStaff: boolean, dateJoined: string, lastLogin?: string, language: string, emailNotifications: boolean, inAppNotifications: boolean, termsAndConditionsAcceptedAt?: string } }, supplyOrder?: { __typename?: 'SupplyOrderNode', id: string, uuid: string, displayId: number, displayIdWithPrefix: string } };

export type WarrantyClaimReviewFragment = { __typename?: 'WarrantyClaimReviewType', id: string, created: string, notes: string, statusDisplay: string, status: WarrantyClaimsWarrantyClaimReviewStatusChoices, approvalType?: WarrantyClaimsWarrantyClaimReviewApprovalTypeChoices, approvalTypeDisplay: string, createdBy?: { __typename?: 'UserType', id: string, uuid: string, email: string, firstName: string, lastName: string, displayName: string, isActive: boolean, isStaff: boolean, dateJoined: string, lastLogin?: string, language: string, emailNotifications: boolean, inAppNotifications: boolean, termsAndConditionsAcceptedAt?: string } };

export type FailureFragment = { __typename?: 'FailureType', id: string, description: string, created: string, updated: string };

export type GetWarrantyClaimQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  uuid?: InputMaybe<Scalars['UUID']['input']>;
}>;


export type GetWarrantyClaimQuery = { __typename?: 'Query', warrantyClaim?: { __typename?: 'WarrantyClaimNode', id: string, uuid: string, invoiceDate?: string, failureDate?: string, serialNumber?: string, created: string, quantity: number, description: string, finalClient: string, phone: string, externalId?: string, displayId: number, orderId?: number, warrantyClaimType: WarrantyClaimsWarrantyClaimWarrantyClaimTypeChoices, displayWarrantyClaimType: string, applyForCredit: boolean, rmaCode?: string, amount?: string, state: WarrantyClaimsWarrantyClaimStateChoices, stateDisplay: string, requiredApprovalType?: string, requiresSpecialApproval: boolean, requiresInspectionReview: boolean, hasCompletedInspectionReview: boolean, canCurrentUserApprove: boolean, requiredApprovalsList: Array<WarrantyClaimsWarrantyClaimReviewApprovalTypeChoices>, missingApprovals: Array<WarrantyClaimsWarrantyClaimReviewApprovalTypeChoices>, isFullyApproved: boolean, isInFinalState: boolean, inspectionReview?: { __typename?: 'WarrantyClaimInspectionReviewType', statusDisplay: string, status: WarrantyClaimsWarrantyClaimInspectionReviewStatusChoices, inWarranty: boolean, id: string, created: string, updated: string, received: boolean, receivedDate?: string, inspected: boolean, inspectedDate?: string, failureDescription: string, createdBy?: { __typename?: 'UserType', id: string, uuid: string, email: string, firstName: string, lastName: string, displayName: string, isActive: boolean, isStaff: boolean, dateJoined: string, lastLogin?: string, language: string, emailNotifications: boolean, inAppNotifications: boolean, termsAndConditionsAcceptedAt?: string }, updatedBy?: { __typename?: 'UserType', id: string, uuid: string, email: string, firstName: string, lastName: string, displayName: string, isActive: boolean, isStaff: boolean, dateJoined: string, lastLogin?: string, language: string, emailNotifications: boolean, inAppNotifications: boolean, termsAndConditionsAcceptedAt?: string }, warrantyClaim: { __typename?: 'WarrantyClaimNode', id: string }, files: Array<{ __typename?: 'WarrantyClaimInspectionFileType', id: string, file?: string }> }, seeder?: { __typename?: 'SeederType', id: string, uuid: string, displayName: string, year?: number, rowCount: number, meterType: SeedersSeederMeterTypeChoices, account: { __typename?: 'AccountType', id: string, uuid: string, name: string }, brand: { __typename?: 'SeederBrandType', id: string }, model?: { __typename?: 'SeederModelType', id: string }, installedCategories: Array<{ __typename?: 'CategoryType', id: string, uuid: string }> }, images: Array<{ __typename?: 'WarrantyClaimImageType', id: string, file: string, warrantyClaim: { __typename?: 'WarrantyClaimNode', id: string } }>, videos: Array<{ __typename?: 'WarrantyClaimVideoType', id: string, file: string, warrantyClaim: { __typename?: 'WarrantyClaimNode', id: string } }>, reviews: Array<{ __typename?: 'WarrantyClaimReviewType', id: string, created: string, notes: string, statusDisplay: string, status: WarrantyClaimsWarrantyClaimReviewStatusChoices, approvalType?: WarrantyClaimsWarrantyClaimReviewApprovalTypeChoices, approvalTypeDisplay: string, createdBy?: { __typename?: 'UserType', id: string, uuid: string, email: string, firstName: string, lastName: string, displayName: string, isActive: boolean, isStaff: boolean, dateJoined: string, lastLogin?: string, language: string, emailNotifications: boolean, inAppNotifications: boolean, termsAndConditionsAcceptedAt?: string } }>, product?: { __typename?: 'WarrantyProductType', id: string, quantity: number, externalId: string, name: string, displayName: string, price: string, order: number, description: string, rowCount: number, originalProduct?: { __typename?: 'ProductNode', id: string, uuid: string, image?: string }, subcategory?: { __typename?: 'SubcategoryType', id: string, name: string, category: { __typename?: 'CategoryType', id: string, uuid: string, name: string } } }, contact: { __typename?: 'ContactType', id: string, uuid: string, externalId: string, email?: string, firstName: string, lastName: string, displayName: string, phone: string, mobilePhone: string, active: boolean, type: { __typename?: 'ContactTypeType', id: string, name: string }, account: { __typename?: 'AccountType', id: string, uuid: string, name: string, taxId?: string, externalId: string, isFavorite: boolean, address?: string, location?: { __typename?: 'LocationType', id: string, path?: string, iva: Decimal }, owner?: { __typename?: 'OrganizationType', id: string, name: string, externalId: string, isEu: boolean, displayName: string, logo?: string, logoThumbnail?: string, location?: { __typename?: 'LocationType', id: string, name: string, path?: string, iva: Decimal }, group: { __typename?: 'OrganizationGroupType', id: string, dealerCommission?: string } } } }, createdBy?: { __typename?: 'UserType', id: string, uuid: string, email: string, firstName: string, lastName: string, displayName: string, isActive: boolean, isStaff: boolean, dateJoined: string, lastLogin?: string, language: string, emailNotifications: boolean, inAppNotifications: boolean, termsAndConditionsAcceptedAt?: string }, lastReview?: { __typename?: 'WarrantyClaimReviewType', id: string, created: string, notes: string, statusDisplay: string, status: WarrantyClaimsWarrantyClaimReviewStatusChoices, approvalType?: WarrantyClaimsWarrantyClaimReviewApprovalTypeChoices, approvalTypeDisplay: string, createdBy?: { __typename?: 'UserType', id: string, uuid: string, email: string, firstName: string, lastName: string, displayName: string, isActive: boolean, isStaff: boolean, dateJoined: string, lastLogin?: string, language: string, emailNotifications: boolean, inAppNotifications: boolean, termsAndConditionsAcceptedAt?: string } }, supplyOrder?: { __typename?: 'SupplyOrderNode', id: string, uuid: string, displayId: number, displayIdWithPrefix: string } } };

export type GetWarrantyClaimsQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  owner?: InputMaybe<Scalars['UUID']['input']>;
  accountGlobalID?: InputMaybe<Scalars['UUID']['input']>;
  createdBy?: InputMaybe<Scalars['UUID']['input']>;
  createdGte?: InputMaybe<Scalars['Date']['input']>;
  createdLte?: InputMaybe<Scalars['Date']['input']>;
  created?: InputMaybe<Scalars['Date']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  warrantyClaimType?: InputMaybe<WarrantyClaimsWarrantyClaimWarrantyClaimTypeChoices>;
  inspectionReviewStatus?: InputMaybe<Scalars['String']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetWarrantyClaimsQuery = { __typename?: 'Query', warrantyClaims?: { __typename?: 'WarrantyClaimNodeConnection', count: number, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string, endCursor?: string }, edges: Array<{ __typename?: 'WarrantyClaimNodeEdge', cursor: string, node?: { __typename?: 'WarrantyClaimNode', id: string, uuid: string, invoiceDate?: string, failureDate?: string, serialNumber?: string, created: string, quantity: number, description: string, finalClient: string, phone: string, externalId?: string, displayId: number, orderId?: number, warrantyClaimType: WarrantyClaimsWarrantyClaimWarrantyClaimTypeChoices, displayWarrantyClaimType: string, applyForCredit: boolean, rmaCode?: string, amount?: string, state: WarrantyClaimsWarrantyClaimStateChoices, stateDisplay: string, requiredApprovalType?: string, requiresSpecialApproval: boolean, requiresInspectionReview: boolean, hasCompletedInspectionReview: boolean, canCurrentUserApprove: boolean, requiredApprovalsList: Array<WarrantyClaimsWarrantyClaimReviewApprovalTypeChoices>, missingApprovals: Array<WarrantyClaimsWarrantyClaimReviewApprovalTypeChoices>, isFullyApproved: boolean, isInFinalState: boolean, product?: { __typename?: 'WarrantyProductType', id: string, quantity: number, externalId: string, name: string, displayName: string, price: string, order: number, description: string, rowCount: number, originalProduct?: { __typename?: 'ProductNode', id: string, uuid: string, image?: string }, subcategory?: { __typename?: 'SubcategoryType', id: string, name: string, category: { __typename?: 'CategoryType', id: string, uuid: string, name: string } } }, contact: { __typename?: 'ContactType', id: string, uuid: string, externalId: string, email?: string, firstName: string, lastName: string, displayName: string, phone: string, mobilePhone: string, active: boolean, type: { __typename?: 'ContactTypeType', id: string, name: string }, account: { __typename?: 'AccountType', id: string, uuid: string, name: string, taxId?: string, externalId: string, isFavorite: boolean, address?: string, location?: { __typename?: 'LocationType', id: string, path?: string, iva: Decimal }, owner?: { __typename?: 'OrganizationType', id: string, name: string, externalId: string, isEu: boolean, displayName: string, logo?: string, logoThumbnail?: string, location?: { __typename?: 'LocationType', id: string, name: string, path?: string, iva: Decimal }, group: { __typename?: 'OrganizationGroupType', id: string, dealerCommission?: string } } } }, createdBy?: { __typename?: 'UserType', id: string, uuid: string, email: string, firstName: string, lastName: string, displayName: string, isActive: boolean, isStaff: boolean, dateJoined: string, lastLogin?: string, language: string, emailNotifications: boolean, inAppNotifications: boolean, termsAndConditionsAcceptedAt?: string }, seeder?: { __typename?: 'SeederType', uuid: string, displayName: string, rowCount: number, id: string }, lastReview?: { __typename?: 'WarrantyClaimReviewType', id: string, created: string, notes: string, statusDisplay: string, status: WarrantyClaimsWarrantyClaimReviewStatusChoices, approvalType?: WarrantyClaimsWarrantyClaimReviewApprovalTypeChoices, approvalTypeDisplay: string, createdBy?: { __typename?: 'UserType', id: string, uuid: string, email: string, firstName: string, lastName: string, displayName: string, isActive: boolean, isStaff: boolean, dateJoined: string, lastLogin?: string, language: string, emailNotifications: boolean, inAppNotifications: boolean, termsAndConditionsAcceptedAt?: string } }, inspectionReview?: { __typename?: 'WarrantyClaimInspectionReviewType', statusDisplay: string, status: WarrantyClaimsWarrantyClaimInspectionReviewStatusChoices, inWarranty: boolean }, supplyOrder?: { __typename?: 'SupplyOrderNode', id: string, uuid: string, displayId: number, displayIdWithPrefix: string } } }> } };

export type GetFailuresQueryVariables = Exact<{ [key: string]: never; }>;


export type GetFailuresQuery = { __typename?: 'Query', failures: Array<{ __typename?: 'FailureType', id: string, description: string, created: string, updated: string }> };

export type GetWarrantyClaimApprovalConfigQueryVariables = Exact<{ [key: string]: never; }>;


export type GetWarrantyClaimApprovalConfigQuery = { __typename?: 'Query', warrantyClaimApprovalConfig?: { __typename?: 'WarrantyClaimApprovalConfigType', id: string, secondaryApprovalThreshold: string, mainApprovalThreshold: string } };

export type CreateWarrantyClaimMutationVariables = Exact<{
  input: CreateWarrantyClaimMutationInput;
}>;


export type CreateWarrantyClaimMutation = { __typename?: 'Mutation', createWarrantyClaim?: { __typename?: 'CreateWarrantyClaimMutationPayload', warrantyClaim?: { __typename?: 'WarrantyClaimNode', id: string, uuid: string, invoiceDate?: string, failureDate?: string, serialNumber?: string, created: string, quantity: number, description: string, finalClient: string, phone: string, externalId?: string, displayId: number, orderId?: number, warrantyClaimType: WarrantyClaimsWarrantyClaimWarrantyClaimTypeChoices, displayWarrantyClaimType: string, applyForCredit: boolean, rmaCode?: string, amount?: string, state: WarrantyClaimsWarrantyClaimStateChoices, stateDisplay: string, requiredApprovalType?: string, requiresSpecialApproval: boolean, requiresInspectionReview: boolean, hasCompletedInspectionReview: boolean, canCurrentUserApprove: boolean, requiredApprovalsList: Array<WarrantyClaimsWarrantyClaimReviewApprovalTypeChoices>, missingApprovals: Array<WarrantyClaimsWarrantyClaimReviewApprovalTypeChoices>, isFullyApproved: boolean, isInFinalState: boolean, inspectionReview?: { __typename?: 'WarrantyClaimInspectionReviewType', statusDisplay: string, status: WarrantyClaimsWarrantyClaimInspectionReviewStatusChoices, inWarranty: boolean, id: string, created: string, updated: string, received: boolean, receivedDate?: string, inspected: boolean, inspectedDate?: string, failureDescription: string, createdBy?: { __typename?: 'UserType', id: string, uuid: string, email: string, firstName: string, lastName: string, displayName: string, isActive: boolean, isStaff: boolean, dateJoined: string, lastLogin?: string, language: string, emailNotifications: boolean, inAppNotifications: boolean, termsAndConditionsAcceptedAt?: string }, updatedBy?: { __typename?: 'UserType', id: string, uuid: string, email: string, firstName: string, lastName: string, displayName: string, isActive: boolean, isStaff: boolean, dateJoined: string, lastLogin?: string, language: string, emailNotifications: boolean, inAppNotifications: boolean, termsAndConditionsAcceptedAt?: string }, warrantyClaim: { __typename?: 'WarrantyClaimNode', id: string }, files: Array<{ __typename?: 'WarrantyClaimInspectionFileType', id: string, file?: string }> }, seeder?: { __typename?: 'SeederType', id: string, uuid: string, displayName: string, year?: number, rowCount: number, meterType: SeedersSeederMeterTypeChoices, account: { __typename?: 'AccountType', id: string, uuid: string, name: string }, brand: { __typename?: 'SeederBrandType', id: string }, model?: { __typename?: 'SeederModelType', id: string }, installedCategories: Array<{ __typename?: 'CategoryType', id: string, uuid: string }> }, images: Array<{ __typename?: 'WarrantyClaimImageType', id: string, file: string, warrantyClaim: { __typename?: 'WarrantyClaimNode', id: string } }>, videos: Array<{ __typename?: 'WarrantyClaimVideoType', id: string, file: string, warrantyClaim: { __typename?: 'WarrantyClaimNode', id: string } }>, reviews: Array<{ __typename?: 'WarrantyClaimReviewType', id: string, created: string, notes: string, statusDisplay: string, status: WarrantyClaimsWarrantyClaimReviewStatusChoices, approvalType?: WarrantyClaimsWarrantyClaimReviewApprovalTypeChoices, approvalTypeDisplay: string, createdBy?: { __typename?: 'UserType', id: string, uuid: string, email: string, firstName: string, lastName: string, displayName: string, isActive: boolean, isStaff: boolean, dateJoined: string, lastLogin?: string, language: string, emailNotifications: boolean, inAppNotifications: boolean, termsAndConditionsAcceptedAt?: string } }>, product?: { __typename?: 'WarrantyProductType', id: string, quantity: number, externalId: string, name: string, displayName: string, price: string, order: number, description: string, rowCount: number, originalProduct?: { __typename?: 'ProductNode', id: string, uuid: string, image?: string }, subcategory?: { __typename?: 'SubcategoryType', id: string, name: string, category: { __typename?: 'CategoryType', id: string, uuid: string, name: string } } }, contact: { __typename?: 'ContactType', id: string, uuid: string, externalId: string, email?: string, firstName: string, lastName: string, displayName: string, phone: string, mobilePhone: string, active: boolean, type: { __typename?: 'ContactTypeType', id: string, name: string }, account: { __typename?: 'AccountType', id: string, uuid: string, name: string, taxId?: string, externalId: string, isFavorite: boolean, address?: string, location?: { __typename?: 'LocationType', id: string, path?: string, iva: Decimal }, owner?: { __typename?: 'OrganizationType', id: string, name: string, externalId: string, isEu: boolean, displayName: string, logo?: string, logoThumbnail?: string, location?: { __typename?: 'LocationType', id: string, name: string, path?: string, iva: Decimal }, group: { __typename?: 'OrganizationGroupType', id: string, dealerCommission?: string } } } }, createdBy?: { __typename?: 'UserType', id: string, uuid: string, email: string, firstName: string, lastName: string, displayName: string, isActive: boolean, isStaff: boolean, dateJoined: string, lastLogin?: string, language: string, emailNotifications: boolean, inAppNotifications: boolean, termsAndConditionsAcceptedAt?: string }, lastReview?: { __typename?: 'WarrantyClaimReviewType', id: string, created: string, notes: string, statusDisplay: string, status: WarrantyClaimsWarrantyClaimReviewStatusChoices, approvalType?: WarrantyClaimsWarrantyClaimReviewApprovalTypeChoices, approvalTypeDisplay: string, createdBy?: { __typename?: 'UserType', id: string, uuid: string, email: string, firstName: string, lastName: string, displayName: string, isActive: boolean, isStaff: boolean, dateJoined: string, lastLogin?: string, language: string, emailNotifications: boolean, inAppNotifications: boolean, termsAndConditionsAcceptedAt?: string } }, supplyOrder?: { __typename?: 'SupplyOrderNode', id: string, uuid: string, displayId: number, displayIdWithPrefix: string } }, errors: Array<{ __typename?: 'ErrorType', field: string, messages: Array<string> }> } };

export type UpdateWarrantyClaimMutationVariables = Exact<{
  input: UpdateWarrantyClaimMutationInput;
}>;


export type UpdateWarrantyClaimMutation = { __typename?: 'Mutation', updateWarrantyClaim?: { __typename?: 'UpdateWarrantyClaimMutationPayload', warrantyClaim?: { __typename?: 'WarrantyClaimNode', id: string, uuid: string, invoiceDate?: string, failureDate?: string, serialNumber?: string, created: string, quantity: number, description: string, finalClient: string, phone: string, externalId?: string, displayId: number, orderId?: number, warrantyClaimType: WarrantyClaimsWarrantyClaimWarrantyClaimTypeChoices, displayWarrantyClaimType: string, applyForCredit: boolean, rmaCode?: string, amount?: string, state: WarrantyClaimsWarrantyClaimStateChoices, stateDisplay: string, requiredApprovalType?: string, requiresSpecialApproval: boolean, requiresInspectionReview: boolean, hasCompletedInspectionReview: boolean, canCurrentUserApprove: boolean, requiredApprovalsList: Array<WarrantyClaimsWarrantyClaimReviewApprovalTypeChoices>, missingApprovals: Array<WarrantyClaimsWarrantyClaimReviewApprovalTypeChoices>, isFullyApproved: boolean, isInFinalState: boolean, inspectionReview?: { __typename?: 'WarrantyClaimInspectionReviewType', statusDisplay: string, status: WarrantyClaimsWarrantyClaimInspectionReviewStatusChoices, inWarranty: boolean, id: string, created: string, updated: string, received: boolean, receivedDate?: string, inspected: boolean, inspectedDate?: string, failureDescription: string, createdBy?: { __typename?: 'UserType', id: string, uuid: string, email: string, firstName: string, lastName: string, displayName: string, isActive: boolean, isStaff: boolean, dateJoined: string, lastLogin?: string, language: string, emailNotifications: boolean, inAppNotifications: boolean, termsAndConditionsAcceptedAt?: string }, updatedBy?: { __typename?: 'UserType', id: string, uuid: string, email: string, firstName: string, lastName: string, displayName: string, isActive: boolean, isStaff: boolean, dateJoined: string, lastLogin?: string, language: string, emailNotifications: boolean, inAppNotifications: boolean, termsAndConditionsAcceptedAt?: string }, warrantyClaim: { __typename?: 'WarrantyClaimNode', id: string }, files: Array<{ __typename?: 'WarrantyClaimInspectionFileType', id: string, file?: string }> }, seeder?: { __typename?: 'SeederType', id: string, uuid: string, displayName: string, year?: number, rowCount: number, meterType: SeedersSeederMeterTypeChoices, account: { __typename?: 'AccountType', id: string, uuid: string, name: string }, brand: { __typename?: 'SeederBrandType', id: string }, model?: { __typename?: 'SeederModelType', id: string }, installedCategories: Array<{ __typename?: 'CategoryType', id: string, uuid: string }> }, images: Array<{ __typename?: 'WarrantyClaimImageType', id: string, file: string, warrantyClaim: { __typename?: 'WarrantyClaimNode', id: string } }>, videos: Array<{ __typename?: 'WarrantyClaimVideoType', id: string, file: string, warrantyClaim: { __typename?: 'WarrantyClaimNode', id: string } }>, reviews: Array<{ __typename?: 'WarrantyClaimReviewType', id: string, created: string, notes: string, statusDisplay: string, status: WarrantyClaimsWarrantyClaimReviewStatusChoices, approvalType?: WarrantyClaimsWarrantyClaimReviewApprovalTypeChoices, approvalTypeDisplay: string, createdBy?: { __typename?: 'UserType', id: string, uuid: string, email: string, firstName: string, lastName: string, displayName: string, isActive: boolean, isStaff: boolean, dateJoined: string, lastLogin?: string, language: string, emailNotifications: boolean, inAppNotifications: boolean, termsAndConditionsAcceptedAt?: string } }>, product?: { __typename?: 'WarrantyProductType', id: string, quantity: number, externalId: string, name: string, displayName: string, price: string, order: number, description: string, rowCount: number, originalProduct?: { __typename?: 'ProductNode', id: string, uuid: string, image?: string }, subcategory?: { __typename?: 'SubcategoryType', id: string, name: string, category: { __typename?: 'CategoryType', id: string, uuid: string, name: string } } }, contact: { __typename?: 'ContactType', id: string, uuid: string, externalId: string, email?: string, firstName: string, lastName: string, displayName: string, phone: string, mobilePhone: string, active: boolean, type: { __typename?: 'ContactTypeType', id: string, name: string }, account: { __typename?: 'AccountType', id: string, uuid: string, name: string, taxId?: string, externalId: string, isFavorite: boolean, address?: string, location?: { __typename?: 'LocationType', id: string, path?: string, iva: Decimal }, owner?: { __typename?: 'OrganizationType', id: string, name: string, externalId: string, isEu: boolean, displayName: string, logo?: string, logoThumbnail?: string, location?: { __typename?: 'LocationType', id: string, name: string, path?: string, iva: Decimal }, group: { __typename?: 'OrganizationGroupType', id: string, dealerCommission?: string } } } }, createdBy?: { __typename?: 'UserType', id: string, uuid: string, email: string, firstName: string, lastName: string, displayName: string, isActive: boolean, isStaff: boolean, dateJoined: string, lastLogin?: string, language: string, emailNotifications: boolean, inAppNotifications: boolean, termsAndConditionsAcceptedAt?: string }, lastReview?: { __typename?: 'WarrantyClaimReviewType', id: string, created: string, notes: string, statusDisplay: string, status: WarrantyClaimsWarrantyClaimReviewStatusChoices, approvalType?: WarrantyClaimsWarrantyClaimReviewApprovalTypeChoices, approvalTypeDisplay: string, createdBy?: { __typename?: 'UserType', id: string, uuid: string, email: string, firstName: string, lastName: string, displayName: string, isActive: boolean, isStaff: boolean, dateJoined: string, lastLogin?: string, language: string, emailNotifications: boolean, inAppNotifications: boolean, termsAndConditionsAcceptedAt?: string } }, supplyOrder?: { __typename?: 'SupplyOrderNode', id: string, uuid: string, displayId: number, displayIdWithPrefix: string } }, errors: Array<{ __typename?: 'ErrorType', field: string, messages: Array<string> }> } };

export type CreateWarrantyClaimInspectionReviewMutationVariables = Exact<{
  input: CreateWarrantyClaimInspectionReviewMutationInput;
}>;


export type CreateWarrantyClaimInspectionReviewMutation = { __typename?: 'Mutation', createWarrantyClaimInspectionReview?: { __typename?: 'CreateWarrantyClaimInspectionReviewMutationPayload', warrantyClaimInspectionReview?: { __typename?: 'WarrantyClaimInspectionReviewType', id: string, created: string, updated: string, received: boolean, receivedDate?: string, inspected: boolean, inspectedDate?: string, failureDescription: string, status: WarrantyClaimsWarrantyClaimInspectionReviewStatusChoices, statusDisplay: string, inWarranty: boolean, createdBy?: { __typename?: 'UserType', id: string, uuid: string, email: string, firstName: string, lastName: string, displayName: string, isActive: boolean, isStaff: boolean, dateJoined: string, lastLogin?: string, language: string, emailNotifications: boolean, inAppNotifications: boolean, termsAndConditionsAcceptedAt?: string }, updatedBy?: { __typename?: 'UserType', id: string, uuid: string, email: string, firstName: string, lastName: string, displayName: string, isActive: boolean, isStaff: boolean, dateJoined: string, lastLogin?: string, language: string, emailNotifications: boolean, inAppNotifications: boolean, termsAndConditionsAcceptedAt?: string }, warrantyClaim: { __typename?: 'WarrantyClaimNode', id: string }, files: Array<{ __typename?: 'WarrantyClaimInspectionFileType', id: string, file?: string }> }, errors: Array<{ __typename?: 'ErrorType', field: string, messages: Array<string> }> } };

export type RejectWarrantyClaimMutationVariables = Exact<{
  input: RejectWarrantyClaimRequestMutationInput;
}>;


export type RejectWarrantyClaimMutation = { __typename?: 'Mutation', rejectWarrantyClaim?: { __typename?: 'RejectWarrantyClaimRequestMutationPayload', warrantyClaimReview?: { __typename?: 'WarrantyClaimReviewType', id: string, created: string, notes: string, statusDisplay: string, status: WarrantyClaimsWarrantyClaimReviewStatusChoices, approvalType?: WarrantyClaimsWarrantyClaimReviewApprovalTypeChoices, approvalTypeDisplay: string, createdBy?: { __typename?: 'UserType', id: string, uuid: string, email: string, firstName: string, lastName: string, displayName: string, isActive: boolean, isStaff: boolean, dateJoined: string, lastLogin?: string, language: string, emailNotifications: boolean, inAppNotifications: boolean, termsAndConditionsAcceptedAt?: string } }, errors: Array<{ __typename?: 'ErrorType', field: string, messages: Array<string> }> } };

export type ApproveWarrantyClaimMutationVariables = Exact<{
  input: ApproveWarrantyClaimRequestMutationInput;
}>;


export type ApproveWarrantyClaimMutation = { __typename?: 'Mutation', approveWarrantyClaim?: { __typename?: 'ApproveWarrantyClaimRequestMutationPayload', warrantyClaimReview?: { __typename?: 'WarrantyClaimReviewType', id: string, created: string, notes: string, statusDisplay: string, status: WarrantyClaimsWarrantyClaimReviewStatusChoices, approvalType?: WarrantyClaimsWarrantyClaimReviewApprovalTypeChoices, approvalTypeDisplay: string, createdBy?: { __typename?: 'UserType', id: string, uuid: string, email: string, firstName: string, lastName: string, displayName: string, isActive: boolean, isStaff: boolean, dateJoined: string, lastLogin?: string, language: string, emailNotifications: boolean, inAppNotifications: boolean, termsAndConditionsAcceptedAt?: string } }, errors: Array<{ __typename?: 'ErrorType', field: string, messages: Array<string> }> } };

export type CreateShipmentWarrantyClaimMutationVariables = Exact<{
  input: CreateShipmentWarrantyClaimMutationInput;
}>;


export type CreateShipmentWarrantyClaimMutation = { __typename?: 'Mutation', createShipmentWarrantyClaim?: { __typename?: 'CreateShipmentWarrantyClaimMutationPayload', warrantyClaim?: { __typename?: 'WarrantyClaimNode', id: string, uuid: string, invoiceDate?: string, failureDate?: string, serialNumber?: string, created: string, quantity: number, description: string, finalClient: string, phone: string, externalId?: string, displayId: number, orderId?: number, warrantyClaimType: WarrantyClaimsWarrantyClaimWarrantyClaimTypeChoices, displayWarrantyClaimType: string, applyForCredit: boolean, rmaCode?: string, amount?: string, state: WarrantyClaimsWarrantyClaimStateChoices, stateDisplay: string, requiredApprovalType?: string, requiresSpecialApproval: boolean, requiresInspectionReview: boolean, hasCompletedInspectionReview: boolean, canCurrentUserApprove: boolean, requiredApprovalsList: Array<WarrantyClaimsWarrantyClaimReviewApprovalTypeChoices>, missingApprovals: Array<WarrantyClaimsWarrantyClaimReviewApprovalTypeChoices>, isFullyApproved: boolean, isInFinalState: boolean, inspectionReview?: { __typename?: 'WarrantyClaimInspectionReviewType', statusDisplay: string, status: WarrantyClaimsWarrantyClaimInspectionReviewStatusChoices, inWarranty: boolean, id: string, created: string, updated: string, received: boolean, receivedDate?: string, inspected: boolean, inspectedDate?: string, failureDescription: string, createdBy?: { __typename?: 'UserType', id: string, uuid: string, email: string, firstName: string, lastName: string, displayName: string, isActive: boolean, isStaff: boolean, dateJoined: string, lastLogin?: string, language: string, emailNotifications: boolean, inAppNotifications: boolean, termsAndConditionsAcceptedAt?: string }, updatedBy?: { __typename?: 'UserType', id: string, uuid: string, email: string, firstName: string, lastName: string, displayName: string, isActive: boolean, isStaff: boolean, dateJoined: string, lastLogin?: string, language: string, emailNotifications: boolean, inAppNotifications: boolean, termsAndConditionsAcceptedAt?: string }, warrantyClaim: { __typename?: 'WarrantyClaimNode', id: string }, files: Array<{ __typename?: 'WarrantyClaimInspectionFileType', id: string, file?: string }> }, seeder?: { __typename?: 'SeederType', id: string, uuid: string, displayName: string, year?: number, rowCount: number, meterType: SeedersSeederMeterTypeChoices, account: { __typename?: 'AccountType', id: string, uuid: string, name: string }, brand: { __typename?: 'SeederBrandType', id: string }, model?: { __typename?: 'SeederModelType', id: string }, installedCategories: Array<{ __typename?: 'CategoryType', id: string, uuid: string }> }, images: Array<{ __typename?: 'WarrantyClaimImageType', id: string, file: string, warrantyClaim: { __typename?: 'WarrantyClaimNode', id: string } }>, videos: Array<{ __typename?: 'WarrantyClaimVideoType', id: string, file: string, warrantyClaim: { __typename?: 'WarrantyClaimNode', id: string } }>, reviews: Array<{ __typename?: 'WarrantyClaimReviewType', id: string, created: string, notes: string, statusDisplay: string, status: WarrantyClaimsWarrantyClaimReviewStatusChoices, approvalType?: WarrantyClaimsWarrantyClaimReviewApprovalTypeChoices, approvalTypeDisplay: string, createdBy?: { __typename?: 'UserType', id: string, uuid: string, email: string, firstName: string, lastName: string, displayName: string, isActive: boolean, isStaff: boolean, dateJoined: string, lastLogin?: string, language: string, emailNotifications: boolean, inAppNotifications: boolean, termsAndConditionsAcceptedAt?: string } }>, product?: { __typename?: 'WarrantyProductType', id: string, quantity: number, externalId: string, name: string, displayName: string, price: string, order: number, description: string, rowCount: number, originalProduct?: { __typename?: 'ProductNode', id: string, uuid: string, image?: string }, subcategory?: { __typename?: 'SubcategoryType', id: string, name: string, category: { __typename?: 'CategoryType', id: string, uuid: string, name: string } } }, contact: { __typename?: 'ContactType', id: string, uuid: string, externalId: string, email?: string, firstName: string, lastName: string, displayName: string, phone: string, mobilePhone: string, active: boolean, type: { __typename?: 'ContactTypeType', id: string, name: string }, account: { __typename?: 'AccountType', id: string, uuid: string, name: string, taxId?: string, externalId: string, isFavorite: boolean, address?: string, location?: { __typename?: 'LocationType', id: string, path?: string, iva: Decimal }, owner?: { __typename?: 'OrganizationType', id: string, name: string, externalId: string, isEu: boolean, displayName: string, logo?: string, logoThumbnail?: string, location?: { __typename?: 'LocationType', id: string, name: string, path?: string, iva: Decimal }, group: { __typename?: 'OrganizationGroupType', id: string, dealerCommission?: string } } } }, createdBy?: { __typename?: 'UserType', id: string, uuid: string, email: string, firstName: string, lastName: string, displayName: string, isActive: boolean, isStaff: boolean, dateJoined: string, lastLogin?: string, language: string, emailNotifications: boolean, inAppNotifications: boolean, termsAndConditionsAcceptedAt?: string }, lastReview?: { __typename?: 'WarrantyClaimReviewType', id: string, created: string, notes: string, statusDisplay: string, status: WarrantyClaimsWarrantyClaimReviewStatusChoices, approvalType?: WarrantyClaimsWarrantyClaimReviewApprovalTypeChoices, approvalTypeDisplay: string, createdBy?: { __typename?: 'UserType', id: string, uuid: string, email: string, firstName: string, lastName: string, displayName: string, isActive: boolean, isStaff: boolean, dateJoined: string, lastLogin?: string, language: string, emailNotifications: boolean, inAppNotifications: boolean, termsAndConditionsAcceptedAt?: string } }, supplyOrder?: { __typename?: 'SupplyOrderNode', id: string, uuid: string, displayId: number, displayIdWithPrefix: string } }, errors: Array<{ __typename?: 'ErrorType', field: string, messages: Array<string> }> } };

export type CancelWarrantyClaimMutationVariables = Exact<{
  input: CancelWarrantyClaimRequestMutationInput;
}>;


export type CancelWarrantyClaimMutation = { __typename?: 'Mutation', cancelWarrantyClaim?: { __typename?: 'CancelWarrantyClaimRequestMutationPayload', warrantyClaimReview?: { __typename?: 'WarrantyClaimReviewType', id: string, created: string, notes: string, statusDisplay: string, status: WarrantyClaimsWarrantyClaimReviewStatusChoices, approvalType?: WarrantyClaimsWarrantyClaimReviewApprovalTypeChoices, approvalTypeDisplay: string, createdBy?: { __typename?: 'UserType', id: string, uuid: string, email: string, firstName: string, lastName: string, displayName: string, isActive: boolean, isStaff: boolean, dateJoined: string, lastLogin?: string, language: string, emailNotifications: boolean, inAppNotifications: boolean, termsAndConditionsAcceptedAt?: string } }, errors: Array<{ __typename?: 'ErrorType', field: string, messages: Array<string> }> } };

export type CloseWarrantyClaimWithRmaMutationVariables = Exact<{
  input: CloseWarrantyClaimWithRmaMutationInput;
}>;


export type CloseWarrantyClaimWithRmaMutation = { __typename?: 'Mutation', closeWarrantyClaimWithRma?: { __typename?: 'CloseWarrantyClaimWithRMAMutationPayload', warrantyClaimReview?: { __typename?: 'WarrantyClaimReviewType', id: string, created: string, notes: string, statusDisplay: string, status: WarrantyClaimsWarrantyClaimReviewStatusChoices, approvalType?: WarrantyClaimsWarrantyClaimReviewApprovalTypeChoices, approvalTypeDisplay: string, createdBy?: { __typename?: 'UserType', id: string, uuid: string, email: string, firstName: string, lastName: string, displayName: string, isActive: boolean, isStaff: boolean, dateJoined: string, lastLogin?: string, language: string, emailNotifications: boolean, inAppNotifications: boolean, termsAndConditionsAcceptedAt?: string } }, errors: Array<{ __typename?: 'ErrorType', field: string, messages: Array<string> }> } };

export type ExportExcelWarrantyClaimsMutationVariables = Exact<{
  orderBy?: InputMaybe<Scalars['String']['input']>;
  accountGlobalID?: InputMaybe<Scalars['UUID']['input']>;
  owner?: InputMaybe<Scalars['UUID']['input']>;
  createdBy?: InputMaybe<Scalars['UUID']['input']>;
  createdGte?: InputMaybe<Scalars['Date']['input']>;
  createdLte?: InputMaybe<Scalars['Date']['input']>;
  created?: InputMaybe<Scalars['Date']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  inspectionReviewStatus?: InputMaybe<Scalars['String']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  warrantyClaimId?: InputMaybe<Scalars['UUID']['input']>;
}>;


export type ExportExcelWarrantyClaimsMutation = { __typename?: 'Mutation', exportExcelWarrantyClaims?: { __typename?: 'ExportExcelWarrantyClaims', job?: { __typename?: 'ExportJobType', id: string }, errors?: Array<{ __typename?: 'ErrorType', field: string, messages: Array<string> }> } };

export const SalesPotentialAnalyticsFragmentDoc = gql`
    fragment SalesPotentialAnalytics on SalesPotentialAnalyticsType {
  rowsCount
  seedersCount
  bySeederBrand {
    label
    count
    percentage
  }
  byMeterType {
    label
    count
    percentage
  }
  byCategory {
    label
    count
    percentage
  }
}
    `;
export const LocationOptionFragmentDoc = gql`
    fragment LocationOption on LocationType {
  id
  path
  iva
}
    `;
export const OrganizationGroupFragmentDoc = gql`
    fragment OrganizationGroup on OrganizationGroupType {
  id
  dealerCommission
}
    `;
export const OrganizationFragmentDoc = gql`
    fragment Organization on OrganizationType {
  id
  name
  externalId
  isEu
  displayName
  location {
    id
    name
    path
    iva
  }
  group {
    ...OrganizationGroup
  }
  logo
  logoThumbnail
}
    ${OrganizationGroupFragmentDoc}`;
export const AccountFragmentDoc = gql`
    fragment Account on AccountNode {
  id
  uuid
  name
  taxId
  externalId
  isFavorite
  address
  location {
    ...LocationOption
  }
  owner {
    ...Organization
  }
}
    ${LocationOptionFragmentDoc}
${OrganizationFragmentDoc}`;
export const AccountOptionFragmentDoc = gql`
    fragment AccountOption on AccountNode {
  id
  uuid
  name
  externalId
  location {
    ...LocationOption
  }
  owner {
    isEu
    id
  }
}
    ${LocationOptionFragmentDoc}`;
export const AccountListFragmentDoc = gql`
    fragment AccountList on AccountNode {
  taxId
  id
  uuid
  name
  externalId
  isFavorite
  location {
    id
    path
  }
  owner {
    id
    name
  }
}
    `;
export const DateSeriesFragmentDoc = gql`
    fragment DateSeries on DateSeriesDatum {
  date
  count
  amount
}
    `;
export const AmountDatumFragmentDoc = gql`
    fragment AmountDatum on AmountDatum {
  label
  count
  amount
  percentage
}
    `;
export const ProductRankingDatumFragmentDoc = gql`
    fragment ProductRankingDatum on ProductRankingDatum {
  count
  amount
  ranking
  product {
    displayName
    subcategory {
      name
      category {
        name
      }
    }
  }
}
    `;
export const WarrantyProductRankingDatumFragmentDoc = gql`
    fragment WarrantyProductRankingDatum on WarrantyProductRankingDatum {
  count
  amount
  ranking
  product {
    displayName
    subcategory {
      name
      category {
        name
      }
    }
  }
}
    `;
export const ContactTypeOptionFragmentDoc = gql`
    fragment ContactTypeOption on ContactTypeType {
  id
  name
}
    `;
export const AccountTypeFragmentDoc = gql`
    fragment AccountType on AccountType {
  id
  uuid
  name
  taxId
  externalId
  isFavorite
  address
  location {
    ...LocationOption
  }
  owner {
    ...Organization
  }
}
    ${LocationOptionFragmentDoc}
${OrganizationFragmentDoc}`;
export const ContactFragmentDoc = gql`
    fragment Contact on ContactNode {
  id
  uuid
  externalId
  email
  firstName
  lastName
  displayName
  phone
  mobilePhone
  active
  type {
    ...ContactTypeOption
  }
  account {
    ...AccountType
  }
}
    ${ContactTypeOptionFragmentDoc}
${AccountTypeFragmentDoc}`;
export const ContactListFragmentDoc = gql`
    fragment ContactList on ContactNode {
  uuid
  id
  email
  lastName
  firstName
  account {
    id
    uuid
    name
    owner {
      id
      name
    }
  }
  mobilePhone
  phone
  type {
    id
    name
  }
}
    `;
export const FeatureFlagFragmentDoc = gql`
    fragment FeatureFlag on FeatureFlagType {
  id
  name
  description
  isActive
  userHasAccess
}
    `;
export const NotificationFragmentDoc = gql`
    fragment Notification on NotificationNode {
  id
  uuid
  message
  path
  isRead
  created
  updated
  user {
    id
  }
}
    `;
export const ErrorFragmentDoc = gql`
    fragment Error on ErrorType {
  field
  messages
}
    `;
export const MinimalUserTypeFragmentDoc = gql`
    fragment MinimalUserType on UserType {
  id
  uuid
  email
  firstName
  lastName
  displayName
  isActive
  isStaff
  dateJoined
  lastLogin
  language
  emailNotifications
  inAppNotifications
  termsAndConditionsAcceptedAt
}
    `;
export const DraftBlueprintEcnFragmentDoc = gql`
    fragment DraftBlueprintEcn on DraftBlueprintEcnType {
  id
  file
}
    `;
export const DraftEcnFragmentDoc = gql`
    fragment DraftEcn on DraftEcnNode {
  id
  uuid
  step
  data
  created
  createdBy {
    ...MinimalUserType
  }
  updatedBy {
    ...MinimalUserType
  }
  updated
  blueprints {
    ...DraftBlueprintEcn
  }
}
    ${MinimalUserTypeFragmentDoc}
${DraftBlueprintEcnFragmentDoc}`;
export const DraftEcnListFragmentDoc = gql`
    fragment DraftEcnList on DraftEcnNode {
  ...DraftEcn
  ecnNumberDuplicated
}
    ${DraftEcnFragmentDoc}`;
export const DefaultEcnTaskFragmentDoc = gql`
    fragment DefaultEcnTask on DefaultTaskType {
  id
  name
  displayName
  description
  roles {
    id
    name
  }
  ecnTypes
}
    `;
export const EcnTaskFragmentDoc = gql`
    fragment EcnTask on EcnTaskType {
  id
  originalTask {
    id
  }
  notes
  name
  displayName
  roles {
    id
    name
  }
  done
  doneBy {
    ...MinimalUserType
  }
  ecnTypes
}
    ${MinimalUserTypeFragmentDoc}`;
export const ProductSubcategoryOptionFragmentDoc = gql`
    fragment ProductSubcategoryOption on SubcategoryType {
  id
  name
}
    `;
export const ProductOriginOptionFragmentDoc = gql`
    fragment ProductOriginOption on ProductOriginType {
  id
  name
}
    `;
export const EcnNewPartFragmentDoc = gql`
    fragment EcnNewPart on EcnNewPartType {
  id
  name
  externalId
  subcategory {
    ...ProductSubcategoryOption
  }
  type
  displayType
  pricing
  yearlyForecast
  betaQuantity
  buyingDate
  estimatedDateArrival
  buyingPrice
  supplier
  origin {
    ...ProductOriginOption
  }
  description
  supportNotes
  supportLink
  tariffPosition
  tariffPositionNotes
  partsArrived
}
    ${ProductSubcategoryOptionFragmentDoc}
${ProductOriginOptionFragmentDoc}`;
export const ProductOptionFragmentDoc = gql`
    fragment ProductOption on ProductNode {
  id
  name
  displayName
  displayType
  externalId
  subcategory {
    id
    name
    category {
      name
      id
    }
  }
}
    `;
export const EcnCancelledPartFragmentDoc = gql`
    fragment EcnCancelledPart on EcnCancelledPartType {
  id
  part {
    ...ProductOption
    type
    displayType
  }
  replace
  displayReplace
  currentVersion
  targetVersion
  description
  pricing
  yearlyForecast
  betaQuantity
  buyingDate
  estimatedDateArrival
  buyingPrice
  supplier
  origin {
    ...ProductOriginOption
  }
  supportNotes
  supportLink
  tariffPosition
  tariffPositionNotes
  partsArrived
}
    ${ProductOptionFragmentDoc}
${ProductOriginOptionFragmentDoc}`;
export const EcnPartFragmentDoc = gql`
    fragment EcnPart on EcnPartType {
  id
  externalId
  newParts {
    ...EcnNewPart
  }
  cancelledParts {
    ...EcnCancelledPart
  }
  type
  displayType
}
    ${EcnNewPartFragmentDoc}
${EcnCancelledPartFragmentDoc}`;
export const EcnFragmentDoc = gql`
    fragment Ecn on EcnNode {
  id
  uuid
  created
  effectiveDate
  previousEcnId
  nextEcnId
  createdBy {
    ...MinimalUserType
  }
  realesedBy {
    ...MinimalUserType
  }
  updated
  updatedBy {
    ...MinimalUserType
  }
  status
  displayStatus
  displayId
  ecnNumber
  notes
  recipient
  displayRecipient
  oems {
    id
    name
  }
  fyi {
    id
    name
  }
  informedUsers {
    id
    email
  }
  blueprints {
    id
    file
  }
  tasks {
    ...EcnTask
  }
  parts {
    ...EcnPart
  }
  viewed
  warrantyPriority
  seasonPriority
  displaySeasonPriority
  files {
    id
    created
    file
  }
}
    ${MinimalUserTypeFragmentDoc}
${EcnTaskFragmentDoc}
${EcnPartFragmentDoc}`;
export const MinimalUserFragmentDoc = gql`
    fragment MinimalUser on UserType {
  id
  email
  firstName
  lastName
  displayName
  isActive
  isStaff
  dateJoined
  lastLogin
  language
  emailNotifications
  inAppNotifications
  termsAndConditionsAcceptedAt
}
    `;
export const EcnListFragmentDoc = gql`
    fragment EcnList on EcnNode {
  uuid
  id
  displayId
  created
  effectiveDate
  createdBy {
    ...MinimalUserType
  }
  realesedBy {
    ...MinimalUserType
  }
  parts {
    id
    type
    displayType
    newParts {
      ...EcnNewPart
    }
    cancelledParts {
      ...EcnCancelledPart
    }
  }
  status
  displayStatus
  fyi {
    id
    name
  }
  tasks {
    id
    done
    name
    displayName
    users {
      ...MinimalUser
    }
  }
  totalInformedUsers
  totalNotInformedUsers
  ecnNumber
  viewed
  warrantyPriority
  seasonPriority
  displaySeasonPriority
}
    ${MinimalUserTypeFragmentDoc}
${EcnNewPartFragmentDoc}
${EcnCancelledPartFragmentDoc}
${MinimalUserFragmentDoc}`;
export const HistoricalEcnFragmentDoc = gql`
    fragment HistoricalEcn on HistoricalEcnType {
  created
  updated
  id
  status
  displayId
  ecnNumber
  notes
  recipient
  warrantyPriority
  seasonPriority
  effectiveDate
  historyId
  historyDate
  historyChangeReason
  historyTypeDisplay
}
    `;
export const EcnTaskCommentFragmentDoc = gql`
    fragment EcnTaskComment on EcnTaskCommentNode {
  id
  uuid
  created
  createdBy {
    ...MinimalUserType
  }
  task {
    id
  }
  content
}
    ${MinimalUserTypeFragmentDoc}`;
export const PaymentMethodFragmentDoc = gql`
    fragment PaymentMethod on PaymentMethodType {
  id
  name
  order
  multiplier
  slug
  paymentmethodcategorySet {
    finnancied
  }
}
    `;
export const PaymentMethodOptionFragmentDoc = gql`
    fragment PaymentMethodOption on PaymentMethodType {
  id
  name
}
    `;
export const PaymentMethodCategoryFragmentDoc = gql`
    fragment PaymentMethodCategory on PaymentMethodCategoryType {
  id
  name
  finnancied
  paymentMethods {
    id
    name
  }
}
    `;
export const CategoryOptionFragmentDoc = gql`
    fragment CategoryOption on CategoryNode {
  id
  uuid
  name
}
    `;
export const CategoryFragmentDoc = gql`
    fragment Category on CategoryNode {
  ...CategoryOption
  enabledForAssistedQuote
}
    ${CategoryOptionFragmentDoc}`;
export const SubcategoryFragmentDoc = gql`
    fragment Subcategory on SubcategoryType {
  id
  name
  category {
    id
    uuid
    name
  }
}
    `;
export const RuleGroupFragmentDoc = gql`
    fragment RuleGroup on RuleGroupType {
  id
  name
}
    `;
export const CategoryOptionTypeFragmentDoc = gql`
    fragment CategoryOptionType on CategoryType {
  id
  uuid
  name
}
    `;
export const CategoryTypeFragmentDoc = gql`
    fragment CategoryType on CategoryType {
  ...CategoryOptionType
  enabledForAssistedQuote
}
    ${CategoryOptionTypeFragmentDoc}`;
export const ProductFragmentDoc = gql`
    fragment Product on ProductNode {
  id
  uuid
  displayType
  externalId
  name
  type
  displayType
  displayName
  price
  rowCount
  subcategory {
    ...Subcategory
  }
  ruleGroup {
    ...RuleGroup
  }
  ruleGroups {
    ...RuleGroup
  }
  ruleCategories {
    ...CategoryType
  }
  order
  description
  published
}
    ${SubcategoryFragmentDoc}
${RuleGroupFragmentDoc}
${CategoryTypeFragmentDoc}`;
export const ProductPriceModifiersFragmentDoc = gql`
    fragment ProductPriceModifiers on ProductPriceModifierType {
  id
  billingType
  enableDiscount
  commissionMultiplier
  productExternalIds
}
    `;
export const QuoteRuleFragmentDoc = gql`
    fragment QuoteRule on QuoteRuleType {
  id
  product {
    id
    uuid
    externalId
  }
  productCategory {
    id
    uuid
    name
  }
  group {
    ...RuleGroup
  }
  valueSource
  image
  referenceSource
  referenceMultiplier
  operator
  description
  errorMessage
  useForValidation
  useForInitialValue
  prioritizeRule
}
    ${RuleGroupFragmentDoc}`;
export const QuotedProductPayloadFragmentDoc = gql`
    fragment QuotedProductPayload on ProductNode {
  id
  uuid
  externalId
  name
  price
  rowCount
  subcategory {
    id
  }
  ruleGroup {
    id
  }
  ruleGroups {
    id
  }
  ruleCategories {
    uuid
    id
  }
  order
  description
}
    `;
export const ProductEffectiveDateFragmentDoc = gql`
    fragment ProductEffectiveDate on ProductNode {
  id
  uuid
  externalId
  isEffective
}
    `;
export const PageInfoFragmentDoc = gql`
    fragment PageInfo on PageInfo {
  hasNextPage
  hasPreviousPage
  startCursor
  endCursor
}
    `;
export const MinimalQuotedProductFragmentDoc = gql`
    fragment MinimalQuotedProduct on QuotedProductType {
  price
  quantity
  enableDiscount
  commissionMultiplier
  externalId
  bundleName
  bundleMultiplier
  bundleQuantity
}
    `;
export const QuotedProductFragmentDoc = gql`
    fragment QuotedProduct on QuotedProductType {
  ...MinimalQuotedProduct
  id
  bundle {
    id
  }
  name
  order
  rowCount
  externalId
  description
  subcategoryName
  categoryName
  origin {
    ...ProductOriginOption
  }
  subcategory {
    ...Subcategory
  }
  ruleGroup {
    ...RuleGroup
  }
  ruleCategories {
    ...CategoryType
  }
}
    ${MinimalQuotedProductFragmentDoc}
${ProductOriginOptionFragmentDoc}
${SubcategoryFragmentDoc}
${RuleGroupFragmentDoc}
${CategoryTypeFragmentDoc}`;
export const WarrantyProductFragmentDoc = gql`
    fragment WarrantyProduct on WarrantyProductType {
  originalProduct {
    id
    uuid
    image
  }
  id
  quantity
  externalId
  name
  displayName
  price
  order
  description
  rowCount
  subcategory {
    ...Subcategory
  }
}
    ${SubcategoryFragmentDoc}`;
export const OrderedProductFragmentDoc = gql`
    fragment OrderedProduct on OrderedProductType {
  id
  quantity
  quantityLeft
  quotedProduct {
    ...QuotedProduct
  }
  warrantyProduct {
    ...WarrantyProduct
  }
}
    ${QuotedProductFragmentDoc}
${WarrantyProductFragmentDoc}`;
export const SupplyOrderQuoteDetailFragmentDoc = gql`
    fragment SupplyOrderQuoteDetail on SupplyOrderNode {
  id
  uuid
  displayId
  created
  statusDisplay
  status
  orderedProducts {
    ...OrderedProduct
  }
}
    ${OrderedProductFragmentDoc}`;
export const MinimalQuotedPaymentMethodFragmentDoc = gql`
    fragment MinimalQuotedPaymentMethod on QuotedPaymentMethodType {
  name
  multiplier
  extraMultiplier
  slug
  finnancied
}
    `;
export const QuotedPaymentMethodFragmentDoc = gql`
    fragment QuotedPaymentMethod on QuotedPaymentMethodType {
  ...MinimalQuotedPaymentMethod
  id
  order
  isCustom
  dealerCommission
  originalPaymentMethod {
    id
  }
}
    ${MinimalQuotedPaymentMethodFragmentDoc}`;
export const QuoteSaleFragmentDoc = gql`
    fragment QuoteSale on QuoteNode {
  id
  uuid
  displayId
  sale {
    id
  }
  closeReason {
    id
  }
  paymentMethods {
    ...QuotedPaymentMethod
  }
  products {
    ...QuotedProduct
  }
}
    ${QuotedPaymentMethodFragmentDoc}
${QuotedProductFragmentDoc}`;
export const QuoteEditFragmentDoc = gql`
    fragment QuoteEdit on QuoteNode {
  id
  uuid
  billingType
  displayId
  additionalChargesValue
  additionalChargesDescription
  kitMultiplier {
    id
  }
  rowCount
  seeder {
    id
    uuid
  }
  notes
  contact {
    id
    uuid
    account {
      id
      uuid
    }
  }
  products {
    ...QuotedProduct
  }
  paymentMethods {
    ...QuotedPaymentMethod
  }
  created
  createdBy {
    ...MinimalUserType
  }
  updated
  updatedBy {
    ...MinimalUserType
  }
}
    ${QuotedProductFragmentDoc}
${QuotedPaymentMethodFragmentDoc}
${MinimalUserTypeFragmentDoc}`;
export const BankInvoicePdfDisclaimerFragmentDoc = gql`
    fragment BankInvoicePdfDisclaimer on BankInvoicePDFDisclaimerType {
  id
  legalName
  address
  taxId
  taxpayerType
  startOfActivities
  disclaimer
  bankAccountName
  bankAccountNumber
  routingTransitNumberChecks
  routingTransitNumberIncomingAch
  routingTransitNumberOutgoingAch
  routingTransitNumberWires
  bankSwiftCodeInternational
  bankAccountAddress
}
    `;
export const CloseReasonFragmentDoc = gql`
    fragment CloseReason on CloseReasonType {
  id
  description
}
    `;
export const MinimalQuoteFragmentDoc = gql`
    fragment MinimalQuote on QuoteNode {
  id
  uuid
  displayName
  displayId
  status
  statusDisplay
}
    `;
export const QuoteKitMultiplierFragmentDoc = gql`
    fragment QuoteKitMultiplier on QuoteKitMultiplierType {
  id
  name
  multiplier
}
    `;
export const SeederTypeFragmentDoc = gql`
    fragment SeederType on SeederType {
  id
  uuid
  account {
    id
    uuid
    name
  }
  brand {
    id
  }
  model {
    id
  }
  displayName
  year
  rowCount
  meterType
  installedCategories {
    id
    uuid
  }
}
    `;
export const ContactTypeFragmentDoc = gql`
    fragment ContactType on ContactType {
  id
  uuid
  externalId
  email
  firstName
  lastName
  displayName
  phone
  mobilePhone
  active
  type {
    ...ContactTypeOption
  }
  account {
    ...AccountType
  }
}
    ${ContactTypeOptionFragmentDoc}
${AccountTypeFragmentDoc}`;
export const MinimalSaleFragmentDoc = gql`
    fragment MinimalSale on SaleNode {
  id
  uuid
  paymentMethod {
    ...QuotedPaymentMethod
  }
}
    ${QuotedPaymentMethodFragmentDoc}`;
export const QuoteCloseReasonFragmentDoc = gql`
    fragment QuoteCloseReason on QuoteCloseReasonType {
  id
  description
  quote {
    id
  }
}
    `;
export const QuotePdfFragmentDoc = gql`
    fragment QuotePdf on QuotePDFType {
  id
  file
  type
  paymentMethod {
    ...QuotedPaymentMethod
  }
  recipient
  typeDisplay
  emailStatus
  created
  createdBy {
    ...MinimalUserType
  }
}
    ${QuotedPaymentMethodFragmentDoc}
${MinimalUserTypeFragmentDoc}`;
export const QuoteFragmentDoc = gql`
    fragment Quote on QuoteNode {
  ...MinimalQuote
  additionalChargesValue
  additionalChargesDescription
  billingType
  displayBillingType
  rowCount
  notes
  kitMultiplier {
    ...QuoteKitMultiplier
  }
  seeder {
    ...SeederType
  }
  products {
    ...QuotedProduct
  }
  paymentMethods {
    ...QuotedPaymentMethod
  }
  contact {
    ...ContactType
  }
  sale {
    ...MinimalSale
  }
  created
  createdBy {
    ...MinimalUserType
  }
  closeReason {
    ...QuoteCloseReason
  }
  supplyOrder {
    id
    uuid
  }
  pdfs {
    ...QuotePdf
  }
  supplyOrder {
    id
    uuid
    displayId
    created
    statusDisplay
    status
    charter
    orderedProducts {
      ...OrderedProduct
    }
  }
}
    ${MinimalQuoteFragmentDoc}
${QuoteKitMultiplierFragmentDoc}
${SeederTypeFragmentDoc}
${QuotedProductFragmentDoc}
${QuotedPaymentMethodFragmentDoc}
${ContactTypeFragmentDoc}
${MinimalSaleFragmentDoc}
${MinimalUserTypeFragmentDoc}
${QuoteCloseReasonFragmentDoc}
${QuotePdfFragmentDoc}
${OrderedProductFragmentDoc}`;
export const SaleFragmentDoc = gql`
    fragment Sale on SaleNode {
  id
  uuid
  created
  createdBy {
    ...MinimalUserType
  }
  quote {
    ...Quote
  }
  paymentMethod {
    ...QuotedPaymentMethod
  }
}
    ${MinimalUserTypeFragmentDoc}
${QuoteFragmentDoc}
${QuotedPaymentMethodFragmentDoc}`;
export const QuoteListFragmentDoc = gql`
    fragment QuoteList on QuoteNode {
  uuid
  id
  created
  status
  displayId
  statusDisplay
  contact {
    id
    uuid
    email
    displayName
    account {
      id
      uuid
      name
      owner {
        id
        name
      }
    }
  }
  seeder {
    displayName
    brand {
      name
    }
  }
  createdBy {
    displayName
    email
  }
  closeReason {
    id
  }
  paymentMethods {
    ...QuotedPaymentMethod
  }
  kitMultiplier {
    multiplier
  }
  rowCount
  products {
    ...QuotedProduct
  }
}
    ${QuotedPaymentMethodFragmentDoc}
${QuotedProductFragmentDoc}`;
export const SaleListFragmentDoc = gql`
    fragment SaleList on SaleNode {
  id
  uuid
  created
  createdBy {
    displayName
  }
  quote {
    ...QuoteList
  }
  paymentMethod {
    ...QuotedPaymentMethod
  }
}
    ${QuoteListFragmentDoc}
${QuotedPaymentMethodFragmentDoc}`;
export const SeederFragmentDoc = gql`
    fragment Seeder on SeederNode {
  id
  uuid
  account {
    id
    uuid
    name
  }
  brand {
    id
  }
  model {
    id
  }
  displayName
  year
  rowCount
  meterType
  installedCategories {
    id
    uuid
  }
}
    `;
export const SeederOptionFragmentDoc = gql`
    fragment SeederOption on SeederNode {
  id
  uuid
  displayName
  rowCount
}
    `;
export const SeederListFragmentDoc = gql`
    fragment SeederList on SeederNode {
  id
  uuid
  account {
    id
    uuid
    name
  }
  brand {
    id
    name
  }
  model {
    id
    name
  }
  displayName
  year
  rowCount
  meterType
  meterTypeDisplay
  installedCategories {
    id
    uuid
    name
  }
}
    `;
export const SeederOptionTypeFragmentDoc = gql`
    fragment SeederOptionType on SeederType {
  uuid
  displayName
  rowCount
  id
}
    `;
export const WarrantyClaimReviewFragmentDoc = gql`
    fragment WarrantyClaimReview on WarrantyClaimReviewType {
  id
  created
  createdBy {
    ...MinimalUserType
  }
  notes
  statusDisplay
  status
  approvalType
  approvalTypeDisplay
}
    ${MinimalUserTypeFragmentDoc}`;
export const WarrantyClaimListFragmentDoc = gql`
    fragment WarrantyClaimList on WarrantyClaimNode {
  id
  uuid
  invoiceDate
  failureDate
  serialNumber
  created
  quantity
  description
  finalClient
  phone
  externalId
  displayId
  orderId
  warrantyClaimType
  displayWarrantyClaimType
  applyForCredit
  rmaCode
  amount
  state
  stateDisplay
  requiredApprovalType
  requiresSpecialApproval
  requiresInspectionReview
  hasCompletedInspectionReview
  canCurrentUserApprove
  requiredApprovalsList
  missingApprovals
  isFullyApproved
  isInFinalState
  product {
    ...WarrantyProduct
  }
  contact {
    ...ContactType
  }
  createdBy {
    ...MinimalUserType
  }
  seeder {
    ...SeederOptionType
  }
  lastReview {
    ...WarrantyClaimReview
  }
  inspectionReview {
    statusDisplay
    status
    inWarranty
  }
  supplyOrder {
    id
    uuid
    displayId
    displayIdWithPrefix
  }
}
    ${WarrantyProductFragmentDoc}
${ContactTypeFragmentDoc}
${MinimalUserTypeFragmentDoc}
${SeederOptionTypeFragmentDoc}
${WarrantyClaimReviewFragmentDoc}`;
export const MinimalSupplyOrderFragmentDoc = gql`
    fragment MinimalSupplyOrder on SupplyOrderNode {
  id
  uuid
  displayName
  externalDealerId
  isUrgent
}
    `;
export const ShipmentProductFragmentDoc = gql`
    fragment ShipmentProduct on ShipmentProductType {
  id
  supplyOrder {
    id
  }
  shipment {
    id
  }
  quantity
  orderedProduct {
    ...OrderedProduct
  }
  batch
}
    ${OrderedProductFragmentDoc}`;
export const ShipmentFragmentDoc = gql`
    fragment Shipment on ShipmentType {
  id
  externalId
  invoice
  supplyOrder {
    ...MinimalSupplyOrder
  }
  productsShipped {
    ...ShipmentProduct
  }
  created
  createdBy {
    ...MinimalUserType
  }
  status
  statusDisplay
}
    ${MinimalSupplyOrderFragmentDoc}
${ShipmentProductFragmentDoc}
${MinimalUserTypeFragmentDoc}`;
export const SupplyOrderFragmentDoc = gql`
    fragment SupplyOrder on SupplyOrderNode {
  id
  uuid
  displayId
  displayIdWithPrefix
  charter
  charterDisplay
  externalDealerId
  isUrgent
  internalOrder
  estimatedDispatchDate
  comment
  warrantyClaim {
    ...WarrantyClaimList
  }
  quote {
    ...Quote
  }
  orderedProducts {
    ...OrderedProduct
  }
  productsWithoutShipment {
    ...OrderedProduct
  }
  shipments {
    ...Shipment
  }
  salesCanReview
  status
  statusDisplay
  created
  createdBy {
    ...MinimalUserType
  }
  userNotification
}
    ${WarrantyClaimListFragmentDoc}
${QuoteFragmentDoc}
${OrderedProductFragmentDoc}
${ShipmentFragmentDoc}
${MinimalUserTypeFragmentDoc}`;
export const SupplyOrderReviewFragmentDoc = gql`
    fragment SupplyOrderReview on SupplyOrderReviewType {
  id
  statusDisplay
  typeDisplay
  notes
  created
  createdBy {
    ...MinimalUserType
  }
}
    ${MinimalUserTypeFragmentDoc}`;
export const SupplyOrderDetailFragmentDoc = gql`
    fragment SupplyOrderDetail on SupplyOrderNode {
  ...SupplyOrder
  reviewStart
  reviews {
    ...SupplyOrderReview
  }
  shipAddress {
    id
  }
  shipStreet
  shipLocation
  shipPostalCode
  updated
  updatedBy {
    ...MinimalUserType
  }
  isUrgent
}
    ${SupplyOrderFragmentDoc}
${SupplyOrderReviewFragmentDoc}
${MinimalUserTypeFragmentDoc}`;
export const SupplyOrderListFragmentDoc = gql`
    fragment SupplyOrderList on SupplyOrderNode {
  id
  uuid
  charter
  charterDisplay
  displayIdWithPrefix
  externalDealerId
  quantityShipped
  quote {
    id
    uuid
    contact {
      email
      account {
        name
        owner {
          name
        }
      }
    }
    seeder {
      displayName
    }
    rowCount
    sale {
      paymentMethod {
        multiplier
        extraMultiplier
        finnancied
      }
    }
    kitMultiplier {
      multiplier
    }
  }
  warrantyClaim {
    contact {
      account {
        name
        owner {
          name
        }
      }
    }
  }
  statusDisplay
  status
  orderedProducts {
    quantity
    quotedProduct {
      price
      quantity
      commissionMultiplier
      enableDiscount
      bundleName
      bundleMultiplier
      bundleQuantity
    }
  }
  created
  userNotification
  isUrgent
  estimatedDispatchDate
}
    `;
export const DownloadFragmentDoc = gql`
    fragment Download on DownloadType {
  contentType
  data
  filename
}
    `;
export const JobFragmentDoc = gql`
    fragment Job on JobType {
  id
  status
  result
}
    `;
export const RuntimeSettingsFragmentDoc = gql`
    fragment RuntimeSettings on RuntimeSettingsType {
  id
  quotePdfDisclaimer
  taxIdLabel
  signaturesInDisclaimer
  maxVideoSize
  datastudioUrl
  tinymceUrl
  featureTermsAndConditions
  termsAndConditions
  termsAndConditionsUpdatedAt
  gefcoTrackingUrl
  gefcoTrackingInstructions
  urgentOrderSurcharge
}
    `;
export const LocaleTranslationsFragmentDoc = gql`
    fragment LocaleTranslations on LocaleTranslationType {
  id
  locale
  extract
  json
}
    `;
export const OrganizationOptionFragmentDoc = gql`
    fragment OrganizationOption on OrganizationType {
  id
  name
}
    `;
export const MinimalUserNodeFragmentDoc = gql`
    fragment MinimalUserNode on UserNode {
  id
  uuid
  email
  firstName
  lastName
  displayName
  isActive
  isStaff
  dateJoined
  lastLogin
  language
  emailNotifications
  inAppNotifications
  termsAndConditionsAcceptedAt
}
    `;
export const RoleFragmentDoc = gql`
    fragment Role on RoleType {
  id
  name
}
    `;
export const PermissionsFragmentDoc = gql`
    fragment Permissions on UserPermissions {
  viewQuotes
  viewSales
  viewSupplyOrders
  viewAccounts
  viewContacts
  viewOpportunities
  viewAnalytics
  viewWarrantyClaims
  viewSeeders
  assignAccountOwner
  requestSupplyOrderReview
  submitSalesSupplyOrderReview
  submitCreditsSupplyOrderReview
  receiveSupplyOrderApprovedNotification
  viewWarrantyClaimsAnalytics
  manageQuotes
  manageSales
  manageSupplyOrders
  editApprovedSupplyOrders
  manageShipments
  manageWarrantyClaims
  performTechnicalReview
  manageAccounts
  viewDatastudio
  manageEcns
  viewEcns
  warrantyClaimsWarrantyAdminApprove
  warrantyClaimsManageApprove
  ticketSystemAccess
  viewStockForecast
  manageStockForecast
  configureMrpParameters
}
    `;
export const UserNodeFragmentDoc = gql`
    fragment UserNode on UserNode {
  ...MinimalUserNode
  uuid
  organization {
    ...Organization
  }
  role {
    ...Role
  }
  ecnRoles {
    id
  }
  permissions {
    ...Permissions
  }
  ecnRoles {
    id
  }
}
    ${MinimalUserNodeFragmentDoc}
${OrganizationFragmentDoc}
${RoleFragmentDoc}
${PermissionsFragmentDoc}`;
export const UserFragmentDoc = gql`
    fragment User on UserType {
  ...MinimalUser
  organization {
    ...Organization
  }
  role {
    ...Role
  }
  ecnRoles {
    id
  }
  permissions {
    ...Permissions
  }
  ecnRoles {
    id
  }
}
    ${MinimalUserFragmentDoc}
${OrganizationFragmentDoc}
${RoleFragmentDoc}
${PermissionsFragmentDoc}`;
export const NotificationConfigFragmentDoc = gql`
    fragment NotificationConfig on NotificationConfigType {
  id
  user {
    id
  }
  name
  inAppEnabled
  emailEnabled
  displayName
}
    `;
export const NotificationConfigNameFragmentDoc = gql`
    fragment NotificationConfigName on NotificationConfigNameType {
  value
  label
}
    `;
export const OrganizationAddressFragmentDoc = gql`
    fragment OrganizationAddress on OrganizationAddressType {
  id
  street
  postalCode
  location {
    name
  }
}
    `;
export const WarrantyClaimInspectionReviewFragmentDoc = gql`
    fragment WarrantyClaimInspectionReview on WarrantyClaimInspectionReviewType {
  id
  created
  createdBy {
    ...MinimalUserType
  }
  updated
  updatedBy {
    ...MinimalUserType
  }
  warrantyClaim {
    id
  }
  received
  receivedDate
  inspected
  inspectedDate
  failureDescription
  status
  statusDisplay
  inWarranty
  files {
    id
    file
  }
}
    ${MinimalUserTypeFragmentDoc}`;
export const WarrantyClaimImageFragmentDoc = gql`
    fragment WarrantyClaimImage on WarrantyClaimImageType {
  id
  file
  warrantyClaim {
    id
  }
}
    `;
export const WarrantyClaimVideoFragmentDoc = gql`
    fragment WarrantyClaimVideo on WarrantyClaimVideoType {
  id
  file
  warrantyClaim {
    id
  }
}
    `;
export const WarrantyClaimFragmentDoc = gql`
    fragment WarrantyClaim on WarrantyClaimNode {
  ...WarrantyClaimList
  inspectionReview {
    ...WarrantyClaimInspectionReview
  }
  seeder {
    ...SeederType
  }
  images {
    ...WarrantyClaimImage
  }
  videos {
    ...WarrantyClaimVideo
  }
  reviews {
    ...WarrantyClaimReview
  }
}
    ${WarrantyClaimListFragmentDoc}
${WarrantyClaimInspectionReviewFragmentDoc}
${SeederTypeFragmentDoc}
${WarrantyClaimImageFragmentDoc}
${WarrantyClaimVideoFragmentDoc}
${WarrantyClaimReviewFragmentDoc}`;
export const FailureFragmentDoc = gql`
    fragment Failure on FailureType {
  id
  description
  created
  updated
}
    `;
export const GetSalesPotentialAnalyticsDocument = gql`
    query getSalesPotentialAnalytics($filters: AnalyticsFilters!) {
  salesPotentialAnalytics(filters: $filters) {
    ...SalesPotentialAnalytics
  }
}
    ${SalesPotentialAnalyticsFragmentDoc}`;

/**
 * __useGetSalesPotentialAnalyticsQuery__
 *
 * To run a query within a React component, call `useGetSalesPotentialAnalyticsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSalesPotentialAnalyticsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSalesPotentialAnalyticsQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useGetSalesPotentialAnalyticsQuery(baseOptions: Apollo.QueryHookOptions<GetSalesPotentialAnalyticsQuery, GetSalesPotentialAnalyticsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSalesPotentialAnalyticsQuery, GetSalesPotentialAnalyticsQueryVariables>(GetSalesPotentialAnalyticsDocument, options);
      }
export function useGetSalesPotentialAnalyticsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSalesPotentialAnalyticsQuery, GetSalesPotentialAnalyticsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSalesPotentialAnalyticsQuery, GetSalesPotentialAnalyticsQueryVariables>(GetSalesPotentialAnalyticsDocument, options);
        }
export type GetSalesPotentialAnalyticsQueryHookResult = ReturnType<typeof useGetSalesPotentialAnalyticsQuery>;
export type GetSalesPotentialAnalyticsLazyQueryHookResult = ReturnType<typeof useGetSalesPotentialAnalyticsLazyQuery>;
export type GetSalesPotentialAnalyticsQueryResult = Apollo.QueryResult<GetSalesPotentialAnalyticsQuery, GetSalesPotentialAnalyticsQueryVariables>;
export function refetchGetSalesPotentialAnalyticsQuery(variables: GetSalesPotentialAnalyticsQueryVariables) {
      return { query: GetSalesPotentialAnalyticsDocument, variables: variables }
    }
export const CreateAccountDocument = gql`
    mutation createAccount($input: CreateAccountMutationInput!) {
  createAccount(input: $input) {
    account {
      id
      uuid
    }
    errors {
      ...Error
    }
  }
}
    ${ErrorFragmentDoc}`;
export type CreateAccountMutationFn = Apollo.MutationFunction<CreateAccountMutation, CreateAccountMutationVariables>;

/**
 * __useCreateAccountMutation__
 *
 * To run a mutation, you first call `useCreateAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAccountMutation, { data, loading, error }] = useCreateAccountMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateAccountMutation(baseOptions?: Apollo.MutationHookOptions<CreateAccountMutation, CreateAccountMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateAccountMutation, CreateAccountMutationVariables>(CreateAccountDocument, options);
      }
export type CreateAccountMutationHookResult = ReturnType<typeof useCreateAccountMutation>;
export type CreateAccountMutationResult = Apollo.MutationResult<CreateAccountMutation>;
export type CreateAccountMutationOptions = Apollo.BaseMutationOptions<CreateAccountMutation, CreateAccountMutationVariables>;
export const GetAccountUuidDocument = gql`
    query getAccountUuid($id: ID!) {
  account(id: $id) {
    id
    uuid
    name
  }
}
    `;

/**
 * __useGetAccountUuidQuery__
 *
 * To run a query within a React component, call `useGetAccountUuidQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAccountUuidQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAccountUuidQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetAccountUuidQuery(baseOptions: Apollo.QueryHookOptions<GetAccountUuidQuery, GetAccountUuidQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAccountUuidQuery, GetAccountUuidQueryVariables>(GetAccountUuidDocument, options);
      }
export function useGetAccountUuidLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAccountUuidQuery, GetAccountUuidQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAccountUuidQuery, GetAccountUuidQueryVariables>(GetAccountUuidDocument, options);
        }
export type GetAccountUuidQueryHookResult = ReturnType<typeof useGetAccountUuidQuery>;
export type GetAccountUuidLazyQueryHookResult = ReturnType<typeof useGetAccountUuidLazyQuery>;
export type GetAccountUuidQueryResult = Apollo.QueryResult<GetAccountUuidQuery, GetAccountUuidQueryVariables>;
export function refetchGetAccountUuidQuery(variables: GetAccountUuidQueryVariables) {
      return { query: GetAccountUuidDocument, variables: variables }
    }
export const GetAccountDocument = gql`
    query getAccount($id: ID!, $uuid: UUID) {
  account(id: $id, uuid: $uuid) {
    ...Account
  }
}
    ${AccountFragmentDoc}`;

/**
 * __useGetAccountQuery__
 *
 * To run a query within a React component, call `useGetAccountQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAccountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAccountQuery({
 *   variables: {
 *      id: // value for 'id'
 *      uuid: // value for 'uuid'
 *   },
 * });
 */
export function useGetAccountQuery(baseOptions: Apollo.QueryHookOptions<GetAccountQuery, GetAccountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAccountQuery, GetAccountQueryVariables>(GetAccountDocument, options);
      }
export function useGetAccountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAccountQuery, GetAccountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAccountQuery, GetAccountQueryVariables>(GetAccountDocument, options);
        }
export type GetAccountQueryHookResult = ReturnType<typeof useGetAccountQuery>;
export type GetAccountLazyQueryHookResult = ReturnType<typeof useGetAccountLazyQuery>;
export type GetAccountQueryResult = Apollo.QueryResult<GetAccountQuery, GetAccountQueryVariables>;
export function refetchGetAccountQuery(variables: GetAccountQueryVariables) {
      return { query: GetAccountDocument, variables: variables }
    }
export const GetAccountsDocument = gql`
    query getAccounts($first: Int, $offset: Int, $orderBy: String, $owner: UUID) {
  accounts(first: $first, offset: $offset, orderBy: $orderBy, owner_Id: $owner) {
    count
    edges {
      node {
        ...AccountList
      }
      cursor
    }
    pageInfo {
      ...PageInfo
    }
  }
}
    ${AccountListFragmentDoc}
${PageInfoFragmentDoc}`;

/**
 * __useGetAccountsQuery__
 *
 * To run a query within a React component, call `useGetAccountsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAccountsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAccountsQuery({
 *   variables: {
 *      first: // value for 'first'
 *      offset: // value for 'offset'
 *      orderBy: // value for 'orderBy'
 *      owner: // value for 'owner'
 *   },
 * });
 */
export function useGetAccountsQuery(baseOptions?: Apollo.QueryHookOptions<GetAccountsQuery, GetAccountsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAccountsQuery, GetAccountsQueryVariables>(GetAccountsDocument, options);
      }
export function useGetAccountsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAccountsQuery, GetAccountsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAccountsQuery, GetAccountsQueryVariables>(GetAccountsDocument, options);
        }
export type GetAccountsQueryHookResult = ReturnType<typeof useGetAccountsQuery>;
export type GetAccountsLazyQueryHookResult = ReturnType<typeof useGetAccountsLazyQuery>;
export type GetAccountsQueryResult = Apollo.QueryResult<GetAccountsQuery, GetAccountsQueryVariables>;
export function refetchGetAccountsQuery(variables?: GetAccountsQueryVariables) {
      return { query: GetAccountsDocument, variables: variables }
    }
export const UpdateAccountDocument = gql`
    mutation updateAccount($input: UpdateAccountMutationInput!) {
  updateAccount(input: $input) {
    account {
      id
    }
    errors {
      ...Error
    }
  }
}
    ${ErrorFragmentDoc}`;
export type UpdateAccountMutationFn = Apollo.MutationFunction<UpdateAccountMutation, UpdateAccountMutationVariables>;

/**
 * __useUpdateAccountMutation__
 *
 * To run a mutation, you first call `useUpdateAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAccountMutation, { data, loading, error }] = useUpdateAccountMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateAccountMutation(baseOptions?: Apollo.MutationHookOptions<UpdateAccountMutation, UpdateAccountMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateAccountMutation, UpdateAccountMutationVariables>(UpdateAccountDocument, options);
      }
export type UpdateAccountMutationHookResult = ReturnType<typeof useUpdateAccountMutation>;
export type UpdateAccountMutationResult = Apollo.MutationResult<UpdateAccountMutation>;
export type UpdateAccountMutationOptions = Apollo.BaseMutationOptions<UpdateAccountMutation, UpdateAccountMutationVariables>;
export const GetAccountOptionsDocument = gql`
    query getAccountOptions {
  accounts {
    edges {
      node {
        ...AccountOption
      }
      cursor
    }
    pageInfo {
      ...PageInfo
    }
  }
}
    ${AccountOptionFragmentDoc}
${PageInfoFragmentDoc}`;

/**
 * __useGetAccountOptionsQuery__
 *
 * To run a query within a React component, call `useGetAccountOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAccountOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAccountOptionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAccountOptionsQuery(baseOptions?: Apollo.QueryHookOptions<GetAccountOptionsQuery, GetAccountOptionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAccountOptionsQuery, GetAccountOptionsQueryVariables>(GetAccountOptionsDocument, options);
      }
export function useGetAccountOptionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAccountOptionsQuery, GetAccountOptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAccountOptionsQuery, GetAccountOptionsQueryVariables>(GetAccountOptionsDocument, options);
        }
export type GetAccountOptionsQueryHookResult = ReturnType<typeof useGetAccountOptionsQuery>;
export type GetAccountOptionsLazyQueryHookResult = ReturnType<typeof useGetAccountOptionsLazyQuery>;
export type GetAccountOptionsQueryResult = Apollo.QueryResult<GetAccountOptionsQuery, GetAccountOptionsQueryVariables>;
export function refetchGetAccountOptionsQuery(variables?: GetAccountOptionsQueryVariables) {
      return { query: GetAccountOptionsDocument, variables: variables }
    }
export const GetAccountOptionDocument = gql`
    query getAccountOption($id: ID!, $uuid: UUID) {
  account(id: $id, uuid: $uuid) {
    ...AccountOption
  }
}
    ${AccountOptionFragmentDoc}`;

/**
 * __useGetAccountOptionQuery__
 *
 * To run a query within a React component, call `useGetAccountOptionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAccountOptionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAccountOptionQuery({
 *   variables: {
 *      id: // value for 'id'
 *      uuid: // value for 'uuid'
 *   },
 * });
 */
export function useGetAccountOptionQuery(baseOptions: Apollo.QueryHookOptions<GetAccountOptionQuery, GetAccountOptionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAccountOptionQuery, GetAccountOptionQueryVariables>(GetAccountOptionDocument, options);
      }
export function useGetAccountOptionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAccountOptionQuery, GetAccountOptionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAccountOptionQuery, GetAccountOptionQueryVariables>(GetAccountOptionDocument, options);
        }
export type GetAccountOptionQueryHookResult = ReturnType<typeof useGetAccountOptionQuery>;
export type GetAccountOptionLazyQueryHookResult = ReturnType<typeof useGetAccountOptionLazyQuery>;
export type GetAccountOptionQueryResult = Apollo.QueryResult<GetAccountOptionQuery, GetAccountOptionQueryVariables>;
export function refetchGetAccountOptionQuery(variables: GetAccountOptionQueryVariables) {
      return { query: GetAccountOptionDocument, variables: variables }
    }
export const GetAccountEditDocument = gql`
    query getAccountEdit($id: ID!) {
  account(id: $id) {
    id
    uuid
    name
    externalId
    taxId
    owner {
      id
    }
    location {
      id
    }
  }
}
    `;

/**
 * __useGetAccountEditQuery__
 *
 * To run a query within a React component, call `useGetAccountEditQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAccountEditQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAccountEditQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetAccountEditQuery(baseOptions: Apollo.QueryHookOptions<GetAccountEditQuery, GetAccountEditQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAccountEditQuery, GetAccountEditQueryVariables>(GetAccountEditDocument, options);
      }
export function useGetAccountEditLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAccountEditQuery, GetAccountEditQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAccountEditQuery, GetAccountEditQueryVariables>(GetAccountEditDocument, options);
        }
export type GetAccountEditQueryHookResult = ReturnType<typeof useGetAccountEditQuery>;
export type GetAccountEditLazyQueryHookResult = ReturnType<typeof useGetAccountEditLazyQuery>;
export type GetAccountEditQueryResult = Apollo.QueryResult<GetAccountEditQuery, GetAccountEditQueryVariables>;
export function refetchGetAccountEditQuery(variables: GetAccountEditQueryVariables) {
      return { query: GetAccountEditDocument, variables: variables }
    }
export const DeleteAccountDocument = gql`
    mutation deleteAccount($input: DeleteAccountMutationInput!) {
  deleteAccount(input: $input) {
    errors {
      ...Error
    }
  }
}
    ${ErrorFragmentDoc}`;
export type DeleteAccountMutationFn = Apollo.MutationFunction<DeleteAccountMutation, DeleteAccountMutationVariables>;

/**
 * __useDeleteAccountMutation__
 *
 * To run a mutation, you first call `useDeleteAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteAccountMutation, { data, loading, error }] = useDeleteAccountMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteAccountMutation(baseOptions?: Apollo.MutationHookOptions<DeleteAccountMutation, DeleteAccountMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteAccountMutation, DeleteAccountMutationVariables>(DeleteAccountDocument, options);
      }
export type DeleteAccountMutationHookResult = ReturnType<typeof useDeleteAccountMutation>;
export type DeleteAccountMutationResult = Apollo.MutationResult<DeleteAccountMutation>;
export type DeleteAccountMutationOptions = Apollo.BaseMutationOptions<DeleteAccountMutation, DeleteAccountMutationVariables>;
export const ToggleFavoriteAcccountDocument = gql`
    mutation toggleFavoriteAcccount($id: UUID!) {
  toggleFavoriteAccount(id: $id) {
    ok
  }
}
    `;
export type ToggleFavoriteAcccountMutationFn = Apollo.MutationFunction<ToggleFavoriteAcccountMutation, ToggleFavoriteAcccountMutationVariables>;

/**
 * __useToggleFavoriteAcccountMutation__
 *
 * To run a mutation, you first call `useToggleFavoriteAcccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useToggleFavoriteAcccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [toggleFavoriteAcccountMutation, { data, loading, error }] = useToggleFavoriteAcccountMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useToggleFavoriteAcccountMutation(baseOptions?: Apollo.MutationHookOptions<ToggleFavoriteAcccountMutation, ToggleFavoriteAcccountMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ToggleFavoriteAcccountMutation, ToggleFavoriteAcccountMutationVariables>(ToggleFavoriteAcccountDocument, options);
      }
export type ToggleFavoriteAcccountMutationHookResult = ReturnType<typeof useToggleFavoriteAcccountMutation>;
export type ToggleFavoriteAcccountMutationResult = Apollo.MutationResult<ToggleFavoriteAcccountMutation>;
export type ToggleFavoriteAcccountMutationOptions = Apollo.BaseMutationOptions<ToggleFavoriteAcccountMutation, ToggleFavoriteAcccountMutationVariables>;
export const GetAccountTaxDocument = gql`
    query getAccountTax($uuid: UUID) {
  account(uuid: $uuid, id: "") {
    uuid
    location {
      id
      iva
    }
    owner {
      location {
        id
        iva
      }
    }
  }
}
    `;

/**
 * __useGetAccountTaxQuery__
 *
 * To run a query within a React component, call `useGetAccountTaxQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAccountTaxQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAccountTaxQuery({
 *   variables: {
 *      uuid: // value for 'uuid'
 *   },
 * });
 */
export function useGetAccountTaxQuery(baseOptions?: Apollo.QueryHookOptions<GetAccountTaxQuery, GetAccountTaxQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAccountTaxQuery, GetAccountTaxQueryVariables>(GetAccountTaxDocument, options);
      }
export function useGetAccountTaxLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAccountTaxQuery, GetAccountTaxQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAccountTaxQuery, GetAccountTaxQueryVariables>(GetAccountTaxDocument, options);
        }
export type GetAccountTaxQueryHookResult = ReturnType<typeof useGetAccountTaxQuery>;
export type GetAccountTaxLazyQueryHookResult = ReturnType<typeof useGetAccountTaxLazyQuery>;
export type GetAccountTaxQueryResult = Apollo.QueryResult<GetAccountTaxQuery, GetAccountTaxQueryVariables>;
export function refetchGetAccountTaxQuery(variables?: GetAccountTaxQueryVariables) {
      return { query: GetAccountTaxDocument, variables: variables }
    }
export const GetSalesAnalyticsDocument = gql`
    query getSalesAnalytics($filters: AnalyticsFilters!) {
  salesAnalytics(filters: $filters) {
    count
    amount
    byDate {
      ...DateSeries
    }
    productRanking {
      ...ProductRankingDatum
    }
    byBillingType {
      ...AmountDatum
    }
    byPaymentMethod {
      ...AmountDatum
    }
    bySeederBrand {
      ...AmountDatum
    }
    bySeederModel {
      ...AmountDatum
    }
    byOrganization {
      ...AmountDatum
    }
    byAccount {
      ...AmountDatum
    }
    byUser {
      ...AmountDatum
    }
  }
}
    ${DateSeriesFragmentDoc}
${ProductRankingDatumFragmentDoc}
${AmountDatumFragmentDoc}`;

/**
 * __useGetSalesAnalyticsQuery__
 *
 * To run a query within a React component, call `useGetSalesAnalyticsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSalesAnalyticsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSalesAnalyticsQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useGetSalesAnalyticsQuery(baseOptions: Apollo.QueryHookOptions<GetSalesAnalyticsQuery, GetSalesAnalyticsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSalesAnalyticsQuery, GetSalesAnalyticsQueryVariables>(GetSalesAnalyticsDocument, options);
      }
export function useGetSalesAnalyticsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSalesAnalyticsQuery, GetSalesAnalyticsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSalesAnalyticsQuery, GetSalesAnalyticsQueryVariables>(GetSalesAnalyticsDocument, options);
        }
export type GetSalesAnalyticsQueryHookResult = ReturnType<typeof useGetSalesAnalyticsQuery>;
export type GetSalesAnalyticsLazyQueryHookResult = ReturnType<typeof useGetSalesAnalyticsLazyQuery>;
export type GetSalesAnalyticsQueryResult = Apollo.QueryResult<GetSalesAnalyticsQuery, GetSalesAnalyticsQueryVariables>;
export function refetchGetSalesAnalyticsQuery(variables: GetSalesAnalyticsQueryVariables) {
      return { query: GetSalesAnalyticsDocument, variables: variables }
    }
export const GetQuotesAnalyticsDocument = gql`
    query getQuotesAnalytics($filters: AnalyticsFilters!) {
  quotesAnalytics(filters: $filters) {
    count
    amount
    byDate {
      ...DateSeries
    }
    productRanking {
      ...ProductRankingDatum
    }
    byBillingType {
      ...AmountDatum
    }
    byPaymentMethod {
      ...AmountDatum
    }
    bySeederBrand {
      ...AmountDatum
    }
    bySeederModel {
      ...AmountDatum
    }
    byStatus {
      ...AmountDatum
    }
    byOrganization {
      ...AmountDatum
    }
    byAccount {
      ...AmountDatum
    }
    byUser {
      ...AmountDatum
    }
    byCloseReason {
      ...AmountDatum
    }
  }
}
    ${DateSeriesFragmentDoc}
${ProductRankingDatumFragmentDoc}
${AmountDatumFragmentDoc}`;

/**
 * __useGetQuotesAnalyticsQuery__
 *
 * To run a query within a React component, call `useGetQuotesAnalyticsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetQuotesAnalyticsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetQuotesAnalyticsQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useGetQuotesAnalyticsQuery(baseOptions: Apollo.QueryHookOptions<GetQuotesAnalyticsQuery, GetQuotesAnalyticsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetQuotesAnalyticsQuery, GetQuotesAnalyticsQueryVariables>(GetQuotesAnalyticsDocument, options);
      }
export function useGetQuotesAnalyticsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetQuotesAnalyticsQuery, GetQuotesAnalyticsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetQuotesAnalyticsQuery, GetQuotesAnalyticsQueryVariables>(GetQuotesAnalyticsDocument, options);
        }
export type GetQuotesAnalyticsQueryHookResult = ReturnType<typeof useGetQuotesAnalyticsQuery>;
export type GetQuotesAnalyticsLazyQueryHookResult = ReturnType<typeof useGetQuotesAnalyticsLazyQuery>;
export type GetQuotesAnalyticsQueryResult = Apollo.QueryResult<GetQuotesAnalyticsQuery, GetQuotesAnalyticsQueryVariables>;
export function refetchGetQuotesAnalyticsQuery(variables: GetQuotesAnalyticsQueryVariables) {
      return { query: GetQuotesAnalyticsDocument, variables: variables }
    }
export const GetWarrantyClaimsAnalyticsDocument = gql`
    query getWarrantyClaimsAnalytics($filters: AnalyticsFilters!) {
  warrantyClaimsAnalytics(filters: $filters) {
    count
    byDate {
      ...DateSeries
    }
    productRanking {
      ...WarrantyProductRankingDatum
    }
    pendingCount
    cancelledCount
    approvedCount
    rejectedCount
    failRate {
      product {
        displayName
        subcategory {
          name
          category {
            name
          }
        }
      }
      percentage
      failQuantity
      saleQuantity
    }
  }
}
    ${DateSeriesFragmentDoc}
${WarrantyProductRankingDatumFragmentDoc}`;

/**
 * __useGetWarrantyClaimsAnalyticsQuery__
 *
 * To run a query within a React component, call `useGetWarrantyClaimsAnalyticsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWarrantyClaimsAnalyticsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWarrantyClaimsAnalyticsQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useGetWarrantyClaimsAnalyticsQuery(baseOptions: Apollo.QueryHookOptions<GetWarrantyClaimsAnalyticsQuery, GetWarrantyClaimsAnalyticsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetWarrantyClaimsAnalyticsQuery, GetWarrantyClaimsAnalyticsQueryVariables>(GetWarrantyClaimsAnalyticsDocument, options);
      }
export function useGetWarrantyClaimsAnalyticsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetWarrantyClaimsAnalyticsQuery, GetWarrantyClaimsAnalyticsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetWarrantyClaimsAnalyticsQuery, GetWarrantyClaimsAnalyticsQueryVariables>(GetWarrantyClaimsAnalyticsDocument, options);
        }
export type GetWarrantyClaimsAnalyticsQueryHookResult = ReturnType<typeof useGetWarrantyClaimsAnalyticsQuery>;
export type GetWarrantyClaimsAnalyticsLazyQueryHookResult = ReturnType<typeof useGetWarrantyClaimsAnalyticsLazyQuery>;
export type GetWarrantyClaimsAnalyticsQueryResult = Apollo.QueryResult<GetWarrantyClaimsAnalyticsQuery, GetWarrantyClaimsAnalyticsQueryVariables>;
export function refetchGetWarrantyClaimsAnalyticsQuery(variables: GetWarrantyClaimsAnalyticsQueryVariables) {
      return { query: GetWarrantyClaimsAnalyticsDocument, variables: variables }
    }
export const GetContactsDocument = gql`
    query getContacts($first: Int, $offset: Int, $accountGlobalId: UUID, $orderBy: String, $owner: UUID, $query: String) {
  contacts(
    first: $first
    offset: $offset
    orderBy: $orderBy
    account_Owner_Id: $owner
    account_Id: $accountGlobalId
    active: true
    query: $query
  ) {
    count
    edges {
      node {
        ...ContactList
      }
      cursor
    }
    pageInfo {
      ...PageInfo
    }
  }
}
    ${ContactListFragmentDoc}
${PageInfoFragmentDoc}`;

/**
 * __useGetContactsQuery__
 *
 * To run a query within a React component, call `useGetContactsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetContactsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetContactsQuery({
 *   variables: {
 *      first: // value for 'first'
 *      offset: // value for 'offset'
 *      accountGlobalId: // value for 'accountGlobalId'
 *      orderBy: // value for 'orderBy'
 *      owner: // value for 'owner'
 *      query: // value for 'query'
 *   },
 * });
 */
export function useGetContactsQuery(baseOptions?: Apollo.QueryHookOptions<GetContactsQuery, GetContactsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetContactsQuery, GetContactsQueryVariables>(GetContactsDocument, options);
      }
export function useGetContactsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetContactsQuery, GetContactsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetContactsQuery, GetContactsQueryVariables>(GetContactsDocument, options);
        }
export type GetContactsQueryHookResult = ReturnType<typeof useGetContactsQuery>;
export type GetContactsLazyQueryHookResult = ReturnType<typeof useGetContactsLazyQuery>;
export type GetContactsQueryResult = Apollo.QueryResult<GetContactsQuery, GetContactsQueryVariables>;
export function refetchGetContactsQuery(variables?: GetContactsQueryVariables) {
      return { query: GetContactsDocument, variables: variables }
    }
export const GetContactDocument = gql`
    query getContact($id: ID!) {
  contact(id: $id) {
    ...Contact
  }
}
    ${ContactFragmentDoc}`;

/**
 * __useGetContactQuery__
 *
 * To run a query within a React component, call `useGetContactQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetContactQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetContactQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetContactQuery(baseOptions: Apollo.QueryHookOptions<GetContactQuery, GetContactQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetContactQuery, GetContactQueryVariables>(GetContactDocument, options);
      }
export function useGetContactLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetContactQuery, GetContactQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetContactQuery, GetContactQueryVariables>(GetContactDocument, options);
        }
export type GetContactQueryHookResult = ReturnType<typeof useGetContactQuery>;
export type GetContactLazyQueryHookResult = ReturnType<typeof useGetContactLazyQuery>;
export type GetContactQueryResult = Apollo.QueryResult<GetContactQuery, GetContactQueryVariables>;
export function refetchGetContactQuery(variables: GetContactQueryVariables) {
      return { query: GetContactDocument, variables: variables }
    }
export const GetContactsOptionsDocument = gql`
    query getContactsOptions($account: UUID) {
  contacts(account_Id: $account, active: true) {
    edges {
      cursor
      node {
        id
        uuid
        displayName
      }
    }
    pageInfo {
      ...PageInfo
    }
  }
}
    ${PageInfoFragmentDoc}`;

/**
 * __useGetContactsOptionsQuery__
 *
 * To run a query within a React component, call `useGetContactsOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetContactsOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetContactsOptionsQuery({
 *   variables: {
 *      account: // value for 'account'
 *   },
 * });
 */
export function useGetContactsOptionsQuery(baseOptions?: Apollo.QueryHookOptions<GetContactsOptionsQuery, GetContactsOptionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetContactsOptionsQuery, GetContactsOptionsQueryVariables>(GetContactsOptionsDocument, options);
      }
export function useGetContactsOptionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetContactsOptionsQuery, GetContactsOptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetContactsOptionsQuery, GetContactsOptionsQueryVariables>(GetContactsOptionsDocument, options);
        }
export type GetContactsOptionsQueryHookResult = ReturnType<typeof useGetContactsOptionsQuery>;
export type GetContactsOptionsLazyQueryHookResult = ReturnType<typeof useGetContactsOptionsLazyQuery>;
export type GetContactsOptionsQueryResult = Apollo.QueryResult<GetContactsOptionsQuery, GetContactsOptionsQueryVariables>;
export function refetchGetContactsOptionsQuery(variables?: GetContactsOptionsQueryVariables) {
      return { query: GetContactsOptionsDocument, variables: variables }
    }
export const GetContactTypesDocument = gql`
    query getContactTypes {
  contactTypes {
    id
    name
  }
}
    `;

/**
 * __useGetContactTypesQuery__
 *
 * To run a query within a React component, call `useGetContactTypesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetContactTypesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetContactTypesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetContactTypesQuery(baseOptions?: Apollo.QueryHookOptions<GetContactTypesQuery, GetContactTypesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetContactTypesQuery, GetContactTypesQueryVariables>(GetContactTypesDocument, options);
      }
export function useGetContactTypesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetContactTypesQuery, GetContactTypesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetContactTypesQuery, GetContactTypesQueryVariables>(GetContactTypesDocument, options);
        }
export type GetContactTypesQueryHookResult = ReturnType<typeof useGetContactTypesQuery>;
export type GetContactTypesLazyQueryHookResult = ReturnType<typeof useGetContactTypesLazyQuery>;
export type GetContactTypesQueryResult = Apollo.QueryResult<GetContactTypesQuery, GetContactTypesQueryVariables>;
export function refetchGetContactTypesQuery(variables?: GetContactTypesQueryVariables) {
      return { query: GetContactTypesDocument, variables: variables }
    }
export const CreateContactDocument = gql`
    mutation createContact($input: CreateContactMutationInput!) {
  createContact(input: $input) {
    contact {
      id
      uuid
    }
    errors {
      ...Error
    }
  }
}
    ${ErrorFragmentDoc}`;
export type CreateContactMutationFn = Apollo.MutationFunction<CreateContactMutation, CreateContactMutationVariables>;

/**
 * __useCreateContactMutation__
 *
 * To run a mutation, you first call `useCreateContactMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateContactMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createContactMutation, { data, loading, error }] = useCreateContactMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateContactMutation(baseOptions?: Apollo.MutationHookOptions<CreateContactMutation, CreateContactMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateContactMutation, CreateContactMutationVariables>(CreateContactDocument, options);
      }
export type CreateContactMutationHookResult = ReturnType<typeof useCreateContactMutation>;
export type CreateContactMutationResult = Apollo.MutationResult<CreateContactMutation>;
export type CreateContactMutationOptions = Apollo.BaseMutationOptions<CreateContactMutation, CreateContactMutationVariables>;
export const UpdateContactDocument = gql`
    mutation updateContact($input: UpdateContactMutationInput!) {
  updateContact(input: $input) {
    contact {
      id
      uuid
    }
    errors {
      ...Error
    }
  }
}
    ${ErrorFragmentDoc}`;
export type UpdateContactMutationFn = Apollo.MutationFunction<UpdateContactMutation, UpdateContactMutationVariables>;

/**
 * __useUpdateContactMutation__
 *
 * To run a mutation, you first call `useUpdateContactMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateContactMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateContactMutation, { data, loading, error }] = useUpdateContactMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateContactMutation(baseOptions?: Apollo.MutationHookOptions<UpdateContactMutation, UpdateContactMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateContactMutation, UpdateContactMutationVariables>(UpdateContactDocument, options);
      }
export type UpdateContactMutationHookResult = ReturnType<typeof useUpdateContactMutation>;
export type UpdateContactMutationResult = Apollo.MutationResult<UpdateContactMutation>;
export type UpdateContactMutationOptions = Apollo.BaseMutationOptions<UpdateContactMutation, UpdateContactMutationVariables>;
export const DeleteContactDocument = gql`
    mutation deleteContact($input: DeleteContactMutationInput!) {
  deleteContact(input: $input) {
    errors {
      ...Error
    }
  }
}
    ${ErrorFragmentDoc}`;
export type DeleteContactMutationFn = Apollo.MutationFunction<DeleteContactMutation, DeleteContactMutationVariables>;

/**
 * __useDeleteContactMutation__
 *
 * To run a mutation, you first call `useDeleteContactMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteContactMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteContactMutation, { data, loading, error }] = useDeleteContactMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteContactMutation(baseOptions?: Apollo.MutationHookOptions<DeleteContactMutation, DeleteContactMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteContactMutation, DeleteContactMutationVariables>(DeleteContactDocument, options);
      }
export type DeleteContactMutationHookResult = ReturnType<typeof useDeleteContactMutation>;
export type DeleteContactMutationResult = Apollo.MutationResult<DeleteContactMutation>;
export type DeleteContactMutationOptions = Apollo.BaseMutationOptions<DeleteContactMutation, DeleteContactMutationVariables>;
export const GetFeatureFlagsDocument = gql`
    query getFeatureFlags {
  activeFeatureFlags {
    ...FeatureFlag
  }
}
    ${FeatureFlagFragmentDoc}`;

/**
 * __useGetFeatureFlagsQuery__
 *
 * To run a query within a React component, call `useGetFeatureFlagsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFeatureFlagsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFeatureFlagsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetFeatureFlagsQuery(baseOptions?: Apollo.QueryHookOptions<GetFeatureFlagsQuery, GetFeatureFlagsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetFeatureFlagsQuery, GetFeatureFlagsQueryVariables>(GetFeatureFlagsDocument, options);
      }
export function useGetFeatureFlagsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetFeatureFlagsQuery, GetFeatureFlagsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetFeatureFlagsQuery, GetFeatureFlagsQueryVariables>(GetFeatureFlagsDocument, options);
        }
export type GetFeatureFlagsQueryHookResult = ReturnType<typeof useGetFeatureFlagsQuery>;
export type GetFeatureFlagsLazyQueryHookResult = ReturnType<typeof useGetFeatureFlagsLazyQuery>;
export type GetFeatureFlagsQueryResult = Apollo.QueryResult<GetFeatureFlagsQuery, GetFeatureFlagsQueryVariables>;
export function refetchGetFeatureFlagsQuery(variables?: GetFeatureFlagsQueryVariables) {
      return { query: GetFeatureFlagsDocument, variables: variables }
    }
export const GetFeatureFlagDocument = gql`
    query getFeatureFlag($name: String!) {
  activeFeatureFlag(name: $name) {
    ...FeatureFlag
  }
}
    ${FeatureFlagFragmentDoc}`;

/**
 * __useGetFeatureFlagQuery__
 *
 * To run a query within a React component, call `useGetFeatureFlagQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFeatureFlagQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFeatureFlagQuery({
 *   variables: {
 *      name: // value for 'name'
 *   },
 * });
 */
export function useGetFeatureFlagQuery(baseOptions: Apollo.QueryHookOptions<GetFeatureFlagQuery, GetFeatureFlagQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetFeatureFlagQuery, GetFeatureFlagQueryVariables>(GetFeatureFlagDocument, options);
      }
export function useGetFeatureFlagLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetFeatureFlagQuery, GetFeatureFlagQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetFeatureFlagQuery, GetFeatureFlagQueryVariables>(GetFeatureFlagDocument, options);
        }
export type GetFeatureFlagQueryHookResult = ReturnType<typeof useGetFeatureFlagQuery>;
export type GetFeatureFlagLazyQueryHookResult = ReturnType<typeof useGetFeatureFlagLazyQuery>;
export type GetFeatureFlagQueryResult = Apollo.QueryResult<GetFeatureFlagQuery, GetFeatureFlagQueryVariables>;
export function refetchGetFeatureFlagQuery(variables: GetFeatureFlagQueryVariables) {
      return { query: GetFeatureFlagDocument, variables: variables }
    }
export const GetUserFeatureAccessDocument = gql`
    query getUserFeatureAccess($featureName: String!) {
  userFeatureAccess(featureName: $featureName)
}
    `;

/**
 * __useGetUserFeatureAccessQuery__
 *
 * To run a query within a React component, call `useGetUserFeatureAccessQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserFeatureAccessQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserFeatureAccessQuery({
 *   variables: {
 *      featureName: // value for 'featureName'
 *   },
 * });
 */
export function useGetUserFeatureAccessQuery(baseOptions: Apollo.QueryHookOptions<GetUserFeatureAccessQuery, GetUserFeatureAccessQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUserFeatureAccessQuery, GetUserFeatureAccessQueryVariables>(GetUserFeatureAccessDocument, options);
      }
export function useGetUserFeatureAccessLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserFeatureAccessQuery, GetUserFeatureAccessQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUserFeatureAccessQuery, GetUserFeatureAccessQueryVariables>(GetUserFeatureAccessDocument, options);
        }
export type GetUserFeatureAccessQueryHookResult = ReturnType<typeof useGetUserFeatureAccessQuery>;
export type GetUserFeatureAccessLazyQueryHookResult = ReturnType<typeof useGetUserFeatureAccessLazyQuery>;
export type GetUserFeatureAccessQueryResult = Apollo.QueryResult<GetUserFeatureAccessQuery, GetUserFeatureAccessQueryVariables>;
export function refetchGetUserFeatureAccessQuery(variables: GetUserFeatureAccessQueryVariables) {
      return { query: GetUserFeatureAccessDocument, variables: variables }
    }
export const GetLocationsDocument = gql`
    query getLocations($id: Int, $query: String, $parentDescendatsId: Int) {
  locations(id: $id, query: $query, parentDecendatsId: $parentDescendatsId) {
    ...LocationOption
  }
}
    ${LocationOptionFragmentDoc}`;

/**
 * __useGetLocationsQuery__
 *
 * To run a query within a React component, call `useGetLocationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLocationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLocationsQuery({
 *   variables: {
 *      id: // value for 'id'
 *      query: // value for 'query'
 *      parentDescendatsId: // value for 'parentDescendatsId'
 *   },
 * });
 */
export function useGetLocationsQuery(baseOptions?: Apollo.QueryHookOptions<GetLocationsQuery, GetLocationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLocationsQuery, GetLocationsQueryVariables>(GetLocationsDocument, options);
      }
export function useGetLocationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetLocationsQuery, GetLocationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLocationsQuery, GetLocationsQueryVariables>(GetLocationsDocument, options);
        }
export type GetLocationsQueryHookResult = ReturnType<typeof useGetLocationsQuery>;
export type GetLocationsLazyQueryHookResult = ReturnType<typeof useGetLocationsLazyQuery>;
export type GetLocationsQueryResult = Apollo.QueryResult<GetLocationsQuery, GetLocationsQueryVariables>;
export function refetchGetLocationsQuery(variables?: GetLocationsQueryVariables) {
      return { query: GetLocationsDocument, variables: variables }
    }
export const GetLocationDocument = gql`
    query getLocation($id: ID!) {
  location(id: $id) {
    ...LocationOption
  }
}
    ${LocationOptionFragmentDoc}`;

/**
 * __useGetLocationQuery__
 *
 * To run a query within a React component, call `useGetLocationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLocationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLocationQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetLocationQuery(baseOptions: Apollo.QueryHookOptions<GetLocationQuery, GetLocationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLocationQuery, GetLocationQueryVariables>(GetLocationDocument, options);
      }
export function useGetLocationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetLocationQuery, GetLocationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLocationQuery, GetLocationQueryVariables>(GetLocationDocument, options);
        }
export type GetLocationQueryHookResult = ReturnType<typeof useGetLocationQuery>;
export type GetLocationLazyQueryHookResult = ReturnType<typeof useGetLocationLazyQuery>;
export type GetLocationQueryResult = Apollo.QueryResult<GetLocationQuery, GetLocationQueryVariables>;
export function refetchGetLocationQuery(variables: GetLocationQueryVariables) {
      return { query: GetLocationDocument, variables: variables }
    }
export const GetNotificationsDocument = gql`
    query getNotifications($offset: Int, $after: String, $before: String, $first: Int, $last: Int) {
  unreadCount
  notifications(
    offset: $offset
    after: $after
    before: $before
    first: $first
    last: $last
  ) {
    edges {
      cursor
      node {
        ...Notification
      }
    }
    pageInfo {
      ...PageInfo
    }
  }
}
    ${NotificationFragmentDoc}
${PageInfoFragmentDoc}`;

/**
 * __useGetNotificationsQuery__
 *
 * To run a query within a React component, call `useGetNotificationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetNotificationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetNotificationsQuery({
 *   variables: {
 *      offset: // value for 'offset'
 *      after: // value for 'after'
 *      before: // value for 'before'
 *      first: // value for 'first'
 *      last: // value for 'last'
 *   },
 * });
 */
export function useGetNotificationsQuery(baseOptions?: Apollo.QueryHookOptions<GetNotificationsQuery, GetNotificationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetNotificationsQuery, GetNotificationsQueryVariables>(GetNotificationsDocument, options);
      }
export function useGetNotificationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetNotificationsQuery, GetNotificationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetNotificationsQuery, GetNotificationsQueryVariables>(GetNotificationsDocument, options);
        }
export type GetNotificationsQueryHookResult = ReturnType<typeof useGetNotificationsQuery>;
export type GetNotificationsLazyQueryHookResult = ReturnType<typeof useGetNotificationsLazyQuery>;
export type GetNotificationsQueryResult = Apollo.QueryResult<GetNotificationsQuery, GetNotificationsQueryVariables>;
export function refetchGetNotificationsQuery(variables?: GetNotificationsQueryVariables) {
      return { query: GetNotificationsDocument, variables: variables }
    }
export const GetNotificationsUnreadCountDocument = gql`
    query getNotificationsUnreadCount {
  unreadCount
}
    `;

/**
 * __useGetNotificationsUnreadCountQuery__
 *
 * To run a query within a React component, call `useGetNotificationsUnreadCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetNotificationsUnreadCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetNotificationsUnreadCountQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetNotificationsUnreadCountQuery(baseOptions?: Apollo.QueryHookOptions<GetNotificationsUnreadCountQuery, GetNotificationsUnreadCountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetNotificationsUnreadCountQuery, GetNotificationsUnreadCountQueryVariables>(GetNotificationsUnreadCountDocument, options);
      }
export function useGetNotificationsUnreadCountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetNotificationsUnreadCountQuery, GetNotificationsUnreadCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetNotificationsUnreadCountQuery, GetNotificationsUnreadCountQueryVariables>(GetNotificationsUnreadCountDocument, options);
        }
export type GetNotificationsUnreadCountQueryHookResult = ReturnType<typeof useGetNotificationsUnreadCountQuery>;
export type GetNotificationsUnreadCountLazyQueryHookResult = ReturnType<typeof useGetNotificationsUnreadCountLazyQuery>;
export type GetNotificationsUnreadCountQueryResult = Apollo.QueryResult<GetNotificationsUnreadCountQuery, GetNotificationsUnreadCountQueryVariables>;
export function refetchGetNotificationsUnreadCountQuery(variables?: GetNotificationsUnreadCountQueryVariables) {
      return { query: GetNotificationsUnreadCountDocument, variables: variables }
    }
export const MarkNotificationAsReadDocument = gql`
    mutation markNotificationAsRead($input: MarkNotificationAsReadMutationInput!) {
  markNotificationAsRead(input: $input) {
    notification {
      ...Notification
    }
    errors {
      field
      messages
    }
  }
}
    ${NotificationFragmentDoc}`;
export type MarkNotificationAsReadMutationFn = Apollo.MutationFunction<MarkNotificationAsReadMutation, MarkNotificationAsReadMutationVariables>;

/**
 * __useMarkNotificationAsReadMutation__
 *
 * To run a mutation, you first call `useMarkNotificationAsReadMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMarkNotificationAsReadMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [markNotificationAsReadMutation, { data, loading, error }] = useMarkNotificationAsReadMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useMarkNotificationAsReadMutation(baseOptions?: Apollo.MutationHookOptions<MarkNotificationAsReadMutation, MarkNotificationAsReadMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MarkNotificationAsReadMutation, MarkNotificationAsReadMutationVariables>(MarkNotificationAsReadDocument, options);
      }
export type MarkNotificationAsReadMutationHookResult = ReturnType<typeof useMarkNotificationAsReadMutation>;
export type MarkNotificationAsReadMutationResult = Apollo.MutationResult<MarkNotificationAsReadMutation>;
export type MarkNotificationAsReadMutationOptions = Apollo.BaseMutationOptions<MarkNotificationAsReadMutation, MarkNotificationAsReadMutationVariables>;
export const MarkAllNotificationsAsReadDocument = gql`
    mutation markAllNotificationsAsRead {
  markAllNotificationsAsRead {
    status
  }
}
    `;
export type MarkAllNotificationsAsReadMutationFn = Apollo.MutationFunction<MarkAllNotificationsAsReadMutation, MarkAllNotificationsAsReadMutationVariables>;

/**
 * __useMarkAllNotificationsAsReadMutation__
 *
 * To run a mutation, you first call `useMarkAllNotificationsAsReadMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMarkAllNotificationsAsReadMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [markAllNotificationsAsReadMutation, { data, loading, error }] = useMarkAllNotificationsAsReadMutation({
 *   variables: {
 *   },
 * });
 */
export function useMarkAllNotificationsAsReadMutation(baseOptions?: Apollo.MutationHookOptions<MarkAllNotificationsAsReadMutation, MarkAllNotificationsAsReadMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MarkAllNotificationsAsReadMutation, MarkAllNotificationsAsReadMutationVariables>(MarkAllNotificationsAsReadDocument, options);
      }
export type MarkAllNotificationsAsReadMutationHookResult = ReturnType<typeof useMarkAllNotificationsAsReadMutation>;
export type MarkAllNotificationsAsReadMutationResult = Apollo.MutationResult<MarkAllNotificationsAsReadMutation>;
export type MarkAllNotificationsAsReadMutationOptions = Apollo.BaseMutationOptions<MarkAllNotificationsAsReadMutation, MarkAllNotificationsAsReadMutationVariables>;
export const GetEcnsNumbersDocument = gql`
    query getEcnsNumbers {
  ecns {
    edges {
      node {
        ecnNumber
      }
    }
  }
}
    `;

/**
 * __useGetEcnsNumbersQuery__
 *
 * To run a query within a React component, call `useGetEcnsNumbersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEcnsNumbersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEcnsNumbersQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetEcnsNumbersQuery(baseOptions?: Apollo.QueryHookOptions<GetEcnsNumbersQuery, GetEcnsNumbersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEcnsNumbersQuery, GetEcnsNumbersQueryVariables>(GetEcnsNumbersDocument, options);
      }
export function useGetEcnsNumbersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetEcnsNumbersQuery, GetEcnsNumbersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEcnsNumbersQuery, GetEcnsNumbersQueryVariables>(GetEcnsNumbersDocument, options);
        }
export type GetEcnsNumbersQueryHookResult = ReturnType<typeof useGetEcnsNumbersQuery>;
export type GetEcnsNumbersLazyQueryHookResult = ReturnType<typeof useGetEcnsNumbersLazyQuery>;
export type GetEcnsNumbersQueryResult = Apollo.QueryResult<GetEcnsNumbersQuery, GetEcnsNumbersQueryVariables>;
export function refetchGetEcnsNumbersQuery(variables?: GetEcnsNumbersQueryVariables) {
      return { query: GetEcnsNumbersDocument, variables: variables }
    }
export const GetEcnDocument = gql`
    query getEcn($id: ID!, $uuid: UUID) {
  ecn(id: $id, uuid: $uuid) {
    ...Ecn
  }
}
    ${EcnFragmentDoc}`;

/**
 * __useGetEcnQuery__
 *
 * To run a query within a React component, call `useGetEcnQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEcnQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEcnQuery({
 *   variables: {
 *      id: // value for 'id'
 *      uuid: // value for 'uuid'
 *   },
 * });
 */
export function useGetEcnQuery(baseOptions: Apollo.QueryHookOptions<GetEcnQuery, GetEcnQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEcnQuery, GetEcnQueryVariables>(GetEcnDocument, options);
      }
export function useGetEcnLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetEcnQuery, GetEcnQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEcnQuery, GetEcnQueryVariables>(GetEcnDocument, options);
        }
export type GetEcnQueryHookResult = ReturnType<typeof useGetEcnQuery>;
export type GetEcnLazyQueryHookResult = ReturnType<typeof useGetEcnLazyQuery>;
export type GetEcnQueryResult = Apollo.QueryResult<GetEcnQuery, GetEcnQueryVariables>;
export function refetchGetEcnQuery(variables: GetEcnQueryVariables) {
      return { query: GetEcnDocument, variables: variables }
    }
export const GetDefaultTaskDocument = gql`
    query getDefaultTask($id: UUID) {
  defaultTask(id: $id) {
    ...DefaultEcnTask
  }
}
    ${DefaultEcnTaskFragmentDoc}`;

/**
 * __useGetDefaultTaskQuery__
 *
 * To run a query within a React component, call `useGetDefaultTaskQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDefaultTaskQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDefaultTaskQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetDefaultTaskQuery(baseOptions?: Apollo.QueryHookOptions<GetDefaultTaskQuery, GetDefaultTaskQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDefaultTaskQuery, GetDefaultTaskQueryVariables>(GetDefaultTaskDocument, options);
      }
export function useGetDefaultTaskLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDefaultTaskQuery, GetDefaultTaskQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDefaultTaskQuery, GetDefaultTaskQueryVariables>(GetDefaultTaskDocument, options);
        }
export type GetDefaultTaskQueryHookResult = ReturnType<typeof useGetDefaultTaskQuery>;
export type GetDefaultTaskLazyQueryHookResult = ReturnType<typeof useGetDefaultTaskLazyQuery>;
export type GetDefaultTaskQueryResult = Apollo.QueryResult<GetDefaultTaskQuery, GetDefaultTaskQueryVariables>;
export function refetchGetDefaultTaskQuery(variables?: GetDefaultTaskQueryVariables) {
      return { query: GetDefaultTaskDocument, variables: variables }
    }
export const GetDefaultTasksDocument = gql`
    query getDefaultTasks {
  defaultTasks {
    ...DefaultEcnTask
  }
}
    ${DefaultEcnTaskFragmentDoc}`;

/**
 * __useGetDefaultTasksQuery__
 *
 * To run a query within a React component, call `useGetDefaultTasksQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDefaultTasksQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDefaultTasksQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetDefaultTasksQuery(baseOptions?: Apollo.QueryHookOptions<GetDefaultTasksQuery, GetDefaultTasksQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDefaultTasksQuery, GetDefaultTasksQueryVariables>(GetDefaultTasksDocument, options);
      }
export function useGetDefaultTasksLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDefaultTasksQuery, GetDefaultTasksQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDefaultTasksQuery, GetDefaultTasksQueryVariables>(GetDefaultTasksDocument, options);
        }
export type GetDefaultTasksQueryHookResult = ReturnType<typeof useGetDefaultTasksQuery>;
export type GetDefaultTasksLazyQueryHookResult = ReturnType<typeof useGetDefaultTasksLazyQuery>;
export type GetDefaultTasksQueryResult = Apollo.QueryResult<GetDefaultTasksQuery, GetDefaultTasksQueryVariables>;
export function refetchGetDefaultTasksQuery(variables?: GetDefaultTasksQueryVariables) {
      return { query: GetDefaultTasksDocument, variables: variables }
    }
export const GetRolesDocument = gql`
    query getRoles {
  roles {
    id
    name
    userSet {
      id
      displayName
    }
  }
}
    `;

/**
 * __useGetRolesQuery__
 *
 * To run a query within a React component, call `useGetRolesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRolesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRolesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetRolesQuery(baseOptions?: Apollo.QueryHookOptions<GetRolesQuery, GetRolesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRolesQuery, GetRolesQueryVariables>(GetRolesDocument, options);
      }
export function useGetRolesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRolesQuery, GetRolesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRolesQuery, GetRolesQueryVariables>(GetRolesDocument, options);
        }
export type GetRolesQueryHookResult = ReturnType<typeof useGetRolesQuery>;
export type GetRolesLazyQueryHookResult = ReturnType<typeof useGetRolesLazyQuery>;
export type GetRolesQueryResult = Apollo.QueryResult<GetRolesQuery, GetRolesQueryVariables>;
export function refetchGetRolesQuery(variables?: GetRolesQueryVariables) {
      return { query: GetRolesDocument, variables: variables }
    }
export const GetValidEncNumberDocument = gql`
    query getValidEncNumber($ecnNumber: String!, $id: UUID) {
  validEcnNumber(ecnNumber: $ecnNumber, id: $id)
}
    `;

/**
 * __useGetValidEncNumberQuery__
 *
 * To run a query within a React component, call `useGetValidEncNumberQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetValidEncNumberQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetValidEncNumberQuery({
 *   variables: {
 *      ecnNumber: // value for 'ecnNumber'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetValidEncNumberQuery(baseOptions: Apollo.QueryHookOptions<GetValidEncNumberQuery, GetValidEncNumberQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetValidEncNumberQuery, GetValidEncNumberQueryVariables>(GetValidEncNumberDocument, options);
      }
export function useGetValidEncNumberLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetValidEncNumberQuery, GetValidEncNumberQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetValidEncNumberQuery, GetValidEncNumberQueryVariables>(GetValidEncNumberDocument, options);
        }
export type GetValidEncNumberQueryHookResult = ReturnType<typeof useGetValidEncNumberQuery>;
export type GetValidEncNumberLazyQueryHookResult = ReturnType<typeof useGetValidEncNumberLazyQuery>;
export type GetValidEncNumberQueryResult = Apollo.QueryResult<GetValidEncNumberQuery, GetValidEncNumberQueryVariables>;
export function refetchGetValidEncNumberQuery(variables: GetValidEncNumberQueryVariables) {
      return { query: GetValidEncNumberDocument, variables: variables }
    }
export const GetDraftEcnDocument = gql`
    query getDraftEcn($id: ID!, $uuid: UUID) {
  draftEcn(id: $id, uuid: $uuid) {
    ...DraftEcn
  }
}
    ${DraftEcnFragmentDoc}`;

/**
 * __useGetDraftEcnQuery__
 *
 * To run a query within a React component, call `useGetDraftEcnQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDraftEcnQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDraftEcnQuery({
 *   variables: {
 *      id: // value for 'id'
 *      uuid: // value for 'uuid'
 *   },
 * });
 */
export function useGetDraftEcnQuery(baseOptions: Apollo.QueryHookOptions<GetDraftEcnQuery, GetDraftEcnQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDraftEcnQuery, GetDraftEcnQueryVariables>(GetDraftEcnDocument, options);
      }
export function useGetDraftEcnLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDraftEcnQuery, GetDraftEcnQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDraftEcnQuery, GetDraftEcnQueryVariables>(GetDraftEcnDocument, options);
        }
export type GetDraftEcnQueryHookResult = ReturnType<typeof useGetDraftEcnQuery>;
export type GetDraftEcnLazyQueryHookResult = ReturnType<typeof useGetDraftEcnLazyQuery>;
export type GetDraftEcnQueryResult = Apollo.QueryResult<GetDraftEcnQuery, GetDraftEcnQueryVariables>;
export function refetchGetDraftEcnQuery(variables: GetDraftEcnQueryVariables) {
      return { query: GetDraftEcnDocument, variables: variables }
    }
export const GetProductOriginsDocument = gql`
    query getProductOrigins {
  productOrigins {
    ...ProductOriginOption
  }
}
    ${ProductOriginOptionFragmentDoc}`;

/**
 * __useGetProductOriginsQuery__
 *
 * To run a query within a React component, call `useGetProductOriginsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProductOriginsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProductOriginsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetProductOriginsQuery(baseOptions?: Apollo.QueryHookOptions<GetProductOriginsQuery, GetProductOriginsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProductOriginsQuery, GetProductOriginsQueryVariables>(GetProductOriginsDocument, options);
      }
export function useGetProductOriginsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProductOriginsQuery, GetProductOriginsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProductOriginsQuery, GetProductOriginsQueryVariables>(GetProductOriginsDocument, options);
        }
export type GetProductOriginsQueryHookResult = ReturnType<typeof useGetProductOriginsQuery>;
export type GetProductOriginsLazyQueryHookResult = ReturnType<typeof useGetProductOriginsLazyQuery>;
export type GetProductOriginsQueryResult = Apollo.QueryResult<GetProductOriginsQuery, GetProductOriginsQueryVariables>;
export function refetchGetProductOriginsQuery(variables?: GetProductOriginsQueryVariables) {
      return { query: GetProductOriginsDocument, variables: variables }
    }
export const GetDraftsEcnsDocument = gql`
    query getDraftsEcns($first: Int, $after: String, $before: String, $offset: Int, $orderBy: String, $last: Int, $query: String, $createdGte: Date, $createdLte: Date) {
  draftsEcns(
    first: $first
    after: $after
    before: $before
    offset: $offset
    orderBy: $orderBy
    last: $last
    query: $query
    createdGte: $createdGte
    createdLte: $createdLte
  ) {
    pageInfo {
      ...PageInfo
    }
    count
    edges {
      cursor
      node {
        ...DraftEcnList
      }
    }
  }
}
    ${PageInfoFragmentDoc}
${DraftEcnListFragmentDoc}`;

/**
 * __useGetDraftsEcnsQuery__
 *
 * To run a query within a React component, call `useGetDraftsEcnsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDraftsEcnsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDraftsEcnsQuery({
 *   variables: {
 *      first: // value for 'first'
 *      after: // value for 'after'
 *      before: // value for 'before'
 *      offset: // value for 'offset'
 *      orderBy: // value for 'orderBy'
 *      last: // value for 'last'
 *      query: // value for 'query'
 *      createdGte: // value for 'createdGte'
 *      createdLte: // value for 'createdLte'
 *   },
 * });
 */
export function useGetDraftsEcnsQuery(baseOptions?: Apollo.QueryHookOptions<GetDraftsEcnsQuery, GetDraftsEcnsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDraftsEcnsQuery, GetDraftsEcnsQueryVariables>(GetDraftsEcnsDocument, options);
      }
export function useGetDraftsEcnsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDraftsEcnsQuery, GetDraftsEcnsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDraftsEcnsQuery, GetDraftsEcnsQueryVariables>(GetDraftsEcnsDocument, options);
        }
export type GetDraftsEcnsQueryHookResult = ReturnType<typeof useGetDraftsEcnsQuery>;
export type GetDraftsEcnsLazyQueryHookResult = ReturnType<typeof useGetDraftsEcnsLazyQuery>;
export type GetDraftsEcnsQueryResult = Apollo.QueryResult<GetDraftsEcnsQuery, GetDraftsEcnsQueryVariables>;
export function refetchGetDraftsEcnsQuery(variables?: GetDraftsEcnsQueryVariables) {
      return { query: GetDraftsEcnsDocument, variables: variables }
    }
export const GetEcnsDocument = gql`
    query getEcns($first: Int, $after: String, $before: String, $offset: Int, $orderBy: String, $last: Int, $query: String, $createdGte: Date, $createdLte: Date, $createdByIn: [UUID], $releasedByIn: [UUID], $statusIn: [EcnsEcnStatusChoices], $tasksDone: Boolean, $recipientIn: [EcnsEcnRecipientChoices], $pendingTaskName: String, $pendingTaskNameIn: [String], $partsNumbers: [String], $seasonPriority: EcnsEcnSeasonPriorityChoices, $parts_Type_In: [EcnsEcnPartTypeChoices], $parts_NewParts_Type_In: [EcnsEcnNewPartTypeChoices], $tasksPendingForUsers: [String], $ecnNumber_In: [String], $effectiveDate_Gte: Date, $effectiveDate_Lte: Date, $warrantyPriority: Boolean, $tasksRolesUsersIn: [UUID]) {
  ecns(
    first: $first
    after: $after
    before: $before
    offset: $offset
    orderBy: $orderBy
    last: $last
    query: $query
    createdGte: $createdGte
    createdLte: $createdLte
    createdBy_In: $createdByIn
    realesedBy_In: $releasedByIn
    status_In: $statusIn
    tasks_Done: $tasksDone
    recipient_In: $recipientIn
    pendingTasksName: $pendingTaskName
    pendingTasksNameIn: $pendingTaskNameIn
    partsNumbers: $partsNumbers
    seasonPriority: $seasonPriority
    parts_Type_In: $parts_Type_In
    parts_NewParts_Type_In: $parts_NewParts_Type_In
    tasksPendingForUsers: $tasksPendingForUsers
    ecnNumber_In: $ecnNumber_In
    effectiveDate_Gte: $effectiveDate_Gte
    effectiveDate_Lte: $effectiveDate_Lte
    warrantyPriority: $warrantyPriority
    tasks_Roles_Users_Id_In: $tasksRolesUsersIn
  ) {
    pageInfo {
      ...PageInfo
    }
    count
    edges {
      cursor
      node {
        ...EcnList
      }
    }
  }
}
    ${PageInfoFragmentDoc}
${EcnListFragmentDoc}`;

/**
 * __useGetEcnsQuery__
 *
 * To run a query within a React component, call `useGetEcnsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEcnsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEcnsQuery({
 *   variables: {
 *      first: // value for 'first'
 *      after: // value for 'after'
 *      before: // value for 'before'
 *      offset: // value for 'offset'
 *      orderBy: // value for 'orderBy'
 *      last: // value for 'last'
 *      query: // value for 'query'
 *      createdGte: // value for 'createdGte'
 *      createdLte: // value for 'createdLte'
 *      createdByIn: // value for 'createdByIn'
 *      releasedByIn: // value for 'releasedByIn'
 *      statusIn: // value for 'statusIn'
 *      tasksDone: // value for 'tasksDone'
 *      recipientIn: // value for 'recipientIn'
 *      pendingTaskName: // value for 'pendingTaskName'
 *      pendingTaskNameIn: // value for 'pendingTaskNameIn'
 *      partsNumbers: // value for 'partsNumbers'
 *      seasonPriority: // value for 'seasonPriority'
 *      parts_Type_In: // value for 'parts_Type_In'
 *      parts_NewParts_Type_In: // value for 'parts_NewParts_Type_In'
 *      tasksPendingForUsers: // value for 'tasksPendingForUsers'
 *      ecnNumber_In: // value for 'ecnNumber_In'
 *      effectiveDate_Gte: // value for 'effectiveDate_Gte'
 *      effectiveDate_Lte: // value for 'effectiveDate_Lte'
 *      warrantyPriority: // value for 'warrantyPriority'
 *      tasksRolesUsersIn: // value for 'tasksRolesUsersIn'
 *   },
 * });
 */
export function useGetEcnsQuery(baseOptions?: Apollo.QueryHookOptions<GetEcnsQuery, GetEcnsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEcnsQuery, GetEcnsQueryVariables>(GetEcnsDocument, options);
      }
export function useGetEcnsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetEcnsQuery, GetEcnsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEcnsQuery, GetEcnsQueryVariables>(GetEcnsDocument, options);
        }
export type GetEcnsQueryHookResult = ReturnType<typeof useGetEcnsQuery>;
export type GetEcnsLazyQueryHookResult = ReturnType<typeof useGetEcnsLazyQuery>;
export type GetEcnsQueryResult = Apollo.QueryResult<GetEcnsQuery, GetEcnsQueryVariables>;
export function refetchGetEcnsQuery(variables?: GetEcnsQueryVariables) {
      return { query: GetEcnsDocument, variables: variables }
    }
export const GetPartsNumbersDocument = gql`
    query getPartsNumbers {
  partsNumbers {
    displayName
    externalId
  }
}
    `;

/**
 * __useGetPartsNumbersQuery__
 *
 * To run a query within a React component, call `useGetPartsNumbersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPartsNumbersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPartsNumbersQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetPartsNumbersQuery(baseOptions?: Apollo.QueryHookOptions<GetPartsNumbersQuery, GetPartsNumbersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPartsNumbersQuery, GetPartsNumbersQueryVariables>(GetPartsNumbersDocument, options);
      }
export function useGetPartsNumbersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPartsNumbersQuery, GetPartsNumbersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPartsNumbersQuery, GetPartsNumbersQueryVariables>(GetPartsNumbersDocument, options);
        }
export type GetPartsNumbersQueryHookResult = ReturnType<typeof useGetPartsNumbersQuery>;
export type GetPartsNumbersLazyQueryHookResult = ReturnType<typeof useGetPartsNumbersLazyQuery>;
export type GetPartsNumbersQueryResult = Apollo.QueryResult<GetPartsNumbersQuery, GetPartsNumbersQueryVariables>;
export function refetchGetPartsNumbersQuery(variables?: GetPartsNumbersQueryVariables) {
      return { query: GetPartsNumbersDocument, variables: variables }
    }
export const CreateEcnDocument = gql`
    mutation createEcn($input: CreateEcnMutationInput!) {
  createEcn(input: $input) {
    ecn {
      id
    }
    errors {
      ...Error
    }
  }
}
    ${ErrorFragmentDoc}`;
export type CreateEcnMutationFn = Apollo.MutationFunction<CreateEcnMutation, CreateEcnMutationVariables>;

/**
 * __useCreateEcnMutation__
 *
 * To run a mutation, you first call `useCreateEcnMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateEcnMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createEcnMutation, { data, loading, error }] = useCreateEcnMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateEcnMutation(baseOptions?: Apollo.MutationHookOptions<CreateEcnMutation, CreateEcnMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateEcnMutation, CreateEcnMutationVariables>(CreateEcnDocument, options);
      }
export type CreateEcnMutationHookResult = ReturnType<typeof useCreateEcnMutation>;
export type CreateEcnMutationResult = Apollo.MutationResult<CreateEcnMutation>;
export type CreateEcnMutationOptions = Apollo.BaseMutationOptions<CreateEcnMutation, CreateEcnMutationVariables>;
export const UpdateEcnDocument = gql`
    mutation updateEcn($input: UpdateEcnMutationInput!) {
  updateEcn(input: $input) {
    ecn {
      id
    }
    errors {
      ...Error
    }
  }
}
    ${ErrorFragmentDoc}`;
export type UpdateEcnMutationFn = Apollo.MutationFunction<UpdateEcnMutation, UpdateEcnMutationVariables>;

/**
 * __useUpdateEcnMutation__
 *
 * To run a mutation, you first call `useUpdateEcnMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateEcnMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateEcnMutation, { data, loading, error }] = useUpdateEcnMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateEcnMutation(baseOptions?: Apollo.MutationHookOptions<UpdateEcnMutation, UpdateEcnMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateEcnMutation, UpdateEcnMutationVariables>(UpdateEcnDocument, options);
      }
export type UpdateEcnMutationHookResult = ReturnType<typeof useUpdateEcnMutation>;
export type UpdateEcnMutationResult = Apollo.MutationResult<UpdateEcnMutation>;
export type UpdateEcnMutationOptions = Apollo.BaseMutationOptions<UpdateEcnMutation, UpdateEcnMutationVariables>;
export const EcnPricingTaskDocument = gql`
    mutation ecnPricingTask($input: PricingTaskMutationInput!) {
  ecnPricingTask(input: $input) {
    ecn {
      id
    }
    errors {
      ...Error
    }
  }
}
    ${ErrorFragmentDoc}`;
export type EcnPricingTaskMutationFn = Apollo.MutationFunction<EcnPricingTaskMutation, EcnPricingTaskMutationVariables>;

/**
 * __useEcnPricingTaskMutation__
 *
 * To run a mutation, you first call `useEcnPricingTaskMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEcnPricingTaskMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [ecnPricingTaskMutation, { data, loading, error }] = useEcnPricingTaskMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEcnPricingTaskMutation(baseOptions?: Apollo.MutationHookOptions<EcnPricingTaskMutation, EcnPricingTaskMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EcnPricingTaskMutation, EcnPricingTaskMutationVariables>(EcnPricingTaskDocument, options);
      }
export type EcnPricingTaskMutationHookResult = ReturnType<typeof useEcnPricingTaskMutation>;
export type EcnPricingTaskMutationResult = Apollo.MutationResult<EcnPricingTaskMutation>;
export type EcnPricingTaskMutationOptions = Apollo.BaseMutationOptions<EcnPricingTaskMutation, EcnPricingTaskMutationVariables>;
export const EcnForecastTaskDocument = gql`
    mutation ecnForecastTask($input: ForecastTaskMutationInput!) {
  ecnForecastTask(input: $input) {
    ecn {
      id
    }
    errors {
      ...Error
    }
  }
}
    ${ErrorFragmentDoc}`;
export type EcnForecastTaskMutationFn = Apollo.MutationFunction<EcnForecastTaskMutation, EcnForecastTaskMutationVariables>;

/**
 * __useEcnForecastTaskMutation__
 *
 * To run a mutation, you first call `useEcnForecastTaskMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEcnForecastTaskMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [ecnForecastTaskMutation, { data, loading, error }] = useEcnForecastTaskMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEcnForecastTaskMutation(baseOptions?: Apollo.MutationHookOptions<EcnForecastTaskMutation, EcnForecastTaskMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EcnForecastTaskMutation, EcnForecastTaskMutationVariables>(EcnForecastTaskDocument, options);
      }
export type EcnForecastTaskMutationHookResult = ReturnType<typeof useEcnForecastTaskMutation>;
export type EcnForecastTaskMutationResult = Apollo.MutationResult<EcnForecastTaskMutation>;
export type EcnForecastTaskMutationOptions = Apollo.BaseMutationOptions<EcnForecastTaskMutation, EcnForecastTaskMutationVariables>;
export const NewModCancelledPartsPurchaseTaskDocument = gql`
    mutation newModCancelledPartsPurchaseTask($input: NewModCancelledPartsPurchaseTaskMutationInput!) {
  newModCancelledPartsPurchaseTask(input: $input) {
    ecn {
      id
    }
    errors {
      ...Error
    }
  }
}
    ${ErrorFragmentDoc}`;
export type NewModCancelledPartsPurchaseTaskMutationFn = Apollo.MutationFunction<NewModCancelledPartsPurchaseTaskMutation, NewModCancelledPartsPurchaseTaskMutationVariables>;

/**
 * __useNewModCancelledPartsPurchaseTaskMutation__
 *
 * To run a mutation, you first call `useNewModCancelledPartsPurchaseTaskMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useNewModCancelledPartsPurchaseTaskMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [newModCancelledPartsPurchaseTaskMutation, { data, loading, error }] = useNewModCancelledPartsPurchaseTaskMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useNewModCancelledPartsPurchaseTaskMutation(baseOptions?: Apollo.MutationHookOptions<NewModCancelledPartsPurchaseTaskMutation, NewModCancelledPartsPurchaseTaskMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<NewModCancelledPartsPurchaseTaskMutation, NewModCancelledPartsPurchaseTaskMutationVariables>(NewModCancelledPartsPurchaseTaskDocument, options);
      }
export type NewModCancelledPartsPurchaseTaskMutationHookResult = ReturnType<typeof useNewModCancelledPartsPurchaseTaskMutation>;
export type NewModCancelledPartsPurchaseTaskMutationResult = Apollo.MutationResult<NewModCancelledPartsPurchaseTaskMutation>;
export type NewModCancelledPartsPurchaseTaskMutationOptions = Apollo.BaseMutationOptions<NewModCancelledPartsPurchaseTaskMutation, NewModCancelledPartsPurchaseTaskMutationVariables>;
export const NewModCancelPartsTaskDocument = gql`
    mutation newModCancelPartsTask($input: NewModCancelPartsTaskMutationInput!) {
  newModCancelPartsTask(input: $input) {
    ecn {
      id
    }
    errors {
      ...Error
    }
  }
}
    ${ErrorFragmentDoc}`;
export type NewModCancelPartsTaskMutationFn = Apollo.MutationFunction<NewModCancelPartsTaskMutation, NewModCancelPartsTaskMutationVariables>;

/**
 * __useNewModCancelPartsTaskMutation__
 *
 * To run a mutation, you first call `useNewModCancelPartsTaskMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useNewModCancelPartsTaskMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [newModCancelPartsTaskMutation, { data, loading, error }] = useNewModCancelPartsTaskMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useNewModCancelPartsTaskMutation(baseOptions?: Apollo.MutationHookOptions<NewModCancelPartsTaskMutation, NewModCancelPartsTaskMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<NewModCancelPartsTaskMutation, NewModCancelPartsTaskMutationVariables>(NewModCancelPartsTaskDocument, options);
      }
export type NewModCancelPartsTaskMutationHookResult = ReturnType<typeof useNewModCancelPartsTaskMutation>;
export type NewModCancelPartsTaskMutationResult = Apollo.MutationResult<NewModCancelPartsTaskMutation>;
export type NewModCancelPartsTaskMutationOptions = Apollo.BaseMutationOptions<NewModCancelPartsTaskMutation, NewModCancelPartsTaskMutationVariables>;
export const ProductSupportTaskDocument = gql`
    mutation productSupportTask($input: ProductSupportTaskMutationInput!) {
  productSupportTask(input: $input) {
    ecn {
      id
    }
    errors {
      ...Error
    }
  }
}
    ${ErrorFragmentDoc}`;
export type ProductSupportTaskMutationFn = Apollo.MutationFunction<ProductSupportTaskMutation, ProductSupportTaskMutationVariables>;

/**
 * __useProductSupportTaskMutation__
 *
 * To run a mutation, you first call `useProductSupportTaskMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProductSupportTaskMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [productSupportTaskMutation, { data, loading, error }] = useProductSupportTaskMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useProductSupportTaskMutation(baseOptions?: Apollo.MutationHookOptions<ProductSupportTaskMutation, ProductSupportTaskMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ProductSupportTaskMutation, ProductSupportTaskMutationVariables>(ProductSupportTaskDocument, options);
      }
export type ProductSupportTaskMutationHookResult = ReturnType<typeof useProductSupportTaskMutation>;
export type ProductSupportTaskMutationResult = Apollo.MutationResult<ProductSupportTaskMutation>;
export type ProductSupportTaskMutationOptions = Apollo.BaseMutationOptions<ProductSupportTaskMutation, ProductSupportTaskMutationVariables>;
export const EcnMarkAsSeenDocument = gql`
    mutation ecnMarkAsSeen($input: EcnMarkAsSeenMutationInput!) {
  ecnMarkAsSeen(input: $input) {
    ecn {
      id
    }
    errors {
      ...Error
    }
  }
}
    ${ErrorFragmentDoc}`;
export type EcnMarkAsSeenMutationFn = Apollo.MutationFunction<EcnMarkAsSeenMutation, EcnMarkAsSeenMutationVariables>;

/**
 * __useEcnMarkAsSeenMutation__
 *
 * To run a mutation, you first call `useEcnMarkAsSeenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEcnMarkAsSeenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [ecnMarkAsSeenMutation, { data, loading, error }] = useEcnMarkAsSeenMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEcnMarkAsSeenMutation(baseOptions?: Apollo.MutationHookOptions<EcnMarkAsSeenMutation, EcnMarkAsSeenMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EcnMarkAsSeenMutation, EcnMarkAsSeenMutationVariables>(EcnMarkAsSeenDocument, options);
      }
export type EcnMarkAsSeenMutationHookResult = ReturnType<typeof useEcnMarkAsSeenMutation>;
export type EcnMarkAsSeenMutationResult = Apollo.MutationResult<EcnMarkAsSeenMutation>;
export type EcnMarkAsSeenMutationOptions = Apollo.BaseMutationOptions<EcnMarkAsSeenMutation, EcnMarkAsSeenMutationVariables>;
export const DraftEcnDocument = gql`
    mutation draftEcn($input: DraftEcnMutationInput!) {
  draftEcn(input: $input) {
    draftEcn {
      id
      data
      blueprints {
        ...DraftBlueprintEcn
      }
    }
    errors {
      ...Error
    }
  }
}
    ${DraftBlueprintEcnFragmentDoc}
${ErrorFragmentDoc}`;
export type DraftEcnMutationFn = Apollo.MutationFunction<DraftEcnMutation, DraftEcnMutationVariables>;

/**
 * __useDraftEcnMutation__
 *
 * To run a mutation, you first call `useDraftEcnMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDraftEcnMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [draftEcnMutation, { data, loading, error }] = useDraftEcnMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDraftEcnMutation(baseOptions?: Apollo.MutationHookOptions<DraftEcnMutation, DraftEcnMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DraftEcnMutation, DraftEcnMutationVariables>(DraftEcnDocument, options);
      }
export type DraftEcnMutationHookResult = ReturnType<typeof useDraftEcnMutation>;
export type DraftEcnMutationResult = Apollo.MutationResult<DraftEcnMutation>;
export type DraftEcnMutationOptions = Apollo.BaseMutationOptions<DraftEcnMutation, DraftEcnMutationVariables>;
export const DeleteDraftEcnDocument = gql`
    mutation deleteDraftEcn($input: DeleteDraftEcnMutationInput!) {
  deleteDraftEcn(input: $input) {
    errors {
      ...Error
    }
  }
}
    ${ErrorFragmentDoc}`;
export type DeleteDraftEcnMutationFn = Apollo.MutationFunction<DeleteDraftEcnMutation, DeleteDraftEcnMutationVariables>;

/**
 * __useDeleteDraftEcnMutation__
 *
 * To run a mutation, you first call `useDeleteDraftEcnMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteDraftEcnMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteDraftEcnMutation, { data, loading, error }] = useDeleteDraftEcnMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteDraftEcnMutation(baseOptions?: Apollo.MutationHookOptions<DeleteDraftEcnMutation, DeleteDraftEcnMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteDraftEcnMutation, DeleteDraftEcnMutationVariables>(DeleteDraftEcnDocument, options);
      }
export type DeleteDraftEcnMutationHookResult = ReturnType<typeof useDeleteDraftEcnMutation>;
export type DeleteDraftEcnMutationResult = Apollo.MutationResult<DeleteDraftEcnMutation>;
export type DeleteDraftEcnMutationOptions = Apollo.BaseMutationOptions<DeleteDraftEcnMutation, DeleteDraftEcnMutationVariables>;
export const NotificateTasksForUserDocument = gql`
    mutation notificateTasksForUser($input: NotificateTasksForUserInput!) {
  notificateTasksForUser(input: $input) {
    errors {
      ...Error
    }
  }
}
    ${ErrorFragmentDoc}`;
export type NotificateTasksForUserMutationFn = Apollo.MutationFunction<NotificateTasksForUserMutation, NotificateTasksForUserMutationVariables>;

/**
 * __useNotificateTasksForUserMutation__
 *
 * To run a mutation, you first call `useNotificateTasksForUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useNotificateTasksForUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [notificateTasksForUserMutation, { data, loading, error }] = useNotificateTasksForUserMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useNotificateTasksForUserMutation(baseOptions?: Apollo.MutationHookOptions<NotificateTasksForUserMutation, NotificateTasksForUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<NotificateTasksForUserMutation, NotificateTasksForUserMutationVariables>(NotificateTasksForUserDocument, options);
      }
export type NotificateTasksForUserMutationHookResult = ReturnType<typeof useNotificateTasksForUserMutation>;
export type NotificateTasksForUserMutationResult = Apollo.MutationResult<NotificateTasksForUserMutation>;
export type NotificateTasksForUserMutationOptions = Apollo.BaseMutationOptions<NotificateTasksForUserMutation, NotificateTasksForUserMutationVariables>;
export const UpdateEffectiveDateDocument = gql`
    mutation updateEffectiveDate($id: UUID!, $effectiveDate: Date!) {
  updateEffectiveDate(id: $id, effectiveDate: $effectiveDate) {
    ecn {
      id
    }
  }
}
    `;
export type UpdateEffectiveDateMutationFn = Apollo.MutationFunction<UpdateEffectiveDateMutation, UpdateEffectiveDateMutationVariables>;

/**
 * __useUpdateEffectiveDateMutation__
 *
 * To run a mutation, you first call `useUpdateEffectiveDateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateEffectiveDateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateEffectiveDateMutation, { data, loading, error }] = useUpdateEffectiveDateMutation({
 *   variables: {
 *      id: // value for 'id'
 *      effectiveDate: // value for 'effectiveDate'
 *   },
 * });
 */
export function useUpdateEffectiveDateMutation(baseOptions?: Apollo.MutationHookOptions<UpdateEffectiveDateMutation, UpdateEffectiveDateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateEffectiveDateMutation, UpdateEffectiveDateMutationVariables>(UpdateEffectiveDateDocument, options);
      }
export type UpdateEffectiveDateMutationHookResult = ReturnType<typeof useUpdateEffectiveDateMutation>;
export type UpdateEffectiveDateMutationResult = Apollo.MutationResult<UpdateEffectiveDateMutation>;
export type UpdateEffectiveDateMutationOptions = Apollo.BaseMutationOptions<UpdateEffectiveDateMutation, UpdateEffectiveDateMutationVariables>;
export const GetEcnTaskCommentsDocument = gql`
    query getEcnTaskComments($taskId: UUID) {
  taskComments(task_Id: $taskId) {
    pageInfo {
      ...PageInfo
    }
    edges {
      node {
        ...EcnTaskComment
      }
    }
    count
  }
}
    ${PageInfoFragmentDoc}
${EcnTaskCommentFragmentDoc}`;

/**
 * __useGetEcnTaskCommentsQuery__
 *
 * To run a query within a React component, call `useGetEcnTaskCommentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEcnTaskCommentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEcnTaskCommentsQuery({
 *   variables: {
 *      taskId: // value for 'taskId'
 *   },
 * });
 */
export function useGetEcnTaskCommentsQuery(baseOptions?: Apollo.QueryHookOptions<GetEcnTaskCommentsQuery, GetEcnTaskCommentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEcnTaskCommentsQuery, GetEcnTaskCommentsQueryVariables>(GetEcnTaskCommentsDocument, options);
      }
export function useGetEcnTaskCommentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetEcnTaskCommentsQuery, GetEcnTaskCommentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEcnTaskCommentsQuery, GetEcnTaskCommentsQueryVariables>(GetEcnTaskCommentsDocument, options);
        }
export type GetEcnTaskCommentsQueryHookResult = ReturnType<typeof useGetEcnTaskCommentsQuery>;
export type GetEcnTaskCommentsLazyQueryHookResult = ReturnType<typeof useGetEcnTaskCommentsLazyQuery>;
export type GetEcnTaskCommentsQueryResult = Apollo.QueryResult<GetEcnTaskCommentsQuery, GetEcnTaskCommentsQueryVariables>;
export function refetchGetEcnTaskCommentsQuery(variables?: GetEcnTaskCommentsQueryVariables) {
      return { query: GetEcnTaskCommentsDocument, variables: variables }
    }
export const EcnTaskCommentDocument = gql`
    mutation ecnTaskComment($input: EcnTaskCommentMutationInput!) {
  ecnTaskComment(input: $input) {
    ecnTaskComment {
      ...EcnTaskComment
    }
    errors {
      ...Error
    }
  }
}
    ${EcnTaskCommentFragmentDoc}
${ErrorFragmentDoc}`;
export type EcnTaskCommentMutationFn = Apollo.MutationFunction<EcnTaskCommentMutation, EcnTaskCommentMutationVariables>;

/**
 * __useEcnTaskCommentMutation__
 *
 * To run a mutation, you first call `useEcnTaskCommentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEcnTaskCommentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [ecnTaskCommentMutation, { data, loading, error }] = useEcnTaskCommentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEcnTaskCommentMutation(baseOptions?: Apollo.MutationHookOptions<EcnTaskCommentMutation, EcnTaskCommentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EcnTaskCommentMutation, EcnTaskCommentMutationVariables>(EcnTaskCommentDocument, options);
      }
export type EcnTaskCommentMutationHookResult = ReturnType<typeof useEcnTaskCommentMutation>;
export type EcnTaskCommentMutationResult = Apollo.MutationResult<EcnTaskCommentMutation>;
export type EcnTaskCommentMutationOptions = Apollo.BaseMutationOptions<EcnTaskCommentMutation, EcnTaskCommentMutationVariables>;
export const PartsArrivalTaskDocument = gql`
    mutation partsArrivalTask($input: PartsArrivalTaskMutationInput!) {
  partsArrivalTask(input: $input) {
    ecn {
      id
    }
    errors {
      ...Error
    }
  }
}
    ${ErrorFragmentDoc}`;
export type PartsArrivalTaskMutationFn = Apollo.MutationFunction<PartsArrivalTaskMutation, PartsArrivalTaskMutationVariables>;

/**
 * __usePartsArrivalTaskMutation__
 *
 * To run a mutation, you first call `usePartsArrivalTaskMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePartsArrivalTaskMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [partsArrivalTaskMutation, { data, loading, error }] = usePartsArrivalTaskMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePartsArrivalTaskMutation(baseOptions?: Apollo.MutationHookOptions<PartsArrivalTaskMutation, PartsArrivalTaskMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PartsArrivalTaskMutation, PartsArrivalTaskMutationVariables>(PartsArrivalTaskDocument, options);
      }
export type PartsArrivalTaskMutationHookResult = ReturnType<typeof usePartsArrivalTaskMutation>;
export type PartsArrivalTaskMutationResult = Apollo.MutationResult<PartsArrivalTaskMutation>;
export type PartsArrivalTaskMutationOptions = Apollo.BaseMutationOptions<PartsArrivalTaskMutation, PartsArrivalTaskMutationVariables>;
export const EcnFilesDocument = gql`
    mutation ecnFiles($ecnId: UUID!, $files: [Upload!]!) {
  ecnFiles(ecnId: $ecnId, files: $files) {
    ecnFiles {
      id
      file
    }
    errors {
      ...Error
    }
  }
}
    ${ErrorFragmentDoc}`;
export type EcnFilesMutationFn = Apollo.MutationFunction<EcnFilesMutation, EcnFilesMutationVariables>;

/**
 * __useEcnFilesMutation__
 *
 * To run a mutation, you first call `useEcnFilesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEcnFilesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [ecnFilesMutation, { data, loading, error }] = useEcnFilesMutation({
 *   variables: {
 *      ecnId: // value for 'ecnId'
 *      files: // value for 'files'
 *   },
 * });
 */
export function useEcnFilesMutation(baseOptions?: Apollo.MutationHookOptions<EcnFilesMutation, EcnFilesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EcnFilesMutation, EcnFilesMutationVariables>(EcnFilesDocument, options);
      }
export type EcnFilesMutationHookResult = ReturnType<typeof useEcnFilesMutation>;
export type EcnFilesMutationResult = Apollo.MutationResult<EcnFilesMutation>;
export type EcnFilesMutationOptions = Apollo.BaseMutationOptions<EcnFilesMutation, EcnFilesMutationVariables>;
export const DeleteEcnFileDocument = gql`
    mutation deleteEcnFile($id: UUID!) {
  deleteEcnFile(id: $id) {
    ok
    id
  }
}
    `;
export type DeleteEcnFileMutationFn = Apollo.MutationFunction<DeleteEcnFileMutation, DeleteEcnFileMutationVariables>;

/**
 * __useDeleteEcnFileMutation__
 *
 * To run a mutation, you first call `useDeleteEcnFileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteEcnFileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteEcnFileMutation, { data, loading, error }] = useDeleteEcnFileMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteEcnFileMutation(baseOptions?: Apollo.MutationHookOptions<DeleteEcnFileMutation, DeleteEcnFileMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteEcnFileMutation, DeleteEcnFileMutationVariables>(DeleteEcnFileDocument, options);
      }
export type DeleteEcnFileMutationHookResult = ReturnType<typeof useDeleteEcnFileMutation>;
export type DeleteEcnFileMutationResult = Apollo.MutationResult<DeleteEcnFileMutation>;
export type DeleteEcnFileMutationOptions = Apollo.BaseMutationOptions<DeleteEcnFileMutation, DeleteEcnFileMutationVariables>;
export const EcnAnalyticsDocument = gql`
    query ecnAnalytics($filters: AnalyticsFilters!) {
  ecnAnalytics(filters: $filters) {
    byStatus {
      label
      count
    }
    accumulatedInProgressByEcn {
      label
      count
    }
    accumulatedWithoutEffectiveDateByEcn {
      label
      count
    }
    byEffectiveDate {
      label
      count
    }
    byWarrantyPriorityInProgress {
      label
      count
    }
    byWarrantyPriorityInProgress {
      label
      count
    }
    byWarrantyPriority {
      label
      count
    }
    byEffectiveDateAndSeasonPriority {
      label
      lowCount
      mediumCount
      highCount
    }
    byPartType {
      label
      count
    }
    accumulatedInProgress {
      min
      max
      avg
    }
    accumulatedWithoutEffectiveDate {
      min
      max
      avg
    }
    bySeasonPriority {
      label
      count
    }
  }
}
    `;

/**
 * __useEcnAnalyticsQuery__
 *
 * To run a query within a React component, call `useEcnAnalyticsQuery` and pass it any options that fit your needs.
 * When your component renders, `useEcnAnalyticsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEcnAnalyticsQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useEcnAnalyticsQuery(baseOptions: Apollo.QueryHookOptions<EcnAnalyticsQuery, EcnAnalyticsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EcnAnalyticsQuery, EcnAnalyticsQueryVariables>(EcnAnalyticsDocument, options);
      }
export function useEcnAnalyticsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EcnAnalyticsQuery, EcnAnalyticsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EcnAnalyticsQuery, EcnAnalyticsQueryVariables>(EcnAnalyticsDocument, options);
        }
export type EcnAnalyticsQueryHookResult = ReturnType<typeof useEcnAnalyticsQuery>;
export type EcnAnalyticsLazyQueryHookResult = ReturnType<typeof useEcnAnalyticsLazyQuery>;
export type EcnAnalyticsQueryResult = Apollo.QueryResult<EcnAnalyticsQuery, EcnAnalyticsQueryVariables>;
export function refetchEcnAnalyticsQuery(variables: EcnAnalyticsQueryVariables) {
      return { query: EcnAnalyticsDocument, variables: variables }
    }
export const CancelEcnDocument = gql`
    mutation cancelEcn($id: UUID!) {
  cancelEcn(id: $id) {
    ok
  }
}
    `;
export type CancelEcnMutationFn = Apollo.MutationFunction<CancelEcnMutation, CancelEcnMutationVariables>;

/**
 * __useCancelEcnMutation__
 *
 * To run a mutation, you first call `useCancelEcnMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCancelEcnMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cancelEcnMutation, { data, loading, error }] = useCancelEcnMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCancelEcnMutation(baseOptions?: Apollo.MutationHookOptions<CancelEcnMutation, CancelEcnMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CancelEcnMutation, CancelEcnMutationVariables>(CancelEcnDocument, options);
      }
export type CancelEcnMutationHookResult = ReturnType<typeof useCancelEcnMutation>;
export type CancelEcnMutationResult = Apollo.MutationResult<CancelEcnMutation>;
export type CancelEcnMutationOptions = Apollo.BaseMutationOptions<CancelEcnMutation, CancelEcnMutationVariables>;
export const MakeEcnEffectiveDocument = gql`
    mutation makeEcnEffective($input: MakeEcnEffectiveMutationInput!) {
  makeEcnEffective(input: $input) {
    ecn {
      id
    }
    errors {
      ...Error
    }
  }
}
    ${ErrorFragmentDoc}`;
export type MakeEcnEffectiveMutationFn = Apollo.MutationFunction<MakeEcnEffectiveMutation, MakeEcnEffectiveMutationVariables>;

/**
 * __useMakeEcnEffectiveMutation__
 *
 * To run a mutation, you first call `useMakeEcnEffectiveMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMakeEcnEffectiveMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [makeEcnEffectiveMutation, { data, loading, error }] = useMakeEcnEffectiveMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useMakeEcnEffectiveMutation(baseOptions?: Apollo.MutationHookOptions<MakeEcnEffectiveMutation, MakeEcnEffectiveMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MakeEcnEffectiveMutation, MakeEcnEffectiveMutationVariables>(MakeEcnEffectiveDocument, options);
      }
export type MakeEcnEffectiveMutationHookResult = ReturnType<typeof useMakeEcnEffectiveMutation>;
export type MakeEcnEffectiveMutationResult = Apollo.MutationResult<MakeEcnEffectiveMutation>;
export type MakeEcnEffectiveMutationOptions = Apollo.BaseMutationOptions<MakeEcnEffectiveMutation, MakeEcnEffectiveMutationVariables>;
export const ValidExternalIdDocument = gql`
    query validExternalId($externalId: String!, $ignoreId: UUID) {
  validExternalId(externalId: $externalId, ignoreId: $ignoreId)
}
    `;

/**
 * __useValidExternalIdQuery__
 *
 * To run a query within a React component, call `useValidExternalIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useValidExternalIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useValidExternalIdQuery({
 *   variables: {
 *      externalId: // value for 'externalId'
 *      ignoreId: // value for 'ignoreId'
 *   },
 * });
 */
export function useValidExternalIdQuery(baseOptions: Apollo.QueryHookOptions<ValidExternalIdQuery, ValidExternalIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ValidExternalIdQuery, ValidExternalIdQueryVariables>(ValidExternalIdDocument, options);
      }
export function useValidExternalIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ValidExternalIdQuery, ValidExternalIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ValidExternalIdQuery, ValidExternalIdQueryVariables>(ValidExternalIdDocument, options);
        }
export type ValidExternalIdQueryHookResult = ReturnType<typeof useValidExternalIdQuery>;
export type ValidExternalIdLazyQueryHookResult = ReturnType<typeof useValidExternalIdLazyQuery>;
export type ValidExternalIdQueryResult = Apollo.QueryResult<ValidExternalIdQuery, ValidExternalIdQueryVariables>;
export function refetchValidExternalIdQuery(variables: ValidExternalIdQueryVariables) {
      return { query: ValidExternalIdDocument, variables: variables }
    }
export const EcnHistoryDiffDocument = gql`
    query ecnHistoryDiff($id: UUID!) {
  ecnHistoryDiff(id: $id) {
    changes {
      field
      old
      new
      verboseField
    }
    changedFields
    date
    updatedBy {
      ...MinimalUser
    }
  }
}
    ${MinimalUserFragmentDoc}`;

/**
 * __useEcnHistoryDiffQuery__
 *
 * To run a query within a React component, call `useEcnHistoryDiffQuery` and pass it any options that fit your needs.
 * When your component renders, `useEcnHistoryDiffQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEcnHistoryDiffQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useEcnHistoryDiffQuery(baseOptions: Apollo.QueryHookOptions<EcnHistoryDiffQuery, EcnHistoryDiffQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EcnHistoryDiffQuery, EcnHistoryDiffQueryVariables>(EcnHistoryDiffDocument, options);
      }
export function useEcnHistoryDiffLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EcnHistoryDiffQuery, EcnHistoryDiffQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EcnHistoryDiffQuery, EcnHistoryDiffQueryVariables>(EcnHistoryDiffDocument, options);
        }
export type EcnHistoryDiffQueryHookResult = ReturnType<typeof useEcnHistoryDiffQuery>;
export type EcnHistoryDiffLazyQueryHookResult = ReturnType<typeof useEcnHistoryDiffLazyQuery>;
export type EcnHistoryDiffQueryResult = Apollo.QueryResult<EcnHistoryDiffQuery, EcnHistoryDiffQueryVariables>;
export function refetchEcnHistoryDiffQuery(variables: EcnHistoryDiffQueryVariables) {
      return { query: EcnHistoryDiffDocument, variables: variables }
    }
export const GetPaymentMethodCategoriesDocument = gql`
    query getPaymentMethodCategories {
  paymentMethodCategories {
    id
    name
    finnancied
  }
}
    `;

/**
 * __useGetPaymentMethodCategoriesQuery__
 *
 * To run a query within a React component, call `useGetPaymentMethodCategoriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPaymentMethodCategoriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPaymentMethodCategoriesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetPaymentMethodCategoriesQuery(baseOptions?: Apollo.QueryHookOptions<GetPaymentMethodCategoriesQuery, GetPaymentMethodCategoriesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPaymentMethodCategoriesQuery, GetPaymentMethodCategoriesQueryVariables>(GetPaymentMethodCategoriesDocument, options);
      }
export function useGetPaymentMethodCategoriesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPaymentMethodCategoriesQuery, GetPaymentMethodCategoriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPaymentMethodCategoriesQuery, GetPaymentMethodCategoriesQueryVariables>(GetPaymentMethodCategoriesDocument, options);
        }
export type GetPaymentMethodCategoriesQueryHookResult = ReturnType<typeof useGetPaymentMethodCategoriesQuery>;
export type GetPaymentMethodCategoriesLazyQueryHookResult = ReturnType<typeof useGetPaymentMethodCategoriesLazyQuery>;
export type GetPaymentMethodCategoriesQueryResult = Apollo.QueryResult<GetPaymentMethodCategoriesQuery, GetPaymentMethodCategoriesQueryVariables>;
export function refetchGetPaymentMethodCategoriesQuery(variables?: GetPaymentMethodCategoriesQueryVariables) {
      return { query: GetPaymentMethodCategoriesDocument, variables: variables }
    }
export const GetPaymentMethodsDocument = gql`
    query getPaymentMethods {
  paymentMethods {
    ...PaymentMethod
  }
}
    ${PaymentMethodFragmentDoc}`;

/**
 * __useGetPaymentMethodsQuery__
 *
 * To run a query within a React component, call `useGetPaymentMethodsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPaymentMethodsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPaymentMethodsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetPaymentMethodsQuery(baseOptions?: Apollo.QueryHookOptions<GetPaymentMethodsQuery, GetPaymentMethodsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPaymentMethodsQuery, GetPaymentMethodsQueryVariables>(GetPaymentMethodsDocument, options);
      }
export function useGetPaymentMethodsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPaymentMethodsQuery, GetPaymentMethodsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPaymentMethodsQuery, GetPaymentMethodsQueryVariables>(GetPaymentMethodsDocument, options);
        }
export type GetPaymentMethodsQueryHookResult = ReturnType<typeof useGetPaymentMethodsQuery>;
export type GetPaymentMethodsLazyQueryHookResult = ReturnType<typeof useGetPaymentMethodsLazyQuery>;
export type GetPaymentMethodsQueryResult = Apollo.QueryResult<GetPaymentMethodsQuery, GetPaymentMethodsQueryVariables>;
export function refetchGetPaymentMethodsQuery(variables?: GetPaymentMethodsQueryVariables) {
      return { query: GetPaymentMethodsDocument, variables: variables }
    }
export const GetPaymentMethodDocument = gql`
    query getPaymentMethod($id: UUID) {
  paymentMethod(id: $id) {
    ...PaymentMethod
  }
}
    ${PaymentMethodFragmentDoc}`;

/**
 * __useGetPaymentMethodQuery__
 *
 * To run a query within a React component, call `useGetPaymentMethodQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPaymentMethodQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPaymentMethodQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetPaymentMethodQuery(baseOptions?: Apollo.QueryHookOptions<GetPaymentMethodQuery, GetPaymentMethodQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPaymentMethodQuery, GetPaymentMethodQueryVariables>(GetPaymentMethodDocument, options);
      }
export function useGetPaymentMethodLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPaymentMethodQuery, GetPaymentMethodQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPaymentMethodQuery, GetPaymentMethodQueryVariables>(GetPaymentMethodDocument, options);
        }
export type GetPaymentMethodQueryHookResult = ReturnType<typeof useGetPaymentMethodQuery>;
export type GetPaymentMethodLazyQueryHookResult = ReturnType<typeof useGetPaymentMethodLazyQuery>;
export type GetPaymentMethodQueryResult = Apollo.QueryResult<GetPaymentMethodQuery, GetPaymentMethodQueryVariables>;
export function refetchGetPaymentMethodQuery(variables?: GetPaymentMethodQueryVariables) {
      return { query: GetPaymentMethodDocument, variables: variables }
    }
export const GetPaymentMethodOptionsDocument = gql`
    query getPaymentMethodOptions($categoryId: UUID, $organizationId: UUID) {
  paymentMethods(categoryId: $categoryId, organizationId: $organizationId) {
    id
    name
  }
}
    `;

/**
 * __useGetPaymentMethodOptionsQuery__
 *
 * To run a query within a React component, call `useGetPaymentMethodOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPaymentMethodOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPaymentMethodOptionsQuery({
 *   variables: {
 *      categoryId: // value for 'categoryId'
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useGetPaymentMethodOptionsQuery(baseOptions?: Apollo.QueryHookOptions<GetPaymentMethodOptionsQuery, GetPaymentMethodOptionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPaymentMethodOptionsQuery, GetPaymentMethodOptionsQueryVariables>(GetPaymentMethodOptionsDocument, options);
      }
export function useGetPaymentMethodOptionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPaymentMethodOptionsQuery, GetPaymentMethodOptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPaymentMethodOptionsQuery, GetPaymentMethodOptionsQueryVariables>(GetPaymentMethodOptionsDocument, options);
        }
export type GetPaymentMethodOptionsQueryHookResult = ReturnType<typeof useGetPaymentMethodOptionsQuery>;
export type GetPaymentMethodOptionsLazyQueryHookResult = ReturnType<typeof useGetPaymentMethodOptionsLazyQuery>;
export type GetPaymentMethodOptionsQueryResult = Apollo.QueryResult<GetPaymentMethodOptionsQuery, GetPaymentMethodOptionsQueryVariables>;
export function refetchGetPaymentMethodOptionsQuery(variables?: GetPaymentMethodOptionsQueryVariables) {
      return { query: GetPaymentMethodOptionsDocument, variables: variables }
    }
export const GetCategoriesDocument = gql`
    query getCategories($enabledForSeeder: Boolean, $seederId: UUID) {
  categories(enabledForSeeder: $enabledForSeeder, seederId: $seederId) {
    edges {
      node {
        ...CategoryOption
      }
    }
    pageInfo {
      ...PageInfo
    }
  }
}
    ${CategoryOptionFragmentDoc}
${PageInfoFragmentDoc}`;

/**
 * __useGetCategoriesQuery__
 *
 * To run a query within a React component, call `useGetCategoriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCategoriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCategoriesQuery({
 *   variables: {
 *      enabledForSeeder: // value for 'enabledForSeeder'
 *      seederId: // value for 'seederId'
 *   },
 * });
 */
export function useGetCategoriesQuery(baseOptions?: Apollo.QueryHookOptions<GetCategoriesQuery, GetCategoriesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCategoriesQuery, GetCategoriesQueryVariables>(GetCategoriesDocument, options);
      }
export function useGetCategoriesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCategoriesQuery, GetCategoriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCategoriesQuery, GetCategoriesQueryVariables>(GetCategoriesDocument, options);
        }
export type GetCategoriesQueryHookResult = ReturnType<typeof useGetCategoriesQuery>;
export type GetCategoriesLazyQueryHookResult = ReturnType<typeof useGetCategoriesLazyQuery>;
export type GetCategoriesQueryResult = Apollo.QueryResult<GetCategoriesQuery, GetCategoriesQueryVariables>;
export function refetchGetCategoriesQuery(variables?: GetCategoriesQueryVariables) {
      return { query: GetCategoriesDocument, variables: variables }
    }
export const GetCategoriesForAssistedQuoteDocument = gql`
    query getCategoriesForAssistedQuote {
  categories(enabledForAssistedQuote: true) {
    edges {
      cursor
      node {
        ...CategoryOption
      }
    }
    pageInfo {
      ...PageInfo
    }
  }
}
    ${CategoryOptionFragmentDoc}
${PageInfoFragmentDoc}`;

/**
 * __useGetCategoriesForAssistedQuoteQuery__
 *
 * To run a query within a React component, call `useGetCategoriesForAssistedQuoteQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCategoriesForAssistedQuoteQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCategoriesForAssistedQuoteQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetCategoriesForAssistedQuoteQuery(baseOptions?: Apollo.QueryHookOptions<GetCategoriesForAssistedQuoteQuery, GetCategoriesForAssistedQuoteQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCategoriesForAssistedQuoteQuery, GetCategoriesForAssistedQuoteQueryVariables>(GetCategoriesForAssistedQuoteDocument, options);
      }
export function useGetCategoriesForAssistedQuoteLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCategoriesForAssistedQuoteQuery, GetCategoriesForAssistedQuoteQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCategoriesForAssistedQuoteQuery, GetCategoriesForAssistedQuoteQueryVariables>(GetCategoriesForAssistedQuoteDocument, options);
        }
export type GetCategoriesForAssistedQuoteQueryHookResult = ReturnType<typeof useGetCategoriesForAssistedQuoteQuery>;
export type GetCategoriesForAssistedQuoteLazyQueryHookResult = ReturnType<typeof useGetCategoriesForAssistedQuoteLazyQuery>;
export type GetCategoriesForAssistedQuoteQueryResult = Apollo.QueryResult<GetCategoriesForAssistedQuoteQuery, GetCategoriesForAssistedQuoteQueryVariables>;
export function refetchGetCategoriesForAssistedQuoteQuery(variables?: GetCategoriesForAssistedQuoteQueryVariables) {
      return { query: GetCategoriesForAssistedQuoteDocument, variables: variables }
    }
export const GetProductOptionsDocument = gql`
    query getProductOptions($query: String, $name: String, $externalIdIcontains: String) {
  products(query: $query, name: $name, externalIdIcontains: $externalIdIcontains) {
    pageInfo {
      ...PageInfo
    }
    edges {
      cursor
      node {
        id
        uuid
        name
        displayName
        externalId
        published
        subcategory {
          id
          category {
            id
            uuid
          }
        }
      }
    }
  }
}
    ${PageInfoFragmentDoc}`;

/**
 * __useGetProductOptionsQuery__
 *
 * To run a query within a React component, call `useGetProductOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProductOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProductOptionsQuery({
 *   variables: {
 *      query: // value for 'query'
 *      name: // value for 'name'
 *      externalIdIcontains: // value for 'externalIdIcontains'
 *   },
 * });
 */
export function useGetProductOptionsQuery(baseOptions?: Apollo.QueryHookOptions<GetProductOptionsQuery, GetProductOptionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProductOptionsQuery, GetProductOptionsQueryVariables>(GetProductOptionsDocument, options);
      }
export function useGetProductOptionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProductOptionsQuery, GetProductOptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProductOptionsQuery, GetProductOptionsQueryVariables>(GetProductOptionsDocument, options);
        }
export type GetProductOptionsQueryHookResult = ReturnType<typeof useGetProductOptionsQuery>;
export type GetProductOptionsLazyQueryHookResult = ReturnType<typeof useGetProductOptionsLazyQuery>;
export type GetProductOptionsQueryResult = Apollo.QueryResult<GetProductOptionsQuery, GetProductOptionsQueryVariables>;
export function refetchGetProductOptionsQuery(variables?: GetProductOptionsQueryVariables) {
      return { query: GetProductOptionsDocument, variables: variables }
    }
export const GetProductDocument = gql`
    query getProduct($id: ID!, $uuid: UUID) {
  product(id: $id, uuid: $uuid) {
    ...Product
  }
}
    ${ProductFragmentDoc}`;

/**
 * __useGetProductQuery__
 *
 * To run a query within a React component, call `useGetProductQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProductQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProductQuery({
 *   variables: {
 *      id: // value for 'id'
 *      uuid: // value for 'uuid'
 *   },
 * });
 */
export function useGetProductQuery(baseOptions: Apollo.QueryHookOptions<GetProductQuery, GetProductQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProductQuery, GetProductQueryVariables>(GetProductDocument, options);
      }
export function useGetProductLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProductQuery, GetProductQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProductQuery, GetProductQueryVariables>(GetProductDocument, options);
        }
export type GetProductQueryHookResult = ReturnType<typeof useGetProductQuery>;
export type GetProductLazyQueryHookResult = ReturnType<typeof useGetProductLazyQuery>;
export type GetProductQueryResult = Apollo.QueryResult<GetProductQuery, GetProductQueryVariables>;
export function refetchGetProductQuery(variables: GetProductQueryVariables) {
      return { query: GetProductDocument, variables: variables }
    }
export const GetProductsDocument = gql`
    query getProducts($idIn: [ID], $externalIdIn: [String]) {
  products(id_In: $idIn, externalId_In: $externalIdIn) {
    edges {
      cursor
      node {
        ...Product
      }
    }
    pageInfo {
      ...PageInfo
    }
  }
}
    ${ProductFragmentDoc}
${PageInfoFragmentDoc}`;

/**
 * __useGetProductsQuery__
 *
 * To run a query within a React component, call `useGetProductsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProductsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProductsQuery({
 *   variables: {
 *      idIn: // value for 'idIn'
 *      externalIdIn: // value for 'externalIdIn'
 *   },
 * });
 */
export function useGetProductsQuery(baseOptions?: Apollo.QueryHookOptions<GetProductsQuery, GetProductsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProductsQuery, GetProductsQueryVariables>(GetProductsDocument, options);
      }
export function useGetProductsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProductsQuery, GetProductsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProductsQuery, GetProductsQueryVariables>(GetProductsDocument, options);
        }
export type GetProductsQueryHookResult = ReturnType<typeof useGetProductsQuery>;
export type GetProductsLazyQueryHookResult = ReturnType<typeof useGetProductsLazyQuery>;
export type GetProductsQueryResult = Apollo.QueryResult<GetProductsQuery, GetProductsQueryVariables>;
export function refetchGetProductsQuery(variables?: GetProductsQueryVariables) {
      return { query: GetProductsDocument, variables: variables }
    }
export const GetProductsEffectiveDatesDocument = gql`
    query getProductsEffectiveDates($idIn: [ID], $externalIdIn: [String]) {
  products(id_In: $idIn, externalId_In: $externalIdIn) {
    edges {
      node {
        ...ProductEffectiveDate
      }
    }
  }
}
    ${ProductEffectiveDateFragmentDoc}`;

/**
 * __useGetProductsEffectiveDatesQuery__
 *
 * To run a query within a React component, call `useGetProductsEffectiveDatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProductsEffectiveDatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProductsEffectiveDatesQuery({
 *   variables: {
 *      idIn: // value for 'idIn'
 *      externalIdIn: // value for 'externalIdIn'
 *   },
 * });
 */
export function useGetProductsEffectiveDatesQuery(baseOptions?: Apollo.QueryHookOptions<GetProductsEffectiveDatesQuery, GetProductsEffectiveDatesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProductsEffectiveDatesQuery, GetProductsEffectiveDatesQueryVariables>(GetProductsEffectiveDatesDocument, options);
      }
export function useGetProductsEffectiveDatesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProductsEffectiveDatesQuery, GetProductsEffectiveDatesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProductsEffectiveDatesQuery, GetProductsEffectiveDatesQueryVariables>(GetProductsEffectiveDatesDocument, options);
        }
export type GetProductsEffectiveDatesQueryHookResult = ReturnType<typeof useGetProductsEffectiveDatesQuery>;
export type GetProductsEffectiveDatesLazyQueryHookResult = ReturnType<typeof useGetProductsEffectiveDatesLazyQuery>;
export type GetProductsEffectiveDatesQueryResult = Apollo.QueryResult<GetProductsEffectiveDatesQuery, GetProductsEffectiveDatesQueryVariables>;
export function refetchGetProductsEffectiveDatesQuery(variables?: GetProductsEffectiveDatesQueryVariables) {
      return { query: GetProductsEffectiveDatesDocument, variables: variables }
    }
export const GetProductPriceModifiersDocument = gql`
    query getProductPriceModifiers($accountId: UUID!) {
  productPriceModifiers(accountId: $accountId) {
    ...ProductPriceModifiers
  }
}
    ${ProductPriceModifiersFragmentDoc}`;

/**
 * __useGetProductPriceModifiersQuery__
 *
 * To run a query within a React component, call `useGetProductPriceModifiersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProductPriceModifiersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProductPriceModifiersQuery({
 *   variables: {
 *      accountId: // value for 'accountId'
 *   },
 * });
 */
export function useGetProductPriceModifiersQuery(baseOptions: Apollo.QueryHookOptions<GetProductPriceModifiersQuery, GetProductPriceModifiersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProductPriceModifiersQuery, GetProductPriceModifiersQueryVariables>(GetProductPriceModifiersDocument, options);
      }
export function useGetProductPriceModifiersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProductPriceModifiersQuery, GetProductPriceModifiersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProductPriceModifiersQuery, GetProductPriceModifiersQueryVariables>(GetProductPriceModifiersDocument, options);
        }
export type GetProductPriceModifiersQueryHookResult = ReturnType<typeof useGetProductPriceModifiersQuery>;
export type GetProductPriceModifiersLazyQueryHookResult = ReturnType<typeof useGetProductPriceModifiersLazyQuery>;
export type GetProductPriceModifiersQueryResult = Apollo.QueryResult<GetProductPriceModifiersQuery, GetProductPriceModifiersQueryVariables>;
export function refetchGetProductPriceModifiersQuery(variables: GetProductPriceModifiersQueryVariables) {
      return { query: GetProductPriceModifiersDocument, variables: variables }
    }
export const GetSubcategoriesDocument = gql`
    query getSubcategories {
  subcategories {
    ...Subcategory
  }
}
    ${SubcategoryFragmentDoc}`;

/**
 * __useGetSubcategoriesQuery__
 *
 * To run a query within a React component, call `useGetSubcategoriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSubcategoriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSubcategoriesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetSubcategoriesQuery(baseOptions?: Apollo.QueryHookOptions<GetSubcategoriesQuery, GetSubcategoriesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSubcategoriesQuery, GetSubcategoriesQueryVariables>(GetSubcategoriesDocument, options);
      }
export function useGetSubcategoriesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSubcategoriesQuery, GetSubcategoriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSubcategoriesQuery, GetSubcategoriesQueryVariables>(GetSubcategoriesDocument, options);
        }
export type GetSubcategoriesQueryHookResult = ReturnType<typeof useGetSubcategoriesQuery>;
export type GetSubcategoriesLazyQueryHookResult = ReturnType<typeof useGetSubcategoriesLazyQuery>;
export type GetSubcategoriesQueryResult = Apollo.QueryResult<GetSubcategoriesQuery, GetSubcategoriesQueryVariables>;
export function refetchGetSubcategoriesQuery(variables?: GetSubcategoriesQueryVariables) {
      return { query: GetSubcategoriesDocument, variables: variables }
    }
export const GetQuoteRulesDocument = gql`
    query getQuoteRules {
  quoteRules {
    ...QuoteRule
  }
}
    ${QuoteRuleFragmentDoc}`;

/**
 * __useGetQuoteRulesQuery__
 *
 * To run a query within a React component, call `useGetQuoteRulesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetQuoteRulesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetQuoteRulesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetQuoteRulesQuery(baseOptions?: Apollo.QueryHookOptions<GetQuoteRulesQuery, GetQuoteRulesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetQuoteRulesQuery, GetQuoteRulesQueryVariables>(GetQuoteRulesDocument, options);
      }
export function useGetQuoteRulesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetQuoteRulesQuery, GetQuoteRulesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetQuoteRulesQuery, GetQuoteRulesQueryVariables>(GetQuoteRulesDocument, options);
        }
export type GetQuoteRulesQueryHookResult = ReturnType<typeof useGetQuoteRulesQuery>;
export type GetQuoteRulesLazyQueryHookResult = ReturnType<typeof useGetQuoteRulesLazyQuery>;
export type GetQuoteRulesQueryResult = Apollo.QueryResult<GetQuoteRulesQuery, GetQuoteRulesQueryVariables>;
export function refetchGetQuoteRulesQuery(variables?: GetQuoteRulesQueryVariables) {
      return { query: GetQuoteRulesDocument, variables: variables }
    }
export const GetProductsImagesDocument = gql`
    query getProductsImages($externalIds: [String!]!) {
  productsImages(externalIds: $externalIds) {
    image
    externalId
    uuid
    id
  }
}
    `;

/**
 * __useGetProductsImagesQuery__
 *
 * To run a query within a React component, call `useGetProductsImagesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProductsImagesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProductsImagesQuery({
 *   variables: {
 *      externalIds: // value for 'externalIds'
 *   },
 * });
 */
export function useGetProductsImagesQuery(baseOptions: Apollo.QueryHookOptions<GetProductsImagesQuery, GetProductsImagesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProductsImagesQuery, GetProductsImagesQueryVariables>(GetProductsImagesDocument, options);
      }
export function useGetProductsImagesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProductsImagesQuery, GetProductsImagesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProductsImagesQuery, GetProductsImagesQueryVariables>(GetProductsImagesDocument, options);
        }
export type GetProductsImagesQueryHookResult = ReturnType<typeof useGetProductsImagesQuery>;
export type GetProductsImagesLazyQueryHookResult = ReturnType<typeof useGetProductsImagesLazyQuery>;
export type GetProductsImagesQueryResult = Apollo.QueryResult<GetProductsImagesQuery, GetProductsImagesQueryVariables>;
export function refetchGetProductsImagesQuery(variables: GetProductsImagesQueryVariables) {
      return { query: GetProductsImagesDocument, variables: variables }
    }
export const GetMinimalProductsForAssistedQuoteDocument = gql`
    query getMinimalProductsForAssistedQuote {
  products {
    pageInfo {
      ...PageInfo
    }
    edges {
      cursor
      node {
        id
        uuid
        ruleCategories {
          id
          uuid
        }
      }
    }
  }
}
    ${PageInfoFragmentDoc}`;

/**
 * __useGetMinimalProductsForAssistedQuoteQuery__
 *
 * To run a query within a React component, call `useGetMinimalProductsForAssistedQuoteQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMinimalProductsForAssistedQuoteQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMinimalProductsForAssistedQuoteQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetMinimalProductsForAssistedQuoteQuery(baseOptions?: Apollo.QueryHookOptions<GetMinimalProductsForAssistedQuoteQuery, GetMinimalProductsForAssistedQuoteQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMinimalProductsForAssistedQuoteQuery, GetMinimalProductsForAssistedQuoteQueryVariables>(GetMinimalProductsForAssistedQuoteDocument, options);
      }
export function useGetMinimalProductsForAssistedQuoteLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMinimalProductsForAssistedQuoteQuery, GetMinimalProductsForAssistedQuoteQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMinimalProductsForAssistedQuoteQuery, GetMinimalProductsForAssistedQuoteQueryVariables>(GetMinimalProductsForAssistedQuoteDocument, options);
        }
export type GetMinimalProductsForAssistedQuoteQueryHookResult = ReturnType<typeof useGetMinimalProductsForAssistedQuoteQuery>;
export type GetMinimalProductsForAssistedQuoteLazyQueryHookResult = ReturnType<typeof useGetMinimalProductsForAssistedQuoteLazyQuery>;
export type GetMinimalProductsForAssistedQuoteQueryResult = Apollo.QueryResult<GetMinimalProductsForAssistedQuoteQuery, GetMinimalProductsForAssistedQuoteQueryVariables>;
export function refetchGetMinimalProductsForAssistedQuoteQuery(variables?: GetMinimalProductsForAssistedQuoteQueryVariables) {
      return { query: GetMinimalProductsForAssistedQuoteDocument, variables: variables }
    }
export const GetBundlesDocument = gql`
    query getBundles {
  bundles {
    id
    name
    multiplier
    selectable
    items {
      quantity
      product {
        ...QuotedProductPayload
        published
      }
    }
  }
}
    ${QuotedProductPayloadFragmentDoc}`;

/**
 * __useGetBundlesQuery__
 *
 * To run a query within a React component, call `useGetBundlesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBundlesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBundlesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetBundlesQuery(baseOptions?: Apollo.QueryHookOptions<GetBundlesQuery, GetBundlesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetBundlesQuery, GetBundlesQueryVariables>(GetBundlesDocument, options);
      }
export function useGetBundlesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetBundlesQuery, GetBundlesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetBundlesQuery, GetBundlesQueryVariables>(GetBundlesDocument, options);
        }
export type GetBundlesQueryHookResult = ReturnType<typeof useGetBundlesQuery>;
export type GetBundlesLazyQueryHookResult = ReturnType<typeof useGetBundlesLazyQuery>;
export type GetBundlesQueryResult = Apollo.QueryResult<GetBundlesQuery, GetBundlesQueryVariables>;
export function refetchGetBundlesQuery(variables?: GetBundlesQueryVariables) {
      return { query: GetBundlesDocument, variables: variables }
    }
export const GetProductsForAssistedQuoteDocument = gql`
    query getProductsForAssistedQuote($idIn: [ID]) {
  products(id_In: $idIn) {
    edges {
      cursor
      node {
        ...QuotedProductPayload
      }
    }
    pageInfo {
      ...PageInfo
    }
  }
}
    ${QuotedProductPayloadFragmentDoc}
${PageInfoFragmentDoc}`;

/**
 * __useGetProductsForAssistedQuoteQuery__
 *
 * To run a query within a React component, call `useGetProductsForAssistedQuoteQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProductsForAssistedQuoteQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProductsForAssistedQuoteQuery({
 *   variables: {
 *      idIn: // value for 'idIn'
 *   },
 * });
 */
export function useGetProductsForAssistedQuoteQuery(baseOptions?: Apollo.QueryHookOptions<GetProductsForAssistedQuoteQuery, GetProductsForAssistedQuoteQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProductsForAssistedQuoteQuery, GetProductsForAssistedQuoteQueryVariables>(GetProductsForAssistedQuoteDocument, options);
      }
export function useGetProductsForAssistedQuoteLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProductsForAssistedQuoteQuery, GetProductsForAssistedQuoteQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProductsForAssistedQuoteQuery, GetProductsForAssistedQuoteQueryVariables>(GetProductsForAssistedQuoteDocument, options);
        }
export type GetProductsForAssistedQuoteQueryHookResult = ReturnType<typeof useGetProductsForAssistedQuoteQuery>;
export type GetProductsForAssistedQuoteLazyQueryHookResult = ReturnType<typeof useGetProductsForAssistedQuoteLazyQuery>;
export type GetProductsForAssistedQuoteQueryResult = Apollo.QueryResult<GetProductsForAssistedQuoteQuery, GetProductsForAssistedQuoteQueryVariables>;
export function refetchGetProductsForAssistedQuoteQuery(variables?: GetProductsForAssistedQuoteQueryVariables) {
      return { query: GetProductsForAssistedQuoteDocument, variables: variables }
    }
export const GetProductsPriceDocument = gql`
    query getProductsPrice($idIn: [ID], $externalIdIn: [String]) {
  products(id_In: $idIn, externalId_In: $externalIdIn) {
    edges {
      node {
        id
        uuid
        externalId
        price
      }
    }
  }
}
    `;

/**
 * __useGetProductsPriceQuery__
 *
 * To run a query within a React component, call `useGetProductsPriceQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProductsPriceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProductsPriceQuery({
 *   variables: {
 *      idIn: // value for 'idIn'
 *      externalIdIn: // value for 'externalIdIn'
 *   },
 * });
 */
export function useGetProductsPriceQuery(baseOptions?: Apollo.QueryHookOptions<GetProductsPriceQuery, GetProductsPriceQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProductsPriceQuery, GetProductsPriceQueryVariables>(GetProductsPriceDocument, options);
      }
export function useGetProductsPriceLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProductsPriceQuery, GetProductsPriceQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProductsPriceQuery, GetProductsPriceQueryVariables>(GetProductsPriceDocument, options);
        }
export type GetProductsPriceQueryHookResult = ReturnType<typeof useGetProductsPriceQuery>;
export type GetProductsPriceLazyQueryHookResult = ReturnType<typeof useGetProductsPriceLazyQuery>;
export type GetProductsPriceQueryResult = Apollo.QueryResult<GetProductsPriceQuery, GetProductsPriceQueryVariables>;
export function refetchGetProductsPriceQuery(variables?: GetProductsPriceQueryVariables) {
      return { query: GetProductsPriceDocument, variables: variables }
    }
export const CreateQuoteDocument = gql`
    mutation createQuote($input: CreateQuoteMutationInput!) {
  createQuote(input: $input) {
    errors {
      ...Error
    }
    quote {
      id
      uuid
    }
  }
}
    ${ErrorFragmentDoc}`;
export type CreateQuoteMutationFn = Apollo.MutationFunction<CreateQuoteMutation, CreateQuoteMutationVariables>;

/**
 * __useCreateQuoteMutation__
 *
 * To run a mutation, you first call `useCreateQuoteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateQuoteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createQuoteMutation, { data, loading, error }] = useCreateQuoteMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateQuoteMutation(baseOptions?: Apollo.MutationHookOptions<CreateQuoteMutation, CreateQuoteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateQuoteMutation, CreateQuoteMutationVariables>(CreateQuoteDocument, options);
      }
export type CreateQuoteMutationHookResult = ReturnType<typeof useCreateQuoteMutation>;
export type CreateQuoteMutationResult = Apollo.MutationResult<CreateQuoteMutation>;
export type CreateQuoteMutationOptions = Apollo.BaseMutationOptions<CreateQuoteMutation, CreateQuoteMutationVariables>;
export const UpdateQuoteDocument = gql`
    mutation updateQuote($input: UpdateQuoteMutationInput!) {
  updateQuote(input: $input) {
    errors {
      ...Error
    }
    quote {
      id
      uuid
    }
  }
}
    ${ErrorFragmentDoc}`;
export type UpdateQuoteMutationFn = Apollo.MutationFunction<UpdateQuoteMutation, UpdateQuoteMutationVariables>;

/**
 * __useUpdateQuoteMutation__
 *
 * To run a mutation, you first call `useUpdateQuoteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateQuoteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateQuoteMutation, { data, loading, error }] = useUpdateQuoteMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateQuoteMutation(baseOptions?: Apollo.MutationHookOptions<UpdateQuoteMutation, UpdateQuoteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateQuoteMutation, UpdateQuoteMutationVariables>(UpdateQuoteDocument, options);
      }
export type UpdateQuoteMutationHookResult = ReturnType<typeof useUpdateQuoteMutation>;
export type UpdateQuoteMutationResult = Apollo.MutationResult<UpdateQuoteMutation>;
export type UpdateQuoteMutationOptions = Apollo.BaseMutationOptions<UpdateQuoteMutation, UpdateQuoteMutationVariables>;
export const GetQuoteEditDocument = gql`
    query getQuoteEdit($id: ID!, $uuid: UUID) {
  quote(id: $id, uuid: $uuid) {
    ...QuoteEdit
  }
}
    ${QuoteEditFragmentDoc}`;

/**
 * __useGetQuoteEditQuery__
 *
 * To run a query within a React component, call `useGetQuoteEditQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetQuoteEditQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetQuoteEditQuery({
 *   variables: {
 *      id: // value for 'id'
 *      uuid: // value for 'uuid'
 *   },
 * });
 */
export function useGetQuoteEditQuery(baseOptions: Apollo.QueryHookOptions<GetQuoteEditQuery, GetQuoteEditQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetQuoteEditQuery, GetQuoteEditQueryVariables>(GetQuoteEditDocument, options);
      }
export function useGetQuoteEditLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetQuoteEditQuery, GetQuoteEditQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetQuoteEditQuery, GetQuoteEditQueryVariables>(GetQuoteEditDocument, options);
        }
export type GetQuoteEditQueryHookResult = ReturnType<typeof useGetQuoteEditQuery>;
export type GetQuoteEditLazyQueryHookResult = ReturnType<typeof useGetQuoteEditLazyQuery>;
export type GetQuoteEditQueryResult = Apollo.QueryResult<GetQuoteEditQuery, GetQuoteEditQueryVariables>;
export function refetchGetQuoteEditQuery(variables: GetQuoteEditQueryVariables) {
      return { query: GetQuoteEditDocument, variables: variables }
    }
export const GetQuoteKitMultipliersDocument = gql`
    query getQuoteKitMultipliers {
  quoteKitMultipliers {
    ...QuoteKitMultiplier
  }
}
    ${QuoteKitMultiplierFragmentDoc}`;

/**
 * __useGetQuoteKitMultipliersQuery__
 *
 * To run a query within a React component, call `useGetQuoteKitMultipliersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetQuoteKitMultipliersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetQuoteKitMultipliersQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetQuoteKitMultipliersQuery(baseOptions?: Apollo.QueryHookOptions<GetQuoteKitMultipliersQuery, GetQuoteKitMultipliersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetQuoteKitMultipliersQuery, GetQuoteKitMultipliersQueryVariables>(GetQuoteKitMultipliersDocument, options);
      }
export function useGetQuoteKitMultipliersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetQuoteKitMultipliersQuery, GetQuoteKitMultipliersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetQuoteKitMultipliersQuery, GetQuoteKitMultipliersQueryVariables>(GetQuoteKitMultipliersDocument, options);
        }
export type GetQuoteKitMultipliersQueryHookResult = ReturnType<typeof useGetQuoteKitMultipliersQuery>;
export type GetQuoteKitMultipliersLazyQueryHookResult = ReturnType<typeof useGetQuoteKitMultipliersLazyQuery>;
export type GetQuoteKitMultipliersQueryResult = Apollo.QueryResult<GetQuoteKitMultipliersQuery, GetQuoteKitMultipliersQueryVariables>;
export function refetchGetQuoteKitMultipliersQuery(variables?: GetQuoteKitMultipliersQueryVariables) {
      return { query: GetQuoteKitMultipliersDocument, variables: variables }
    }
export const GetQuoteKitMultiplierDocument = gql`
    query getQuoteKitMultiplier($id: UUID!) {
  quoteKitMultiplier(id: $id) {
    ...QuoteKitMultiplier
  }
}
    ${QuoteKitMultiplierFragmentDoc}`;

/**
 * __useGetQuoteKitMultiplierQuery__
 *
 * To run a query within a React component, call `useGetQuoteKitMultiplierQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetQuoteKitMultiplierQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetQuoteKitMultiplierQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetQuoteKitMultiplierQuery(baseOptions: Apollo.QueryHookOptions<GetQuoteKitMultiplierQuery, GetQuoteKitMultiplierQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetQuoteKitMultiplierQuery, GetQuoteKitMultiplierQueryVariables>(GetQuoteKitMultiplierDocument, options);
      }
export function useGetQuoteKitMultiplierLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetQuoteKitMultiplierQuery, GetQuoteKitMultiplierQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetQuoteKitMultiplierQuery, GetQuoteKitMultiplierQueryVariables>(GetQuoteKitMultiplierDocument, options);
        }
export type GetQuoteKitMultiplierQueryHookResult = ReturnType<typeof useGetQuoteKitMultiplierQuery>;
export type GetQuoteKitMultiplierLazyQueryHookResult = ReturnType<typeof useGetQuoteKitMultiplierLazyQuery>;
export type GetQuoteKitMultiplierQueryResult = Apollo.QueryResult<GetQuoteKitMultiplierQuery, GetQuoteKitMultiplierQueryVariables>;
export function refetchGetQuoteKitMultiplierQuery(variables: GetQuoteKitMultiplierQueryVariables) {
      return { query: GetQuoteKitMultiplierDocument, variables: variables }
    }
export const GetQuotesDocument = gql`
    query getQuotes($first: Int, $after: String, $before: String, $offset: Int, $orderBy: String, $last: Int, $query: String, $createdGte: Date, $createdLte: Date, $owner: UUID, $accountGlobalId: UUID, $contactGlobalId: UUID, $user: UUID, $status: QuotesQuoteStatusChoices, $product: String) {
  quotes(
    first: $first
    after: $after
    before: $before
    offset: $offset
    orderBy: $orderBy
    last: $last
    contact_Account_Id: $accountGlobalId
    contact_Id: $contactGlobalId
    query: $query
    contact_Account_Owner_Id: $owner
    createdGte: $createdGte
    createdLte: $createdLte
    user: $user
    status: $status
    product: $product
  ) {
    count
    pageInfo {
      ...PageInfo
    }
    edges {
      cursor
      node {
        ...QuoteList
      }
    }
  }
}
    ${PageInfoFragmentDoc}
${QuoteListFragmentDoc}`;

/**
 * __useGetQuotesQuery__
 *
 * To run a query within a React component, call `useGetQuotesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetQuotesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetQuotesQuery({
 *   variables: {
 *      first: // value for 'first'
 *      after: // value for 'after'
 *      before: // value for 'before'
 *      offset: // value for 'offset'
 *      orderBy: // value for 'orderBy'
 *      last: // value for 'last'
 *      query: // value for 'query'
 *      createdGte: // value for 'createdGte'
 *      createdLte: // value for 'createdLte'
 *      owner: // value for 'owner'
 *      accountGlobalId: // value for 'accountGlobalId'
 *      contactGlobalId: // value for 'contactGlobalId'
 *      user: // value for 'user'
 *      status: // value for 'status'
 *      product: // value for 'product'
 *   },
 * });
 */
export function useGetQuotesQuery(baseOptions?: Apollo.QueryHookOptions<GetQuotesQuery, GetQuotesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetQuotesQuery, GetQuotesQueryVariables>(GetQuotesDocument, options);
      }
export function useGetQuotesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetQuotesQuery, GetQuotesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetQuotesQuery, GetQuotesQueryVariables>(GetQuotesDocument, options);
        }
export type GetQuotesQueryHookResult = ReturnType<typeof useGetQuotesQuery>;
export type GetQuotesLazyQueryHookResult = ReturnType<typeof useGetQuotesLazyQuery>;
export type GetQuotesQueryResult = Apollo.QueryResult<GetQuotesQuery, GetQuotesQueryVariables>;
export function refetchGetQuotesQuery(variables?: GetQuotesQueryVariables) {
      return { query: GetQuotesDocument, variables: variables }
    }
export const GetQuoteDocument = gql`
    query getQuote($id: ID!, $uuid: UUID) {
  quote(id: $id, uuid: $uuid) {
    ...Quote
  }
}
    ${QuoteFragmentDoc}`;

/**
 * __useGetQuoteQuery__
 *
 * To run a query within a React component, call `useGetQuoteQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetQuoteQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetQuoteQuery({
 *   variables: {
 *      id: // value for 'id'
 *      uuid: // value for 'uuid'
 *   },
 * });
 */
export function useGetQuoteQuery(baseOptions: Apollo.QueryHookOptions<GetQuoteQuery, GetQuoteQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetQuoteQuery, GetQuoteQueryVariables>(GetQuoteDocument, options);
      }
export function useGetQuoteLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetQuoteQuery, GetQuoteQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetQuoteQuery, GetQuoteQueryVariables>(GetQuoteDocument, options);
        }
export type GetQuoteQueryHookResult = ReturnType<typeof useGetQuoteQuery>;
export type GetQuoteLazyQueryHookResult = ReturnType<typeof useGetQuoteLazyQuery>;
export type GetQuoteQueryResult = Apollo.QueryResult<GetQuoteQuery, GetQuoteQueryVariables>;
export function refetchGetQuoteQuery(variables: GetQuoteQueryVariables) {
      return { query: GetQuoteDocument, variables: variables }
    }
export const ExportExcelQuotesDocument = gql`
    mutation exportExcelQuotes($query: String, $createdGte: Date, $createdLte: Date, $owner: UUID, $accountGlobalId: UUID, $contactGlobalId: UUID, $user: UUID, $status: QuotesQuoteStatusChoices, $product: String, $quoteId: UUID, $paymentMethodId: UUID) {
  exportExcelQuotes(
    contact_Account_Id: $accountGlobalId
    contact_Id: $contactGlobalId
    query: $query
    contact_Account_Owner_Id: $owner
    createdGte: $createdGte
    createdLte: $createdLte
    user: $user
    status: $status
    product: $product
    quoteId: $quoteId
    paymentMethodId: $paymentMethodId
  ) {
    job {
      id
      status
    }
  }
}
    `;
export type ExportExcelQuotesMutationFn = Apollo.MutationFunction<ExportExcelQuotesMutation, ExportExcelQuotesMutationVariables>;

/**
 * __useExportExcelQuotesMutation__
 *
 * To run a mutation, you first call `useExportExcelQuotesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useExportExcelQuotesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [exportExcelQuotesMutation, { data, loading, error }] = useExportExcelQuotesMutation({
 *   variables: {
 *      query: // value for 'query'
 *      createdGte: // value for 'createdGte'
 *      createdLte: // value for 'createdLte'
 *      owner: // value for 'owner'
 *      accountGlobalId: // value for 'accountGlobalId'
 *      contactGlobalId: // value for 'contactGlobalId'
 *      user: // value for 'user'
 *      status: // value for 'status'
 *      product: // value for 'product'
 *      quoteId: // value for 'quoteId'
 *      paymentMethodId: // value for 'paymentMethodId'
 *   },
 * });
 */
export function useExportExcelQuotesMutation(baseOptions?: Apollo.MutationHookOptions<ExportExcelQuotesMutation, ExportExcelQuotesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ExportExcelQuotesMutation, ExportExcelQuotesMutationVariables>(ExportExcelQuotesDocument, options);
      }
export type ExportExcelQuotesMutationHookResult = ReturnType<typeof useExportExcelQuotesMutation>;
export type ExportExcelQuotesMutationResult = Apollo.MutationResult<ExportExcelQuotesMutation>;
export type ExportExcelQuotesMutationOptions = Apollo.BaseMutationOptions<ExportExcelQuotesMutation, ExportExcelQuotesMutationVariables>;
export const UpdateQuotePricesDocument = gql`
    mutation updateQuotePrices($input: UpdateQuotePricesMutationInput!) {
  updateQuotePrices(input: $input) {
    quote {
      id
    }
    errors {
      ...Error
    }
  }
}
    ${ErrorFragmentDoc}`;
export type UpdateQuotePricesMutationFn = Apollo.MutationFunction<UpdateQuotePricesMutation, UpdateQuotePricesMutationVariables>;

/**
 * __useUpdateQuotePricesMutation__
 *
 * To run a mutation, you first call `useUpdateQuotePricesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateQuotePricesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateQuotePricesMutation, { data, loading, error }] = useUpdateQuotePricesMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateQuotePricesMutation(baseOptions?: Apollo.MutationHookOptions<UpdateQuotePricesMutation, UpdateQuotePricesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateQuotePricesMutation, UpdateQuotePricesMutationVariables>(UpdateQuotePricesDocument, options);
      }
export type UpdateQuotePricesMutationHookResult = ReturnType<typeof useUpdateQuotePricesMutation>;
export type UpdateQuotePricesMutationResult = Apollo.MutationResult<UpdateQuotePricesMutation>;
export type UpdateQuotePricesMutationOptions = Apollo.BaseMutationOptions<UpdateQuotePricesMutation, UpdateQuotePricesMutationVariables>;
export const DeleteQuoteDocument = gql`
    mutation deleteQuote($input: DeleteQuoteMutationInput!) {
  deleteQuote(input: $input) {
    errors {
      ...Error
    }
  }
}
    ${ErrorFragmentDoc}`;
export type DeleteQuoteMutationFn = Apollo.MutationFunction<DeleteQuoteMutation, DeleteQuoteMutationVariables>;

/**
 * __useDeleteQuoteMutation__
 *
 * To run a mutation, you first call `useDeleteQuoteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteQuoteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteQuoteMutation, { data, loading, error }] = useDeleteQuoteMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteQuoteMutation(baseOptions?: Apollo.MutationHookOptions<DeleteQuoteMutation, DeleteQuoteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteQuoteMutation, DeleteQuoteMutationVariables>(DeleteQuoteDocument, options);
      }
export type DeleteQuoteMutationHookResult = ReturnType<typeof useDeleteQuoteMutation>;
export type DeleteQuoteMutationResult = Apollo.MutationResult<DeleteQuoteMutation>;
export type DeleteQuoteMutationOptions = Apollo.BaseMutationOptions<DeleteQuoteMutation, DeleteQuoteMutationVariables>;
export const CreateBankInvoicePdfDocument = gql`
    mutation createBankInvoicePDF($paymentMethodUuid: UUID!, $quoteUuid: UUID!) {
  createBankInvicePdf(paymentMethodId: $paymentMethodUuid, quoteId: $quoteUuid) {
    job {
      id
    }
    errors {
      ...Error
    }
  }
}
    ${ErrorFragmentDoc}`;
export type CreateBankInvoicePdfMutationFn = Apollo.MutationFunction<CreateBankInvoicePdfMutation, CreateBankInvoicePdfMutationVariables>;

/**
 * __useCreateBankInvoicePdfMutation__
 *
 * To run a mutation, you first call `useCreateBankInvoicePdfMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateBankInvoicePdfMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createBankInvoicePdfMutation, { data, loading, error }] = useCreateBankInvoicePdfMutation({
 *   variables: {
 *      paymentMethodUuid: // value for 'paymentMethodUuid'
 *      quoteUuid: // value for 'quoteUuid'
 *   },
 * });
 */
export function useCreateBankInvoicePdfMutation(baseOptions?: Apollo.MutationHookOptions<CreateBankInvoicePdfMutation, CreateBankInvoicePdfMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateBankInvoicePdfMutation, CreateBankInvoicePdfMutationVariables>(CreateBankInvoicePdfDocument, options);
      }
export type CreateBankInvoicePdfMutationHookResult = ReturnType<typeof useCreateBankInvoicePdfMutation>;
export type CreateBankInvoicePdfMutationResult = Apollo.MutationResult<CreateBankInvoicePdfMutation>;
export type CreateBankInvoicePdfMutationOptions = Apollo.BaseMutationOptions<CreateBankInvoicePdfMutation, CreateBankInvoicePdfMutationVariables>;
export const CreateQuotePdfDocument = gql`
    mutation createQuotePdf($paymentMethodId: UUID, $productDisplay: QuotesQuotePDFProductDisplayChoices, $quoteUuid: UUID!, $recipient: String, $type: QuotesQuotePDFTypeChoices) {
  createQuotePdf(
    paymentMethodId: $paymentMethodId
    productDisplay: $productDisplay
    quoteId: $quoteUuid
    recipient: $recipient
    type: $type
  ) {
    job {
      id
    }
    errors {
      ...Error
    }
  }
}
    ${ErrorFragmentDoc}`;
export type CreateQuotePdfMutationFn = Apollo.MutationFunction<CreateQuotePdfMutation, CreateQuotePdfMutationVariables>;

/**
 * __useCreateQuotePdfMutation__
 *
 * To run a mutation, you first call `useCreateQuotePdfMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateQuotePdfMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createQuotePdfMutation, { data, loading, error }] = useCreateQuotePdfMutation({
 *   variables: {
 *      paymentMethodId: // value for 'paymentMethodId'
 *      productDisplay: // value for 'productDisplay'
 *      quoteUuid: // value for 'quoteUuid'
 *      recipient: // value for 'recipient'
 *      type: // value for 'type'
 *   },
 * });
 */
export function useCreateQuotePdfMutation(baseOptions?: Apollo.MutationHookOptions<CreateQuotePdfMutation, CreateQuotePdfMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateQuotePdfMutation, CreateQuotePdfMutationVariables>(CreateQuotePdfDocument, options);
      }
export type CreateQuotePdfMutationHookResult = ReturnType<typeof useCreateQuotePdfMutation>;
export type CreateQuotePdfMutationResult = Apollo.MutationResult<CreateQuotePdfMutation>;
export type CreateQuotePdfMutationOptions = Apollo.BaseMutationOptions<CreateQuotePdfMutation, CreateQuotePdfMutationVariables>;
export const GetBankInvoicePdfDisclaimerDocument = gql`
    query getBankInvoicePdfDisclaimer {
  bankInvoicePdfDisclaimer {
    ...BankInvoicePdfDisclaimer
  }
}
    ${BankInvoicePdfDisclaimerFragmentDoc}`;

/**
 * __useGetBankInvoicePdfDisclaimerQuery__
 *
 * To run a query within a React component, call `useGetBankInvoicePdfDisclaimerQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBankInvoicePdfDisclaimerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBankInvoicePdfDisclaimerQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetBankInvoicePdfDisclaimerQuery(baseOptions?: Apollo.QueryHookOptions<GetBankInvoicePdfDisclaimerQuery, GetBankInvoicePdfDisclaimerQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetBankInvoicePdfDisclaimerQuery, GetBankInvoicePdfDisclaimerQueryVariables>(GetBankInvoicePdfDisclaimerDocument, options);
      }
export function useGetBankInvoicePdfDisclaimerLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetBankInvoicePdfDisclaimerQuery, GetBankInvoicePdfDisclaimerQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetBankInvoicePdfDisclaimerQuery, GetBankInvoicePdfDisclaimerQueryVariables>(GetBankInvoicePdfDisclaimerDocument, options);
        }
export type GetBankInvoicePdfDisclaimerQueryHookResult = ReturnType<typeof useGetBankInvoicePdfDisclaimerQuery>;
export type GetBankInvoicePdfDisclaimerLazyQueryHookResult = ReturnType<typeof useGetBankInvoicePdfDisclaimerLazyQuery>;
export type GetBankInvoicePdfDisclaimerQueryResult = Apollo.QueryResult<GetBankInvoicePdfDisclaimerQuery, GetBankInvoicePdfDisclaimerQueryVariables>;
export function refetchGetBankInvoicePdfDisclaimerQuery(variables?: GetBankInvoicePdfDisclaimerQueryVariables) {
      return { query: GetBankInvoicePdfDisclaimerDocument, variables: variables }
    }
export const GetCloseReasonsDocument = gql`
    query getCloseReasons {
  closeReasons {
    ...CloseReason
  }
}
    ${CloseReasonFragmentDoc}`;

/**
 * __useGetCloseReasonsQuery__
 *
 * To run a query within a React component, call `useGetCloseReasonsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCloseReasonsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCloseReasonsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetCloseReasonsQuery(baseOptions?: Apollo.QueryHookOptions<GetCloseReasonsQuery, GetCloseReasonsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCloseReasonsQuery, GetCloseReasonsQueryVariables>(GetCloseReasonsDocument, options);
      }
export function useGetCloseReasonsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCloseReasonsQuery, GetCloseReasonsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCloseReasonsQuery, GetCloseReasonsQueryVariables>(GetCloseReasonsDocument, options);
        }
export type GetCloseReasonsQueryHookResult = ReturnType<typeof useGetCloseReasonsQuery>;
export type GetCloseReasonsLazyQueryHookResult = ReturnType<typeof useGetCloseReasonsLazyQuery>;
export type GetCloseReasonsQueryResult = Apollo.QueryResult<GetCloseReasonsQuery, GetCloseReasonsQueryVariables>;
export function refetchGetCloseReasonsQuery(variables?: GetCloseReasonsQueryVariables) {
      return { query: GetCloseReasonsDocument, variables: variables }
    }
export const CloseQuotesDocument = gql`
    mutation closeQuotes($input: [QuoteCloseReasonInputType]!) {
  closeQuotes(input: $input) {
    status
  }
}
    `;
export type CloseQuotesMutationFn = Apollo.MutationFunction<CloseQuotesMutation, CloseQuotesMutationVariables>;

/**
 * __useCloseQuotesMutation__
 *
 * To run a mutation, you first call `useCloseQuotesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCloseQuotesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [closeQuotesMutation, { data, loading, error }] = useCloseQuotesMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCloseQuotesMutation(baseOptions?: Apollo.MutationHookOptions<CloseQuotesMutation, CloseQuotesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CloseQuotesMutation, CloseQuotesMutationVariables>(CloseQuotesDocument, options);
      }
export type CloseQuotesMutationHookResult = ReturnType<typeof useCloseQuotesMutation>;
export type CloseQuotesMutationResult = Apollo.MutationResult<CloseQuotesMutation>;
export type CloseQuotesMutationOptions = Apollo.BaseMutationOptions<CloseQuotesMutation, CloseQuotesMutationVariables>;
export const CreateSaleDocument = gql`
    mutation createSale($input: CreateSaleMutationInput!) {
  createSale(input: $input) {
    sale {
      id
      uuid
    }
    errors {
      ...Error
    }
  }
}
    ${ErrorFragmentDoc}`;
export type CreateSaleMutationFn = Apollo.MutationFunction<CreateSaleMutation, CreateSaleMutationVariables>;

/**
 * __useCreateSaleMutation__
 *
 * To run a mutation, you first call `useCreateSaleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateSaleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createSaleMutation, { data, loading, error }] = useCreateSaleMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateSaleMutation(baseOptions?: Apollo.MutationHookOptions<CreateSaleMutation, CreateSaleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateSaleMutation, CreateSaleMutationVariables>(CreateSaleDocument, options);
      }
export type CreateSaleMutationHookResult = ReturnType<typeof useCreateSaleMutation>;
export type CreateSaleMutationResult = Apollo.MutationResult<CreateSaleMutation>;
export type CreateSaleMutationOptions = Apollo.BaseMutationOptions<CreateSaleMutation, CreateSaleMutationVariables>;
export const UpdateSaleDocument = gql`
    mutation updateSale($input: UpdateSaleMutationInput!) {
  updateSale(input: $input) {
    errors {
      ...Error
    }
    sale {
      id
      uuid
    }
  }
}
    ${ErrorFragmentDoc}`;
export type UpdateSaleMutationFn = Apollo.MutationFunction<UpdateSaleMutation, UpdateSaleMutationVariables>;

/**
 * __useUpdateSaleMutation__
 *
 * To run a mutation, you first call `useUpdateSaleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSaleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSaleMutation, { data, loading, error }] = useUpdateSaleMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateSaleMutation(baseOptions?: Apollo.MutationHookOptions<UpdateSaleMutation, UpdateSaleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateSaleMutation, UpdateSaleMutationVariables>(UpdateSaleDocument, options);
      }
export type UpdateSaleMutationHookResult = ReturnType<typeof useUpdateSaleMutation>;
export type UpdateSaleMutationResult = Apollo.MutationResult<UpdateSaleMutation>;
export type UpdateSaleMutationOptions = Apollo.BaseMutationOptions<UpdateSaleMutation, UpdateSaleMutationVariables>;
export const GetSaleDocument = gql`
    query getSale($id: ID!, $uuid: UUID) {
  sale(id: $id, uuid: $uuid) {
    ...Sale
  }
}
    ${SaleFragmentDoc}`;

/**
 * __useGetSaleQuery__
 *
 * To run a query within a React component, call `useGetSaleQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSaleQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSaleQuery({
 *   variables: {
 *      id: // value for 'id'
 *      uuid: // value for 'uuid'
 *   },
 * });
 */
export function useGetSaleQuery(baseOptions: Apollo.QueryHookOptions<GetSaleQuery, GetSaleQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSaleQuery, GetSaleQueryVariables>(GetSaleDocument, options);
      }
export function useGetSaleLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSaleQuery, GetSaleQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSaleQuery, GetSaleQueryVariables>(GetSaleDocument, options);
        }
export type GetSaleQueryHookResult = ReturnType<typeof useGetSaleQuery>;
export type GetSaleLazyQueryHookResult = ReturnType<typeof useGetSaleLazyQuery>;
export type GetSaleQueryResult = Apollo.QueryResult<GetSaleQuery, GetSaleQueryVariables>;
export function refetchGetSaleQuery(variables: GetSaleQueryVariables) {
      return { query: GetSaleDocument, variables: variables }
    }
export const GetSalesDocument = gql`
    query getSales($first: Int, $after: String, $before: String, $offset: Int, $orderBy: String, $last: Int, $query: String, $createdGte: Date, $createdLte: Date, $owner: UUID, $accountGlobalId: UUID, $contactGlobalId: UUID, $user: UUID) {
  sales(
    first: $first
    after: $after
    before: $before
    offset: $offset
    orderBy: $orderBy
    last: $last
    query: $query
    quote_Contact_Account_Id: $accountGlobalId
    quote_Contact_Id: $contactGlobalId
    quote_Contact_Account_Owner_Id: $owner
    createdGte: $createdGte
    createdLte: $createdLte
    user: $user
  ) {
    count
    pageInfo {
      ...PageInfo
    }
    edges {
      cursor
      node {
        ...SaleList
      }
    }
  }
}
    ${PageInfoFragmentDoc}
${SaleListFragmentDoc}`;

/**
 * __useGetSalesQuery__
 *
 * To run a query within a React component, call `useGetSalesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSalesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSalesQuery({
 *   variables: {
 *      first: // value for 'first'
 *      after: // value for 'after'
 *      before: // value for 'before'
 *      offset: // value for 'offset'
 *      orderBy: // value for 'orderBy'
 *      last: // value for 'last'
 *      query: // value for 'query'
 *      createdGte: // value for 'createdGte'
 *      createdLte: // value for 'createdLte'
 *      owner: // value for 'owner'
 *      accountGlobalId: // value for 'accountGlobalId'
 *      contactGlobalId: // value for 'contactGlobalId'
 *      user: // value for 'user'
 *   },
 * });
 */
export function useGetSalesQuery(baseOptions?: Apollo.QueryHookOptions<GetSalesQuery, GetSalesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSalesQuery, GetSalesQueryVariables>(GetSalesDocument, options);
      }
export function useGetSalesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSalesQuery, GetSalesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSalesQuery, GetSalesQueryVariables>(GetSalesDocument, options);
        }
export type GetSalesQueryHookResult = ReturnType<typeof useGetSalesQuery>;
export type GetSalesLazyQueryHookResult = ReturnType<typeof useGetSalesLazyQuery>;
export type GetSalesQueryResult = Apollo.QueryResult<GetSalesQuery, GetSalesQueryVariables>;
export function refetchGetSalesQuery(variables?: GetSalesQueryVariables) {
      return { query: GetSalesDocument, variables: variables }
    }
export const ExportExcelSalesDocument = gql`
    mutation exportExcelSales($query: String, $createdGte: Date, $createdLte: Date, $owner: UUID, $accountGlobalId: UUID, $contactGlobalId: UUID, $user: UUID, $saleId: UUID) {
  exportExcelSales(
    query: $query
    quote_Contact_Account_Id: $accountGlobalId
    quote_Contact_Id: $contactGlobalId
    quote_Contact_Account_Owner_Id: $owner
    createdGte: $createdGte
    createdLte: $createdLte
    user: $user
    saleId: $saleId
  ) {
    job {
      id
      status
    }
  }
}
    `;
export type ExportExcelSalesMutationFn = Apollo.MutationFunction<ExportExcelSalesMutation, ExportExcelSalesMutationVariables>;

/**
 * __useExportExcelSalesMutation__
 *
 * To run a mutation, you first call `useExportExcelSalesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useExportExcelSalesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [exportExcelSalesMutation, { data, loading, error }] = useExportExcelSalesMutation({
 *   variables: {
 *      query: // value for 'query'
 *      createdGte: // value for 'createdGte'
 *      createdLte: // value for 'createdLte'
 *      owner: // value for 'owner'
 *      accountGlobalId: // value for 'accountGlobalId'
 *      contactGlobalId: // value for 'contactGlobalId'
 *      user: // value for 'user'
 *      saleId: // value for 'saleId'
 *   },
 * });
 */
export function useExportExcelSalesMutation(baseOptions?: Apollo.MutationHookOptions<ExportExcelSalesMutation, ExportExcelSalesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ExportExcelSalesMutation, ExportExcelSalesMutationVariables>(ExportExcelSalesDocument, options);
      }
export type ExportExcelSalesMutationHookResult = ReturnType<typeof useExportExcelSalesMutation>;
export type ExportExcelSalesMutationResult = Apollo.MutationResult<ExportExcelSalesMutation>;
export type ExportExcelSalesMutationOptions = Apollo.BaseMutationOptions<ExportExcelSalesMutation, ExportExcelSalesMutationVariables>;
export const GetSeederModelsDocument = gql`
    query getSeederModels($seederBrandId: UUID) {
  seederModels(seederBrandId: $seederBrandId) {
    id
    name
  }
}
    `;

/**
 * __useGetSeederModelsQuery__
 *
 * To run a query within a React component, call `useGetSeederModelsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSeederModelsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSeederModelsQuery({
 *   variables: {
 *      seederBrandId: // value for 'seederBrandId'
 *   },
 * });
 */
export function useGetSeederModelsQuery(baseOptions?: Apollo.QueryHookOptions<GetSeederModelsQuery, GetSeederModelsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSeederModelsQuery, GetSeederModelsQueryVariables>(GetSeederModelsDocument, options);
      }
export function useGetSeederModelsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSeederModelsQuery, GetSeederModelsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSeederModelsQuery, GetSeederModelsQueryVariables>(GetSeederModelsDocument, options);
        }
export type GetSeederModelsQueryHookResult = ReturnType<typeof useGetSeederModelsQuery>;
export type GetSeederModelsLazyQueryHookResult = ReturnType<typeof useGetSeederModelsLazyQuery>;
export type GetSeederModelsQueryResult = Apollo.QueryResult<GetSeederModelsQuery, GetSeederModelsQueryVariables>;
export function refetchGetSeederModelsQuery(variables?: GetSeederModelsQueryVariables) {
      return { query: GetSeederModelsDocument, variables: variables }
    }
export const GetSeederBrandsDocument = gql`
    query getSeederBrands($organizationId: UUID) {
  seederBrands(organizationId: $organizationId) {
    id
    name
  }
}
    `;

/**
 * __useGetSeederBrandsQuery__
 *
 * To run a query within a React component, call `useGetSeederBrandsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSeederBrandsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSeederBrandsQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useGetSeederBrandsQuery(baseOptions?: Apollo.QueryHookOptions<GetSeederBrandsQuery, GetSeederBrandsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSeederBrandsQuery, GetSeederBrandsQueryVariables>(GetSeederBrandsDocument, options);
      }
export function useGetSeederBrandsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSeederBrandsQuery, GetSeederBrandsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSeederBrandsQuery, GetSeederBrandsQueryVariables>(GetSeederBrandsDocument, options);
        }
export type GetSeederBrandsQueryHookResult = ReturnType<typeof useGetSeederBrandsQuery>;
export type GetSeederBrandsLazyQueryHookResult = ReturnType<typeof useGetSeederBrandsLazyQuery>;
export type GetSeederBrandsQueryResult = Apollo.QueryResult<GetSeederBrandsQuery, GetSeederBrandsQueryVariables>;
export function refetchGetSeederBrandsQuery(variables?: GetSeederBrandsQueryVariables) {
      return { query: GetSeederBrandsDocument, variables: variables }
    }
export const GetSeederOptionsDocument = gql`
    query getSeederOptions($accountId: UUID) {
  seeders(account_Id: $accountId) {
    pageInfo {
      ...PageInfo
    }
    count
    edges {
      cursor
      node {
        ...SeederOption
      }
    }
  }
}
    ${PageInfoFragmentDoc}
${SeederOptionFragmentDoc}`;

/**
 * __useGetSeederOptionsQuery__
 *
 * To run a query within a React component, call `useGetSeederOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSeederOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSeederOptionsQuery({
 *   variables: {
 *      accountId: // value for 'accountId'
 *   },
 * });
 */
export function useGetSeederOptionsQuery(baseOptions?: Apollo.QueryHookOptions<GetSeederOptionsQuery, GetSeederOptionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSeederOptionsQuery, GetSeederOptionsQueryVariables>(GetSeederOptionsDocument, options);
      }
export function useGetSeederOptionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSeederOptionsQuery, GetSeederOptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSeederOptionsQuery, GetSeederOptionsQueryVariables>(GetSeederOptionsDocument, options);
        }
export type GetSeederOptionsQueryHookResult = ReturnType<typeof useGetSeederOptionsQuery>;
export type GetSeederOptionsLazyQueryHookResult = ReturnType<typeof useGetSeederOptionsLazyQuery>;
export type GetSeederOptionsQueryResult = Apollo.QueryResult<GetSeederOptionsQuery, GetSeederOptionsQueryVariables>;
export function refetchGetSeederOptionsQuery(variables?: GetSeederOptionsQueryVariables) {
      return { query: GetSeederOptionsDocument, variables: variables }
    }
export const GetSeederDocument = gql`
    query getSeeder($uuid: UUID, $id: ID!) {
  seeder(id: $id, uuid: $uuid) {
    id
    uuid
    account {
      id
      uuid
      name
    }
    brand {
      id
    }
    model {
      id
    }
    year
    rowCount
    meterType
    installedCategories {
      id
      uuid
    }
  }
}
    `;

/**
 * __useGetSeederQuery__
 *
 * To run a query within a React component, call `useGetSeederQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSeederQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSeederQuery({
 *   variables: {
 *      uuid: // value for 'uuid'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetSeederQuery(baseOptions: Apollo.QueryHookOptions<GetSeederQuery, GetSeederQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSeederQuery, GetSeederQueryVariables>(GetSeederDocument, options);
      }
export function useGetSeederLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSeederQuery, GetSeederQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSeederQuery, GetSeederQueryVariables>(GetSeederDocument, options);
        }
export type GetSeederQueryHookResult = ReturnType<typeof useGetSeederQuery>;
export type GetSeederLazyQueryHookResult = ReturnType<typeof useGetSeederLazyQuery>;
export type GetSeederQueryResult = Apollo.QueryResult<GetSeederQuery, GetSeederQueryVariables>;
export function refetchGetSeederQuery(variables: GetSeederQueryVariables) {
      return { query: GetSeederDocument, variables: variables }
    }
export const CreateSeederDocument = gql`
    mutation createSeeder($input: CreateSeederMutationInput!) {
  createSeeder(input: $input) {
    seeder {
      id
      uuid
      account {
        id
        uuid
      }
    }
    errors {
      ...Error
    }
  }
}
    ${ErrorFragmentDoc}`;
export type CreateSeederMutationFn = Apollo.MutationFunction<CreateSeederMutation, CreateSeederMutationVariables>;

/**
 * __useCreateSeederMutation__
 *
 * To run a mutation, you first call `useCreateSeederMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateSeederMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createSeederMutation, { data, loading, error }] = useCreateSeederMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateSeederMutation(baseOptions?: Apollo.MutationHookOptions<CreateSeederMutation, CreateSeederMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateSeederMutation, CreateSeederMutationVariables>(CreateSeederDocument, options);
      }
export type CreateSeederMutationHookResult = ReturnType<typeof useCreateSeederMutation>;
export type CreateSeederMutationResult = Apollo.MutationResult<CreateSeederMutation>;
export type CreateSeederMutationOptions = Apollo.BaseMutationOptions<CreateSeederMutation, CreateSeederMutationVariables>;
export const UpdateSeederDocument = gql`
    mutation updateSeeder($input: UpdateSeederMutationInput!) {
  updateSeeder(input: $input) {
    seeder {
      id
      account {
        id
      }
    }
    errors {
      ...Error
    }
  }
}
    ${ErrorFragmentDoc}`;
export type UpdateSeederMutationFn = Apollo.MutationFunction<UpdateSeederMutation, UpdateSeederMutationVariables>;

/**
 * __useUpdateSeederMutation__
 *
 * To run a mutation, you first call `useUpdateSeederMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSeederMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSeederMutation, { data, loading, error }] = useUpdateSeederMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateSeederMutation(baseOptions?: Apollo.MutationHookOptions<UpdateSeederMutation, UpdateSeederMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateSeederMutation, UpdateSeederMutationVariables>(UpdateSeederDocument, options);
      }
export type UpdateSeederMutationHookResult = ReturnType<typeof useUpdateSeederMutation>;
export type UpdateSeederMutationResult = Apollo.MutationResult<UpdateSeederMutation>;
export type UpdateSeederMutationOptions = Apollo.BaseMutationOptions<UpdateSeederMutation, UpdateSeederMutationVariables>;
export const GetSeedersDocument = gql`
    query getSeeders($first: Int, $offset: Int, $query: String, $orderBy: String, $accountGlobalId: UUID) {
  seeders(
    first: $first
    offset: $offset
    query: $query
    orderBy: $orderBy
    account_Id: $accountGlobalId
  ) {
    pageInfo {
      ...PageInfo
    }
    count
    edges {
      cursor
      node {
        ...SeederList
      }
    }
  }
}
    ${PageInfoFragmentDoc}
${SeederListFragmentDoc}`;

/**
 * __useGetSeedersQuery__
 *
 * To run a query within a React component, call `useGetSeedersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSeedersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSeedersQuery({
 *   variables: {
 *      first: // value for 'first'
 *      offset: // value for 'offset'
 *      query: // value for 'query'
 *      orderBy: // value for 'orderBy'
 *      accountGlobalId: // value for 'accountGlobalId'
 *   },
 * });
 */
export function useGetSeedersQuery(baseOptions?: Apollo.QueryHookOptions<GetSeedersQuery, GetSeedersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSeedersQuery, GetSeedersQueryVariables>(GetSeedersDocument, options);
      }
export function useGetSeedersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSeedersQuery, GetSeedersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSeedersQuery, GetSeedersQueryVariables>(GetSeedersDocument, options);
        }
export type GetSeedersQueryHookResult = ReturnType<typeof useGetSeedersQuery>;
export type GetSeedersLazyQueryHookResult = ReturnType<typeof useGetSeedersLazyQuery>;
export type GetSeedersQueryResult = Apollo.QueryResult<GetSeedersQuery, GetSeedersQueryVariables>;
export function refetchGetSeedersQuery(variables?: GetSeedersQueryVariables) {
      return { query: GetSeedersDocument, variables: variables }
    }
export const DeleteSeederDocument = gql`
    mutation deleteSeeder($input: DeleteSeederMutationInput!) {
  deleteSeeder(input: $input) {
    errors {
      ...Error
    }
  }
}
    ${ErrorFragmentDoc}`;
export type DeleteSeederMutationFn = Apollo.MutationFunction<DeleteSeederMutation, DeleteSeederMutationVariables>;

/**
 * __useDeleteSeederMutation__
 *
 * To run a mutation, you first call `useDeleteSeederMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteSeederMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteSeederMutation, { data, loading, error }] = useDeleteSeederMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteSeederMutation(baseOptions?: Apollo.MutationHookOptions<DeleteSeederMutation, DeleteSeederMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteSeederMutation, DeleteSeederMutationVariables>(DeleteSeederDocument, options);
      }
export type DeleteSeederMutationHookResult = ReturnType<typeof useDeleteSeederMutation>;
export type DeleteSeederMutationResult = Apollo.MutationResult<DeleteSeederMutation>;
export type DeleteSeederMutationOptions = Apollo.BaseMutationOptions<DeleteSeederMutation, DeleteSeederMutationVariables>;
export const GetForecastRunsDocument = gql`
    query GetForecastRuns {
  forecastRuns {
    id
    status
    created
    completedAt
    totalSkus
    totalOrderLines
    totalOrderValue
    createdBy {
      displayName
    }
  }
}
    `;

/**
 * __useGetForecastRunsQuery__
 *
 * To run a query within a React component, call `useGetForecastRunsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetForecastRunsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetForecastRunsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetForecastRunsQuery(baseOptions?: Apollo.QueryHookOptions<GetForecastRunsQuery, GetForecastRunsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetForecastRunsQuery, GetForecastRunsQueryVariables>(GetForecastRunsDocument, options);
      }
export function useGetForecastRunsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetForecastRunsQuery, GetForecastRunsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetForecastRunsQuery, GetForecastRunsQueryVariables>(GetForecastRunsDocument, options);
        }
export type GetForecastRunsQueryHookResult = ReturnType<typeof useGetForecastRunsQuery>;
export type GetForecastRunsLazyQueryHookResult = ReturnType<typeof useGetForecastRunsLazyQuery>;
export type GetForecastRunsQueryResult = Apollo.QueryResult<GetForecastRunsQuery, GetForecastRunsQueryVariables>;
export function refetchGetForecastRunsQuery(variables?: GetForecastRunsQueryVariables) {
      return { query: GetForecastRunsDocument, variables: variables }
    }
export const GetForecastRunDocument = gql`
    query GetForecastRun($id: UUID!) {
  forecastRun(id: $id) {
    id
    status
    created
    completedAt
    errorMessage
    totalSkus
    totalOrderLines
    totalOrderValue
    stockSnapshotAt
  }
}
    `;

/**
 * __useGetForecastRunQuery__
 *
 * To run a query within a React component, call `useGetForecastRunQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetForecastRunQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetForecastRunQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetForecastRunQuery(baseOptions: Apollo.QueryHookOptions<GetForecastRunQuery, GetForecastRunQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetForecastRunQuery, GetForecastRunQueryVariables>(GetForecastRunDocument, options);
      }
export function useGetForecastRunLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetForecastRunQuery, GetForecastRunQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetForecastRunQuery, GetForecastRunQueryVariables>(GetForecastRunDocument, options);
        }
export type GetForecastRunQueryHookResult = ReturnType<typeof useGetForecastRunQuery>;
export type GetForecastRunLazyQueryHookResult = ReturnType<typeof useGetForecastRunLazyQuery>;
export type GetForecastRunQueryResult = Apollo.QueryResult<GetForecastRunQuery, GetForecastRunQueryVariables>;
export function refetchGetForecastRunQuery(variables: GetForecastRunQueryVariables) {
      return { query: GetForecastRunDocument, variables: variables }
    }
export const GetForecastRecommendationsDocument = gql`
    query GetForecastRecommendations($forecastRunId: UUID!, $onlyWithOrders: Boolean) {
  forecastRecommendations(
    forecastRunId: $forecastRunId
    onlyWithOrders: $onlyWithOrders
  ) {
    id
    finalOrder
    quoteNeed
    historicalGap
    suggestedOrder
    maxOrderCap
    minimumStock
    minStockGap
    reasonCode
    priority
    orderValue
    manualInput
    product {
      id
      externalId
      name
    }
  }
}
    `;

/**
 * __useGetForecastRecommendationsQuery__
 *
 * To run a query within a React component, call `useGetForecastRecommendationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetForecastRecommendationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetForecastRecommendationsQuery({
 *   variables: {
 *      forecastRunId: // value for 'forecastRunId'
 *      onlyWithOrders: // value for 'onlyWithOrders'
 *   },
 * });
 */
export function useGetForecastRecommendationsQuery(baseOptions: Apollo.QueryHookOptions<GetForecastRecommendationsQuery, GetForecastRecommendationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetForecastRecommendationsQuery, GetForecastRecommendationsQueryVariables>(GetForecastRecommendationsDocument, options);
      }
export function useGetForecastRecommendationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetForecastRecommendationsQuery, GetForecastRecommendationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetForecastRecommendationsQuery, GetForecastRecommendationsQueryVariables>(GetForecastRecommendationsDocument, options);
        }
export type GetForecastRecommendationsQueryHookResult = ReturnType<typeof useGetForecastRecommendationsQuery>;
export type GetForecastRecommendationsLazyQueryHookResult = ReturnType<typeof useGetForecastRecommendationsLazyQuery>;
export type GetForecastRecommendationsQueryResult = Apollo.QueryResult<GetForecastRecommendationsQuery, GetForecastRecommendationsQueryVariables>;
export function refetchGetForecastRecommendationsQuery(variables: GetForecastRecommendationsQueryVariables) {
      return { query: GetForecastRecommendationsDocument, variables: variables }
    }
export const GetMrpParametersDocument = gql`
    query GetMrpParameters {
  mrpParameters {
    id
    quoteNoOrderThreshold
    quoteReorderTarget
    monthlyHistoricalCoverageTarget
    stockThresholdUnits
    reducedOrderFractionOfCap
    globalMaxOrderPerSku
    useDynamicCapByUnitPrice
    leadTimeMonths
    minimumDemandMonthsToTrustAverage
    maxPercentOfPeakMonth
    highPriorityOrderValue
    mediumPriorityOrderValue
    priceTiers
  }
  mrpLifecycleOverrides {
    id
    lifecycle
    categoryCap
    multiplier
    forceZero
  }
}
    `;

/**
 * __useGetMrpParametersQuery__
 *
 * To run a query within a React component, call `useGetMrpParametersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMrpParametersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMrpParametersQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetMrpParametersQuery(baseOptions?: Apollo.QueryHookOptions<GetMrpParametersQuery, GetMrpParametersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMrpParametersQuery, GetMrpParametersQueryVariables>(GetMrpParametersDocument, options);
      }
export function useGetMrpParametersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMrpParametersQuery, GetMrpParametersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMrpParametersQuery, GetMrpParametersQueryVariables>(GetMrpParametersDocument, options);
        }
export type GetMrpParametersQueryHookResult = ReturnType<typeof useGetMrpParametersQuery>;
export type GetMrpParametersLazyQueryHookResult = ReturnType<typeof useGetMrpParametersLazyQuery>;
export type GetMrpParametersQueryResult = Apollo.QueryResult<GetMrpParametersQuery, GetMrpParametersQueryVariables>;
export function refetchGetMrpParametersQuery(variables?: GetMrpParametersQueryVariables) {
      return { query: GetMrpParametersDocument, variables: variables }
    }
export const RunForecastDocument = gql`
    mutation RunForecast {
  runForecast {
    forecastRun {
      id
      status
    }
    errors {
      field
      messages
    }
  }
}
    `;
export type RunForecastMutationFn = Apollo.MutationFunction<RunForecastMutation, RunForecastMutationVariables>;

/**
 * __useRunForecastMutation__
 *
 * To run a mutation, you first call `useRunForecastMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRunForecastMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [runForecastMutation, { data, loading, error }] = useRunForecastMutation({
 *   variables: {
 *   },
 * });
 */
export function useRunForecastMutation(baseOptions?: Apollo.MutationHookOptions<RunForecastMutation, RunForecastMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RunForecastMutation, RunForecastMutationVariables>(RunForecastDocument, options);
      }
export type RunForecastMutationHookResult = ReturnType<typeof useRunForecastMutation>;
export type RunForecastMutationResult = Apollo.MutationResult<RunForecastMutation>;
export type RunForecastMutationOptions = Apollo.BaseMutationOptions<RunForecastMutation, RunForecastMutationVariables>;
export const ExportCloudOrderDocument = gql`
    mutation ExportCloudOrder($forecastRunId: UUID!) {
  exportCloudOrder(forecastRunId: $forecastRunId) {
    job {
      id
      status
    }
  }
}
    `;
export type ExportCloudOrderMutationFn = Apollo.MutationFunction<ExportCloudOrderMutation, ExportCloudOrderMutationVariables>;

/**
 * __useExportCloudOrderMutation__
 *
 * To run a mutation, you first call `useExportCloudOrderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useExportCloudOrderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [exportCloudOrderMutation, { data, loading, error }] = useExportCloudOrderMutation({
 *   variables: {
 *      forecastRunId: // value for 'forecastRunId'
 *   },
 * });
 */
export function useExportCloudOrderMutation(baseOptions?: Apollo.MutationHookOptions<ExportCloudOrderMutation, ExportCloudOrderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ExportCloudOrderMutation, ExportCloudOrderMutationVariables>(ExportCloudOrderDocument, options);
      }
export type ExportCloudOrderMutationHookResult = ReturnType<typeof useExportCloudOrderMutation>;
export type ExportCloudOrderMutationResult = Apollo.MutationResult<ExportCloudOrderMutation>;
export type ExportCloudOrderMutationOptions = Apollo.BaseMutationOptions<ExportCloudOrderMutation, ExportCloudOrderMutationVariables>;
export const ImportInTransitStockDocument = gql`
    mutation ImportInTransitStock($file: Upload!) {
  importInTransitStock(file: $file) {
    result {
      imported
      skipped
      duplicates
    }
    errors {
      field
      messages
    }
  }
}
    `;
export type ImportInTransitStockMutationFn = Apollo.MutationFunction<ImportInTransitStockMutation, ImportInTransitStockMutationVariables>;

/**
 * __useImportInTransitStockMutation__
 *
 * To run a mutation, you first call `useImportInTransitStockMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useImportInTransitStockMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [importInTransitStockMutation, { data, loading, error }] = useImportInTransitStockMutation({
 *   variables: {
 *      file: // value for 'file'
 *   },
 * });
 */
export function useImportInTransitStockMutation(baseOptions?: Apollo.MutationHookOptions<ImportInTransitStockMutation, ImportInTransitStockMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ImportInTransitStockMutation, ImportInTransitStockMutationVariables>(ImportInTransitStockDocument, options);
      }
export type ImportInTransitStockMutationHookResult = ReturnType<typeof useImportInTransitStockMutation>;
export type ImportInTransitStockMutationResult = Apollo.MutationResult<ImportInTransitStockMutation>;
export type ImportInTransitStockMutationOptions = Apollo.BaseMutationOptions<ImportInTransitStockMutation, ImportInTransitStockMutationVariables>;
export const ImportMonthlyDemandDocument = gql`
    mutation ImportMonthlyDemand($file: Upload!) {
  importMonthlyDemand(file: $file) {
    result {
      imported
      skipped
      duplicates
    }
    errors {
      field
      messages
    }
  }
}
    `;
export type ImportMonthlyDemandMutationFn = Apollo.MutationFunction<ImportMonthlyDemandMutation, ImportMonthlyDemandMutationVariables>;

/**
 * __useImportMonthlyDemandMutation__
 *
 * To run a mutation, you first call `useImportMonthlyDemandMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useImportMonthlyDemandMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [importMonthlyDemandMutation, { data, loading, error }] = useImportMonthlyDemandMutation({
 *   variables: {
 *      file: // value for 'file'
 *   },
 * });
 */
export function useImportMonthlyDemandMutation(baseOptions?: Apollo.MutationHookOptions<ImportMonthlyDemandMutation, ImportMonthlyDemandMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ImportMonthlyDemandMutation, ImportMonthlyDemandMutationVariables>(ImportMonthlyDemandDocument, options);
      }
export type ImportMonthlyDemandMutationHookResult = ReturnType<typeof useImportMonthlyDemandMutation>;
export type ImportMonthlyDemandMutationResult = Apollo.MutationResult<ImportMonthlyDemandMutation>;
export type ImportMonthlyDemandMutationOptions = Apollo.BaseMutationOptions<ImportMonthlyDemandMutation, ImportMonthlyDemandMutationVariables>;
export const UpdateMrpLifecycleOverridesDocument = gql`
    mutation UpdateMrpLifecycleOverrides($overrides: [MRPLifecycleOverrideInput!]!) {
  updateMrpLifecycleOverrides(overrides: $overrides) {
    overrides {
      id
      lifecycle
      categoryCap
      multiplier
      forceZero
    }
  }
}
    `;
export type UpdateMrpLifecycleOverridesMutationFn = Apollo.MutationFunction<UpdateMrpLifecycleOverridesMutation, UpdateMrpLifecycleOverridesMutationVariables>;

/**
 * __useUpdateMrpLifecycleOverridesMutation__
 *
 * To run a mutation, you first call `useUpdateMrpLifecycleOverridesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateMrpLifecycleOverridesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateMrpLifecycleOverridesMutation, { data, loading, error }] = useUpdateMrpLifecycleOverridesMutation({
 *   variables: {
 *      overrides: // value for 'overrides'
 *   },
 * });
 */
export function useUpdateMrpLifecycleOverridesMutation(baseOptions?: Apollo.MutationHookOptions<UpdateMrpLifecycleOverridesMutation, UpdateMrpLifecycleOverridesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateMrpLifecycleOverridesMutation, UpdateMrpLifecycleOverridesMutationVariables>(UpdateMrpLifecycleOverridesDocument, options);
      }
export type UpdateMrpLifecycleOverridesMutationHookResult = ReturnType<typeof useUpdateMrpLifecycleOverridesMutation>;
export type UpdateMrpLifecycleOverridesMutationResult = Apollo.MutationResult<UpdateMrpLifecycleOverridesMutation>;
export type UpdateMrpLifecycleOverridesMutationOptions = Apollo.BaseMutationOptions<UpdateMrpLifecycleOverridesMutation, UpdateMrpLifecycleOverridesMutationVariables>;
export const UpdateRecommendationManualInputDocument = gql`
    mutation UpdateRecommendationManualInput($recommendationId: UUID!, $manualInput: Int) {
  updateRecommendationManualInput(
    recommendationId: $recommendationId
    manualInput: $manualInput
  ) {
    recommendation {
      id
      manualInput
      suggestedOrder
      finalOrder
      reasonCode
      priority
      orderValue
    }
  }
}
    `;
export type UpdateRecommendationManualInputMutationFn = Apollo.MutationFunction<UpdateRecommendationManualInputMutation, UpdateRecommendationManualInputMutationVariables>;

/**
 * __useUpdateRecommendationManualInputMutation__
 *
 * To run a mutation, you first call `useUpdateRecommendationManualInputMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateRecommendationManualInputMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateRecommendationManualInputMutation, { data, loading, error }] = useUpdateRecommendationManualInputMutation({
 *   variables: {
 *      recommendationId: // value for 'recommendationId'
 *      manualInput: // value for 'manualInput'
 *   },
 * });
 */
export function useUpdateRecommendationManualInputMutation(baseOptions?: Apollo.MutationHookOptions<UpdateRecommendationManualInputMutation, UpdateRecommendationManualInputMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateRecommendationManualInputMutation, UpdateRecommendationManualInputMutationVariables>(UpdateRecommendationManualInputDocument, options);
      }
export type UpdateRecommendationManualInputMutationHookResult = ReturnType<typeof useUpdateRecommendationManualInputMutation>;
export type UpdateRecommendationManualInputMutationResult = Apollo.MutationResult<UpdateRecommendationManualInputMutation>;
export type UpdateRecommendationManualInputMutationOptions = Apollo.BaseMutationOptions<UpdateRecommendationManualInputMutation, UpdateRecommendationManualInputMutationVariables>;
export const UpdateMrpParametersDocument = gql`
    mutation UpdateMrpParameters($input: MRPParametersInput!) {
  updateMrpParameters(input: $input) {
    parameters {
      id
      quoteNoOrderThreshold
      quoteReorderTarget
      monthlyHistoricalCoverageTarget
      stockThresholdUnits
      reducedOrderFractionOfCap
      globalMaxOrderPerSku
      useDynamicCapByUnitPrice
      leadTimeMonths
      minimumDemandMonthsToTrustAverage
      maxPercentOfPeakMonth
      highPriorityOrderValue
      mediumPriorityOrderValue
      priceTiers
    }
    errors {
      field
      messages
    }
  }
}
    `;
export type UpdateMrpParametersMutationFn = Apollo.MutationFunction<UpdateMrpParametersMutation, UpdateMrpParametersMutationVariables>;

/**
 * __useUpdateMrpParametersMutation__
 *
 * To run a mutation, you first call `useUpdateMrpParametersMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateMrpParametersMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateMrpParametersMutation, { data, loading, error }] = useUpdateMrpParametersMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateMrpParametersMutation(baseOptions?: Apollo.MutationHookOptions<UpdateMrpParametersMutation, UpdateMrpParametersMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateMrpParametersMutation, UpdateMrpParametersMutationVariables>(UpdateMrpParametersDocument, options);
      }
export type UpdateMrpParametersMutationHookResult = ReturnType<typeof useUpdateMrpParametersMutation>;
export type UpdateMrpParametersMutationResult = Apollo.MutationResult<UpdateMrpParametersMutation>;
export type UpdateMrpParametersMutationOptions = Apollo.BaseMutationOptions<UpdateMrpParametersMutation, UpdateMrpParametersMutationVariables>;
export const GetProductsStocksDocument = gql`
    query getProductsStocks($externalIds: [String]!) {
  productsStocks(externalIds: $externalIds) {
    stocks {
      externalId
      availableQuantity
      found
    }
    errors {
      code
      message
    }
  }
}
    `;

/**
 * __useGetProductsStocksQuery__
 *
 * To run a query within a React component, call `useGetProductsStocksQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProductsStocksQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProductsStocksQuery({
 *   variables: {
 *      externalIds: // value for 'externalIds'
 *   },
 * });
 */
export function useGetProductsStocksQuery(baseOptions: Apollo.QueryHookOptions<GetProductsStocksQuery, GetProductsStocksQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProductsStocksQuery, GetProductsStocksQueryVariables>(GetProductsStocksDocument, options);
      }
export function useGetProductsStocksLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProductsStocksQuery, GetProductsStocksQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProductsStocksQuery, GetProductsStocksQueryVariables>(GetProductsStocksDocument, options);
        }
export type GetProductsStocksQueryHookResult = ReturnType<typeof useGetProductsStocksQuery>;
export type GetProductsStocksLazyQueryHookResult = ReturnType<typeof useGetProductsStocksLazyQuery>;
export type GetProductsStocksQueryResult = Apollo.QueryResult<GetProductsStocksQuery, GetProductsStocksQueryVariables>;
export function refetchGetProductsStocksQuery(variables: GetProductsStocksQueryVariables) {
      return { query: GetProductsStocksDocument, variables: variables }
    }
export const CreateSupplyOrderQuoteDocument = gql`
    mutation createSupplyOrderQuote($input: CreateSupplyOrderQuoteMutationInput!) {
  createSupplyOrderQuote(input: $input) {
    supplyOrder {
      id
      uuid
    }
    errors {
      ...Error
    }
  }
}
    ${ErrorFragmentDoc}`;
export type CreateSupplyOrderQuoteMutationFn = Apollo.MutationFunction<CreateSupplyOrderQuoteMutation, CreateSupplyOrderQuoteMutationVariables>;

/**
 * __useCreateSupplyOrderQuoteMutation__
 *
 * To run a mutation, you first call `useCreateSupplyOrderQuoteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateSupplyOrderQuoteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createSupplyOrderQuoteMutation, { data, loading, error }] = useCreateSupplyOrderQuoteMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateSupplyOrderQuoteMutation(baseOptions?: Apollo.MutationHookOptions<CreateSupplyOrderQuoteMutation, CreateSupplyOrderQuoteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateSupplyOrderQuoteMutation, CreateSupplyOrderQuoteMutationVariables>(CreateSupplyOrderQuoteDocument, options);
      }
export type CreateSupplyOrderQuoteMutationHookResult = ReturnType<typeof useCreateSupplyOrderQuoteMutation>;
export type CreateSupplyOrderQuoteMutationResult = Apollo.MutationResult<CreateSupplyOrderQuoteMutation>;
export type CreateSupplyOrderQuoteMutationOptions = Apollo.BaseMutationOptions<CreateSupplyOrderQuoteMutation, CreateSupplyOrderQuoteMutationVariables>;
export const UpdateSupplyOrderQuoteDocument = gql`
    mutation updateSupplyOrderQuote($input: UpdateSupplyOrderQuoteMutationInput!) {
  updateSupplyOrderQuote(input: $input) {
    errors {
      ...Error
    }
    supplyOrder {
      id
      uuid
    }
  }
}
    ${ErrorFragmentDoc}`;
export type UpdateSupplyOrderQuoteMutationFn = Apollo.MutationFunction<UpdateSupplyOrderQuoteMutation, UpdateSupplyOrderQuoteMutationVariables>;

/**
 * __useUpdateSupplyOrderQuoteMutation__
 *
 * To run a mutation, you first call `useUpdateSupplyOrderQuoteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSupplyOrderQuoteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSupplyOrderQuoteMutation, { data, loading, error }] = useUpdateSupplyOrderQuoteMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateSupplyOrderQuoteMutation(baseOptions?: Apollo.MutationHookOptions<UpdateSupplyOrderQuoteMutation, UpdateSupplyOrderQuoteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateSupplyOrderQuoteMutation, UpdateSupplyOrderQuoteMutationVariables>(UpdateSupplyOrderQuoteDocument, options);
      }
export type UpdateSupplyOrderQuoteMutationHookResult = ReturnType<typeof useUpdateSupplyOrderQuoteMutation>;
export type UpdateSupplyOrderQuoteMutationResult = Apollo.MutationResult<UpdateSupplyOrderQuoteMutation>;
export type UpdateSupplyOrderQuoteMutationOptions = Apollo.BaseMutationOptions<UpdateSupplyOrderQuoteMutation, UpdateSupplyOrderQuoteMutationVariables>;
export const GetSupplyOrderDocument = gql`
    query getSupplyOrder($id: ID!, $uuid: UUID) {
  supplyOrder(id: $id, uuid: $uuid) {
    ...SupplyOrderDetail
  }
}
    ${SupplyOrderDetailFragmentDoc}`;

/**
 * __useGetSupplyOrderQuery__
 *
 * To run a query within a React component, call `useGetSupplyOrderQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSupplyOrderQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSupplyOrderQuery({
 *   variables: {
 *      id: // value for 'id'
 *      uuid: // value for 'uuid'
 *   },
 * });
 */
export function useGetSupplyOrderQuery(baseOptions: Apollo.QueryHookOptions<GetSupplyOrderQuery, GetSupplyOrderQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSupplyOrderQuery, GetSupplyOrderQueryVariables>(GetSupplyOrderDocument, options);
      }
export function useGetSupplyOrderLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSupplyOrderQuery, GetSupplyOrderQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSupplyOrderQuery, GetSupplyOrderQueryVariables>(GetSupplyOrderDocument, options);
        }
export type GetSupplyOrderQueryHookResult = ReturnType<typeof useGetSupplyOrderQuery>;
export type GetSupplyOrderLazyQueryHookResult = ReturnType<typeof useGetSupplyOrderLazyQuery>;
export type GetSupplyOrderQueryResult = Apollo.QueryResult<GetSupplyOrderQuery, GetSupplyOrderQueryVariables>;
export function refetchGetSupplyOrderQuery(variables: GetSupplyOrderQueryVariables) {
      return { query: GetSupplyOrderDocument, variables: variables }
    }
export const GetSupplyOrdersDocument = gql`
    query getSupplyOrders($first: Int, $after: String, $before: String, $offset: Int, $orderBy: String, $last: Int, $query: String, $createdGte: Date, $createdLte: Date, $owner: UUID, $accountGlobalId: UUID, $contactGlobalId: UUID, $user: UUID, $statusEnumIn: [SupplyOrdersSupplyOrderStatusChoices], $rgy: String, $type: String) {
  supplyOrders(
    first: $first
    after: $after
    before: $before
    offset: $offset
    orderBy: $orderBy
    last: $last
    query: $query
    quote_Contact_Account_Id: $accountGlobalId
    quote_Contact_Id: $contactGlobalId
    owner: $owner
    createdGte: $createdGte
    createdLte: $createdLte
    user: $user
    status_In: $statusEnumIn
    rgy: $rgy
    type: $type
  ) {
    count
    pageInfo {
      ...PageInfo
    }
    edges {
      cursor
      node {
        ...SupplyOrderList
      }
    }
  }
}
    ${PageInfoFragmentDoc}
${SupplyOrderListFragmentDoc}`;

/**
 * __useGetSupplyOrdersQuery__
 *
 * To run a query within a React component, call `useGetSupplyOrdersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSupplyOrdersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSupplyOrdersQuery({
 *   variables: {
 *      first: // value for 'first'
 *      after: // value for 'after'
 *      before: // value for 'before'
 *      offset: // value for 'offset'
 *      orderBy: // value for 'orderBy'
 *      last: // value for 'last'
 *      query: // value for 'query'
 *      createdGte: // value for 'createdGte'
 *      createdLte: // value for 'createdLte'
 *      owner: // value for 'owner'
 *      accountGlobalId: // value for 'accountGlobalId'
 *      contactGlobalId: // value for 'contactGlobalId'
 *      user: // value for 'user'
 *      statusEnumIn: // value for 'statusEnumIn'
 *      rgy: // value for 'rgy'
 *      type: // value for 'type'
 *   },
 * });
 */
export function useGetSupplyOrdersQuery(baseOptions?: Apollo.QueryHookOptions<GetSupplyOrdersQuery, GetSupplyOrdersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSupplyOrdersQuery, GetSupplyOrdersQueryVariables>(GetSupplyOrdersDocument, options);
      }
export function useGetSupplyOrdersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSupplyOrdersQuery, GetSupplyOrdersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSupplyOrdersQuery, GetSupplyOrdersQueryVariables>(GetSupplyOrdersDocument, options);
        }
export type GetSupplyOrdersQueryHookResult = ReturnType<typeof useGetSupplyOrdersQuery>;
export type GetSupplyOrdersLazyQueryHookResult = ReturnType<typeof useGetSupplyOrdersLazyQuery>;
export type GetSupplyOrdersQueryResult = Apollo.QueryResult<GetSupplyOrdersQuery, GetSupplyOrdersQueryVariables>;
export function refetchGetSupplyOrdersQuery(variables?: GetSupplyOrdersQueryVariables) {
      return { query: GetSupplyOrdersDocument, variables: variables }
    }
export const ExportExcelSupplyOrdersDocument = gql`
    mutation exportExcelSupplyOrders($query: String, $createdGte: Date, $createdLte: Date, $owner: UUID, $accountGlobalId: UUID, $contactGlobalId: UUID, $user: UUID, $statusEnumIn: [SupplyOrdersSupplyOrderStatusChoices], $supplyOrderId: UUID, $rgy: String, $isPending: Boolean, $onlyWithStock: Boolean) {
  exportExcelSupplyOrders(
    query: $query
    quote_Contact_Account_Id: $accountGlobalId
    quote_Contact_Id: $contactGlobalId
    owner: $owner
    createdGte: $createdGte
    createdLte: $createdLte
    user: $user
    status_In: $statusEnumIn
    supplyOrderId: $supplyOrderId
    rgy: $rgy
    isPending: $isPending
    onlyWithStock: $onlyWithStock
  ) {
    job {
      id
    }
  }
}
    `;
export type ExportExcelSupplyOrdersMutationFn = Apollo.MutationFunction<ExportExcelSupplyOrdersMutation, ExportExcelSupplyOrdersMutationVariables>;

/**
 * __useExportExcelSupplyOrdersMutation__
 *
 * To run a mutation, you first call `useExportExcelSupplyOrdersMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useExportExcelSupplyOrdersMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [exportExcelSupplyOrdersMutation, { data, loading, error }] = useExportExcelSupplyOrdersMutation({
 *   variables: {
 *      query: // value for 'query'
 *      createdGte: // value for 'createdGte'
 *      createdLte: // value for 'createdLte'
 *      owner: // value for 'owner'
 *      accountGlobalId: // value for 'accountGlobalId'
 *      contactGlobalId: // value for 'contactGlobalId'
 *      user: // value for 'user'
 *      statusEnumIn: // value for 'statusEnumIn'
 *      supplyOrderId: // value for 'supplyOrderId'
 *      rgy: // value for 'rgy'
 *      isPending: // value for 'isPending'
 *      onlyWithStock: // value for 'onlyWithStock'
 *   },
 * });
 */
export function useExportExcelSupplyOrdersMutation(baseOptions?: Apollo.MutationHookOptions<ExportExcelSupplyOrdersMutation, ExportExcelSupplyOrdersMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ExportExcelSupplyOrdersMutation, ExportExcelSupplyOrdersMutationVariables>(ExportExcelSupplyOrdersDocument, options);
      }
export type ExportExcelSupplyOrdersMutationHookResult = ReturnType<typeof useExportExcelSupplyOrdersMutation>;
export type ExportExcelSupplyOrdersMutationResult = Apollo.MutationResult<ExportExcelSupplyOrdersMutation>;
export type ExportExcelSupplyOrdersMutationOptions = Apollo.BaseMutationOptions<ExportExcelSupplyOrdersMutation, ExportExcelSupplyOrdersMutationVariables>;
export const StartSupplyOrderReviewDocument = gql`
    mutation startSupplyOrderReview($input: StartSupplyOrderReviewMutationInput!) {
  startSupplyOrderReview(input: $input) {
    supplyOrder {
      id
      uuid
    }
    errors {
      ...Error
    }
  }
}
    ${ErrorFragmentDoc}`;
export type StartSupplyOrderReviewMutationFn = Apollo.MutationFunction<StartSupplyOrderReviewMutation, StartSupplyOrderReviewMutationVariables>;

/**
 * __useStartSupplyOrderReviewMutation__
 *
 * To run a mutation, you first call `useStartSupplyOrderReviewMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStartSupplyOrderReviewMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [startSupplyOrderReviewMutation, { data, loading, error }] = useStartSupplyOrderReviewMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useStartSupplyOrderReviewMutation(baseOptions?: Apollo.MutationHookOptions<StartSupplyOrderReviewMutation, StartSupplyOrderReviewMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<StartSupplyOrderReviewMutation, StartSupplyOrderReviewMutationVariables>(StartSupplyOrderReviewDocument, options);
      }
export type StartSupplyOrderReviewMutationHookResult = ReturnType<typeof useStartSupplyOrderReviewMutation>;
export type StartSupplyOrderReviewMutationResult = Apollo.MutationResult<StartSupplyOrderReviewMutation>;
export type StartSupplyOrderReviewMutationOptions = Apollo.BaseMutationOptions<StartSupplyOrderReviewMutation, StartSupplyOrderReviewMutationVariables>;
export const ReviewSupplyOrderDocument = gql`
    mutation reviewSupplyOrder($input: SupplyOrderReviewMutationInput!) {
  reviewSupplyOrder(input: $input) {
    supplyOrderReview {
      supplyOrder {
        id
        uuid
      }
    }
    errors {
      ...Error
    }
  }
}
    ${ErrorFragmentDoc}`;
export type ReviewSupplyOrderMutationFn = Apollo.MutationFunction<ReviewSupplyOrderMutation, ReviewSupplyOrderMutationVariables>;

/**
 * __useReviewSupplyOrderMutation__
 *
 * To run a mutation, you first call `useReviewSupplyOrderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReviewSupplyOrderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [reviewSupplyOrderMutation, { data, loading, error }] = useReviewSupplyOrderMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useReviewSupplyOrderMutation(baseOptions?: Apollo.MutationHookOptions<ReviewSupplyOrderMutation, ReviewSupplyOrderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ReviewSupplyOrderMutation, ReviewSupplyOrderMutationVariables>(ReviewSupplyOrderDocument, options);
      }
export type ReviewSupplyOrderMutationHookResult = ReturnType<typeof useReviewSupplyOrderMutation>;
export type ReviewSupplyOrderMutationResult = Apollo.MutationResult<ReviewSupplyOrderMutation>;
export type ReviewSupplyOrderMutationOptions = Apollo.BaseMutationOptions<ReviewSupplyOrderMutation, ReviewSupplyOrderMutationVariables>;
export const CreateShipmentDocument = gql`
    mutation createShipment($input: CreateShipmentMutationInput!) {
  createShipment(input: $input) {
    shipment {
      id
    }
    errors {
      ...Error
    }
  }
}
    ${ErrorFragmentDoc}`;
export type CreateShipmentMutationFn = Apollo.MutationFunction<CreateShipmentMutation, CreateShipmentMutationVariables>;

/**
 * __useCreateShipmentMutation__
 *
 * To run a mutation, you first call `useCreateShipmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateShipmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createShipmentMutation, { data, loading, error }] = useCreateShipmentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateShipmentMutation(baseOptions?: Apollo.MutationHookOptions<CreateShipmentMutation, CreateShipmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateShipmentMutation, CreateShipmentMutationVariables>(CreateShipmentDocument, options);
      }
export type CreateShipmentMutationHookResult = ReturnType<typeof useCreateShipmentMutation>;
export type CreateShipmentMutationResult = Apollo.MutationResult<CreateShipmentMutation>;
export type CreateShipmentMutationOptions = Apollo.BaseMutationOptions<CreateShipmentMutation, CreateShipmentMutationVariables>;
export const DeleteShipmentDocument = gql`
    mutation deleteShipment($input: DeleteShipmentMutationInput!) {
  deleteShipment(input: $input) {
    errors {
      ...Error
    }
  }
}
    ${ErrorFragmentDoc}`;
export type DeleteShipmentMutationFn = Apollo.MutationFunction<DeleteShipmentMutation, DeleteShipmentMutationVariables>;

/**
 * __useDeleteShipmentMutation__
 *
 * To run a mutation, you first call `useDeleteShipmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteShipmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteShipmentMutation, { data, loading, error }] = useDeleteShipmentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteShipmentMutation(baseOptions?: Apollo.MutationHookOptions<DeleteShipmentMutation, DeleteShipmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteShipmentMutation, DeleteShipmentMutationVariables>(DeleteShipmentDocument, options);
      }
export type DeleteShipmentMutationHookResult = ReturnType<typeof useDeleteShipmentMutation>;
export type DeleteShipmentMutationResult = Apollo.MutationResult<DeleteShipmentMutation>;
export type DeleteShipmentMutationOptions = Apollo.BaseMutationOptions<DeleteShipmentMutation, DeleteShipmentMutationVariables>;
export const UpdateShipmentDocument = gql`
    mutation updateShipment($input: UpdateShipmentMutationInput!) {
  updateShipment(input: $input) {
    shipment {
      id
    }
    errors {
      ...Error
    }
  }
}
    ${ErrorFragmentDoc}`;
export type UpdateShipmentMutationFn = Apollo.MutationFunction<UpdateShipmentMutation, UpdateShipmentMutationVariables>;

/**
 * __useUpdateShipmentMutation__
 *
 * To run a mutation, you first call `useUpdateShipmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateShipmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateShipmentMutation, { data, loading, error }] = useUpdateShipmentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateShipmentMutation(baseOptions?: Apollo.MutationHookOptions<UpdateShipmentMutation, UpdateShipmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateShipmentMutation, UpdateShipmentMutationVariables>(UpdateShipmentDocument, options);
      }
export type UpdateShipmentMutationHookResult = ReturnType<typeof useUpdateShipmentMutation>;
export type UpdateShipmentMutationResult = Apollo.MutationResult<UpdateShipmentMutation>;
export type UpdateShipmentMutationOptions = Apollo.BaseMutationOptions<UpdateShipmentMutation, UpdateShipmentMutationVariables>;
export const UploadInvoiceDocument = gql`
    mutation uploadInvoice($input: UploadInvoiceMutationInput!) {
  uploadInvoice(input: $input) {
    shipment {
      id
    }
    errors {
      ...Error
    }
  }
}
    ${ErrorFragmentDoc}`;
export type UploadInvoiceMutationFn = Apollo.MutationFunction<UploadInvoiceMutation, UploadInvoiceMutationVariables>;

/**
 * __useUploadInvoiceMutation__
 *
 * To run a mutation, you first call `useUploadInvoiceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUploadInvoiceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [uploadInvoiceMutation, { data, loading, error }] = useUploadInvoiceMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUploadInvoiceMutation(baseOptions?: Apollo.MutationHookOptions<UploadInvoiceMutation, UploadInvoiceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UploadInvoiceMutation, UploadInvoiceMutationVariables>(UploadInvoiceDocument, options);
      }
export type UploadInvoiceMutationHookResult = ReturnType<typeof useUploadInvoiceMutation>;
export type UploadInvoiceMutationResult = Apollo.MutationResult<UploadInvoiceMutation>;
export type UploadInvoiceMutationOptions = Apollo.BaseMutationOptions<UploadInvoiceMutation, UploadInvoiceMutationVariables>;
export const CreateSupplyOrderPdfDocument = gql`
    mutation createSupplyOrderPdf($supplyOrderId: UUID!) {
  createSupplyOrderPdf(supplyOrderId: $supplyOrderId) {
    job {
      id
    }
    errors {
      ...Error
    }
  }
}
    ${ErrorFragmentDoc}`;
export type CreateSupplyOrderPdfMutationFn = Apollo.MutationFunction<CreateSupplyOrderPdfMutation, CreateSupplyOrderPdfMutationVariables>;

/**
 * __useCreateSupplyOrderPdfMutation__
 *
 * To run a mutation, you first call `useCreateSupplyOrderPdfMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateSupplyOrderPdfMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createSupplyOrderPdfMutation, { data, loading, error }] = useCreateSupplyOrderPdfMutation({
 *   variables: {
 *      supplyOrderId: // value for 'supplyOrderId'
 *   },
 * });
 */
export function useCreateSupplyOrderPdfMutation(baseOptions?: Apollo.MutationHookOptions<CreateSupplyOrderPdfMutation, CreateSupplyOrderPdfMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateSupplyOrderPdfMutation, CreateSupplyOrderPdfMutationVariables>(CreateSupplyOrderPdfDocument, options);
      }
export type CreateSupplyOrderPdfMutationHookResult = ReturnType<typeof useCreateSupplyOrderPdfMutation>;
export type CreateSupplyOrderPdfMutationResult = Apollo.MutationResult<CreateSupplyOrderPdfMutation>;
export type CreateSupplyOrderPdfMutationOptions = Apollo.BaseMutationOptions<CreateSupplyOrderPdfMutation, CreateSupplyOrderPdfMutationVariables>;
export const CreatePrepaidPdfDocument = gql`
    mutation createPrepaidPdf($supplyOrderId: UUID!) {
  createPrepaidPdf(supplyOrderId: $supplyOrderId) {
    job {
      id
    }
    errors {
      ...Error
    }
  }
}
    ${ErrorFragmentDoc}`;
export type CreatePrepaidPdfMutationFn = Apollo.MutationFunction<CreatePrepaidPdfMutation, CreatePrepaidPdfMutationVariables>;

/**
 * __useCreatePrepaidPdfMutation__
 *
 * To run a mutation, you first call `useCreatePrepaidPdfMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePrepaidPdfMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPrepaidPdfMutation, { data, loading, error }] = useCreatePrepaidPdfMutation({
 *   variables: {
 *      supplyOrderId: // value for 'supplyOrderId'
 *   },
 * });
 */
export function useCreatePrepaidPdfMutation(baseOptions?: Apollo.MutationHookOptions<CreatePrepaidPdfMutation, CreatePrepaidPdfMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreatePrepaidPdfMutation, CreatePrepaidPdfMutationVariables>(CreatePrepaidPdfDocument, options);
      }
export type CreatePrepaidPdfMutationHookResult = ReturnType<typeof useCreatePrepaidPdfMutation>;
export type CreatePrepaidPdfMutationResult = Apollo.MutationResult<CreatePrepaidPdfMutation>;
export type CreatePrepaidPdfMutationOptions = Apollo.BaseMutationOptions<CreatePrepaidPdfMutation, CreatePrepaidPdfMutationVariables>;
export const ToggleSubscribeModelNotificationDocument = gql`
    mutation toggleSubscribeModelNotification($input: ToggleSubscribeModelNotificationMutationInput!) {
  toggleSubscribeModelNotification(input: $input) {
    errors {
      ...Error
    }
  }
}
    ${ErrorFragmentDoc}`;
export type ToggleSubscribeModelNotificationMutationFn = Apollo.MutationFunction<ToggleSubscribeModelNotificationMutation, ToggleSubscribeModelNotificationMutationVariables>;

/**
 * __useToggleSubscribeModelNotificationMutation__
 *
 * To run a mutation, you first call `useToggleSubscribeModelNotificationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useToggleSubscribeModelNotificationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [toggleSubscribeModelNotificationMutation, { data, loading, error }] = useToggleSubscribeModelNotificationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useToggleSubscribeModelNotificationMutation(baseOptions?: Apollo.MutationHookOptions<ToggleSubscribeModelNotificationMutation, ToggleSubscribeModelNotificationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ToggleSubscribeModelNotificationMutation, ToggleSubscribeModelNotificationMutationVariables>(ToggleSubscribeModelNotificationDocument, options);
      }
export type ToggleSubscribeModelNotificationMutationHookResult = ReturnType<typeof useToggleSubscribeModelNotificationMutation>;
export type ToggleSubscribeModelNotificationMutationResult = Apollo.MutationResult<ToggleSubscribeModelNotificationMutation>;
export type ToggleSubscribeModelNotificationMutationOptions = Apollo.BaseMutationOptions<ToggleSubscribeModelNotificationMutation, ToggleSubscribeModelNotificationMutationVariables>;
export const UpdateSupplyOrderCommentDocument = gql`
    mutation updateSupplyOrderComment($input: UpdateSupplyOrderCommentMutationInput!) {
  updateSupplyOrderComment(input: $input) {
    errors {
      ...Error
    }
    supplyOrder {
      id
      comment
    }
  }
}
    ${ErrorFragmentDoc}`;
export type UpdateSupplyOrderCommentMutationFn = Apollo.MutationFunction<UpdateSupplyOrderCommentMutation, UpdateSupplyOrderCommentMutationVariables>;

/**
 * __useUpdateSupplyOrderCommentMutation__
 *
 * To run a mutation, you first call `useUpdateSupplyOrderCommentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSupplyOrderCommentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSupplyOrderCommentMutation, { data, loading, error }] = useUpdateSupplyOrderCommentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateSupplyOrderCommentMutation(baseOptions?: Apollo.MutationHookOptions<UpdateSupplyOrderCommentMutation, UpdateSupplyOrderCommentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateSupplyOrderCommentMutation, UpdateSupplyOrderCommentMutationVariables>(UpdateSupplyOrderCommentDocument, options);
      }
export type UpdateSupplyOrderCommentMutationHookResult = ReturnType<typeof useUpdateSupplyOrderCommentMutation>;
export type UpdateSupplyOrderCommentMutationResult = Apollo.MutationResult<UpdateSupplyOrderCommentMutation>;
export type UpdateSupplyOrderCommentMutationOptions = Apollo.BaseMutationOptions<UpdateSupplyOrderCommentMutation, UpdateSupplyOrderCommentMutationVariables>;
export const AddOrderedProductDocument = gql`
    mutation addOrderedProduct($input: OrderedProductSupplyOrderQuoteFormInput!, $orderedProducts: [OrderedProductOrderedProductFormInput!]!) {
  addOrderedProduct(input: $input, orderedProducts: $orderedProducts) {
    errors {
      ...Error
    }
  }
}
    ${ErrorFragmentDoc}`;
export type AddOrderedProductMutationFn = Apollo.MutationFunction<AddOrderedProductMutation, AddOrderedProductMutationVariables>;

/**
 * __useAddOrderedProductMutation__
 *
 * To run a mutation, you first call `useAddOrderedProductMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddOrderedProductMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addOrderedProductMutation, { data, loading, error }] = useAddOrderedProductMutation({
 *   variables: {
 *      input: // value for 'input'
 *      orderedProducts: // value for 'orderedProducts'
 *   },
 * });
 */
export function useAddOrderedProductMutation(baseOptions?: Apollo.MutationHookOptions<AddOrderedProductMutation, AddOrderedProductMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddOrderedProductMutation, AddOrderedProductMutationVariables>(AddOrderedProductDocument, options);
      }
export type AddOrderedProductMutationHookResult = ReturnType<typeof useAddOrderedProductMutation>;
export type AddOrderedProductMutationResult = Apollo.MutationResult<AddOrderedProductMutation>;
export type AddOrderedProductMutationOptions = Apollo.BaseMutationOptions<AddOrderedProductMutation, AddOrderedProductMutationVariables>;
export const GetJobDocument = gql`
    query getJob($id: String!) {
  job(id: $id) {
    ...Job
  }
}
    ${JobFragmentDoc}`;

/**
 * __useGetJobQuery__
 *
 * To run a query within a React component, call `useGetJobQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetJobQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetJobQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetJobQuery(baseOptions: Apollo.QueryHookOptions<GetJobQuery, GetJobQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetJobQuery, GetJobQueryVariables>(GetJobDocument, options);
      }
export function useGetJobLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetJobQuery, GetJobQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetJobQuery, GetJobQueryVariables>(GetJobDocument, options);
        }
export type GetJobQueryHookResult = ReturnType<typeof useGetJobQuery>;
export type GetJobLazyQueryHookResult = ReturnType<typeof useGetJobLazyQuery>;
export type GetJobQueryResult = Apollo.QueryResult<GetJobQuery, GetJobQueryVariables>;
export function refetchGetJobQuery(variables: GetJobQueryVariables) {
      return { query: GetJobDocument, variables: variables }
    }
export const GetExportFileJobDocument = gql`
    query getExportFileJob($id: String!) {
  exportFileJob(id: $id) {
    id
    status
    result {
      ...Download
    }
  }
}
    ${DownloadFragmentDoc}`;

/**
 * __useGetExportFileJobQuery__
 *
 * To run a query within a React component, call `useGetExportFileJobQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetExportFileJobQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetExportFileJobQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetExportFileJobQuery(baseOptions: Apollo.QueryHookOptions<GetExportFileJobQuery, GetExportFileJobQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetExportFileJobQuery, GetExportFileJobQueryVariables>(GetExportFileJobDocument, options);
      }
export function useGetExportFileJobLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetExportFileJobQuery, GetExportFileJobQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetExportFileJobQuery, GetExportFileJobQueryVariables>(GetExportFileJobDocument, options);
        }
export type GetExportFileJobQueryHookResult = ReturnType<typeof useGetExportFileJobQuery>;
export type GetExportFileJobLazyQueryHookResult = ReturnType<typeof useGetExportFileJobLazyQuery>;
export type GetExportFileJobQueryResult = Apollo.QueryResult<GetExportFileJobQuery, GetExportFileJobQueryVariables>;
export function refetchGetExportFileJobQuery(variables: GetExportFileJobQueryVariables) {
      return { query: GetExportFileJobDocument, variables: variables }
    }
export const GetRuntimeSettingsDocument = gql`
    query getRuntimeSettings {
  runtimeSettings {
    ...RuntimeSettings
  }
}
    ${RuntimeSettingsFragmentDoc}`;

/**
 * __useGetRuntimeSettingsQuery__
 *
 * To run a query within a React component, call `useGetRuntimeSettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRuntimeSettingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRuntimeSettingsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetRuntimeSettingsQuery(baseOptions?: Apollo.QueryHookOptions<GetRuntimeSettingsQuery, GetRuntimeSettingsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRuntimeSettingsQuery, GetRuntimeSettingsQueryVariables>(GetRuntimeSettingsDocument, options);
      }
export function useGetRuntimeSettingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRuntimeSettingsQuery, GetRuntimeSettingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRuntimeSettingsQuery, GetRuntimeSettingsQueryVariables>(GetRuntimeSettingsDocument, options);
        }
export type GetRuntimeSettingsQueryHookResult = ReturnType<typeof useGetRuntimeSettingsQuery>;
export type GetRuntimeSettingsLazyQueryHookResult = ReturnType<typeof useGetRuntimeSettingsLazyQuery>;
export type GetRuntimeSettingsQueryResult = Apollo.QueryResult<GetRuntimeSettingsQuery, GetRuntimeSettingsQueryVariables>;
export function refetchGetRuntimeSettingsQuery(variables?: GetRuntimeSettingsQueryVariables) {
      return { query: GetRuntimeSettingsDocument, variables: variables }
    }
export const GetLocaleTranslationDocument = gql`
    query getLocaleTranslation {
  localeTranslations {
    ...LocaleTranslations
  }
}
    ${LocaleTranslationsFragmentDoc}`;

/**
 * __useGetLocaleTranslationQuery__
 *
 * To run a query within a React component, call `useGetLocaleTranslationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLocaleTranslationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLocaleTranslationQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetLocaleTranslationQuery(baseOptions?: Apollo.QueryHookOptions<GetLocaleTranslationQuery, GetLocaleTranslationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLocaleTranslationQuery, GetLocaleTranslationQueryVariables>(GetLocaleTranslationDocument, options);
      }
export function useGetLocaleTranslationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetLocaleTranslationQuery, GetLocaleTranslationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLocaleTranslationQuery, GetLocaleTranslationQueryVariables>(GetLocaleTranslationDocument, options);
        }
export type GetLocaleTranslationQueryHookResult = ReturnType<typeof useGetLocaleTranslationQuery>;
export type GetLocaleTranslationLazyQueryHookResult = ReturnType<typeof useGetLocaleTranslationLazyQuery>;
export type GetLocaleTranslationQueryResult = Apollo.QueryResult<GetLocaleTranslationQuery, GetLocaleTranslationQueryVariables>;
export function refetchGetLocaleTranslationQuery(variables?: GetLocaleTranslationQueryVariables) {
      return { query: GetLocaleTranslationDocument, variables: variables }
    }
export const LoginDocument = gql`
    mutation login($input: LoginInput!) {
  login(input: $input) {
    email
    errors {
      ...Error
    }
    user {
      id
    }
  }
}
    ${ErrorFragmentDoc}`;
export type LoginMutationFn = Apollo.MutationFunction<LoginMutation, LoginMutationVariables>;

/**
 * __useLoginMutation__
 *
 * To run a mutation, you first call `useLoginMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLoginMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [loginMutation, { data, loading, error }] = useLoginMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useLoginMutation(baseOptions?: Apollo.MutationHookOptions<LoginMutation, LoginMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LoginMutation, LoginMutationVariables>(LoginDocument, options);
      }
export type LoginMutationHookResult = ReturnType<typeof useLoginMutation>;
export type LoginMutationResult = Apollo.MutationResult<LoginMutation>;
export type LoginMutationOptions = Apollo.BaseMutationOptions<LoginMutation, LoginMutationVariables>;
export const LogoutDocument = gql`
    mutation logout {
  logout {
    success
  }
}
    `;
export type LogoutMutationFn = Apollo.MutationFunction<LogoutMutation, LogoutMutationVariables>;

/**
 * __useLogoutMutation__
 *
 * To run a mutation, you first call `useLogoutMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLogoutMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [logoutMutation, { data, loading, error }] = useLogoutMutation({
 *   variables: {
 *   },
 * });
 */
export function useLogoutMutation(baseOptions?: Apollo.MutationHookOptions<LogoutMutation, LogoutMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LogoutMutation, LogoutMutationVariables>(LogoutDocument, options);
      }
export type LogoutMutationHookResult = ReturnType<typeof useLogoutMutation>;
export type LogoutMutationResult = Apollo.MutationResult<LogoutMutation>;
export type LogoutMutationOptions = Apollo.BaseMutationOptions<LogoutMutation, LogoutMutationVariables>;
export const ResetPasswordDocument = gql`
    mutation resetPassword($input: ResetPasswordMutationInput!) {
  resetPassword(input: $input) {
    email
    errors {
      ...Error
    }
  }
}
    ${ErrorFragmentDoc}`;
export type ResetPasswordMutationFn = Apollo.MutationFunction<ResetPasswordMutation, ResetPasswordMutationVariables>;

/**
 * __useResetPasswordMutation__
 *
 * To run a mutation, you first call `useResetPasswordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResetPasswordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resetPasswordMutation, { data, loading, error }] = useResetPasswordMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useResetPasswordMutation(baseOptions?: Apollo.MutationHookOptions<ResetPasswordMutation, ResetPasswordMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ResetPasswordMutation, ResetPasswordMutationVariables>(ResetPasswordDocument, options);
      }
export type ResetPasswordMutationHookResult = ReturnType<typeof useResetPasswordMutation>;
export type ResetPasswordMutationResult = Apollo.MutationResult<ResetPasswordMutation>;
export type ResetPasswordMutationOptions = Apollo.BaseMutationOptions<ResetPasswordMutation, ResetPasswordMutationVariables>;
export const UpdatePasswordDocument = gql`
    mutation updatePassword($input: UpdatePasswordMutationInput!) {
  updatePassword(input: $input) {
    errors {
      ...Error
    }
  }
}
    ${ErrorFragmentDoc}`;
export type UpdatePasswordMutationFn = Apollo.MutationFunction<UpdatePasswordMutation, UpdatePasswordMutationVariables>;

/**
 * __useUpdatePasswordMutation__
 *
 * To run a mutation, you first call `useUpdatePasswordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePasswordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePasswordMutation, { data, loading, error }] = useUpdatePasswordMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdatePasswordMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePasswordMutation, UpdatePasswordMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePasswordMutation, UpdatePasswordMutationVariables>(UpdatePasswordDocument, options);
      }
export type UpdatePasswordMutationHookResult = ReturnType<typeof useUpdatePasswordMutation>;
export type UpdatePasswordMutationResult = Apollo.MutationResult<UpdatePasswordMutation>;
export type UpdatePasswordMutationOptions = Apollo.BaseMutationOptions<UpdatePasswordMutation, UpdatePasswordMutationVariables>;
export const SetPasswordDocument = gql`
    mutation setPassword($input: SetPasswordMutationInput!) {
  setPassword(input: $input) {
    errors {
      ...Error
    }
  }
}
    ${ErrorFragmentDoc}`;
export type SetPasswordMutationFn = Apollo.MutationFunction<SetPasswordMutation, SetPasswordMutationVariables>;

/**
 * __useSetPasswordMutation__
 *
 * To run a mutation, you first call `useSetPasswordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetPasswordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setPasswordMutation, { data, loading, error }] = useSetPasswordMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSetPasswordMutation(baseOptions?: Apollo.MutationHookOptions<SetPasswordMutation, SetPasswordMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetPasswordMutation, SetPasswordMutationVariables>(SetPasswordDocument, options);
      }
export type SetPasswordMutationHookResult = ReturnType<typeof useSetPasswordMutation>;
export type SetPasswordMutationResult = Apollo.MutationResult<SetPasswordMutation>;
export type SetPasswordMutationOptions = Apollo.BaseMutationOptions<SetPasswordMutation, SetPasswordMutationVariables>;
export const UpdateUserDocument = gql`
    mutation updateUser($input: UpdateUserMutationInput!) {
  updateUser(input: $input) {
    errors {
      ...Error
    }
  }
}
    ${ErrorFragmentDoc}`;
export type UpdateUserMutationFn = Apollo.MutationFunction<UpdateUserMutation, UpdateUserMutationVariables>;

/**
 * __useUpdateUserMutation__
 *
 * To run a mutation, you first call `useUpdateUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserMutation, { data, loading, error }] = useUpdateUserMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateUserMutation(baseOptions?: Apollo.MutationHookOptions<UpdateUserMutation, UpdateUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateUserMutation, UpdateUserMutationVariables>(UpdateUserDocument, options);
      }
export type UpdateUserMutationHookResult = ReturnType<typeof useUpdateUserMutation>;
export type UpdateUserMutationResult = Apollo.MutationResult<UpdateUserMutation>;
export type UpdateUserMutationOptions = Apollo.BaseMutationOptions<UpdateUserMutation, UpdateUserMutationVariables>;
export const ToggleNotificationConfigDocument = gql`
    mutation toggleNotificationConfig($input: NotificationConfigMutationInput!) {
  toggleNotificationConfig(input: $input) {
    errors {
      ...Error
    }
  }
}
    ${ErrorFragmentDoc}`;
export type ToggleNotificationConfigMutationFn = Apollo.MutationFunction<ToggleNotificationConfigMutation, ToggleNotificationConfigMutationVariables>;

/**
 * __useToggleNotificationConfigMutation__
 *
 * To run a mutation, you first call `useToggleNotificationConfigMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useToggleNotificationConfigMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [toggleNotificationConfigMutation, { data, loading, error }] = useToggleNotificationConfigMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useToggleNotificationConfigMutation(baseOptions?: Apollo.MutationHookOptions<ToggleNotificationConfigMutation, ToggleNotificationConfigMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ToggleNotificationConfigMutation, ToggleNotificationConfigMutationVariables>(ToggleNotificationConfigDocument, options);
      }
export type ToggleNotificationConfigMutationHookResult = ReturnType<typeof useToggleNotificationConfigMutation>;
export type ToggleNotificationConfigMutationResult = Apollo.MutationResult<ToggleNotificationConfigMutation>;
export type ToggleNotificationConfigMutationOptions = Apollo.BaseMutationOptions<ToggleNotificationConfigMutation, ToggleNotificationConfigMutationVariables>;
export const UserDocument = gql`
    query user {
  user {
    organization {
      location {
        id
        iva
        name
      }
      ...Organization
    }
    ...User
  }
}
    ${OrganizationFragmentDoc}
${UserFragmentDoc}`;

/**
 * __useUserQuery__
 *
 * To run a query within a React component, call `useUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserQuery({
 *   variables: {
 *   },
 * });
 */
export function useUserQuery(baseOptions?: Apollo.QueryHookOptions<UserQuery, UserQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserQuery, UserQueryVariables>(UserDocument, options);
      }
export function useUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserQuery, UserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserQuery, UserQueryVariables>(UserDocument, options);
        }
export type UserQueryHookResult = ReturnType<typeof useUserQuery>;
export type UserLazyQueryHookResult = ReturnType<typeof useUserLazyQuery>;
export type UserQueryResult = Apollo.QueryResult<UserQuery, UserQueryVariables>;
export function refetchUserQuery(variables?: UserQueryVariables) {
      return { query: UserDocument, variables: variables }
    }
export const GetUsersDocument = gql`
    query getUsers {
  users {
    ...User
  }
}
    ${UserFragmentDoc}`;

/**
 * __useGetUsersQuery__
 *
 * To run a query within a React component, call `useGetUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUsersQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetUsersQuery(baseOptions?: Apollo.QueryHookOptions<GetUsersQuery, GetUsersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUsersQuery, GetUsersQueryVariables>(GetUsersDocument, options);
      }
export function useGetUsersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUsersQuery, GetUsersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUsersQuery, GetUsersQueryVariables>(GetUsersDocument, options);
        }
export type GetUsersQueryHookResult = ReturnType<typeof useGetUsersQuery>;
export type GetUsersLazyQueryHookResult = ReturnType<typeof useGetUsersLazyQuery>;
export type GetUsersQueryResult = Apollo.QueryResult<GetUsersQuery, GetUsersQueryVariables>;
export function refetchGetUsersQuery(variables?: GetUsersQueryVariables) {
      return { query: GetUsersDocument, variables: variables }
    }
export const GetUserNotificationConfigDocument = gql`
    query getUserNotificationConfig {
  notificationsConfigNames {
    ...NotificationConfigName
  }
  userNotificationsConfigs {
    ...NotificationConfig
  }
}
    ${NotificationConfigNameFragmentDoc}
${NotificationConfigFragmentDoc}`;

/**
 * __useGetUserNotificationConfigQuery__
 *
 * To run a query within a React component, call `useGetUserNotificationConfigQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserNotificationConfigQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserNotificationConfigQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetUserNotificationConfigQuery(baseOptions?: Apollo.QueryHookOptions<GetUserNotificationConfigQuery, GetUserNotificationConfigQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUserNotificationConfigQuery, GetUserNotificationConfigQueryVariables>(GetUserNotificationConfigDocument, options);
      }
export function useGetUserNotificationConfigLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserNotificationConfigQuery, GetUserNotificationConfigQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUserNotificationConfigQuery, GetUserNotificationConfigQueryVariables>(GetUserNotificationConfigDocument, options);
        }
export type GetUserNotificationConfigQueryHookResult = ReturnType<typeof useGetUserNotificationConfigQuery>;
export type GetUserNotificationConfigLazyQueryHookResult = ReturnType<typeof useGetUserNotificationConfigLazyQuery>;
export type GetUserNotificationConfigQueryResult = Apollo.QueryResult<GetUserNotificationConfigQuery, GetUserNotificationConfigQueryVariables>;
export function refetchGetUserNotificationConfigQuery(variables?: GetUserNotificationConfigQueryVariables) {
      return { query: GetUserNotificationConfigDocument, variables: variables }
    }
export const GetChildOrganizationsOptionsDocument = gql`
    query getChildOrganizationsOptions {
  childOrganizations {
    ...OrganizationOption
  }
}
    ${OrganizationOptionFragmentDoc}`;

/**
 * __useGetChildOrganizationsOptionsQuery__
 *
 * To run a query within a React component, call `useGetChildOrganizationsOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetChildOrganizationsOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetChildOrganizationsOptionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetChildOrganizationsOptionsQuery(baseOptions?: Apollo.QueryHookOptions<GetChildOrganizationsOptionsQuery, GetChildOrganizationsOptionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetChildOrganizationsOptionsQuery, GetChildOrganizationsOptionsQueryVariables>(GetChildOrganizationsOptionsDocument, options);
      }
export function useGetChildOrganizationsOptionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetChildOrganizationsOptionsQuery, GetChildOrganizationsOptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetChildOrganizationsOptionsQuery, GetChildOrganizationsOptionsQueryVariables>(GetChildOrganizationsOptionsDocument, options);
        }
export type GetChildOrganizationsOptionsQueryHookResult = ReturnType<typeof useGetChildOrganizationsOptionsQuery>;
export type GetChildOrganizationsOptionsLazyQueryHookResult = ReturnType<typeof useGetChildOrganizationsOptionsLazyQuery>;
export type GetChildOrganizationsOptionsQueryResult = Apollo.QueryResult<GetChildOrganizationsOptionsQuery, GetChildOrganizationsOptionsQueryVariables>;
export function refetchGetChildOrganizationsOptionsQuery(variables?: GetChildOrganizationsOptionsQueryVariables) {
      return { query: GetChildOrganizationsOptionsDocument, variables: variables }
    }
export const GetChildUsersDocument = gql`
    query getChildUsers {
  childUsers {
    ...User
  }
}
    ${UserFragmentDoc}`;

/**
 * __useGetChildUsersQuery__
 *
 * To run a query within a React component, call `useGetChildUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetChildUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetChildUsersQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetChildUsersQuery(baseOptions?: Apollo.QueryHookOptions<GetChildUsersQuery, GetChildUsersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetChildUsersQuery, GetChildUsersQueryVariables>(GetChildUsersDocument, options);
      }
export function useGetChildUsersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetChildUsersQuery, GetChildUsersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetChildUsersQuery, GetChildUsersQueryVariables>(GetChildUsersDocument, options);
        }
export type GetChildUsersQueryHookResult = ReturnType<typeof useGetChildUsersQuery>;
export type GetChildUsersLazyQueryHookResult = ReturnType<typeof useGetChildUsersLazyQuery>;
export type GetChildUsersQueryResult = Apollo.QueryResult<GetChildUsersQuery, GetChildUsersQueryVariables>;
export function refetchGetChildUsersQuery(variables?: GetChildUsersQueryVariables) {
      return { query: GetChildUsersDocument, variables: variables }
    }
export const GetUsersListDocument = gql`
    query getUsersList($ecnRolesIsNull: Boolean) {
  usersNodes(ecnRoles_Isnull: $ecnRolesIsNull) {
    pageInfo {
      ...PageInfo
    }
    edges {
      node {
        ...UserNode
      }
    }
    count
  }
}
    ${PageInfoFragmentDoc}
${UserNodeFragmentDoc}`;

/**
 * __useGetUsersListQuery__
 *
 * To run a query within a React component, call `useGetUsersListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUsersListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUsersListQuery({
 *   variables: {
 *      ecnRolesIsNull: // value for 'ecnRolesIsNull'
 *   },
 * });
 */
export function useGetUsersListQuery(baseOptions?: Apollo.QueryHookOptions<GetUsersListQuery, GetUsersListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUsersListQuery, GetUsersListQueryVariables>(GetUsersListDocument, options);
      }
export function useGetUsersListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUsersListQuery, GetUsersListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUsersListQuery, GetUsersListQueryVariables>(GetUsersListDocument, options);
        }
export type GetUsersListQueryHookResult = ReturnType<typeof useGetUsersListQuery>;
export type GetUsersListLazyQueryHookResult = ReturnType<typeof useGetUsersListLazyQuery>;
export type GetUsersListQueryResult = Apollo.QueryResult<GetUsersListQuery, GetUsersListQueryVariables>;
export function refetchGetUsersListQuery(variables?: GetUsersListQueryVariables) {
      return { query: GetUsersListDocument, variables: variables }
    }
export const GetOrganizationsDocument = gql`
    query getOrganizations {
  organizations {
    ...Organization
  }
}
    ${OrganizationFragmentDoc}`;

/**
 * __useGetOrganizationsQuery__
 *
 * To run a query within a React component, call `useGetOrganizationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrganizationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrganizationsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetOrganizationsQuery(baseOptions?: Apollo.QueryHookOptions<GetOrganizationsQuery, GetOrganizationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOrganizationsQuery, GetOrganizationsQueryVariables>(GetOrganizationsDocument, options);
      }
export function useGetOrganizationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOrganizationsQuery, GetOrganizationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOrganizationsQuery, GetOrganizationsQueryVariables>(GetOrganizationsDocument, options);
        }
export type GetOrganizationsQueryHookResult = ReturnType<typeof useGetOrganizationsQuery>;
export type GetOrganizationsLazyQueryHookResult = ReturnType<typeof useGetOrganizationsLazyQuery>;
export type GetOrganizationsQueryResult = Apollo.QueryResult<GetOrganizationsQuery, GetOrganizationsQueryVariables>;
export function refetchGetOrganizationsQuery(variables?: GetOrganizationsQueryVariables) {
      return { query: GetOrganizationsDocument, variables: variables }
    }
export const ChangeLanguageDocument = gql`
    mutation changeLanguage($language: String!) {
  changeLanguage(language: $language) {
    ok
  }
}
    `;
export type ChangeLanguageMutationFn = Apollo.MutationFunction<ChangeLanguageMutation, ChangeLanguageMutationVariables>;

/**
 * __useChangeLanguageMutation__
 *
 * To run a mutation, you first call `useChangeLanguageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useChangeLanguageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [changeLanguageMutation, { data, loading, error }] = useChangeLanguageMutation({
 *   variables: {
 *      language: // value for 'language'
 *   },
 * });
 */
export function useChangeLanguageMutation(baseOptions?: Apollo.MutationHookOptions<ChangeLanguageMutation, ChangeLanguageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ChangeLanguageMutation, ChangeLanguageMutationVariables>(ChangeLanguageDocument, options);
      }
export type ChangeLanguageMutationHookResult = ReturnType<typeof useChangeLanguageMutation>;
export type ChangeLanguageMutationResult = Apollo.MutationResult<ChangeLanguageMutation>;
export type ChangeLanguageMutationOptions = Apollo.BaseMutationOptions<ChangeLanguageMutation, ChangeLanguageMutationVariables>;
export const UpdateOrganizationDocument = gql`
    mutation updateOrganization($input: UpdateOrganizationMutationInput!) {
  updateOrganization(input: $input) {
    organization {
      id
    }
    errors {
      ...Error
    }
  }
}
    ${ErrorFragmentDoc}`;
export type UpdateOrganizationMutationFn = Apollo.MutationFunction<UpdateOrganizationMutation, UpdateOrganizationMutationVariables>;

/**
 * __useUpdateOrganizationMutation__
 *
 * To run a mutation, you first call `useUpdateOrganizationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateOrganizationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateOrganizationMutation, { data, loading, error }] = useUpdateOrganizationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateOrganizationMutation(baseOptions?: Apollo.MutationHookOptions<UpdateOrganizationMutation, UpdateOrganizationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateOrganizationMutation, UpdateOrganizationMutationVariables>(UpdateOrganizationDocument, options);
      }
export type UpdateOrganizationMutationHookResult = ReturnType<typeof useUpdateOrganizationMutation>;
export type UpdateOrganizationMutationResult = Apollo.MutationResult<UpdateOrganizationMutation>;
export type UpdateOrganizationMutationOptions = Apollo.BaseMutationOptions<UpdateOrganizationMutation, UpdateOrganizationMutationVariables>;
export const GetAccountOrganizationAddressesDocument = gql`
    query getAccountOrganizationAddresses($id: UUID!) {
  accountOrganizationAddresses(id: $id) {
    ...OrganizationAddress
  }
}
    ${OrganizationAddressFragmentDoc}`;

/**
 * __useGetAccountOrganizationAddressesQuery__
 *
 * To run a query within a React component, call `useGetAccountOrganizationAddressesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAccountOrganizationAddressesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAccountOrganizationAddressesQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetAccountOrganizationAddressesQuery(baseOptions: Apollo.QueryHookOptions<GetAccountOrganizationAddressesQuery, GetAccountOrganizationAddressesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAccountOrganizationAddressesQuery, GetAccountOrganizationAddressesQueryVariables>(GetAccountOrganizationAddressesDocument, options);
      }
export function useGetAccountOrganizationAddressesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAccountOrganizationAddressesQuery, GetAccountOrganizationAddressesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAccountOrganizationAddressesQuery, GetAccountOrganizationAddressesQueryVariables>(GetAccountOrganizationAddressesDocument, options);
        }
export type GetAccountOrganizationAddressesQueryHookResult = ReturnType<typeof useGetAccountOrganizationAddressesQuery>;
export type GetAccountOrganizationAddressesLazyQueryHookResult = ReturnType<typeof useGetAccountOrganizationAddressesLazyQuery>;
export type GetAccountOrganizationAddressesQueryResult = Apollo.QueryResult<GetAccountOrganizationAddressesQuery, GetAccountOrganizationAddressesQueryVariables>;
export function refetchGetAccountOrganizationAddressesQuery(variables: GetAccountOrganizationAddressesQueryVariables) {
      return { query: GetAccountOrganizationAddressesDocument, variables: variables }
    }
export const GetWarrantyClaimDocument = gql`
    query getWarrantyClaim($id: ID!, $uuid: UUID) {
  warrantyClaim(id: $id, uuid: $uuid) {
    ...WarrantyClaim
  }
}
    ${WarrantyClaimFragmentDoc}`;

/**
 * __useGetWarrantyClaimQuery__
 *
 * To run a query within a React component, call `useGetWarrantyClaimQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWarrantyClaimQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWarrantyClaimQuery({
 *   variables: {
 *      id: // value for 'id'
 *      uuid: // value for 'uuid'
 *   },
 * });
 */
export function useGetWarrantyClaimQuery(baseOptions: Apollo.QueryHookOptions<GetWarrantyClaimQuery, GetWarrantyClaimQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetWarrantyClaimQuery, GetWarrantyClaimQueryVariables>(GetWarrantyClaimDocument, options);
      }
export function useGetWarrantyClaimLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetWarrantyClaimQuery, GetWarrantyClaimQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetWarrantyClaimQuery, GetWarrantyClaimQueryVariables>(GetWarrantyClaimDocument, options);
        }
export type GetWarrantyClaimQueryHookResult = ReturnType<typeof useGetWarrantyClaimQuery>;
export type GetWarrantyClaimLazyQueryHookResult = ReturnType<typeof useGetWarrantyClaimLazyQuery>;
export type GetWarrantyClaimQueryResult = Apollo.QueryResult<GetWarrantyClaimQuery, GetWarrantyClaimQueryVariables>;
export function refetchGetWarrantyClaimQuery(variables: GetWarrantyClaimQueryVariables) {
      return { query: GetWarrantyClaimDocument, variables: variables }
    }
export const GetWarrantyClaimsDocument = gql`
    query getWarrantyClaims($first: Int, $after: String, $before: String, $offset: Int, $orderBy: String, $last: Int, $owner: UUID, $accountGlobalID: UUID, $createdBy: UUID, $createdGte: Date, $createdLte: Date, $created: Date, $status: String, $warrantyClaimType: WarrantyClaimsWarrantyClaimWarrantyClaimTypeChoices, $inspectionReviewStatus: String, $query: String) {
  warrantyClaims(
    first: $first
    after: $after
    before: $before
    offset: $offset
    orderBy: $orderBy
    last: $last
    contact_Account_Id: $accountGlobalID
    contact_Account_Owner_Id: $owner
    createdBy_Id: $createdBy
    createdGte: $createdGte
    createdLte: $createdLte
    created: $created
    status: $status
    inspectionReviewStatus: $inspectionReviewStatus
    warrantyClaimType: $warrantyClaimType
    query: $query
  ) {
    count
    pageInfo {
      ...PageInfo
    }
    edges {
      cursor
      node {
        ...WarrantyClaimList
      }
    }
  }
}
    ${PageInfoFragmentDoc}
${WarrantyClaimListFragmentDoc}`;

/**
 * __useGetWarrantyClaimsQuery__
 *
 * To run a query within a React component, call `useGetWarrantyClaimsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWarrantyClaimsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWarrantyClaimsQuery({
 *   variables: {
 *      first: // value for 'first'
 *      after: // value for 'after'
 *      before: // value for 'before'
 *      offset: // value for 'offset'
 *      orderBy: // value for 'orderBy'
 *      last: // value for 'last'
 *      owner: // value for 'owner'
 *      accountGlobalID: // value for 'accountGlobalID'
 *      createdBy: // value for 'createdBy'
 *      createdGte: // value for 'createdGte'
 *      createdLte: // value for 'createdLte'
 *      created: // value for 'created'
 *      status: // value for 'status'
 *      warrantyClaimType: // value for 'warrantyClaimType'
 *      inspectionReviewStatus: // value for 'inspectionReviewStatus'
 *      query: // value for 'query'
 *   },
 * });
 */
export function useGetWarrantyClaimsQuery(baseOptions?: Apollo.QueryHookOptions<GetWarrantyClaimsQuery, GetWarrantyClaimsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetWarrantyClaimsQuery, GetWarrantyClaimsQueryVariables>(GetWarrantyClaimsDocument, options);
      }
export function useGetWarrantyClaimsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetWarrantyClaimsQuery, GetWarrantyClaimsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetWarrantyClaimsQuery, GetWarrantyClaimsQueryVariables>(GetWarrantyClaimsDocument, options);
        }
export type GetWarrantyClaimsQueryHookResult = ReturnType<typeof useGetWarrantyClaimsQuery>;
export type GetWarrantyClaimsLazyQueryHookResult = ReturnType<typeof useGetWarrantyClaimsLazyQuery>;
export type GetWarrantyClaimsQueryResult = Apollo.QueryResult<GetWarrantyClaimsQuery, GetWarrantyClaimsQueryVariables>;
export function refetchGetWarrantyClaimsQuery(variables?: GetWarrantyClaimsQueryVariables) {
      return { query: GetWarrantyClaimsDocument, variables: variables }
    }
export const GetFailuresDocument = gql`
    query getFailures {
  failures {
    ...Failure
  }
}
    ${FailureFragmentDoc}`;

/**
 * __useGetFailuresQuery__
 *
 * To run a query within a React component, call `useGetFailuresQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFailuresQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFailuresQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetFailuresQuery(baseOptions?: Apollo.QueryHookOptions<GetFailuresQuery, GetFailuresQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetFailuresQuery, GetFailuresQueryVariables>(GetFailuresDocument, options);
      }
export function useGetFailuresLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetFailuresQuery, GetFailuresQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetFailuresQuery, GetFailuresQueryVariables>(GetFailuresDocument, options);
        }
export type GetFailuresQueryHookResult = ReturnType<typeof useGetFailuresQuery>;
export type GetFailuresLazyQueryHookResult = ReturnType<typeof useGetFailuresLazyQuery>;
export type GetFailuresQueryResult = Apollo.QueryResult<GetFailuresQuery, GetFailuresQueryVariables>;
export function refetchGetFailuresQuery(variables?: GetFailuresQueryVariables) {
      return { query: GetFailuresDocument, variables: variables }
    }
export const GetWarrantyClaimApprovalConfigDocument = gql`
    query getWarrantyClaimApprovalConfig {
  warrantyClaimApprovalConfig {
    id
    secondaryApprovalThreshold
    mainApprovalThreshold
  }
}
    `;

/**
 * __useGetWarrantyClaimApprovalConfigQuery__
 *
 * To run a query within a React component, call `useGetWarrantyClaimApprovalConfigQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWarrantyClaimApprovalConfigQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWarrantyClaimApprovalConfigQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetWarrantyClaimApprovalConfigQuery(baseOptions?: Apollo.QueryHookOptions<GetWarrantyClaimApprovalConfigQuery, GetWarrantyClaimApprovalConfigQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetWarrantyClaimApprovalConfigQuery, GetWarrantyClaimApprovalConfigQueryVariables>(GetWarrantyClaimApprovalConfigDocument, options);
      }
export function useGetWarrantyClaimApprovalConfigLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetWarrantyClaimApprovalConfigQuery, GetWarrantyClaimApprovalConfigQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetWarrantyClaimApprovalConfigQuery, GetWarrantyClaimApprovalConfigQueryVariables>(GetWarrantyClaimApprovalConfigDocument, options);
        }
export type GetWarrantyClaimApprovalConfigQueryHookResult = ReturnType<typeof useGetWarrantyClaimApprovalConfigQuery>;
export type GetWarrantyClaimApprovalConfigLazyQueryHookResult = ReturnType<typeof useGetWarrantyClaimApprovalConfigLazyQuery>;
export type GetWarrantyClaimApprovalConfigQueryResult = Apollo.QueryResult<GetWarrantyClaimApprovalConfigQuery, GetWarrantyClaimApprovalConfigQueryVariables>;
export function refetchGetWarrantyClaimApprovalConfigQuery(variables?: GetWarrantyClaimApprovalConfigQueryVariables) {
      return { query: GetWarrantyClaimApprovalConfigDocument, variables: variables }
    }
export const CreateWarrantyClaimDocument = gql`
    mutation createWarrantyClaim($input: CreateWarrantyClaimMutationInput!) {
  createWarrantyClaim(input: $input) {
    warrantyClaim {
      ...WarrantyClaim
    }
    errors {
      field
      messages
    }
  }
}
    ${WarrantyClaimFragmentDoc}`;
export type CreateWarrantyClaimMutationFn = Apollo.MutationFunction<CreateWarrantyClaimMutation, CreateWarrantyClaimMutationVariables>;

/**
 * __useCreateWarrantyClaimMutation__
 *
 * To run a mutation, you first call `useCreateWarrantyClaimMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateWarrantyClaimMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createWarrantyClaimMutation, { data, loading, error }] = useCreateWarrantyClaimMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateWarrantyClaimMutation(baseOptions?: Apollo.MutationHookOptions<CreateWarrantyClaimMutation, CreateWarrantyClaimMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateWarrantyClaimMutation, CreateWarrantyClaimMutationVariables>(CreateWarrantyClaimDocument, options);
      }
export type CreateWarrantyClaimMutationHookResult = ReturnType<typeof useCreateWarrantyClaimMutation>;
export type CreateWarrantyClaimMutationResult = Apollo.MutationResult<CreateWarrantyClaimMutation>;
export type CreateWarrantyClaimMutationOptions = Apollo.BaseMutationOptions<CreateWarrantyClaimMutation, CreateWarrantyClaimMutationVariables>;
export const UpdateWarrantyClaimDocument = gql`
    mutation updateWarrantyClaim($input: UpdateWarrantyClaimMutationInput!) {
  updateWarrantyClaim(input: $input) {
    warrantyClaim {
      ...WarrantyClaim
    }
    errors {
      field
      messages
    }
  }
}
    ${WarrantyClaimFragmentDoc}`;
export type UpdateWarrantyClaimMutationFn = Apollo.MutationFunction<UpdateWarrantyClaimMutation, UpdateWarrantyClaimMutationVariables>;

/**
 * __useUpdateWarrantyClaimMutation__
 *
 * To run a mutation, you first call `useUpdateWarrantyClaimMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateWarrantyClaimMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateWarrantyClaimMutation, { data, loading, error }] = useUpdateWarrantyClaimMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateWarrantyClaimMutation(baseOptions?: Apollo.MutationHookOptions<UpdateWarrantyClaimMutation, UpdateWarrantyClaimMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateWarrantyClaimMutation, UpdateWarrantyClaimMutationVariables>(UpdateWarrantyClaimDocument, options);
      }
export type UpdateWarrantyClaimMutationHookResult = ReturnType<typeof useUpdateWarrantyClaimMutation>;
export type UpdateWarrantyClaimMutationResult = Apollo.MutationResult<UpdateWarrantyClaimMutation>;
export type UpdateWarrantyClaimMutationOptions = Apollo.BaseMutationOptions<UpdateWarrantyClaimMutation, UpdateWarrantyClaimMutationVariables>;
export const CreateWarrantyClaimInspectionReviewDocument = gql`
    mutation createWarrantyClaimInspectionReview($input: CreateWarrantyClaimInspectionReviewMutationInput!) {
  createWarrantyClaimInspectionReview(input: $input) {
    warrantyClaimInspectionReview {
      ...WarrantyClaimInspectionReview
    }
    errors {
      field
      messages
    }
  }
}
    ${WarrantyClaimInspectionReviewFragmentDoc}`;
export type CreateWarrantyClaimInspectionReviewMutationFn = Apollo.MutationFunction<CreateWarrantyClaimInspectionReviewMutation, CreateWarrantyClaimInspectionReviewMutationVariables>;

/**
 * __useCreateWarrantyClaimInspectionReviewMutation__
 *
 * To run a mutation, you first call `useCreateWarrantyClaimInspectionReviewMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateWarrantyClaimInspectionReviewMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createWarrantyClaimInspectionReviewMutation, { data, loading, error }] = useCreateWarrantyClaimInspectionReviewMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateWarrantyClaimInspectionReviewMutation(baseOptions?: Apollo.MutationHookOptions<CreateWarrantyClaimInspectionReviewMutation, CreateWarrantyClaimInspectionReviewMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateWarrantyClaimInspectionReviewMutation, CreateWarrantyClaimInspectionReviewMutationVariables>(CreateWarrantyClaimInspectionReviewDocument, options);
      }
export type CreateWarrantyClaimInspectionReviewMutationHookResult = ReturnType<typeof useCreateWarrantyClaimInspectionReviewMutation>;
export type CreateWarrantyClaimInspectionReviewMutationResult = Apollo.MutationResult<CreateWarrantyClaimInspectionReviewMutation>;
export type CreateWarrantyClaimInspectionReviewMutationOptions = Apollo.BaseMutationOptions<CreateWarrantyClaimInspectionReviewMutation, CreateWarrantyClaimInspectionReviewMutationVariables>;
export const RejectWarrantyClaimDocument = gql`
    mutation rejectWarrantyClaim($input: RejectWarrantyClaimRequestMutationInput!) {
  rejectWarrantyClaim(input: $input) {
    warrantyClaimReview {
      ...WarrantyClaimReview
    }
    errors {
      field
      messages
    }
  }
}
    ${WarrantyClaimReviewFragmentDoc}`;
export type RejectWarrantyClaimMutationFn = Apollo.MutationFunction<RejectWarrantyClaimMutation, RejectWarrantyClaimMutationVariables>;

/**
 * __useRejectWarrantyClaimMutation__
 *
 * To run a mutation, you first call `useRejectWarrantyClaimMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRejectWarrantyClaimMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [rejectWarrantyClaimMutation, { data, loading, error }] = useRejectWarrantyClaimMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRejectWarrantyClaimMutation(baseOptions?: Apollo.MutationHookOptions<RejectWarrantyClaimMutation, RejectWarrantyClaimMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RejectWarrantyClaimMutation, RejectWarrantyClaimMutationVariables>(RejectWarrantyClaimDocument, options);
      }
export type RejectWarrantyClaimMutationHookResult = ReturnType<typeof useRejectWarrantyClaimMutation>;
export type RejectWarrantyClaimMutationResult = Apollo.MutationResult<RejectWarrantyClaimMutation>;
export type RejectWarrantyClaimMutationOptions = Apollo.BaseMutationOptions<RejectWarrantyClaimMutation, RejectWarrantyClaimMutationVariables>;
export const ApproveWarrantyClaimDocument = gql`
    mutation approveWarrantyClaim($input: ApproveWarrantyClaimRequestMutationInput!) {
  approveWarrantyClaim(input: $input) {
    warrantyClaimReview {
      ...WarrantyClaimReview
    }
    errors {
      field
      messages
    }
  }
}
    ${WarrantyClaimReviewFragmentDoc}`;
export type ApproveWarrantyClaimMutationFn = Apollo.MutationFunction<ApproveWarrantyClaimMutation, ApproveWarrantyClaimMutationVariables>;

/**
 * __useApproveWarrantyClaimMutation__
 *
 * To run a mutation, you first call `useApproveWarrantyClaimMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useApproveWarrantyClaimMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [approveWarrantyClaimMutation, { data, loading, error }] = useApproveWarrantyClaimMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useApproveWarrantyClaimMutation(baseOptions?: Apollo.MutationHookOptions<ApproveWarrantyClaimMutation, ApproveWarrantyClaimMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ApproveWarrantyClaimMutation, ApproveWarrantyClaimMutationVariables>(ApproveWarrantyClaimDocument, options);
      }
export type ApproveWarrantyClaimMutationHookResult = ReturnType<typeof useApproveWarrantyClaimMutation>;
export type ApproveWarrantyClaimMutationResult = Apollo.MutationResult<ApproveWarrantyClaimMutation>;
export type ApproveWarrantyClaimMutationOptions = Apollo.BaseMutationOptions<ApproveWarrantyClaimMutation, ApproveWarrantyClaimMutationVariables>;
export const CreateShipmentWarrantyClaimDocument = gql`
    mutation createShipmentWarrantyClaim($input: CreateShipmentWarrantyClaimMutationInput!) {
  createShipmentWarrantyClaim(input: $input) {
    warrantyClaim {
      ...WarrantyClaim
    }
    errors {
      field
      messages
    }
  }
}
    ${WarrantyClaimFragmentDoc}`;
export type CreateShipmentWarrantyClaimMutationFn = Apollo.MutationFunction<CreateShipmentWarrantyClaimMutation, CreateShipmentWarrantyClaimMutationVariables>;

/**
 * __useCreateShipmentWarrantyClaimMutation__
 *
 * To run a mutation, you first call `useCreateShipmentWarrantyClaimMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateShipmentWarrantyClaimMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createShipmentWarrantyClaimMutation, { data, loading, error }] = useCreateShipmentWarrantyClaimMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateShipmentWarrantyClaimMutation(baseOptions?: Apollo.MutationHookOptions<CreateShipmentWarrantyClaimMutation, CreateShipmentWarrantyClaimMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateShipmentWarrantyClaimMutation, CreateShipmentWarrantyClaimMutationVariables>(CreateShipmentWarrantyClaimDocument, options);
      }
export type CreateShipmentWarrantyClaimMutationHookResult = ReturnType<typeof useCreateShipmentWarrantyClaimMutation>;
export type CreateShipmentWarrantyClaimMutationResult = Apollo.MutationResult<CreateShipmentWarrantyClaimMutation>;
export type CreateShipmentWarrantyClaimMutationOptions = Apollo.BaseMutationOptions<CreateShipmentWarrantyClaimMutation, CreateShipmentWarrantyClaimMutationVariables>;
export const CancelWarrantyClaimDocument = gql`
    mutation cancelWarrantyClaim($input: CancelWarrantyClaimRequestMutationInput!) {
  cancelWarrantyClaim(input: $input) {
    warrantyClaimReview {
      ...WarrantyClaimReview
    }
    errors {
      field
      messages
    }
  }
}
    ${WarrantyClaimReviewFragmentDoc}`;
export type CancelWarrantyClaimMutationFn = Apollo.MutationFunction<CancelWarrantyClaimMutation, CancelWarrantyClaimMutationVariables>;

/**
 * __useCancelWarrantyClaimMutation__
 *
 * To run a mutation, you first call `useCancelWarrantyClaimMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCancelWarrantyClaimMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cancelWarrantyClaimMutation, { data, loading, error }] = useCancelWarrantyClaimMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCancelWarrantyClaimMutation(baseOptions?: Apollo.MutationHookOptions<CancelWarrantyClaimMutation, CancelWarrantyClaimMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CancelWarrantyClaimMutation, CancelWarrantyClaimMutationVariables>(CancelWarrantyClaimDocument, options);
      }
export type CancelWarrantyClaimMutationHookResult = ReturnType<typeof useCancelWarrantyClaimMutation>;
export type CancelWarrantyClaimMutationResult = Apollo.MutationResult<CancelWarrantyClaimMutation>;
export type CancelWarrantyClaimMutationOptions = Apollo.BaseMutationOptions<CancelWarrantyClaimMutation, CancelWarrantyClaimMutationVariables>;
export const CloseWarrantyClaimWithRmaDocument = gql`
    mutation closeWarrantyClaimWithRma($input: CloseWarrantyClaimWithRMAMutationInput!) {
  closeWarrantyClaimWithRma(input: $input) {
    warrantyClaimReview {
      ...WarrantyClaimReview
    }
    errors {
      field
      messages
    }
  }
}
    ${WarrantyClaimReviewFragmentDoc}`;
export type CloseWarrantyClaimWithRmaMutationFn = Apollo.MutationFunction<CloseWarrantyClaimWithRmaMutation, CloseWarrantyClaimWithRmaMutationVariables>;

/**
 * __useCloseWarrantyClaimWithRmaMutation__
 *
 * To run a mutation, you first call `useCloseWarrantyClaimWithRmaMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCloseWarrantyClaimWithRmaMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [closeWarrantyClaimWithRmaMutation, { data, loading, error }] = useCloseWarrantyClaimWithRmaMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCloseWarrantyClaimWithRmaMutation(baseOptions?: Apollo.MutationHookOptions<CloseWarrantyClaimWithRmaMutation, CloseWarrantyClaimWithRmaMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CloseWarrantyClaimWithRmaMutation, CloseWarrantyClaimWithRmaMutationVariables>(CloseWarrantyClaimWithRmaDocument, options);
      }
export type CloseWarrantyClaimWithRmaMutationHookResult = ReturnType<typeof useCloseWarrantyClaimWithRmaMutation>;
export type CloseWarrantyClaimWithRmaMutationResult = Apollo.MutationResult<CloseWarrantyClaimWithRmaMutation>;
export type CloseWarrantyClaimWithRmaMutationOptions = Apollo.BaseMutationOptions<CloseWarrantyClaimWithRmaMutation, CloseWarrantyClaimWithRmaMutationVariables>;
export const ExportExcelWarrantyClaimsDocument = gql`
    mutation exportExcelWarrantyClaims($orderBy: String, $accountGlobalID: UUID, $owner: UUID, $createdBy: UUID, $createdGte: Date, $createdLte: Date, $created: Date, $status: String, $inspectionReviewStatus: String, $query: String, $warrantyClaimId: UUID) {
  exportExcelWarrantyClaims(
    orderBy: $orderBy
    contact_Account_Id: $accountGlobalID
    contact_Account_Owner_Id: $owner
    createdBy_Id: $createdBy
    createdGte: $createdGte
    createdLte: $createdLte
    created: $created
    status: $status
    inspectionReviewStatus: $inspectionReviewStatus
    query: $query
    warrantyClaimId: $warrantyClaimId
  ) {
    job {
      id
    }
    errors {
      ...Error
    }
  }
}
    ${ErrorFragmentDoc}`;
export type ExportExcelWarrantyClaimsMutationFn = Apollo.MutationFunction<ExportExcelWarrantyClaimsMutation, ExportExcelWarrantyClaimsMutationVariables>;

/**
 * __useExportExcelWarrantyClaimsMutation__
 *
 * To run a mutation, you first call `useExportExcelWarrantyClaimsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useExportExcelWarrantyClaimsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [exportExcelWarrantyClaimsMutation, { data, loading, error }] = useExportExcelWarrantyClaimsMutation({
 *   variables: {
 *      orderBy: // value for 'orderBy'
 *      accountGlobalID: // value for 'accountGlobalID'
 *      owner: // value for 'owner'
 *      createdBy: // value for 'createdBy'
 *      createdGte: // value for 'createdGte'
 *      createdLte: // value for 'createdLte'
 *      created: // value for 'created'
 *      status: // value for 'status'
 *      inspectionReviewStatus: // value for 'inspectionReviewStatus'
 *      query: // value for 'query'
 *      warrantyClaimId: // value for 'warrantyClaimId'
 *   },
 * });
 */
export function useExportExcelWarrantyClaimsMutation(baseOptions?: Apollo.MutationHookOptions<ExportExcelWarrantyClaimsMutation, ExportExcelWarrantyClaimsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ExportExcelWarrantyClaimsMutation, ExportExcelWarrantyClaimsMutationVariables>(ExportExcelWarrantyClaimsDocument, options);
      }
export type ExportExcelWarrantyClaimsMutationHookResult = ReturnType<typeof useExportExcelWarrantyClaimsMutation>;
export type ExportExcelWarrantyClaimsMutationResult = Apollo.MutationResult<ExportExcelWarrantyClaimsMutation>;
export type ExportExcelWarrantyClaimsMutationOptions = Apollo.BaseMutationOptions<ExportExcelWarrantyClaimsMutation, ExportExcelWarrantyClaimsMutationVariables>;